webpackJsonp([137591856104208],{

/***/ 319:
/***/ (function(module, exports) {

	"use strict";
	
	function noop() {
	  return null;
	}
	
	noop.isRequired = noop;
	
	function noopThunk() {
	  return noop;
	}
	
	module.exports = {
	  and: noopThunk,
	  between: noopThunk,
	  booleanSome: noopThunk,
	  childrenHavePropXorChildren: noopThunk,
	  childrenOf: noopThunk,
	  childrenOfType: noopThunk,
	  childrenSequenceOf: noopThunk,
	  componentWithName: noopThunk,
	  disallowedIf: noopThunk,
	  elementType: noopThunk,
	  empty: noopThunk,
	  explicitNull: noopThunk,
	  forbidExtraProps: Object,
	  integer: noopThunk,
	  keysOf: noopThunk,
	  mutuallyExclusiveProps: noopThunk,
	  mutuallyExclusiveTrueProps: noopThunk,
	  nChildren: noopThunk,
	  nonNegativeInteger: noop,
	  nonNegativeNumber: noopThunk,
	  numericString: noopThunk,
	  object: noopThunk,
	  or: noopThunk,
	  range: noopThunk,
	  ref: noopThunk,
	  requiredBy: noopThunk,
	  restrictedProp: noopThunk,
	  sequenceOf: noopThunk,
	  shape: noopThunk,
	  stringEndsWith: noopThunk,
	  stringStartsWith: noopThunk,
	  uniqueArray: noopThunk,
	  uniqueArrayOf: noopThunk,
	  valuesOf: noopThunk,
	  withShape: noopThunk
	};
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	module.exports =  true ? __webpack_require__(319) : require('./build');
	
	//# sourceMappingURL=index.js.map

/***/ }),

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES = __webpack_require__(454);
	
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || (Math.pow(2, 53) - 1);
	
	// eslint-disable-next-line max-params, max-statements
	var FlattenIntoArray = function FlattenIntoArray(target, source, sourceLen, start, depth) {
		var targetIndex = start;
		var sourceIndex = 0;
	
		/*
		var mapperFunction;
		if (arguments.length > 5) {
			mapperFunction = arguments[5];
		}
		*/
	
		while (sourceIndex < sourceLen) {
			var P = ES.ToString(sourceIndex);
			var exists = ES.HasProperty(source, P);
			if (exists) {
				var element = ES.Get(source, P);
				/*
				if (typeof mapperFunction !== 'undefined') {
					if (arguments.length <= 6) {
						throw new TypeError('Assertion failed: thisArg is required when mapperFunction is provided');
					}
					element = ES.Call(mapperFunction, arguments[6], [element, sourceIndex, source]);
				}
				*/
				var shouldFlatten = false;
				if (depth > 0) {
					shouldFlatten = ES.IsArray(element);
				}
				if (shouldFlatten) {
					var elementLen = ES.ToLength(ES.Get(element, 'length'));
					targetIndex = FlattenIntoArray(target, element, elementLen, targetIndex, depth - 1);
				} else {
					if (targetIndex >= MAX_SAFE_INTEGER) {
						throw new TypeError('index too large');
					}
					ES.CreateDataPropertyOrThrow(target, ES.ToString(targetIndex), element);
					targetIndex += 1;
				}
			}
			sourceIndex += 1;
		}
	
		return targetIndex;
	};
	
	module.exports = function flat() {
		var O = ES.ToObject(this);
		var sourceLen = ES.ToLength(ES.Get(O, 'length'));
	
		var depthNum = 1;
		if (arguments.length > 0 && typeof arguments[0] !== 'undefined') {
			depthNum = ES.ToInteger(arguments[0]);
		}
	
		var A = ES.ArraySpeciesCreate(O, 0);
		FlattenIntoArray(A, O, sourceLen, 0, depthNum);
		return A;
	};


/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(44);
	var bind = __webpack_require__(45);
	
	var implementation = __webpack_require__(164);
	var getPolyfill = __webpack_require__(165);
	var polyfill = getPolyfill();
	var shim = __webpack_require__(321);
	
	var boundFlat = bind.call(Function.call, polyfill);
	
	define(boundFlat, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = boundFlat;


/***/ }),

/***/ 165:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(164);
	
	module.exports = function getPolyfill() {
		return Array.prototype.flat || implementation;
	};


/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(44);
	var getPolyfill = __webpack_require__(165);
	
	module.exports = function shimFlat() {
		var polyfill = getPolyfill();
		define(
			Array.prototype,
			{ flat: polyfill },
			{ flat: function () { return Array.prototype.flat !== polyfill; } }
		);
		return polyfill;
	};


/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _eventOptionsKey = __webpack_require__(408);
	
	var _eventOptionsKey2 = _interopRequireDefault(_eventOptionsKey);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function ensureCanMutateNextEventHandlers(eventHandlers) {
	  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
	    // eslint-disable-next-line no-param-reassign
	    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
	  }
	}
	
	var TargetEventHandlers = function () {
	  function TargetEventHandlers(target) {
	    _classCallCheck(this, TargetEventHandlers);
	
	    this.target = target;
	    this.events = {};
	  }
	
	  _createClass(TargetEventHandlers, [{
	    key: 'getEventHandlers',
	    value: function () {
	      function getEventHandlers(eventName, options) {
	        var key = String(eventName) + ' ' + String((0, _eventOptionsKey2['default'])(options));
	
	        if (!this.events[key]) {
	          this.events[key] = {
	            handlers: [],
	            handleEvent: undefined
	          };
	          this.events[key].nextHandlers = this.events[key].handlers;
	        }
	
	        return this.events[key];
	      }
	
	      return getEventHandlers;
	    }()
	  }, {
	    key: 'handleEvent',
	    value: function () {
	      function handleEvent(eventName, options, event) {
	        var eventHandlers = this.getEventHandlers(eventName, options);
	        eventHandlers.handlers = eventHandlers.nextHandlers;
	        eventHandlers.handlers.forEach(function (handler) {
	          if (handler) {
	            // We need to check for presence here because a handler function may
	            // cause later handlers to get removed. This can happen if you for
	            // instance have a waypoint that unmounts another waypoint as part of an
	            // onEnter/onLeave handler.
	            handler(event);
	          }
	        });
	      }
	
	      return handleEvent;
	    }()
	  }, {
	    key: 'add',
	    value: function () {
	      function add(eventName, listener, options) {
	        var _this = this;
	
	        // options has already been normalized at this point.
	        var eventHandlers = this.getEventHandlers(eventName, options);
	
	        ensureCanMutateNextEventHandlers(eventHandlers);
	
	        if (eventHandlers.nextHandlers.length === 0) {
	          eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);
	
	          this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
	        }
	
	        eventHandlers.nextHandlers.push(listener);
	
	        var isSubscribed = true;
	        var unsubscribe = function () {
	          function unsubscribe() {
	            if (!isSubscribed) {
	              return;
	            }
	
	            isSubscribed = false;
	
	            ensureCanMutateNextEventHandlers(eventHandlers);
	            var index = eventHandlers.nextHandlers.indexOf(listener);
	            eventHandlers.nextHandlers.splice(index, 1);
	
	            if (eventHandlers.nextHandlers.length === 0) {
	              // All event handlers have been removed, so we want to remove the event
	              // listener from the target node.
	
	              if (_this.target) {
	                // There can be a race condition where the target may no longer exist
	                // when this function is called, e.g. when a React component is
	                // unmounting. Guarding against this prevents the following error:
	                //
	                //   Cannot read property 'removeEventListener' of undefined
	                _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
	              }
	
	              eventHandlers.handleEvent = undefined;
	            }
	          }
	
	          return unsubscribe;
	        }();
	        return unsubscribe;
	      }
	
	      return add;
	    }()
	  }]);
	
	  return TargetEventHandlers;
	}();
	
	exports['default'] = TargetEventHandlers;

/***/ }),

/***/ 406:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	exports['default'] = CAN_USE_DOM;

/***/ }),

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = canUsePassiveEventListeners;
	
	var _canUseDOM = __webpack_require__(406);
	
	var _canUseDOM2 = _interopRequireDefault(_canUseDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Adapted from Modernizr
	// https://github.com/Modernizr/Modernizr/blob/5eea7e2a/feature-detects/dom/passiveeventlisteners.js#L26-L35
	function testPassiveEventListeners() {
	  if (!_canUseDOM2['default']) {
	    return false;
	  }
	
	  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
	    return false;
	  }
	
	  var supportsPassiveOption = false;
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function () {
	        function get() {
	          supportsPassiveOption = true;
	        }
	
	        return get;
	      }()
	    });
	    window.addEventListener('test', null, opts);
	  } catch (e) {
	    // do nothing
	  }
	
	  return supportsPassiveOption;
	}
	
	var memoized = void 0;
	
	function canUsePassiveEventListeners() {
	  if (memoized === undefined) {
	    memoized = testPassiveEventListeners();
	  }
	  return memoized;
	}

/***/ }),

/***/ 408:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = eventOptionsKey;
	/* eslint-disable no-bitwise */
	
	/**
	 * Generate a unique key for any set of event options
	 */
	function eventOptionsKey(normalizedEventOptions) {
	  if (!normalizedEventOptions) {
	    return 0;
	  }
	
	  // If the browser does not support passive event listeners, the normalized
	  // event options will be a boolean.
	  if (normalizedEventOptions === true) {
	    return 100;
	  }
	
	  // At this point, the browser supports passive event listeners, so we expect
	  // the event options to be an object with possible properties of capture,
	  // passive, and once.
	  //
	  // We want to consistently return the same value, regardless of the order of
	  // these properties, so let's use binary maths to assign each property to a
	  // bit, and then add those together (with an offset to account for the
	  // booleans at the beginning of this function).
	  var capture = normalizedEventOptions.capture << 0;
	  var passive = normalizedEventOptions.passive << 1;
	  var once = normalizedEventOptions.once << 2;
	  return capture + passive + once;
	}

/***/ }),

/***/ 90:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.EVENT_HANDLERS_KEY = undefined;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	
	var _normalizeEventOptions = __webpack_require__(409);
	
	var _normalizeEventOptions2 = _interopRequireDefault(_normalizeEventOptions);
	
	var _TargetEventHandlers = __webpack_require__(405);
	
	var _TargetEventHandlers2 = _interopRequireDefault(_TargetEventHandlers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Export to make testing possible.
	var EVENT_HANDLERS_KEY = exports.EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';
	
	function addEventListener(target, eventName, listener, options) {
	  if (!target[EVENT_HANDLERS_KEY]) {
	    // eslint-disable-next-line no-param-reassign
	    target[EVENT_HANDLERS_KEY] = new _TargetEventHandlers2['default'](target);
	  }
	  var normalizedEventOptions = (0, _normalizeEventOptions2['default'])(options);
	  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
	}
	
	// Deprecated
	function removeEventListener(unsubscribeFn) {
	  unsubscribeFn();
	}

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = normalizeEventOptions;
	
	var _canUsePassiveEventListeners = __webpack_require__(407);
	
	var _canUsePassiveEventListeners2 = _interopRequireDefault(_canUsePassiveEventListeners);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function normalizeEventOptions(eventOptions) {
	  if (!eventOptions) {
	    return undefined;
	  }
	
	  if (!(0, _canUsePassiveEventListeners2['default'])()) {
	    // If the browser does not support the passive option, then it is expecting
	    // a boolean for the options argument to specify whether it should use
	    // capture or not. In more modern browsers, this is passed via the `capture`
	    // option, so let's just hoist that value up.
	    return !!eventOptions.capture;
	  }
	
	  return eventOptions;
	}

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(135);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),

/***/ 93:
/***/ (function(module, exports) {

	'use strict';
	
	/* globals
		Set,
		Map,
		WeakSet,
		WeakMap,
	
		Promise,
	
		Symbol,
		Proxy,
	
		Atomics,
		SharedArrayBuffer,
	
		ArrayBuffer,
		DataView,
		Uint8Array,
		Float32Array,
		Float64Array,
		Int8Array,
		Int16Array,
		Int32Array,
		Uint8ClampedArray,
		Uint16Array,
		Uint32Array,
	*/
	
	var undefined; // eslint-disable-line no-shadow-restricted-names
	
	var ThrowTypeError = Object.getOwnPropertyDescriptor
		? (function () { return Object.getOwnPropertyDescriptor(arguments, 'callee').get; }())
		: function () { throw new TypeError(); };
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var generator; // = function * () {};
	var generatorFunction = generator ? getProto(generator) : undefined;
	var asyncFn; // async function() {};
	var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
	var asyncGen; // async function * () {};
	var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
	var asyncGenIterator = asyncGen ? asyncGen() : undefined;
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'$ %Array%': Array,
		'$ %ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'$ %ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
		'$ %ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'$ %ArrayPrototype%': Array.prototype,
		'$ %ArrayProto_entries%': Array.prototype.entries,
		'$ %ArrayProto_forEach%': Array.prototype.forEach,
		'$ %ArrayProto_keys%': Array.prototype.keys,
		'$ %ArrayProto_values%': Array.prototype.values,
		'$ %AsyncFromSyncIteratorPrototype%': undefined,
		'$ %AsyncFunction%': asyncFunction,
		'$ %AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
		'$ %AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
		'$ %AsyncGeneratorFunction%': asyncGenFunction,
		'$ %AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
		'$ %AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
		'$ %Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'$ %Boolean%': Boolean,
		'$ %BooleanPrototype%': Boolean.prototype,
		'$ %DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'$ %DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
		'$ %Date%': Date,
		'$ %DatePrototype%': Date.prototype,
		'$ %decodeURI%': decodeURI,
		'$ %decodeURIComponent%': decodeURIComponent,
		'$ %encodeURI%': encodeURI,
		'$ %encodeURIComponent%': encodeURIComponent,
		'$ %Error%': Error,
		'$ %ErrorPrototype%': Error.prototype,
		'$ %eval%': eval, // eslint-disable-line no-eval
		'$ %EvalError%': EvalError,
		'$ %EvalErrorPrototype%': EvalError.prototype,
		'$ %Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'$ %Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
		'$ %Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'$ %Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
		'$ %Function%': Function,
		'$ %FunctionPrototype%': Function.prototype,
		'$ %Generator%': generator ? getProto(generator()) : undefined,
		'$ %GeneratorFunction%': generatorFunction,
		'$ %GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
		'$ %Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'$ %Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
		'$ %Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'$ %Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
		'$ %Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'$ %Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
		'$ %isFinite%': isFinite,
		'$ %isNaN%': isNaN,
		'$ %IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'$ %JSON%': JSON,
		'$ %JSONParse%': JSON.parse,
		'$ %Map%': typeof Map === 'undefined' ? undefined : Map,
		'$ %MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'$ %MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
		'$ %Math%': Math,
		'$ %Number%': Number,
		'$ %NumberPrototype%': Number.prototype,
		'$ %Object%': Object,
		'$ %ObjectPrototype%': Object.prototype,
		'$ %ObjProto_toString%': Object.prototype.toString,
		'$ %ObjProto_valueOf%': Object.prototype.valueOf,
		'$ %parseFloat%': parseFloat,
		'$ %parseInt%': parseInt,
		'$ %Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'$ %PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
		'$ %PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
		'$ %Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
		'$ %Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
		'$ %Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
		'$ %Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'$ %RangeError%': RangeError,
		'$ %RangeErrorPrototype%': RangeError.prototype,
		'$ %ReferenceError%': ReferenceError,
		'$ %ReferenceErrorPrototype%': ReferenceError.prototype,
		'$ %Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'$ %RegExp%': RegExp,
		'$ %RegExpPrototype%': RegExp.prototype,
		'$ %Set%': typeof Set === 'undefined' ? undefined : Set,
		'$ %SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'$ %SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
		'$ %SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'$ %SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
		'$ %String%': String,
		'$ %StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'$ %StringPrototype%': String.prototype,
		'$ %Symbol%': hasSymbols ? Symbol : undefined,
		'$ %SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
		'$ %SyntaxError%': SyntaxError,
		'$ %SyntaxErrorPrototype%': SyntaxError.prototype,
		'$ %ThrowTypeError%': ThrowTypeError,
		'$ %TypedArray%': TypedArray,
		'$ %TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
		'$ %TypeError%': TypeError,
		'$ %TypeErrorPrototype%': TypeError.prototype,
		'$ %Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'$ %Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
		'$ %Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'$ %Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
		'$ %Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'$ %Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
		'$ %Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'$ %Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
		'$ %URIError%': URIError,
		'$ %URIErrorPrototype%': URIError.prototype,
		'$ %WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'$ %WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
		'$ %WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
		'$ %WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new TypeError('"allowMissing" argument must be a boolean');
		}
	
		var key = '$ ' + name;
		if (!(key in INTRINSICS)) {
			throw new SyntaxError('intrinsic ' + name + ' does not exist!');
		}
	
		// istanbul ignore if // hopefully this is impossible to test :-)
		if (typeof INTRINSICS[key] === 'undefined' && !allowMissing) {
			throw new TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}
		return INTRINSICS[key];
	};


/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(73);
	var toPrimitive = __webpack_require__(461);
	var keys = __webpack_require__(135);
	
	var GetIntrinsic = __webpack_require__(93);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	var $SyntaxError = GetIntrinsic('%SyntaxError%');
	var $Array = GetIntrinsic('%Array%');
	var $String = GetIntrinsic('%String%');
	var $Object = GetIntrinsic('%Object%');
	var $Number = GetIntrinsic('%Number%');
	var $Symbol = GetIntrinsic('%Symbol%', true);
	var $RegExp = GetIntrinsic('%RegExp%');
	
	var hasSymbols = !!$Symbol;
	
	var assertRecord = __webpack_require__(193);
	var $isNaN = __webpack_require__(195);
	var $isFinite = __webpack_require__(194);
	var MAX_SAFE_INTEGER = $Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	
	var assign = __webpack_require__(131);
	var sign = __webpack_require__(197);
	var mod = __webpack_require__(196);
	var isPrimitive = __webpack_require__(458);
	var parseInteger = parseInt;
	var bind = __webpack_require__(45);
	var arraySlice = bind.call(Function.call, $Array.prototype.slice);
	var strSlice = bind.call(Function.call, $String.prototype.slice);
	var isBinary = bind.call(Function.call, $RegExp.prototype.test, /^0b[01]+$/i);
	var isOctal = bind.call(Function.call, $RegExp.prototype.test, /^0o[0-7]+$/i);
	var regexExec = bind.call(Function.call, $RegExp.prototype.exec);
	var nonWS = ['\u0085', '\u200b', '\ufffe'].join('');
	var nonWSregex = new $RegExp('[' + nonWS + ']', 'g');
	var hasNonWS = bind.call(Function.call, $RegExp.prototype.test, nonWSregex);
	var invalidHexLiteral = /^[-+]0x[0-9a-f]+$/i;
	var isInvalidHexLiteral = bind.call(Function.call, $RegExp.prototype.test, invalidHexLiteral);
	var $charCodeAt = bind.call(Function.call, $String.prototype.charCodeAt);
	
	var toStr = bind.call(Function.call, Object.prototype.toString);
	
	var $NumberValueOf = bind.call(Function.call, GetIntrinsic('%NumberPrototype%').valueOf);
	var $BooleanValueOf = bind.call(Function.call, GetIntrinsic('%BooleanPrototype%').valueOf);
	var $StringValueOf = bind.call(Function.call, GetIntrinsic('%StringPrototype%').valueOf);
	var $DateValueOf = bind.call(Function.call, GetIntrinsic('%DatePrototype%').valueOf);
	
	var $floor = Math.floor;
	var $abs = Math.abs;
	
	var $ObjectCreate = Object.create;
	var $gOPD = $Object.getOwnPropertyDescriptor;
	
	var $isExtensible = $Object.isExtensible;
	
	var $defineProperty = $Object.defineProperty;
	
	// whitespace from: http://es5.github.io/#x15.5.4.20
	// implementation from https://github.com/es-shims/es5-shim/blob/v3.4.0/es5-shim.js#L1304-L1324
	var ws = [
		'\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003',
		'\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028',
		'\u2029\uFEFF'
	].join('');
	var trimRegex = new RegExp('(^[' + ws + ']+)|([' + ws + ']+$)', 'g');
	var replace = bind.call(Function.call, $String.prototype.replace);
	var trim = function (value) {
		return replace(value, trimRegex, '');
	};
	
	var ES5 = __webpack_require__(455);
	
	var hasRegExpMatcher = __webpack_require__(489);
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-abstract-operations
	var ES6 = assign(assign({}, ES5), {
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-call-f-v-args
		Call: function Call(F, V) {
			var args = arguments.length > 2 ? arguments[2] : [];
			if (!this.IsCallable(F)) {
				throw new $TypeError(F + ' is not a function');
			}
			return F.apply(V, args);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toprimitive
		ToPrimitive: toPrimitive,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toboolean
		// ToBoolean: ES5.ToBoolean,
	
		// https://ecma-international.org/ecma-262/6.0/#sec-tonumber
		ToNumber: function ToNumber(argument) {
			var value = isPrimitive(argument) ? argument : toPrimitive(argument, $Number);
			if (typeof value === 'symbol') {
				throw new $TypeError('Cannot convert a Symbol value to a number');
			}
			if (typeof value === 'string') {
				if (isBinary(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 2));
				} else if (isOctal(value)) {
					return this.ToNumber(parseInteger(strSlice(value, 2), 8));
				} else if (hasNonWS(value) || isInvalidHexLiteral(value)) {
					return NaN;
				} else {
					var trimmed = trim(value);
					if (trimmed !== value) {
						return this.ToNumber(trimmed);
					}
				}
			}
			return $Number(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tointeger
		// ToInteger: ES5.ToNumber,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint32
		// ToInt32: ES5.ToInt32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint32
		// ToUint32: ES5.ToUint32,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint16
		ToInt16: function ToInt16(argument) {
			var int16bit = this.ToUint16(argument);
			return int16bit >= 0x8000 ? int16bit - 0x10000 : int16bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint16
		// ToUint16: ES5.ToUint16,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toint8
		ToInt8: function ToInt8(argument) {
			var int8bit = this.ToUint8(argument);
			return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8
		ToUint8: function ToUint8(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * $floor($abs(number));
			return mod(posInt, 0x100);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-touint8clamp
		ToUint8Clamp: function ToUint8Clamp(argument) {
			var number = this.ToNumber(argument);
			if ($isNaN(number) || number <= 0) { return 0; }
			if (number >= 0xFF) { return 0xFF; }
			var f = $floor(argument);
			if (f + 0.5 < number) { return f + 1; }
			if (number < f + 0.5) { return f; }
			if (f % 2 !== 0) { return f + 1; }
			return f;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tostring
		ToString: function ToString(argument) {
			if (typeof argument === 'symbol') {
				throw new $TypeError('Cannot convert a Symbol value to a string');
			}
			return $String(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-toobject
		ToObject: function ToObject(value) {
			this.RequireObjectCoercible(value);
			return $Object(value);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-topropertykey
		ToPropertyKey: function ToPropertyKey(argument) {
			var key = this.ToPrimitive(argument, $String);
			return typeof key === 'symbol' ? key : this.ToString(key);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
		ToLength: function ToLength(argument) {
			var len = this.ToInteger(argument);
			if (len <= 0) { return 0; } // includes converting -0 to +0
			if (len > MAX_SAFE_INTEGER) { return MAX_SAFE_INTEGER; }
			return len;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-canonicalnumericindexstring
		CanonicalNumericIndexString: function CanonicalNumericIndexString(argument) {
			if (toStr(argument) !== '[object String]') {
				throw new $TypeError('must be a string');
			}
			if (argument === '-0') { return -0; }
			var n = this.ToNumber(argument);
			if (this.SameValue(this.ToString(n), argument)) { return n; }
			return void 0;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-requireobjectcoercible
		RequireObjectCoercible: ES5.CheckObjectCoercible,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isarray
		IsArray: $Array.isArray || function IsArray(argument) {
			return toStr(argument) === '[object Array]';
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-iscallable
		// IsCallable: ES5.IsCallable,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isconstructor
		IsConstructor: function IsConstructor(argument) {
			return typeof argument === 'function' && !!argument.prototype; // unfortunately there's no way to truly check this without try/catch `new argument`
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isextensible-o
		IsExtensible: Object.preventExtensions
			? function IsExtensible(obj) {
				if (isPrimitive(obj)) {
					return false;
				}
				return $isExtensible(obj);
			}
			: function isExtensible(obj) { return true; }, // eslint-disable-line no-unused-vars
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-isinteger
		IsInteger: function IsInteger(argument) {
			if (typeof argument !== 'number' || $isNaN(argument) || !$isFinite(argument)) {
				return false;
			}
			var abs = $abs(argument);
			return $floor(abs) === abs;
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-ispropertykey
		IsPropertyKey: function IsPropertyKey(argument) {
			return typeof argument === 'string' || typeof argument === 'symbol';
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-isregexp
		IsRegExp: function IsRegExp(argument) {
			if (!argument || typeof argument !== 'object') {
				return false;
			}
			if (hasSymbols) {
				var isRegExp = argument[$Symbol.match];
				if (typeof isRegExp !== 'undefined') {
					return ES5.ToBoolean(isRegExp);
				}
			}
			return hasRegExpMatcher(argument);
		},
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevalue
		// SameValue: ES5.SameValue,
	
		// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-samevaluezero
		SameValueZero: function SameValueZero(x, y) {
			return (x === y) || ($isNaN(x) && $isNaN(y));
		},
	
		/**
		 * 7.3.2 GetV (V, P)
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let O be ToObject(V).
		 * 3. ReturnIfAbrupt(O).
		 * 4. Return O.[[Get]](P, V).
		 */
		GetV: function GetV(V, P) {
			// 7.3.2.1
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.2.2-3
			var O = this.ToObject(V);
	
			// 7.3.2.4
			return O[P];
		},
	
		/**
		 * 7.3.9 - https://ecma-international.org/ecma-262/6.0/#sec-getmethod
		 * 1. Assert: IsPropertyKey(P) is true.
		 * 2. Let func be GetV(O, P).
		 * 3. ReturnIfAbrupt(func).
		 * 4. If func is either undefined or null, return undefined.
		 * 5. If IsCallable(func) is false, throw a TypeError exception.
		 * 6. Return func.
		 */
		GetMethod: function GetMethod(O, P) {
			// 7.3.9.1
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			// 7.3.9.2
			var func = this.GetV(O, P);
	
			// 7.3.9.4
			if (func == null) {
				return void 0;
			}
	
			// 7.3.9.5
			if (!this.IsCallable(func)) {
				throw new $TypeError(P + 'is not a function');
			}
	
			// 7.3.9.6
			return func;
		},
	
		/**
		 * 7.3.1 Get (O, P) - https://ecma-international.org/ecma-262/6.0/#sec-get-o-p
		 * 1. Assert: Type(O) is Object.
		 * 2. Assert: IsPropertyKey(P) is true.
		 * 3. Return O.[[Get]](P, O).
		 */
		Get: function Get(O, P) {
			// 7.3.1.1
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			// 7.3.1.2
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			// 7.3.1.3
			return O[P];
		},
	
		Type: function Type(x) {
			if (typeof x === 'symbol') {
				return 'Symbol';
			}
			return ES5.Type(x);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-speciesconstructor
		SpeciesConstructor: function SpeciesConstructor(O, defaultConstructor) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			var C = O.constructor;
			if (typeof C === 'undefined') {
				return defaultConstructor;
			}
			if (this.Type(C) !== 'Object') {
				throw new $TypeError('O.constructor is not an Object');
			}
			var S = hasSymbols && $Symbol.species ? C[$Symbol.species] : void 0;
			if (S == null) {
				return defaultConstructor;
			}
			if (this.IsConstructor(S)) {
				return S;
			}
			throw new $TypeError('no constructor found');
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-completepropertydescriptor
		CompletePropertyDescriptor: function CompletePropertyDescriptor(Desc) {
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (this.IsGenericDescriptor(Desc) || this.IsDataDescriptor(Desc)) {
				if (!has(Desc, '[[Value]]')) {
					Desc['[[Value]]'] = void 0;
				}
				if (!has(Desc, '[[Writable]]')) {
					Desc['[[Writable]]'] = false;
				}
			} else {
				if (!has(Desc, '[[Get]]')) {
					Desc['[[Get]]'] = void 0;
				}
				if (!has(Desc, '[[Set]]')) {
					Desc['[[Set]]'] = void 0;
				}
			}
			if (!has(Desc, '[[Enumerable]]')) {
				Desc['[[Enumerable]]'] = false;
			}
			if (!has(Desc, '[[Configurable]]')) {
				Desc['[[Configurable]]'] = false;
			}
			return Desc;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-set-o-p-v-throw
		Set: function Set(O, P, V, Throw) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			if (this.Type(Throw) !== 'Boolean') {
				throw new $TypeError('Throw must be a Boolean');
			}
			if (Throw) {
				O[P] = V;
				return true;
			} else {
				try {
					O[P] = V;
				} catch (e) {
					return false;
				}
			}
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-hasownproperty
		HasOwnProperty: function HasOwnProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			return has(O, P);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-hasproperty
		HasProperty: function HasProperty(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('O must be an Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			return P in O;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-isconcatspreadable
		IsConcatSpreadable: function IsConcatSpreadable(O) {
			if (this.Type(O) !== 'Object') {
				return false;
			}
			if (hasSymbols && typeof $Symbol.isConcatSpreadable === 'symbol') {
				var spreadable = this.Get(O, Symbol.isConcatSpreadable);
				if (typeof spreadable !== 'undefined') {
					return this.ToBoolean(spreadable);
				}
			}
			return this.IsArray(O);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-invoke
		Invoke: function Invoke(O, P) {
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('P must be a Property Key');
			}
			var argumentsList = arraySlice(arguments, 2);
			var func = this.GetV(O, P);
			return this.Call(func, O, argumentsList);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-getiterator
		GetIterator: function GetIterator(obj, method) {
			if (!hasSymbols) {
				throw new SyntaxError('ES.GetIterator depends on native iterator support.');
			}
	
			var actualMethod = method;
			if (arguments.length < 2) {
				actualMethod = this.GetMethod(obj, $Symbol.iterator);
			}
			var iterator = this.Call(actualMethod, obj);
			if (this.Type(iterator) !== 'Object') {
				throw new $TypeError('iterator must return an object');
			}
	
			return iterator;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratornext
		IteratorNext: function IteratorNext(iterator, value) {
			var result = this.Invoke(iterator, 'next', arguments.length < 2 ? [] : [value]);
			if (this.Type(result) !== 'Object') {
				throw new $TypeError('iterator next must return an object');
			}
			return result;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorcomplete
		IteratorComplete: function IteratorComplete(iterResult) {
			if (this.Type(iterResult) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
			}
			return this.ToBoolean(this.Get(iterResult, 'done'));
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorvalue
		IteratorValue: function IteratorValue(iterResult) {
			if (this.Type(iterResult) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(iterResult) is not Object');
			}
			return this.Get(iterResult, 'value');
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorstep
		IteratorStep: function IteratorStep(iterator) {
			var result = this.IteratorNext(iterator);
			var done = this.IteratorComplete(result);
			return done === true ? false : result;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-iteratorclose
		IteratorClose: function IteratorClose(iterator, completion) {
			if (this.Type(iterator) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(iterator) is not Object');
			}
			if (!this.IsCallable(completion)) {
				throw new $TypeError('Assertion failed: completion is not a thunk for a Completion Record');
			}
			var completionThunk = completion;
	
			var iteratorReturn = this.GetMethod(iterator, 'return');
	
			if (typeof iteratorReturn === 'undefined') {
				return completionThunk();
			}
	
			var completionRecord;
			try {
				var innerResult = this.Call(iteratorReturn, iterator, []);
			} catch (e) {
				// if we hit here, then "e" is the innerResult completion that needs re-throwing
	
				// if the completion is of type "throw", this will throw.
				completionRecord = completionThunk();
				completionThunk = null; // ensure it's not called twice.
	
				// if not, then return the innerResult completion
				throw e;
			}
			completionRecord = completionThunk(); // if innerResult worked, then throw if the completion does
			completionThunk = null; // ensure it's not called twice.
	
			if (this.Type(innerResult) !== 'Object') {
				throw new $TypeError('iterator .return must return an object');
			}
	
			return completionRecord;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-createiterresultobject
		CreateIterResultObject: function CreateIterResultObject(value, done) {
			if (this.Type(done) !== 'Boolean') {
				throw new $TypeError('Assertion failed: Type(done) is not Boolean');
			}
			return {
				value: value,
				done: done
			};
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-regexpexec
		RegExpExec: function RegExpExec(R, S) {
			if (this.Type(R) !== 'Object') {
				throw new $TypeError('R must be an Object');
			}
			if (this.Type(S) !== 'String') {
				throw new $TypeError('S must be a String');
			}
			var exec = this.Get(R, 'exec');
			if (this.IsCallable(exec)) {
				var result = this.Call(exec, R, [S]);
				if (result === null || this.Type(result) === 'Object') {
					return result;
				}
				throw new $TypeError('"exec" method must return `null` or an Object');
			}
			return regexExec(R, S);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-arrayspeciescreate
		ArraySpeciesCreate: function ArraySpeciesCreate(originalArray, length) {
			if (!this.IsInteger(length) || length < 0) {
				throw new $TypeError('Assertion failed: length must be an integer >= 0');
			}
			var len = length === 0 ? 0 : length;
			var C;
			var isArray = this.IsArray(originalArray);
			if (isArray) {
				C = this.Get(originalArray, 'constructor');
				// TODO: figure out how to make a cross-realm normal Array, a same-realm Array
				// if (this.IsConstructor(C)) {
				// 	if C is another realm's Array, C = undefined
				// 	Object.getPrototypeOf(Object.getPrototypeOf(Object.getPrototypeOf(Array))) === null ?
				// }
				if (this.Type(C) === 'Object' && hasSymbols && $Symbol.species) {
					C = this.Get(C, $Symbol.species);
					if (C === null) {
						C = void 0;
					}
				}
			}
			if (typeof C === 'undefined') {
				return $Array(len);
			}
			if (!this.IsConstructor(C)) {
				throw new $TypeError('C must be a constructor');
			}
			return new C(len); // this.Construct(C, len);
		},
	
		CreateDataProperty: function CreateDataProperty(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var oldDesc = $gOPD(O, P);
			var extensible = oldDesc || (typeof $isExtensible !== 'function' || $isExtensible(O));
			var immutable = oldDesc && (!oldDesc.writable || !oldDesc.configurable);
			if (immutable || !extensible) {
				return false;
			}
			var newDesc = {
				configurable: true,
				enumerable: true,
				value: V,
				writable: true
			};
			$defineProperty(O, P, newDesc);
			return true;
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-createdatapropertyorthrow
		CreateDataPropertyOrThrow: function CreateDataPropertyOrThrow(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
			var success = this.CreateDataProperty(O, P, V);
			if (!success) {
				throw new $TypeError('unable to create data property');
			}
			return success;
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-objectcreate
		ObjectCreate: function ObjectCreate(proto, internalSlotsList) {
			if (proto !== null && this.Type(proto) !== 'Object') {
				throw new $TypeError('Assertion failed: proto must be null or an object');
			}
			var slots = arguments.length < 2 ? [] : internalSlotsList;
			if (slots.length > 0) {
				throw new $SyntaxError('es-abstract does not yet support internal slots');
			}
	
			if (proto === null && !$ObjectCreate) {
				throw new $SyntaxError('native Object.create support is required to create null objects');
			}
	
			return $ObjectCreate(proto);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-advancestringindex
		AdvanceStringIndex: function AdvanceStringIndex(S, index, unicode) {
			if (this.Type(S) !== 'String') {
				throw new $TypeError('S must be a String');
			}
			if (!this.IsInteger(index) || index < 0 || index > MAX_SAFE_INTEGER) {
				throw new $TypeError('Assertion failed: length must be an integer >= 0 and <= 2**53');
			}
			if (this.Type(unicode) !== 'Boolean') {
				throw new $TypeError('Assertion failed: unicode must be a Boolean');
			}
			if (!unicode) {
				return index + 1;
			}
			var length = S.length;
			if ((index + 1) >= length) {
				return index + 1;
			}
	
			var first = $charCodeAt(S, index);
			if (first < 0xD800 || first > 0xDBFF) {
				return index + 1;
			}
	
			var second = $charCodeAt(S, index + 1);
			if (second < 0xDC00 || second > 0xDFFF) {
				return index + 1;
			}
	
			return index + 2;
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-createmethodproperty
		CreateMethodProperty: function CreateMethodProperty(O, P, V) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
	
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			var newDesc = {
				configurable: true,
				enumerable: false,
				value: V,
				writable: true
			};
			return !!$defineProperty(O, P, newDesc);
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-definepropertyorthrow
		DefinePropertyOrThrow: function DefinePropertyOrThrow(O, P, desc) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
	
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			return !!$defineProperty(O, P, desc);
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-deletepropertyorthrow
		DeletePropertyOrThrow: function DeletePropertyOrThrow(O, P) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
	
			if (!this.IsPropertyKey(P)) {
				throw new $TypeError('Assertion failed: IsPropertyKey(P) is not true');
			}
	
			var success = delete O[P];
			if (!success) {
				throw new TypeError('Attempt to delete property failed.');
			}
			return success;
		},
	
		// https://www.ecma-international.org/ecma-262/6.0/#sec-enumerableownnames
		EnumerableOwnNames: function EnumerableOwnNames(O) {
			if (this.Type(O) !== 'Object') {
				throw new $TypeError('Assertion failed: Type(O) is not Object');
			}
	
			return keys(O);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-number-prototype-object
		thisNumberValue: function thisNumberValue(value) {
			if (this.Type(value) === 'Number') {
				return value;
			}
	
			return $NumberValueOf(value);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-boolean-prototype-object
		thisBooleanValue: function thisBooleanValue(value) {
			if (this.Type(value) === 'Boolean') {
				return value;
			}
	
			return $BooleanValueOf(value);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-string-prototype-object
		thisStringValue: function thisStringValue(value) {
			if (this.Type(value) === 'String') {
				return value;
			}
	
			return $StringValueOf(value);
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-date-prototype-object
		thisTimeValue: function thisTimeValue(value) {
			return $DateValueOf(value);
		}
	});
	
	delete ES6.CheckObjectCoercible; // renamed in ES6 to RequireObjectCoercible
	
	module.exports = ES6;


/***/ }),

/***/ 192:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES2015 = __webpack_require__(453);
	var assign = __webpack_require__(131);
	
	var ES2016 = assign(assign({}, ES2015), {
		// https://github.com/tc39/ecma262/pull/60
		SameValueNonNumber: function SameValueNonNumber(x, y) {
			if (typeof x === 'number' || typeof x !== typeof y) {
				throw new TypeError('SameValueNonNumber requires two non-number values of the same type.');
			}
			return this.SameValue(x, y);
		}
	});
	
	module.exports = ES2016;


/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(45);
	
	var ES2016 = __webpack_require__(192);
	var assign = __webpack_require__(131);
	var forEach = __webpack_require__(457);
	
	var GetIntrinsic = __webpack_require__(93);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	var $isEnumerable = bind.call(Function.call, GetIntrinsic('%ObjectPrototype%').propertyIsEnumerable);
	var $pushApply = bind.call(Function.apply, GetIntrinsic('%ArrayPrototype%').push);
	
	var ES2017 = assign(assign({}, ES2016), {
		ToIndex: function ToIndex(value) {
			if (typeof value === 'undefined') {
				return 0;
			}
			var integerIndex = this.ToInteger(value);
			if (integerIndex < 0) {
				throw new RangeError('index must be >= 0');
			}
			var index = this.ToLength(integerIndex);
			if (!this.SameValueZero(integerIndex, index)) {
				throw new RangeError('index must be >= 0 and < 2 ** 53 - 1');
			}
			return index;
		},
	
		// https://www.ecma-international.org/ecma-262/8.0/#sec-enumerableownproperties
		EnumerableOwnProperties: function EnumerableOwnProperties(O, kind) {
			var keys = ES2016.EnumerableOwnNames(O);
			if (kind === 'key') {
				return keys;
			}
			if (kind === 'value' || kind === 'key+value') {
				var results = [];
				forEach(keys, function (key) {
					if ($isEnumerable(O, key)) {
						$pushApply(results, [
							kind === 'value' ? O[key] : [key, O[key]]
						]);
					}
				});
				return results;
			}
			throw new $TypeError('Assertion failed: "kind" is not "key", "value", or "key+value": ' + kind);
		}
	});
	
	delete ES2017.EnumerableOwnNames; // replaced with EnumerableOwnProperties
	
	module.exports = ES2017;


/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(93);
	
	var $Object = GetIntrinsic('%Object%');
	var $TypeError = GetIntrinsic('%TypeError%');
	var $String = GetIntrinsic('%String%');
	
	var assertRecord = __webpack_require__(193);
	var $isNaN = __webpack_require__(195);
	var $isFinite = __webpack_require__(194);
	
	var sign = __webpack_require__(197);
	var mod = __webpack_require__(196);
	
	var IsCallable = __webpack_require__(132);
	var toPrimitive = __webpack_require__(460);
	
	var has = __webpack_require__(73);
	
	// https://es5.github.io/#x9
	var ES5 = {
		ToPrimitive: toPrimitive,
	
		ToBoolean: function ToBoolean(value) {
			return !!value;
		},
		ToNumber: function ToNumber(value) {
			return +value; // eslint-disable-line no-implicit-coercion
		},
		ToInteger: function ToInteger(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number)) { return 0; }
			if (number === 0 || !$isFinite(number)) { return number; }
			return sign(number) * Math.floor(Math.abs(number));
		},
		ToInt32: function ToInt32(x) {
			return this.ToNumber(x) >> 0;
		},
		ToUint32: function ToUint32(x) {
			return this.ToNumber(x) >>> 0;
		},
		ToUint16: function ToUint16(value) {
			var number = this.ToNumber(value);
			if ($isNaN(number) || number === 0 || !$isFinite(number)) { return 0; }
			var posInt = sign(number) * Math.floor(Math.abs(number));
			return mod(posInt, 0x10000);
		},
		ToString: function ToString(value) {
			return $String(value);
		},
		ToObject: function ToObject(value) {
			this.CheckObjectCoercible(value);
			return $Object(value);
		},
		CheckObjectCoercible: function CheckObjectCoercible(value, optMessage) {
			/* jshint eqnull:true */
			if (value == null) {
				throw new $TypeError(optMessage || 'Cannot call method on ' + value);
			}
			return value;
		},
		IsCallable: IsCallable,
		SameValue: function SameValue(x, y) {
			if (x === y) { // 0 === -0, but they are not identical.
				if (x === 0) { return 1 / x === 1 / y; }
				return true;
			}
			return $isNaN(x) && $isNaN(y);
		},
	
		// https://www.ecma-international.org/ecma-262/5.1/#sec-8
		Type: function Type(x) {
			if (x === null) {
				return 'Null';
			}
			if (typeof x === 'undefined') {
				return 'Undefined';
			}
			if (typeof x === 'function' || typeof x === 'object') {
				return 'Object';
			}
			if (typeof x === 'number') {
				return 'Number';
			}
			if (typeof x === 'boolean') {
				return 'Boolean';
			}
			if (typeof x === 'string') {
				return 'String';
			}
		},
	
		// https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
		IsPropertyDescriptor: function IsPropertyDescriptor(Desc) {
			if (this.Type(Desc) !== 'Object') {
				return false;
			}
			var allowed = {
				'[[Configurable]]': true,
				'[[Enumerable]]': true,
				'[[Get]]': true,
				'[[Set]]': true,
				'[[Value]]': true,
				'[[Writable]]': true
			};
	
			for (var key in Desc) { // eslint-disable-line
				if (has(Desc, key) && !allowed[key]) {
					return false;
				}
			}
	
			var isData = has(Desc, '[[Value]]');
			var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
			if (isData && IsAccessor) {
				throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
			}
			return true;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.1
		IsAccessorDescriptor: function IsAccessorDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (!has(Desc, '[[Get]]') && !has(Desc, '[[Set]]')) {
				return false;
			}
	
			return true;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.2
		IsDataDescriptor: function IsDataDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (!has(Desc, '[[Value]]') && !has(Desc, '[[Writable]]')) {
				return false;
			}
	
			return true;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.3
		IsGenericDescriptor: function IsGenericDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return false;
			}
	
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (!this.IsAccessorDescriptor(Desc) && !this.IsDataDescriptor(Desc)) {
				return true;
			}
	
			return false;
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.4
		FromPropertyDescriptor: function FromPropertyDescriptor(Desc) {
			if (typeof Desc === 'undefined') {
				return Desc;
			}
	
			assertRecord(this, 'Property Descriptor', 'Desc', Desc);
	
			if (this.IsDataDescriptor(Desc)) {
				return {
					value: Desc['[[Value]]'],
					writable: !!Desc['[[Writable]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else if (this.IsAccessorDescriptor(Desc)) {
				return {
					get: Desc['[[Get]]'],
					set: Desc['[[Set]]'],
					enumerable: !!Desc['[[Enumerable]]'],
					configurable: !!Desc['[[Configurable]]']
				};
			} else {
				throw new $TypeError('FromPropertyDescriptor must be called with a fully populated Property Descriptor');
			}
		},
	
		// https://ecma-international.org/ecma-262/5.1/#sec-8.10.5
		ToPropertyDescriptor: function ToPropertyDescriptor(Obj) {
			if (this.Type(Obj) !== 'Object') {
				throw new $TypeError('ToPropertyDescriptor requires an object');
			}
	
			var desc = {};
			if (has(Obj, 'enumerable')) {
				desc['[[Enumerable]]'] = this.ToBoolean(Obj.enumerable);
			}
			if (has(Obj, 'configurable')) {
				desc['[[Configurable]]'] = this.ToBoolean(Obj.configurable);
			}
			if (has(Obj, 'value')) {
				desc['[[Value]]'] = Obj.value;
			}
			if (has(Obj, 'writable')) {
				desc['[[Writable]]'] = this.ToBoolean(Obj.writable);
			}
			if (has(Obj, 'get')) {
				var getter = Obj.get;
				if (typeof getter !== 'undefined' && !this.IsCallable(getter)) {
					throw new TypeError('getter must be a function');
				}
				desc['[[Get]]'] = getter;
			}
			if (has(Obj, 'set')) {
				var setter = Obj.set;
				if (typeof setter !== 'undefined' && !this.IsCallable(setter)) {
					throw new $TypeError('setter must be a function');
				}
				desc['[[Set]]'] = setter;
			}
	
			if ((has(desc, '[[Get]]') || has(desc, '[[Set]]')) && (has(desc, '[[Value]]') || has(desc, '[[Writable]]'))) {
				throw new $TypeError('Invalid property descriptor. Cannot both specify accessors and a value or writable attribute');
			}
			return desc;
		}
	};
	
	module.exports = ES5;


/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(192);


/***/ }),

/***/ 193:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(93);
	
	var $TypeError = GetIntrinsic('%TypeError%');
	var $SyntaxError = GetIntrinsic('%SyntaxError%');
	
	var has = __webpack_require__(73);
	
	var predicates = {
	  // https://ecma-international.org/ecma-262/6.0/#sec-property-descriptor-specification-type
	  'Property Descriptor': function isPropertyDescriptor(ES, Desc) {
	    if (ES.Type(Desc) !== 'Object') {
	      return false;
	    }
	    var allowed = {
	      '[[Configurable]]': true,
	      '[[Enumerable]]': true,
	      '[[Get]]': true,
	      '[[Set]]': true,
	      '[[Value]]': true,
	      '[[Writable]]': true
	    };
	
	    for (var key in Desc) { // eslint-disable-line
	      if (has(Desc, key) && !allowed[key]) {
	        return false;
	      }
	    }
	
	    var isData = has(Desc, '[[Value]]');
	    var IsAccessor = has(Desc, '[[Get]]') || has(Desc, '[[Set]]');
	    if (isData && IsAccessor) {
	      throw new $TypeError('Property Descriptors may not be both accessor and data descriptors');
	    }
	    return true;
	  }
	};
	
	module.exports = function assertRecord(ES, recordType, argumentName, value) {
	  var predicate = predicates[recordType];
	  if (typeof predicate !== 'function') {
	    throw new $SyntaxError('unknown record type: ' + recordType);
	  }
	  if (!predicate(ES, value)) {
	    throw new $TypeError(argumentName + ' must be a ' + recordType);
	  }
	  console.log(predicate(ES, value), value);
	};


/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	var bind = __webpack_require__(45);
	var has = bind.call(Function.call, Object.prototype.hasOwnProperty);
	
	var $assign = Object.assign;
	
	module.exports = function assign(target, source) {
		if ($assign) {
			return $assign(target, source);
		}
	
		for (var key in source) {
			if (has(source, key)) {
				target[key] = source[key];
			}
		}
		return target;
	};


/***/ }),

/***/ 457:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function forEach(array, callback) {
		for (var i = 0; i < array.length; i += 1) {
			callback(array[i], i, array);
		}
	};


/***/ }),

/***/ 194:
/***/ (function(module, exports) {

	var $isNaN = Number.isNaN || function (a) { return a !== a; };
	
	module.exports = Number.isFinite || function (x) { return typeof x === 'number' && !$isNaN(x) && x !== Infinity && x !== -Infinity; };


/***/ }),

/***/ 195:
/***/ (function(module, exports) {

	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ }),

/***/ 458:
/***/ (function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ }),

/***/ 196:
/***/ (function(module, exports) {

	module.exports = function mod(number, modulo) {
		var remain = number % modulo;
		return Math.floor(remain >= 0 ? remain : remain + modulo);
	};


/***/ }),

/***/ 197:
/***/ (function(module, exports) {

	module.exports = function sign(number) {
		return number >= 0 ? 1 : -1;
	};


/***/ }),

/***/ 459:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol';
	
	var isPrimitive = __webpack_require__(198);
	var isCallable = __webpack_require__(132);
	var isDate = __webpack_require__(488);
	var isSymbol = __webpack_require__(207);
	
	var ordinaryToPrimitive = function OrdinaryToPrimitive(O, hint) {
		if (typeof O === 'undefined' || O === null) {
			throw new TypeError('Cannot call method on ' + O);
		}
		if (typeof hint !== 'string' || (hint !== 'number' && hint !== 'string')) {
			throw new TypeError('hint must be "string" or "number"');
		}
		var methodNames = hint === 'string' ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
		var method, result, i;
		for (i = 0; i < methodNames.length; ++i) {
			method = O[methodNames[i]];
			if (isCallable(method)) {
				result = method.call(O);
				if (isPrimitive(result)) {
					return result;
				}
			}
		}
		throw new TypeError('No default value');
	};
	
	var GetMethod = function GetMethod(O, P) {
		var func = O[P];
		if (func !== null && typeof func !== 'undefined') {
			if (!isCallable(func)) {
				throw new TypeError(func + ' returned for property ' + P + ' of object ' + O + ' is not a function');
			}
			return func;
		}
		return void 0;
	};
	
	// http://www.ecma-international.org/ecma-262/6.0/#sec-toprimitive
	module.exports = function ToPrimitive(input) {
		if (isPrimitive(input)) {
			return input;
		}
		var hint = 'default';
		if (arguments.length > 1) {
			if (arguments[1] === String) {
				hint = 'string';
			} else if (arguments[1] === Number) {
				hint = 'number';
			}
		}
	
		var exoticToPrim;
		if (hasSymbols) {
			if (Symbol.toPrimitive) {
				exoticToPrim = GetMethod(input, Symbol.toPrimitive);
			} else if (isSymbol(input)) {
				exoticToPrim = Symbol.prototype.valueOf;
			}
		}
		if (typeof exoticToPrim !== 'undefined') {
			var result = exoticToPrim.call(input, hint);
			if (isPrimitive(result)) {
				return result;
			}
			throw new TypeError('unable to convert exotic object to primitive');
		}
		if (hint === 'default' && (isDate(input) || isSymbol(input))) {
			hint = 'string';
		}
		return ordinaryToPrimitive(input, hint === 'default' ? 'number' : hint);
	};


/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	var isPrimitive = __webpack_require__(198);
	
	var isCallable = __webpack_require__(132);
	
	// http://ecma-international.org/ecma-262/5.1/#sec-8.12.8
	var ES5internalSlots = {
		'[[DefaultValue]]': function (O) {
			var actualHint;
			if (arguments.length > 1) {
				actualHint = arguments[1];
			} else {
				actualHint = toStr.call(O) === '[object Date]' ? String : Number;
			}
	
			if (actualHint === String || actualHint === Number) {
				var methods = actualHint === String ? ['toString', 'valueOf'] : ['valueOf', 'toString'];
				var value, i;
				for (i = 0; i < methods.length; ++i) {
					if (isCallable(O[methods[i]])) {
						value = O[methods[i]]();
						if (isPrimitive(value)) {
							return value;
						}
					}
				}
				throw new TypeError('No default value');
			}
			throw new TypeError('invalid [[DefaultValue]] hint supplied');
		}
	};
	
	// http://ecma-international.org/ecma-262/5.1/#sec-9.1
	module.exports = function ToPrimitive(input) {
		if (isPrimitive(input)) {
			return input;
		}
		if (arguments.length > 1) {
			return ES5internalSlots['[[DefaultValue]]'](input, arguments[1]);
		}
		return ES5internalSlots['[[DefaultValue]]'](input);
	};


/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(459);


/***/ }),

/***/ 198:
/***/ (function(module, exports) {

	module.exports = function isPrimitive(value) {
		return value === null || (typeof value !== 'function' && typeof value !== 'object');
	};


/***/ }),

/***/ 204:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2);
	var createFocusTrap = __webpack_require__(205);
	
	var checkedProps = ['active', 'paused', 'tag', 'focusTrapOptions', '_createFocusTrap'];
	
	var FocusTrap = function (_React$Component) {
	  _inherits(FocusTrap, _React$Component);
	
	  function FocusTrap(props) {
	    _classCallCheck(this, FocusTrap);
	
	    var _this = _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).call(this, props));
	
	    _this.setNode = function (el) {
	      _this.node = el;
	    };
	
	    if (typeof document !== 'undefined') {
	      _this.previouslyFocusedElement = document.activeElement;
	    }
	    return _this;
	  }
	
	  _createClass(FocusTrap, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // We need to hijack the returnFocusOnDeactivate option,
	      // because React can move focus into the element before we arrived at
	      // this lifecycle hook (e.g. with autoFocus inputs). So the component
	      // captures the previouslyFocusedElement in componentWillMount,
	      // then (optionally) returns focus to it in componentWillUnmount.
	      var specifiedFocusTrapOptions = this.props.focusTrapOptions;
	      var tailoredFocusTrapOptions = {
	        returnFocusOnDeactivate: false
	      };
	      for (var optionName in specifiedFocusTrapOptions) {
	        if (!specifiedFocusTrapOptions.hasOwnProperty(optionName)) continue;
	        if (optionName === 'returnFocusOnDeactivate') continue;
	        tailoredFocusTrapOptions[optionName] = specifiedFocusTrapOptions[optionName];
	      }
	
	      this.focusTrap = this.props._createFocusTrap(this.node, tailoredFocusTrapOptions);
	      if (this.props.active) {
	        this.focusTrap.activate();
	      }
	      if (this.props.paused) {
	        this.focusTrap.pause();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.active && !this.props.active) {
	        var returnFocusOnDeactivate = this.props.focusTrapOptions.returnFocusOnDeactivate;
	
	        var returnFocus = returnFocusOnDeactivate || false;
	        var config = { returnFocus: returnFocus };
	        this.focusTrap.deactivate(config);
	      } else if (!prevProps.active && this.props.active) {
	        this.focusTrap.activate();
	      }
	
	      if (prevProps.paused && !this.props.paused) {
	        this.focusTrap.unpause();
	      } else if (!prevProps.paused && this.props.paused) {
	        this.focusTrap.pause();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.focusTrap.deactivate();
	      if (this.props.focusTrapOptions.returnFocusOnDeactivate !== false && this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
	        this.previouslyFocusedElement.focus();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var elementProps = {
	        ref: this.setNode
	      };
	
	      // This will get id, className, style, etc. -- arbitrary element props
	      for (var prop in this.props) {
	        if (!this.props.hasOwnProperty(prop)) continue;
	        if (checkedProps.indexOf(prop) !== -1) continue;
	        elementProps[prop] = this.props[prop];
	      }
	
	      return React.createElement(this.props.tag, elementProps, this.props.children);
	    }
	  }]);
	
	  return FocusTrap;
	}(React.Component);
	
	FocusTrap.defaultProps = {
	  active: true,
	  tag: 'div',
	  paused: false,
	  focusTrapOptions: {},
	  _createFocusTrap: createFocusTrap
	};
	
	module.exports = FocusTrap;

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	var tabbable = __webpack_require__(267);
	var xtend = __webpack_require__(268);
	
	var listeningFocusTrap = null;
	
	function focusTrap(element, userOptions) {
	  var doc = document;
	  var container =
	    typeof element === 'string' ? doc.querySelector(element) : element;
	
	  var config = xtend(
	    {
	      returnFocusOnDeactivate: true,
	      escapeDeactivates: true
	    },
	    userOptions
	  );
	
	  var state = {
	    firstTabbableNode: null,
	    lastTabbableNode: null,
	    nodeFocusedBeforeActivation: null,
	    mostRecentlyFocusedNode: null,
	    active: false,
	    paused: false
	  };
	
	  var trap = {
	    activate: activate,
	    deactivate: deactivate,
	    pause: pause,
	    unpause: unpause
	  };
	
	  return trap;
	
	  function activate(activateOptions) {
	    if (state.active) return;
	
	    updateTabbableNodes();
	
	    state.active = true;
	    state.paused = false;
	    state.nodeFocusedBeforeActivation = doc.activeElement;
	
	    var onActivate =
	      activateOptions && activateOptions.onActivate
	        ? activateOptions.onActivate
	        : config.onActivate;
	    if (onActivate) {
	      onActivate();
	    }
	
	    addListeners();
	    return trap;
	  }
	
	  function deactivate(deactivateOptions) {
	    if (!state.active) return;
	
	    removeListeners();
	    state.active = false;
	    state.paused = false;
	
	    var onDeactivate =
	      deactivateOptions && deactivateOptions.onDeactivate !== undefined
	        ? deactivateOptions.onDeactivate
	        : config.onDeactivate;
	    if (onDeactivate) {
	      onDeactivate();
	    }
	
	    var returnFocus =
	      deactivateOptions && deactivateOptions.returnFocus !== undefined
	        ? deactivateOptions.returnFocus
	        : config.returnFocusOnDeactivate;
	    if (returnFocus) {
	      delay(function() {
	        tryFocus(state.nodeFocusedBeforeActivation);
	      });
	    }
	
	    return trap;
	  }
	
	  function pause() {
	    if (state.paused || !state.active) return;
	    state.paused = true;
	    removeListeners();
	  }
	
	  function unpause() {
	    if (!state.paused || !state.active) return;
	    state.paused = false;
	    addListeners();
	  }
	
	  function addListeners() {
	    if (!state.active) return;
	
	    // There can be only one listening focus trap at a time
	    if (listeningFocusTrap) {
	      listeningFocusTrap.pause();
	    }
	    listeningFocusTrap = trap;
	
	    updateTabbableNodes();
	
	    // Delay ensures that the focused element doesn't capture the event
	    // that caused the focus trap activation.
	    delay(function() {
	      tryFocus(getInitialFocusNode());
	    });
	    doc.addEventListener('focusin', checkFocusIn, true);
	    doc.addEventListener('mousedown', checkPointerDown, true);
	    doc.addEventListener('touchstart', checkPointerDown, true);
	    doc.addEventListener('click', checkClick, true);
	    doc.addEventListener('keydown', checkKey, true);
	
	    return trap;
	  }
	
	  function removeListeners() {
	    if (!state.active || listeningFocusTrap !== trap) return;
	
	    doc.removeEventListener('focusin', checkFocusIn, true);
	    doc.removeEventListener('mousedown', checkPointerDown, true);
	    doc.removeEventListener('touchstart', checkPointerDown, true);
	    doc.removeEventListener('click', checkClick, true);
	    doc.removeEventListener('keydown', checkKey, true);
	
	    listeningFocusTrap = null;
	
	    return trap;
	  }
	
	  function getNodeForOption(optionName) {
	    var optionValue = config[optionName];
	    var node = optionValue;
	    if (!optionValue) {
	      return null;
	    }
	    if (typeof optionValue === 'string') {
	      node = doc.querySelector(optionValue);
	      if (!node) {
	        throw new Error('`' + optionName + '` refers to no known node');
	      }
	    }
	    if (typeof optionValue === 'function') {
	      node = optionValue();
	      if (!node) {
	        throw new Error('`' + optionName + '` did not return a node');
	      }
	    }
	    return node;
	  }
	
	  function getInitialFocusNode() {
	    var node;
	    if (getNodeForOption('initialFocus') !== null) {
	      node = getNodeForOption('initialFocus');
	    } else if (container.contains(doc.activeElement)) {
	      node = doc.activeElement;
	    } else {
	      node = state.firstTabbableNode || getNodeForOption('fallbackFocus');
	    }
	
	    if (!node) {
	      throw new Error(
	        "You can't have a focus-trap without at least one focusable element"
	      );
	    }
	
	    return node;
	  }
	
	  // This needs to be done on mousedown and touchstart instead of click
	  // so that it precedes the focus event.
	  function checkPointerDown(e) {
	    if (container.contains(e.target)) return;
	    if (config.clickOutsideDeactivates) {
	      deactivate({
	        returnFocus: !tabbable.isFocusable(e.target)
	      });
	    } else {
	      e.preventDefault();
	    }
	  }
	
	  // In case focus escapes the trap for some strange reason, pull it back in.
	  function checkFocusIn(e) {
	    // In Firefox when you Tab out of an iframe the Document is briefly focused.
	    if (container.contains(e.target) || e.target instanceof Document) {
	      return;
	    }
	    e.stopImmediatePropagation();
	    tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
	  }
	
	  function checkKey(e) {
	    if (config.escapeDeactivates !== false && isEscapeEvent(e)) {
	      e.preventDefault();
	      deactivate();
	      return;
	    }
	    if (isTabEvent(e)) {
	      checkTab(e);
	      return;
	    }
	  }
	
	  // Hijack Tab events on the first and last focusable nodes of the trap,
	  // in order to prevent focus from escaping. If it escapes for even a
	  // moment it can end up scrolling the page and causing confusion so we
	  // kind of need to capture the action at the keydown phase.
	  function checkTab(e) {
	    updateTabbableNodes();
	    if (e.shiftKey && e.target === state.firstTabbableNode) {
	      e.preventDefault();
	      tryFocus(state.lastTabbableNode);
	      return;
	    }
	    if (!e.shiftKey && e.target === state.lastTabbableNode) {
	      e.preventDefault();
	      tryFocus(state.firstTabbableNode);
	      return;
	    }
	  }
	
	  function checkClick(e) {
	    if (config.clickOutsideDeactivates) return;
	    if (container.contains(e.target)) return;
	    e.preventDefault();
	    e.stopImmediatePropagation();
	  }
	
	  function updateTabbableNodes() {
	    var tabbableNodes = tabbable(container);
	    state.firstTabbableNode = tabbableNodes[0] || getInitialFocusNode();
	    state.lastTabbableNode =
	      tabbableNodes[tabbableNodes.length - 1] || getInitialFocusNode();
	  }
	
	  function tryFocus(node) {
	    if (node === doc.activeElement) return;
	    if (!node || !node.focus) {
	      tryFocus(getInitialFocusNode());
	      return;
	    }
	
	    node.focus();
	    state.mostRecentlyFocusedNode = node;
	    if (isSelectableInput(node)) {
	      node.select();
	    }
	  }
	}
	
	function isSelectableInput(node) {
	  return (
	    node.tagName &&
	    node.tagName.toLowerCase() === 'input' &&
	    typeof node.select === 'function'
	  );
	}
	
	function isEscapeEvent(e) {
	  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
	}
	
	function isTabEvent(e) {
	  return e.key === 'Tab' || e.keyCode === 9;
	}
	
	function delay(fn) {
	  return setTimeout(fn, 0);
	}
	
	module.exports = focusTrap;


/***/ }),

/***/ 485:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(485);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 486:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var define = __webpack_require__(44);
	var isSymbol = __webpack_require__(207);
	
	var globalKey = '__ global cache key __';
	/* istanbul ignore else */
	// eslint-disable-next-line no-restricted-properties
	if (typeof Symbol === 'function' && isSymbol(Symbol('foo')) && typeof Symbol['for'] === 'function') {
		// eslint-disable-next-line no-restricted-properties
		globalKey = Symbol['for'](globalKey);
	}
	
	var trueThunk = function () {
		return true;
	};
	
	var ensureCache = function ensureCache() {
		if (!global[globalKey]) {
			var properties = {};
			properties[globalKey] = {};
			var predicates = {};
			predicates[globalKey] = trueThunk;
			define(global, properties, predicates);
		}
		return global[globalKey];
	};
	
	var cache = ensureCache();
	
	var isPrimitive = function isPrimitive(val) {
		return val === null || (typeof val !== 'object' && typeof val !== 'function');
	};
	
	var getPrimitiveKey = function getPrimitiveKey(val) {
		if (isSymbol(val)) {
			return Symbol.prototype.valueOf.call(val);
		}
		return typeof val + ' | ' + String(val);
	};
	
	var requirePrimitiveKey = function requirePrimitiveKey(val) {
		if (!isPrimitive(val)) {
			throw new TypeError('key must not be an object');
		}
	};
	
	var globalCache = {
		clear: function clear() {
			delete global[globalKey];
			cache = ensureCache();
		},
	
		'delete': function deleteKey(key) {
			requirePrimitiveKey(key);
			delete cache[getPrimitiveKey(key)];
			return !globalCache.has(key);
		},
	
		get: function get(key) {
			requirePrimitiveKey(key);
			return cache[getPrimitiveKey(key)];
		},
	
		has: function has(key) {
			requirePrimitiveKey(key);
			return getPrimitiveKey(key) in cache;
		},
	
		set: function set(key, value) {
			requirePrimitiveKey(key);
			var primitiveKey = getPrimitiveKey(key);
			var props = {};
			props[primitiveKey] = value;
			var predicates = {};
			predicates[primitiveKey] = trueThunk;
			define(cache, props, predicates);
			return globalCache.has(key);
		},
	
		setIfMissingThenGet: function setIfMissingThenGet(key, valueThunk) {
			if (globalCache.has(key)) {
				return globalCache.get(key);
			}
			var item = valueThunk();
			globalCache.set(key, item);
			return item;
		}
	};
	
	module.exports = globalCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 487:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var origSymbol = global.Symbol;
	var hasSymbolSham = __webpack_require__(206);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 17], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(45);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),

/***/ 132:
/***/ (function(module, exports) {

	'use strict';
	
	var fnToStr = Function.prototype.toString;
	
	var constructorRegex = /^\s*class\b/;
	var isES6ClassFn = function isES6ClassFunction(value) {
		try {
			var fnStr = fnToStr.call(value);
			return constructorRegex.test(fnStr);
		} catch (e) {
			return false; // not a function
		}
	};
	
	var tryFunctionObject = function tryFunctionToStr(value) {
		try {
			if (isES6ClassFn(value)) { return false; }
			fnToStr.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	var toStr = Object.prototype.toString;
	var fnClass = '[object Function]';
	var genClass = '[object GeneratorFunction]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isCallable(value) {
		if (!value) { return false; }
		if (typeof value !== 'function' && typeof value !== 'object') { return false; }
		if (typeof value === 'function' && !value.prototype) { return true; }
		if (hasToStringTag) { return tryFunctionObject(value); }
		if (isES6ClassFn(value)) { return false; }
		var strClass = toStr.call(value);
		return strClass === fnClass || strClass === genClass;
	};


/***/ }),

/***/ 488:
/***/ (function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateObject(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) { return false; }
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(73);
	var regexExec = RegExp.prototype.exec;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var tryRegexExecCall = function tryRegexExec(value) {
		try {
			var lastIndex = value.lastIndex;
			value.lastIndex = 0;
	
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		} finally {
			value.lastIndex = lastIndex;
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}
		if (!hasToStringTag) {
			return toStr.call(value) === regexClass;
		}
	
		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}
	
		return tryRegexExecCall(value);
	};


/***/ }),

/***/ 207:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	var hasSymbols = __webpack_require__(487)();
	
	if (hasSymbols) {
		var symToStr = Symbol.prototype.toString;
		var symStringRegex = /^Symbol\(.*\)$/;
		var isSymbolObject = function isRealSymbolObject(value) {
			if (typeof value.valueOf() !== 'symbol') {
				return false;
			}
			return symStringRegex.test(symToStr.call(value));
		};
	
		module.exports = function isSymbol(value) {
			if (typeof value === 'symbol') {
				return true;
			}
			if (toStr.call(value) !== '[object Symbol]') {
				return false;
			}
			try {
				return isSymbolObject(value);
			} catch (e) {
				return false;
			}
		};
	} else {
	
		module.exports = function isSymbol(value) {
			// this environment does not support Symbols.
			return false && value;
		};
	}


/***/ }),

/***/ 51:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isTouchDevice;
	function isTouchDevice() {
	  return !!(typeof window !== 'undefined' && ('ontouchstart' in window || window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch)) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints));
	}
	module.exports = exports['default'];

/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),

/***/ 208:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(209);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(208),
	    getRawTag = __webpack_require__(493),
	    objectToString = __webpack_require__(494);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ 492:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 493:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(208);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ 494:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(492);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 495:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(134),
	    now = __webpack_require__(498),
	    toNumber = __webpack_require__(499);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),

/***/ 134:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),

/***/ 496:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(491),
	    isObjectLike = __webpack_require__(496);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(209);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(495),
	    isObject = __webpack_require__(134);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),

/***/ 499:
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(134),
	    isSymbol = __webpack_require__(497);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),

/***/ 211:
/***/ (function(module, exports) {

	(function(root) {
	  var isOn = false;
	  var scrollbarSize;
	  var scrollTop;
	
	  function getScrollbarSize() {
	    if (typeof scrollbarSize !== 'undefined') return scrollbarSize;
	
	    var doc = document.documentElement;
	    var dummyScroller = document.createElement('div');
	    dummyScroller.setAttribute('style', 'width:99px;height:99px;' + 'position:absolute;top:-9999px;overflow:scroll;');
	    doc.appendChild(dummyScroller);
	    scrollbarSize = dummyScroller.offsetWidth - dummyScroller.clientWidth;
	    doc.removeChild(dummyScroller);
	    return scrollbarSize;
	  }
	
	  function hasScrollbar() {
	    return document.documentElement.scrollHeight > window.innerHeight;
	  }
	
	  function on(options) {
	    if (typeof document === 'undefined' || isOn) return;
	    var doc = document.documentElement;
	    scrollTop = window.pageYOffset;
	    if (hasScrollbar()) {
	      doc.style.width = 'calc(100% - '+ getScrollbarSize() +'px)';
	    } else {
	      doc.style.width = '100%';
	    }
	    doc.style.position = 'fixed';
	    doc.style.top = -scrollTop + 'px';
	    doc.style.overflow = 'hidden';
	    isOn = true;
	  }
	
	  function off() {
	    if (typeof document === 'undefined' || !isOn) return;
	    var doc = document.documentElement;
	    doc.style.width = '';
	    doc.style.position = '';
	    doc.style.top = '';
	    doc.style.overflow = '';
	    window.scroll(0, scrollTop);
	    isOn = false;
	  }
	
	  function toggle() {
	    if (isOn) {
	      off();
	      return;
	    }
	    on();
	  }
	
	  var noScroll = {
	    on: on,
	    off: off,
	    toggle: toggle,
	  };
	
	  if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
	    module.exports = noScroll;
	  } else {
	    root.noScroll = noScroll;
	  }
	})(this);


/***/ }),

/***/ 501:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(212); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(212);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(501);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),

/***/ 212:
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),

/***/ 213:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es6-shim
	var keys = __webpack_require__(135);
	var bind = __webpack_require__(45);
	var canBeObject = function (obj) {
		return typeof obj !== 'undefined' && obj !== null;
	};
	var hasSymbols = __webpack_require__(206)();
	var toObject = Object;
	var push = bind.call(Function.call, Array.prototype.push);
	var propIsEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);
	var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;
	
	module.exports = function assign(target, source1) {
		if (!canBeObject(target)) { throw new TypeError('target must be an object'); }
		var objTarget = toObject(target);
		var s, source, i, props, syms, value, key;
		for (s = 1; s < arguments.length; ++s) {
			source = toObject(arguments[s]);
			props = keys(source);
			var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
			if (getSymbols) {
				syms = getSymbols(source);
				for (i = 0; i < syms.length; ++i) {
					key = syms[i];
					if (propIsEnumerable(source, key)) {
						push(props, key);
					}
				}
			}
			for (i = 0; i < props.length; ++i) {
				key = props[i];
				value = source[key];
				if (propIsEnumerable(source, key)) {
					objTarget[key] = value;
				}
			}
		}
		return objTarget;
	};


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defineProperties = __webpack_require__(44);
	
	var implementation = __webpack_require__(213);
	var getPolyfill = __webpack_require__(214);
	var shim = __webpack_require__(502);
	
	var polyfill = getPolyfill();
	
	defineProperties(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(213);
	
	var lacksProperEnumerationOrder = function () {
		if (!Object.assign) {
			return false;
		}
		// v8, specifically in node 4.x, has a bug with incorrect property enumeration order
		// note: this does not detect the bug unless there's 20 characters
		var str = 'abcdefghijklmnopqrst';
		var letters = str.split('');
		var map = {};
		for (var i = 0; i < letters.length; ++i) {
			map[letters[i]] = letters[i];
		}
		var obj = Object.assign({}, map);
		var actual = '';
		for (var k in obj) {
			actual += k;
		}
		return str !== actual;
	};
	
	var assignHasPendingExceptions = function () {
		if (!Object.assign || !Object.preventExtensions) {
			return false;
		}
		// Firefox 37 still has "pending exception" logic in its Object.assign implementation,
		// which is 72% slower than our shim, and Firefox 40's native implementation.
		var thrower = Object.preventExtensions({ 1: 2 });
		try {
			Object.assign(thrower, 'xy');
		} catch (e) {
			return thrower[1] === 'y';
		}
		return false;
	};
	
	module.exports = function getPolyfill() {
		if (!Object.assign) {
			return implementation;
		}
		if (lacksProperEnumerationOrder()) {
			return implementation;
		}
		if (assignHasPendingExceptions()) {
			return implementation;
		}
		return Object.assign;
	};


/***/ }),

/***/ 502:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(44);
	var getPolyfill = __webpack_require__(214);
	
	module.exports = function shimAssign() {
		var polyfill = getPolyfill();
		define(
			Object,
			{ assign: polyfill },
			{ assign: function () { return Object.assign !== polyfill; } }
		);
		return polyfill;
	};


/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var ES = __webpack_require__(456);
	var has = __webpack_require__(73);
	var bind = __webpack_require__(45);
	var isEnumerable = bind.call(Function.call, Object.prototype.propertyIsEnumerable);
	
	module.exports = function values(O) {
		var obj = ES.RequireObjectCoercible(O);
		var vals = [];
		for (var key in obj) {
			if (has(obj, key) && isEnumerable(obj, key)) {
				vals.push(obj[key]);
			}
		}
		return vals;
	};


/***/ }),

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(44);
	
	var implementation = __webpack_require__(215);
	var getPolyfill = __webpack_require__(217);
	var shim = __webpack_require__(503);
	
	var polyfill = getPolyfill();
	
	define(polyfill, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = polyfill;


/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(215);
	
	module.exports = function getPolyfill() {
		return typeof Object.values === 'function' ? Object.values : implementation;
	};


/***/ }),

/***/ 503:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getPolyfill = __webpack_require__(217);
	var define = __webpack_require__(44);
	
	module.exports = function shimValues() {
		var polyfill = getPolyfill();
		define(Object, { values: polyfill }, {
			values: function testValues() {
				return Object.values !== polyfill;
			}
		});
		return polyfill;
	};


/***/ }),

/***/ 54:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @providesModule shallowCompare
	 */
	
	'use strict';
	
	var shallowEqual = __webpack_require__(632);
	
	/**
	 * Does a shallow comparison for props and state.
	 * See ReactComponentWithPureRenderMixin
	 * See also https://facebook.github.io/react/docs/shallow-compare.html
	 */
	function shallowCompare(instance, nextProps, nextState) {
	  return (
	    !shallowEqual(instance.props, nextProps) ||
	    !shallowEqual(instance.state, nextState)
	  );
	}
	
	module.exports = shallowCompare;


/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	module.exports = __webpack_require__(532);


/***/ }),

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	__webpack_require__(533);


/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureCalendarDay = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(54);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMomentProptypes = __webpack_require__(38);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _reactWithStyles = __webpack_require__(26);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _getCalendarDaySettings = __webpack_require__(247);
	
	var _getCalendarDaySettings2 = _interopRequireDefault(_getCalendarDaySettings);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  day: _reactMomentProptypes2['default'].momentObj,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isOutsideDay: _propTypes2['default'].bool,
	  modifiers: _propTypes2['default'].instanceOf(Set),
	  isFocused: _propTypes2['default'].bool,
	  tabIndex: _propTypes2['default'].oneOf([0, -1]),
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  ariaLabelFormat: _propTypes2['default'].string,
	
	  // internationalization
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases))
	}));
	
	var defaultProps = {
	  day: (0, _moment2['default'])(),
	  daySize: _constants.DAY_SIZE,
	  isOutsideDay: false,
	  modifiers: new Set(),
	  isFocused: false,
	  tabIndex: -1,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	
	  renderDayContents: null,
	  ariaLabelFormat: 'dddd, LL',
	
	  // internationalization
	  phrases: _defaultPhrases.CalendarDayPhrases
	};
	
	var CalendarDay = function (_React$Component) {
	  _inherits(CalendarDay, _React$Component);
	
	  function CalendarDay() {
	    var _ref;
	
	    _classCallCheck(this, CalendarDay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = CalendarDay.__proto__ || Object.getPrototypeOf(CalendarDay)).call.apply(_ref, [this].concat(args)));
	
	    _this.setButtonRef = _this.setButtonRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(CalendarDay, [{
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _props = this.props,
	            isFocused = _props.isFocused,
	            tabIndex = _props.tabIndex;
	
	        if (tabIndex === 0) {
	          if (isFocused || tabIndex !== prevProps.tabIndex) {
	            this.buttonRef.focus();
	          }
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'onDayClick',
	    value: function () {
	      function onDayClick(day, e) {
	        var onDayClick = this.props.onDayClick;
	
	        onDayClick(day, e);
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: 'onDayMouseEnter',
	    value: function () {
	      function onDayMouseEnter(day, e) {
	        var onDayMouseEnter = this.props.onDayMouseEnter;
	
	        onDayMouseEnter(day, e);
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: 'onDayMouseLeave',
	    value: function () {
	      function onDayMouseLeave(day, e) {
	        var onDayMouseLeave = this.props.onDayMouseLeave;
	
	        onDayMouseLeave(day, e);
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: 'onKeyDown',
	    value: function () {
	      function onKeyDown(day, e) {
	        var onDayClick = this.props.onDayClick;
	        var key = e.key;
	
	        if (key === 'Enter' || key === ' ') {
	          onDayClick(day, e);
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: 'setButtonRef',
	    value: function () {
	      function setButtonRef(ref) {
	        this.buttonRef = ref;
	      }
	
	      return setButtonRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            day = _props2.day,
	            ariaLabelFormat = _props2.ariaLabelFormat,
	            daySize = _props2.daySize,
	            isOutsideDay = _props2.isOutsideDay,
	            modifiers = _props2.modifiers,
	            renderDayContents = _props2.renderDayContents,
	            tabIndex = _props2.tabIndex,
	            styles = _props2.styles,
	            phrases = _props2.phrases;
	
	
	        if (!day) return _react2['default'].createElement('td', null);
	
	        var _getCalendarDaySettin = (0, _getCalendarDaySettings2['default'])(day, ariaLabelFormat, daySize, modifiers, phrases),
	            daySizeStyles = _getCalendarDaySettin.daySizeStyles,
	            useDefaultCursor = _getCalendarDaySettin.useDefaultCursor,
	            selected = _getCalendarDaySettin.selected,
	            hoveredSpan = _getCalendarDaySettin.hoveredSpan,
	            isOutsideRange = _getCalendarDaySettin.isOutsideRange,
	            ariaLabel = _getCalendarDaySettin.ariaLabel;
	
	        return _react2['default'].createElement(
	          'td',
	          _extends({}, (0, _reactWithStyles.css)(styles.CalendarDay, useDefaultCursor && styles.CalendarDay__defaultCursor, styles.CalendarDay__default, isOutsideDay && styles.CalendarDay__outside, modifiers.has('today') && styles.CalendarDay__today, modifiers.has('first-day-of-week') && styles.CalendarDay__firstDayOfWeek, modifiers.has('last-day-of-week') && styles.CalendarDay__lastDayOfWeek, modifiers.has('hovered-offset') && styles.CalendarDay__hovered_offset, modifiers.has('highlighted-calendar') && styles.CalendarDay__highlighted_calendar, modifiers.has('blocked-minimum-nights') && styles.CalendarDay__blocked_minimum_nights, modifiers.has('blocked-calendar') && styles.CalendarDay__blocked_calendar, hoveredSpan && styles.CalendarDay__hovered_span, modifiers.has('selected-span') && styles.CalendarDay__selected_span, modifiers.has('last-in-range') && styles.CalendarDay__last_in_range, modifiers.has('selected-start') && styles.CalendarDay__selected_start, modifiers.has('selected-end') && styles.CalendarDay__selected_end, selected && styles.CalendarDay__selected, isOutsideRange && styles.CalendarDay__blocked_out_of_range, daySizeStyles), {
	            role: 'button' // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
	            , ref: this.setButtonRef,
	            'aria-label': ariaLabel,
	            onMouseEnter: function () {
	              function onMouseEnter(e) {
	                _this2.onDayMouseEnter(day, e);
	              }
	
	              return onMouseEnter;
	            }(),
	            onMouseLeave: function () {
	              function onMouseLeave(e) {
	                _this2.onDayMouseLeave(day, e);
	              }
	
	              return onMouseLeave;
	            }(),
	            onMouseUp: function () {
	              function onMouseUp(e) {
	                e.currentTarget.blur();
	              }
	
	              return onMouseUp;
	            }(),
	            onClick: function () {
	              function onClick(e) {
	                _this2.onDayClick(day, e);
	              }
	
	              return onClick;
	            }(),
	            onKeyDown: function () {
	              function onKeyDown(e) {
	                _this2.onKeyDown(day, e);
	              }
	
	              return onKeyDown;
	            }(),
	            tabIndex: tabIndex
	          }),
	          renderDayContents ? renderDayContents(day, modifiers) : day.format('D')
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CalendarDay;
	}(_react2['default'].Component);
	
	CalendarDay.propTypes = propTypes;
	CalendarDay.defaultProps = defaultProps;
	
	exports.PureCalendarDay = CalendarDay;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      color = _ref2$reactDates.color,
	      font = _ref2$reactDates.font;
	  return {
	    CalendarDay: {
	      boxSizing: 'border-box',
	      cursor: 'pointer',
	      fontSize: font.size,
	      textAlign: 'center',
	
	      ':active': {
	        outline: 0
	      }
	    },
	
	    CalendarDay__defaultCursor: {
	      cursor: 'default'
	    },
	
	    CalendarDay__default: {
	      border: '1px solid ' + String(color.core.borderLight),
	      color: color.text,
	      background: color.background,
	
	      ':hover': {
	        background: color.core.borderLight,
	        border: '1px double ' + String(color.core.borderLight),
	        color: 'inherit'
	      }
	    },
	
	    CalendarDay__hovered_offset: {
	      background: color.core.borderBright,
	      border: '1px double ' + String(color.core.borderLight),
	      color: 'inherit'
	    },
	
	    CalendarDay__outside: {
	      border: 0,
	
	      background: color.outside.backgroundColor,
	      color: color.outside.color
	    },
	
	    CalendarDay__blocked_minimum_nights: {
	      background: color.minimumNights.backgroundColor,
	      border: '1px solid ' + String(color.minimumNights.borderColor),
	      color: color.minimumNights.color,
	
	      ':hover': {
	        background: color.minimumNights.backgroundColor_hover,
	        color: color.minimumNights.color_active
	      },
	
	      ':active': {
	        background: color.minimumNights.backgroundColor_active,
	        color: color.minimumNights.color_active
	      }
	    },
	
	    CalendarDay__highlighted_calendar: {
	      background: color.highlighted.backgroundColor,
	      color: color.highlighted.color,
	
	      ':hover': {
	        background: color.highlighted.backgroundColor_hover,
	        color: color.highlighted.color_active
	      },
	
	      ':active': {
	        background: color.highlighted.backgroundColor_active,
	        color: color.highlighted.color_active
	      }
	    },
	
	    CalendarDay__selected_span: {
	      background: color.selectedSpan.backgroundColor,
	      border: '1px solid ' + String(color.selectedSpan.borderColor),
	      color: color.selectedSpan.color,
	
	      ':hover': {
	        background: color.selectedSpan.backgroundColor_hover,
	        border: '1px solid ' + String(color.selectedSpan.borderColor),
	        color: color.selectedSpan.color_active
	      },
	
	      ':active': {
	        background: color.selectedSpan.backgroundColor_active,
	        border: '1px solid ' + String(color.selectedSpan.borderColor),
	        color: color.selectedSpan.color_active
	      }
	    },
	
	    CalendarDay__last_in_range: {
	      borderRight: color.core.primary
	    },
	
	    CalendarDay__selected: {
	      background: color.selected.backgroundColor,
	      border: '1px solid ' + String(color.selected.borderColor),
	      color: color.selected.color,
	
	      ':hover': {
	        background: color.selected.backgroundColor_hover,
	        border: '1px solid ' + String(color.selected.borderColor),
	        color: color.selected.color_active
	      },
	
	      ':active': {
	        background: color.selected.backgroundColor_active,
	        border: '1px solid ' + String(color.selected.borderColor),
	        color: color.selected.color_active
	      }
	    },
	
	    CalendarDay__hovered_span: {
	      background: color.hoveredSpan.backgroundColor,
	      border: '1px solid ' + String(color.hoveredSpan.borderColor),
	      color: color.hoveredSpan.color,
	
	      ':hover': {
	        background: color.hoveredSpan.backgroundColor_hover,
	        border: '1px solid ' + String(color.hoveredSpan.borderColor),
	        color: color.hoveredSpan.color_active
	      },
	
	      ':active': {
	        background: color.hoveredSpan.backgroundColor_active,
	        border: '1px solid ' + String(color.hoveredSpan.borderColor),
	        color: color.hoveredSpan.color_active
	      }
	    },
	
	    CalendarDay__blocked_calendar: {
	      background: color.blocked_calendar.backgroundColor,
	      border: '1px solid ' + String(color.blocked_calendar.borderColor),
	      color: color.blocked_calendar.color,
	
	      ':hover': {
	        background: color.blocked_calendar.backgroundColor_hover,
	        border: '1px solid ' + String(color.blocked_calendar.borderColor),
	        color: color.blocked_calendar.color_active
	      },
	
	      ':active': {
	        background: color.blocked_calendar.backgroundColor_active,
	        border: '1px solid ' + String(color.blocked_calendar.borderColor),
	        color: color.blocked_calendar.color_active
	      }
	    },
	
	    CalendarDay__blocked_out_of_range: {
	      background: color.blocked_out_of_range.backgroundColor,
	      border: '1px solid ' + String(color.blocked_out_of_range.borderColor),
	      color: color.blocked_out_of_range.color,
	
	      ':hover': {
	        background: color.blocked_out_of_range.backgroundColor_hover,
	        border: '1px solid ' + String(color.blocked_out_of_range.borderColor),
	        color: color.blocked_out_of_range.color_active
	      },
	
	      ':active': {
	        background: color.blocked_out_of_range.backgroundColor_active,
	        border: '1px solid ' + String(color.blocked_out_of_range.borderColor),
	        color: color.blocked_out_of_range.color_active
	      }
	    },
	
	    CalendarDay__selected_start: {},
	    CalendarDay__selected_end: {},
	    CalendarDay__today: {},
	    CalendarDay__firstDayOfWeek: {},
	    CalendarDay__lastDayOfWeek: {}
	  };
	})(CalendarDay);

/***/ }),

/***/ 228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CalendarIcon = function () {
	  function CalendarIcon(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M107.2 1392.9h241.1v-241.1H107.2v241.1zm294.7 0h267.9v-241.1H401.9v241.1zm-294.7-294.7h241.1V830.4H107.2v267.8zm294.7 0h267.9V830.4H401.9v267.8zM107.2 776.8h241.1V535.7H107.2v241.1zm616.2 616.1h267.9v-241.1H723.4v241.1zM401.9 776.8h267.9V535.7H401.9v241.1zm642.9 616.1H1286v-241.1h-241.1v241.1zm-321.4-294.7h267.9V830.4H723.4v267.8zM428.7 375V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.3-5.3 8-11.5 8-18.8zm616.1 723.2H1286V830.4h-241.1v267.8zM723.4 776.8h267.9V535.7H723.4v241.1zm321.4 0H1286V535.7h-241.1v241.1zm26.8-401.8V133.9c0-7.3-2.7-13.5-8-18.8-5.3-5.3-11.6-8-18.8-8h-53.6c-7.3 0-13.5 2.7-18.8 8-5.3 5.3-8 11.6-8 18.8V375c0 7.3 2.7 13.5 8 18.8 5.3 5.3 11.6 8 18.8 8h53.6c7.3 0 13.5-2.7 18.8-8 5.4-5.3 8-11.5 8-18.8zm321.5-53.6v1071.4c0 29-10.6 54.1-31.8 75.3-21.2 21.2-46.3 31.8-75.3 31.8H107.2c-29 0-54.1-10.6-75.3-31.8C10.6 1447 0 1421.9 0 1392.9V321.4c0-29 10.6-54.1 31.8-75.3s46.3-31.8 75.3-31.8h107.2v-80.4c0-36.8 13.1-68.4 39.3-94.6S311.4 0 348.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3 26.2 26.2 39.3 57.8 39.3 94.6v80.4h321.5v-80.4c0-36.8 13.1-68.4 39.3-94.6C922.9 13.1 954.4 0 991.3 0h53.6c36.8 0 68.4 13.1 94.6 39.3s39.3 57.8 39.3 94.6v80.4H1286c29 0 54.1 10.6 75.3 31.8 21.2 21.2 31.8 46.3 31.8 75.3z'
	      })
	    );
	  }
	
	  return CalendarIcon;
	}();
	
	CalendarIcon.defaultProps = {
	  xmlns: 'http://www.w3.org/2000/svg',
	  viewBox: '0 0 1393.1 1500'
	};
	exports['default'] = CalendarIcon;

/***/ }),

/***/ 229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(54);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMomentProptypes = __webpack_require__(38);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _reactWithStyles = __webpack_require__(26);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _CalendarWeek = __webpack_require__(523);
	
	var _CalendarWeek2 = _interopRequireDefault(_CalendarWeek);
	
	var _CalendarDay = __webpack_require__(136);
	
	var _CalendarDay2 = _interopRequireDefault(_CalendarDay);
	
	var _calculateDimension = __webpack_require__(245);
	
	var _calculateDimension2 = _interopRequireDefault(_calculateDimension);
	
	var _getCalendarMonthWeeks = __webpack_require__(535);
	
	var _getCalendarMonthWeeks2 = _interopRequireDefault(_getCalendarMonthWeeks);
	
	var _isSameDay = __webpack_require__(57);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _toISODateString = __webpack_require__(98);
	
	var _toISODateString2 = _interopRequireDefault(_toISODateString);
	
	var _ScrollableOrientationShape = __webpack_require__(56);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(46);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/no-array-index-key: 0 */
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  month: _reactMomentProptypes2['default'].momentObj,
	  isVisible: _propTypes2['default'].bool,
	  enableOutsideDays: _propTypes2['default'].bool,
	  modifiers: _propTypes2['default'].object,
	  orientation: _ScrollableOrientationShape2['default'],
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	  renderMonth: _propTypes2['default'].func,
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  setMonthHeight: _propTypes2['default'].func,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  focusedDate: _reactMomentProptypes2['default'].momentObj, // indicates focusable day
	  isFocused: _propTypes2['default'].bool, // indicates whether or not to move focus to focusable day
	
	  // i18n
	  monthFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string
	}));
	
	var defaultProps = {
	  month: (0, _moment2['default'])(),
	  isVisible: true,
	  enableOutsideDays: false,
	  modifiers: {},
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  daySize: _constants.DAY_SIZE,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	
	  renderMonth: null,
	  renderCalendarDay: function () {
	    function renderCalendarDay(props) {
	      return _react2['default'].createElement(_CalendarDay2['default'], props);
	    }
	
	    return renderCalendarDay;
	  }(),
	  renderDayContents: null,
	  firstDayOfWeek: null,
	  setMonthHeight: function () {
	    function setMonthHeight() {}
	
	    return setMonthHeight;
	  }(),
	
	
	  focusedDate: null,
	  isFocused: false,
	
	  // i18n
	  monthFormat: 'MMMM YYYY', // english locale
	  phrases: _defaultPhrases.CalendarDayPhrases,
	  dayAriaLabelFormat: undefined,
	  verticalBorderSpacing: undefined
	};
	
	var CalendarMonth = function (_React$Component) {
	  _inherits(CalendarMonth, _React$Component);
	
	  function CalendarMonth(props) {
	    _classCallCheck(this, CalendarMonth);
	
	    var _this = _possibleConstructorReturn(this, (CalendarMonth.__proto__ || Object.getPrototypeOf(CalendarMonth)).call(this, props));
	
	    _this.state = {
	      weeks: (0, _getCalendarMonthWeeks2['default'])(props.month, props.enableOutsideDays, props.firstDayOfWeek == null ? _moment2['default'].localeData().firstDayOfWeek() : props.firstDayOfWeek)
	    };
	
	    _this.setCaptionRef = _this.setCaptionRef.bind(_this);
	    _this.setGridRef = _this.setGridRef.bind(_this);
	    _this.setMonthHeight = _this.setMonthHeight.bind(_this);
	    return _this;
	  }
	
	  _createClass(CalendarMonth, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.setMonthHeightTimeout = setTimeout(this.setMonthHeight, 0);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var month = nextProps.month,
	            enableOutsideDays = nextProps.enableOutsideDays,
	            firstDayOfWeek = nextProps.firstDayOfWeek;
	
	        if (!month.isSame(this.props.month) || enableOutsideDays !== this.props.enableOutsideDays || firstDayOfWeek !== this.props.firstDayOfWeek) {
	          this.setState({
	            weeks: (0, _getCalendarMonthWeeks2['default'])(month, enableOutsideDays, firstDayOfWeek == null ? _moment2['default'].localeData().firstDayOfWeek() : firstDayOfWeek)
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.setMonthHeightTimeout) {
	          clearTimeout(this.setMonthHeightTimeout);
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'setMonthHeight',
	    value: function () {
	      function setMonthHeight() {
	        var setMonthHeight = this.props.setMonthHeight;
	
	        var captionHeight = (0, _calculateDimension2['default'])(this.captionRef, 'height', true, true);
	        var gridHeight = (0, _calculateDimension2['default'])(this.gridRef, 'height');
	
	        setMonthHeight(captionHeight + gridHeight + 1);
	      }
	
	      return setMonthHeight;
	    }()
	  }, {
	    key: 'setCaptionRef',
	    value: function () {
	      function setCaptionRef(ref) {
	        this.captionRef = ref;
	      }
	
	      return setCaptionRef;
	    }()
	  }, {
	    key: 'setGridRef',
	    value: function () {
	      function setGridRef(ref) {
	        this.gridRef = ref;
	      }
	
	      return setGridRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props = this.props,
	            month = _props.month,
	            monthFormat = _props.monthFormat,
	            orientation = _props.orientation,
	            isVisible = _props.isVisible,
	            modifiers = _props.modifiers,
	            onDayClick = _props.onDayClick,
	            onDayMouseEnter = _props.onDayMouseEnter,
	            onDayMouseLeave = _props.onDayMouseLeave,
	            renderMonth = _props.renderMonth,
	            renderCalendarDay = _props.renderCalendarDay,
	            renderDayContents = _props.renderDayContents,
	            daySize = _props.daySize,
	            focusedDate = _props.focusedDate,
	            isFocused = _props.isFocused,
	            styles = _props.styles,
	            phrases = _props.phrases,
	            dayAriaLabelFormat = _props.dayAriaLabelFormat,
	            verticalBorderSpacing = _props.verticalBorderSpacing;
	        var weeks = this.state.weeks;
	
	        var monthTitle = renderMonth ? renderMonth(month) : month.format(monthFormat);
	
	        var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({}, (0, _reactWithStyles.css)(styles.CalendarMonth, orientation === _constants.HORIZONTAL_ORIENTATION && styles.CalendarMonth__horizontal, orientation === _constants.VERTICAL_ORIENTATION && styles.CalendarMonth__vertical, verticalScrollable && styles.CalendarMonth__verticalScrollable), {
	            'data-visible': isVisible
	          }),
	          _react2['default'].createElement(
	            'div',
	            _extends({
	              ref: this.setCaptionRef
	            }, (0, _reactWithStyles.css)(styles.CalendarMonth_caption, verticalScrollable && styles.CalendarMonth_caption__verticalScrollable)),
	            _react2['default'].createElement(
	              'strong',
	              null,
	              monthTitle
	            )
	          ),
	          _react2['default'].createElement(
	            'table',
	            _extends({}, (0, _reactWithStyles.css)(!verticalBorderSpacing && styles.CalendarMonth_table, verticalBorderSpacing && styles.CalendarMonth_verticalSpacing, verticalBorderSpacing && { borderSpacing: '0px ' + String(verticalBorderSpacing) + 'px' }), {
	              role: 'presentation'
	            }),
	            _react2['default'].createElement(
	              'tbody',
	              { ref: this.setGridRef },
	              weeks.map(function (week, i) {
	                return _react2['default'].createElement(
	                  _CalendarWeek2['default'],
	                  { key: i },
	                  week.map(function (day, dayOfWeek) {
	                    return renderCalendarDay({
	                      key: dayOfWeek,
	                      day: day,
	                      daySize: daySize,
	                      isOutsideDay: !day || day.month() !== month.month(),
	                      tabIndex: isVisible && (0, _isSameDay2['default'])(day, focusedDate) ? 0 : -1,
	                      isFocused: isFocused,
	                      onDayMouseEnter: onDayMouseEnter,
	                      onDayMouseLeave: onDayMouseLeave,
	                      onDayClick: onDayClick,
	                      renderDayContents: renderDayContents,
	                      phrases: phrases,
	                      modifiers: modifiers[(0, _toISODateString2['default'])(day)],
	                      ariaLabelFormat: dayAriaLabelFormat
	                    });
	                  })
	                );
	              })
	            )
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CalendarMonth;
	}(_react2['default'].Component);
	
	CalendarMonth.propTypes = propTypes;
	CalendarMonth.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      font = _ref$reactDates.font,
	      spacing = _ref$reactDates.spacing;
	  return {
	    CalendarMonth: {
	      background: color.background,
	      textAlign: 'center',
	      padding: '0 13px',
	      verticalAlign: 'top',
	      userSelect: 'none'
	    },
	
	    CalendarMonth_table: {
	      borderCollapse: 'collapse',
	      borderSpacing: 0
	    },
	
	    CalendarMonth_verticalSpacing: {
	      borderCollapse: 'separate'
	    },
	
	    CalendarMonth_caption: {
	      color: color.text,
	      fontSize: font.captionSize,
	      textAlign: 'center',
	      paddingTop: spacing.captionPaddingTop,
	      paddingBottom: spacing.captionPaddingBottom,
	      captionSide: 'initial'
	    },
	
	    CalendarMonth_caption__verticalScrollable: {
	      paddingTop: 12,
	      paddingBottom: 7
	    }
	  };
	})(CalendarMonth);

/***/ }),

/***/ 230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(54);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMomentProptypes = __webpack_require__(38);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _reactWithStyles = __webpack_require__(26);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _consolidatedEvents = __webpack_require__(90);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _CalendarMonth = __webpack_require__(229);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _isTransitionEndSupported = __webpack_require__(540);
	
	var _isTransitionEndSupported2 = _interopRequireDefault(_isTransitionEndSupported);
	
	var _getTransformStyles = __webpack_require__(538);
	
	var _getTransformStyles2 = _interopRequireDefault(_getTransformStyles);
	
	var _getCalendarMonthWidth = __webpack_require__(248);
	
	var _getCalendarMonthWidth2 = _interopRequireDefault(_getCalendarMonthWidth);
	
	var _toISOMonthString = __webpack_require__(99);
	
	var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);
	
	var _isAfterDay = __webpack_require__(81);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	var _ScrollableOrientationShape = __webpack_require__(56);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(46);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  enableOutsideDays: _propTypes2['default'].bool,
	  firstVisibleMonthIndex: _propTypes2['default'].number,
	  initialMonth: _reactMomentProptypes2['default'].momentObj,
	  isAnimating: _propTypes2['default'].bool,
	  numberOfMonths: _propTypes2['default'].number,
	  modifiers: _propTypes2['default'].object,
	  orientation: _ScrollableOrientationShape2['default'],
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	  onMonthTransitionEnd: _propTypes2['default'].func,
	  renderMonth: _propTypes2['default'].func,
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  transformValue: _propTypes2['default'].string,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  focusedDate: _reactMomentProptypes2['default'].momentObj, // indicates focusable day
	  isFocused: _propTypes2['default'].bool, // indicates whether or not to move focus to focusable day
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  setCalendarMonthHeights: _propTypes2['default'].func,
	  isRTL: _propTypes2['default'].bool,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  // i18n
	  monthFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string
	}));
	
	var defaultProps = {
	  enableOutsideDays: false,
	  firstVisibleMonthIndex: 0,
	  initialMonth: (0, _moment2['default'])(),
	  isAnimating: false,
	  numberOfMonths: 1,
	  modifiers: {},
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	  onMonthTransitionEnd: function () {
	    function onMonthTransitionEnd() {}
	
	    return onMonthTransitionEnd;
	  }(),
	
	  renderMonth: null,
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  transformValue: 'none',
	  daySize: _constants.DAY_SIZE,
	  focusedDate: null,
	  isFocused: false,
	  firstDayOfWeek: null,
	  setCalendarMonthHeights: function () {
	    function setCalendarMonthHeights() {}
	
	    return setCalendarMonthHeights;
	  }(),
	
	  isRTL: false,
	  transitionDuration: 200,
	  verticalBorderSpacing: undefined,
	
	  // i18n
	  monthFormat: 'MMMM YYYY', // english locale
	  phrases: _defaultPhrases.CalendarDayPhrases,
	  dayAriaLabelFormat: undefined
	};
	
	function getMonths(initialMonth, numberOfMonths, withoutTransitionMonths) {
	  var month = initialMonth.clone();
	  if (!withoutTransitionMonths) month = month.subtract(1, 'month');
	
	  var months = [];
	  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
	    months.push(month);
	    month = month.clone().add(1, 'month');
	  }
	
	  return months;
	}
	
	var CalendarMonthGrid = function (_React$Component) {
	  _inherits(CalendarMonthGrid, _React$Component);
	
	  function CalendarMonthGrid(props) {
	    _classCallCheck(this, CalendarMonthGrid);
	
	    var _this = _possibleConstructorReturn(this, (CalendarMonthGrid.__proto__ || Object.getPrototypeOf(CalendarMonthGrid)).call(this, props));
	
	    var withoutTransitionMonths = props.orientation === _constants.VERTICAL_SCROLLABLE;
	    _this.state = {
	      months: getMonths(props.initialMonth, props.numberOfMonths, withoutTransitionMonths)
	    };
	
	    _this.calendarMonthHeights = [];
	
	    _this.isTransitionEndSupported = (0, _isTransitionEndSupported2['default'])();
	    _this.onTransitionEnd = _this.onTransitionEnd.bind(_this);
	    _this.setContainerRef = _this.setContainerRef.bind(_this);
	
	    _this.locale = _moment2['default'].locale();
	    return _this;
	  }
	
	  _createClass(CalendarMonthGrid, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        var _this2 = this;
	
	        var setCalendarMonthHeights = this.props.setCalendarMonthHeights;
	
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(this.container, 'transitionend', this.onTransitionEnd);
	
	        this.setCalendarMonthHeightsTimeout = setTimeout(function () {
	          setCalendarMonthHeights(_this2.calendarMonthHeights);
	        }, 0);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var _this3 = this;
	
	        var initialMonth = nextProps.initialMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            orientation = nextProps.orientation;
	        var months = this.state.months;
	
	
	        var hasMonthChanged = !this.props.initialMonth.isSame(initialMonth, 'month');
	        var hasNumberOfMonthsChanged = this.props.numberOfMonths !== numberOfMonths;
	        var newMonths = months;
	
	        if (hasMonthChanged && !hasNumberOfMonthsChanged) {
	          if ((0, _isAfterDay2['default'])(initialMonth, this.props.initialMonth)) {
	            newMonths = months.slice(1);
	            newMonths.push(months[months.length - 1].clone().add(1, 'month'));
	          } else {
	            newMonths = months.slice(0, months.length - 1);
	            newMonths.unshift(months[0].clone().subtract(1, 'month'));
	          }
	        }
	
	        if (hasNumberOfMonthsChanged) {
	          var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	          newMonths = getMonths(initialMonth, numberOfMonths, withoutTransitionMonths);
	        }
	
	        var momentLocale = _moment2['default'].locale();
	        if (this.locale !== momentLocale) {
	          this.locale = momentLocale;
	          newMonths = newMonths.map(function (m) {
	            return m.locale(_this3.locale);
	          });
	        }
	
	        this.setState({
	          months: newMonths
	        });
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _this4 = this;
	
	        var _props = this.props,
	            isAnimating = _props.isAnimating,
	            transitionDuration = _props.transitionDuration,
	            onMonthTransitionEnd = _props.onMonthTransitionEnd,
	            setCalendarMonthHeights = _props.setCalendarMonthHeights;
	
	        // For IE9, immediately call onMonthTransitionEnd instead of
	        // waiting for the animation to complete. Similarly, if transitionDuration
	        // is set to 0, also immediately invoke the onMonthTransitionEnd callback
	
	        if ((!this.isTransitionEndSupported || !transitionDuration) && isAnimating) {
	          onMonthTransitionEnd();
	        }
	
	        if (!isAnimating && prevProps.isAnimating) {
	          this.setCalendarMonthHeightsTimeout = setTimeout(function () {
	            setCalendarMonthHeights(_this4.calendarMonthHeights);
	          }, 0);
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeEventListener) this.removeEventListener();
	        if (this.setCalendarMonthHeightsTimeout) {
	          clearTimeout(this.setCalendarMonthHeightsTimeout);
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onTransitionEnd',
	    value: function () {
	      function onTransitionEnd() {
	        var onMonthTransitionEnd = this.props.onMonthTransitionEnd;
	
	        onMonthTransitionEnd();
	      }
	
	      return onTransitionEnd;
	    }()
	  }, {
	    key: 'setContainerRef',
	    value: function () {
	      function setContainerRef(ref) {
	        this.container = ref;
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: 'setMonthHeight',
	    value: function () {
	      function setMonthHeight(height, i) {
	        if (this.calendarMonthHeights[i]) {
	          if (i === 0) {
	            this.calendarMonthHeights = [height].concat(this.calendarMonthHeights.slice(0, -1));
	          } else if (i === this.calendarMonthHeights.length - 1) {
	            this.calendarMonthHeights = this.calendarMonthHeights.slice(1).concat(height);
	          }
	        } else {
	          this.calendarMonthHeights[i] = height;
	        }
	      }
	
	      return setMonthHeight;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this5 = this;
	
	        var _props2 = this.props,
	            enableOutsideDays = _props2.enableOutsideDays,
	            firstVisibleMonthIndex = _props2.firstVisibleMonthIndex,
	            isAnimating = _props2.isAnimating,
	            modifiers = _props2.modifiers,
	            numberOfMonths = _props2.numberOfMonths,
	            monthFormat = _props2.monthFormat,
	            orientation = _props2.orientation,
	            transformValue = _props2.transformValue,
	            daySize = _props2.daySize,
	            onDayMouseEnter = _props2.onDayMouseEnter,
	            onDayMouseLeave = _props2.onDayMouseLeave,
	            onDayClick = _props2.onDayClick,
	            renderMonth = _props2.renderMonth,
	            renderCalendarDay = _props2.renderCalendarDay,
	            renderDayContents = _props2.renderDayContents,
	            onMonthTransitionEnd = _props2.onMonthTransitionEnd,
	            firstDayOfWeek = _props2.firstDayOfWeek,
	            focusedDate = _props2.focusedDate,
	            isFocused = _props2.isFocused,
	            isRTL = _props2.isRTL,
	            styles = _props2.styles,
	            phrases = _props2.phrases,
	            dayAriaLabelFormat = _props2.dayAriaLabelFormat,
	            transitionDuration = _props2.transitionDuration,
	            verticalBorderSpacing = _props2.verticalBorderSpacing;
	        var months = this.state.months;
	
	        var isVertical = orientation === _constants.VERTICAL_ORIENTATION;
	        var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	        var isHorizontal = orientation === _constants.HORIZONTAL_ORIENTATION;
	
	        var calendarMonthWidth = (0, _getCalendarMonthWidth2['default'])(daySize);
	
	        var width = isVertical || isVerticalScrollable ? calendarMonthWidth : (numberOfMonths + 2) * calendarMonthWidth;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({}, (0, _reactWithStyles.css)(styles.CalendarMonthGrid, isHorizontal && styles.CalendarMonthGrid__horizontal, isVertical && styles.CalendarMonthGrid__vertical, isVerticalScrollable && styles.CalendarMonthGrid__vertical_scrollable, isAnimating && styles.CalendarMonthGrid__animating, isAnimating && transitionDuration && {
	            transition: 'transform ' + String(transitionDuration) + 'ms ease-in-out'
	          }, (0, _object2['default'])({}, (0, _getTransformStyles2['default'])(transformValue), {
	            width: width
	          })), {
	            ref: this.setContainerRef,
	            onTransitionEnd: onMonthTransitionEnd
	          }),
	          months.map(function (month, i) {
	            var isVisible = i >= firstVisibleMonthIndex && i < firstVisibleMonthIndex + numberOfMonths;
	            var hideForAnimation = i === 0 && !isVisible;
	            var showForAnimation = i === 0 && isAnimating && isVisible;
	            var monthString = (0, _toISOMonthString2['default'])(month);
	            return _react2['default'].createElement(
	              'div',
	              _extends({
	                key: monthString
	              }, (0, _reactWithStyles.css)(isHorizontal && styles.CalendarMonthGrid_month__horizontal, hideForAnimation && styles.CalendarMonthGrid_month__hideForAnimation, showForAnimation && !isVertical && !isRTL && {
	                position: 'absolute',
	                left: -calendarMonthWidth
	              }, showForAnimation && !isVertical && isRTL && {
	                position: 'absolute',
	                right: 0
	              }, showForAnimation && isVertical && {
	                position: 'absolute',
	                top: -_this5.calendarMonthHeights[0]
	              }, !isVisible && !isAnimating && styles.CalendarMonthGrid_month__hidden)),
	              _react2['default'].createElement(_CalendarMonth2['default'], {
	                month: month,
	                isVisible: isVisible,
	                enableOutsideDays: enableOutsideDays,
	                modifiers: modifiers[monthString],
	                monthFormat: monthFormat,
	                orientation: orientation,
	                onDayMouseEnter: onDayMouseEnter,
	                onDayMouseLeave: onDayMouseLeave,
	                onDayClick: onDayClick,
	                renderMonth: renderMonth,
	                renderCalendarDay: renderCalendarDay,
	                renderDayContents: renderDayContents,
	                firstDayOfWeek: firstDayOfWeek,
	                daySize: daySize,
	                focusedDate: isVisible ? focusedDate : null,
	                isFocused: isFocused,
	                phrases: phrases,
	                setMonthHeight: function () {
	                  function setMonthHeight(height) {
	                    _this5.setMonthHeight(height, i);
	                  }
	
	                  return setMonthHeight;
	                }(),
	                dayAriaLabelFormat: dayAriaLabelFormat,
	                verticalBorderSpacing: verticalBorderSpacing
	              })
	            );
	          })
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CalendarMonthGrid;
	}(_react2['default'].Component);
	
	CalendarMonthGrid.propTypes = propTypes;
	CalendarMonthGrid.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      zIndex = _ref$reactDates.zIndex;
	  return {
	    CalendarMonthGrid: {
	      background: color.background,
	      textAlign: 'left',
	      zIndex: zIndex
	    },
	
	    CalendarMonthGrid__animating: {
	      zIndex: zIndex + 1
	    },
	
	    CalendarMonthGrid__horizontal: {
	      position: 'absolute',
	      left: 9
	    },
	
	    CalendarMonthGrid__vertical: {
	      margin: '0 auto'
	    },
	
	    CalendarMonthGrid__vertical_scrollable: {
	      margin: '0 auto',
	      overflowY: 'scroll'
	    },
	
	    CalendarMonthGrid_month__horizontal: {
	      display: 'inline-block',
	      verticalAlign: 'top',
	      minHeight: '100%'
	    },
	
	    CalendarMonthGrid_month__hideForAnimation: {
	      position: 'absolute',
	      zIndex: zIndex - 1,
	      opacity: 0,
	      pointerEvents: 'none'
	    },
	
	    CalendarMonthGrid_month__hidden: {
	      visibility: 'hidden'
	    }
	  };
	})(CalendarMonthGrid);

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = CalendarWeek;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _CalendarDay = __webpack_require__(136);
	
	var _CalendarDay2 = _interopRequireDefault(_CalendarDay);
	
	var _CustomizableCalendarDay = __webpack_require__(526);
	
	var _CustomizableCalendarDay2 = _interopRequireDefault(_CustomizableCalendarDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  children: (0, _airbnbPropTypes.or)([(0, _airbnbPropTypes.childrenOfType)(_CalendarDay2['default']), (0, _airbnbPropTypes.childrenOfType)(_CustomizableCalendarDay2['default'])]).isRequired
	});
	
	function CalendarWeek(_ref) {
	  var children = _ref.children;
	
	  return _react2['default'].createElement(
	    'tr',
	    null,
	    children
	  );
	}
	
	CalendarWeek.propTypes = propTypes;

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ChevronDown = function () {
	  function ChevronDown(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M967.5 288.5L514.3 740.7c-11 11-21 11-32 0L29.1 288.5c-4-5-6-11-6-16 0-13 10-23 23-23 6 0 11 2 15 7l437.2 436.2 437.2-436.2c4-5 9-7 16-7 6 0 11 2 16 7 9 10.9 9 21 0 32z'
	      })
	    );
	  }
	
	  return ChevronDown;
	}();
	
	ChevronDown.defaultProps = {
	  viewBox: '0 0 1000 1000'
	};
	exports['default'] = ChevronDown;

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ChevronUp = function () {
	  function ChevronUp(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M32.1 712.6l453.2-452.2c11-11 21-11 32 0l453.2 452.2c4 5 6 10 6 16 0 13-10 23-22 23-7 0-12-2-16-7L501.3 308.5 64.1 744.7c-4 5-9 7-15 7-7 0-12-2-17-7-9-11-9-21 0-32.1z'
	      })
	    );
	  }
	
	  return ChevronUp;
	}();
	
	ChevronUp.defaultProps = {
	  viewBox: '0 0 1000 1000'
	};
	exports['default'] = ChevronUp;

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CloseButton = function () {
	  function CloseButton(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        fillRule: 'evenodd',
	        d: 'M11.53.47a.75.75 0 0 0-1.061 0l-4.47 4.47L1.529.47A.75.75 0 1 0 .468 1.531l4.47 4.47-4.47 4.47a.75.75 0 1 0 1.061 1.061l4.47-4.47 4.47 4.47a.75.75 0 1 0 1.061-1.061l-4.47-4.47 4.47-4.47a.75.75 0 0 0 0-1.061z'
	      })
	    );
	  }
	
	  return CloseButton;
	}();
	
	CloseButton.defaultProps = {
	  viewBox: '0 0 12 12'
	};
	exports['default'] = CloseButton;

/***/ }),

/***/ 526:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureCustomizableCalendarDay = exports.selectedStyles = exports.lastInRangeStyles = exports.selectedSpanStyles = exports.hoveredSpanStyles = exports.blockedOutOfRangeStyles = exports.blockedCalendarStyles = exports.blockedMinNightsStyles = exports.highlightedCalendarStyles = exports.outsideStyles = exports.defaultStyles = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(54);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _reactMomentProptypes = __webpack_require__(38);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _reactWithStyles = __webpack_require__(26);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _getCalendarDaySettings = __webpack_require__(247);
	
	var _getCalendarDaySettings2 = _interopRequireDefault(_getCalendarDaySettings);
	
	var _constants = __webpack_require__(7);
	
	var _DefaultTheme = __webpack_require__(244);
	
	var _DefaultTheme2 = _interopRequireDefault(_DefaultTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var color = _DefaultTheme2['default'].reactDates.color;
	
	
	function getStyles(stylesObj, isHovered) {
	  if (!stylesObj) return null;
	
	  var hover = stylesObj.hover;
	
	  if (isHovered && hover) {
	    return hover;
	  }
	
	  return stylesObj;
	}
	
	var DayStyleShape = _propTypes2['default'].shape({
	  background: _propTypes2['default'].string,
	  border: (0, _airbnbPropTypes.or)([_propTypes2['default'].string, _propTypes2['default'].number]),
	  color: _propTypes2['default'].string,
	
	  hover: _propTypes2['default'].shape({
	    background: _propTypes2['default'].string,
	    border: (0, _airbnbPropTypes.or)([_propTypes2['default'].string, _propTypes2['default'].number]),
	    color: _propTypes2['default'].string
	  })
	});
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  day: _reactMomentProptypes2['default'].momentObj,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isOutsideDay: _propTypes2['default'].bool,
	  modifiers: _propTypes2['default'].instanceOf(Set),
	  isFocused: _propTypes2['default'].bool,
	  tabIndex: _propTypes2['default'].oneOf([0, -1]),
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  ariaLabelFormat: _propTypes2['default'].string,
	
	  // style overrides
	  defaultStyles: DayStyleShape,
	  outsideStyles: DayStyleShape,
	  todayStyles: DayStyleShape,
	  firstDayOfWeekStyles: DayStyleShape,
	  lastDayOfWeekStyles: DayStyleShape,
	  highlightedCalendarStyles: DayStyleShape,
	  blockedMinNightsStyles: DayStyleShape,
	  blockedCalendarStyles: DayStyleShape,
	  blockedOutOfRangeStyles: DayStyleShape,
	  hoveredSpanStyles: DayStyleShape,
	  selectedSpanStyles: DayStyleShape,
	  lastInRangeStyles: DayStyleShape,
	  selectedStyles: DayStyleShape,
	  selectedStartStyles: DayStyleShape,
	  selectedEndStyles: DayStyleShape,
	  afterHoveredStartStyles: DayStyleShape,
	
	  // internationalization
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.CalendarDayPhrases))
	}));
	
	var defaultStyles = exports.defaultStyles = {
	  border: '1px solid ' + String(color.core.borderLight),
	  color: color.text,
	  background: color.background,
	
	  hover: {
	    background: color.core.borderLight,
	    border: '1px double ' + String(color.core.borderLight),
	    color: 'inherit'
	  }
	};
	
	var outsideStyles = exports.outsideStyles = {
	  background: color.outside.backgroundColor,
	  border: 0,
	  color: color.outside.color
	};
	
	var highlightedCalendarStyles = exports.highlightedCalendarStyles = {
	  background: color.highlighted.backgroundColor,
	  color: color.highlighted.color,
	
	  hover: {
	    background: color.highlighted.backgroundColor_hover,
	    color: color.highlighted.color_active
	  }
	};
	
	var blockedMinNightsStyles = exports.blockedMinNightsStyles = {
	  background: color.minimumNights.backgroundColor,
	  border: '1px solid ' + String(color.minimumNights.borderColor),
	  color: color.minimumNights.color,
	
	  hover: {
	    background: color.minimumNights.backgroundColor_hover,
	    color: color.minimumNights.color_active
	  }
	};
	
	var blockedCalendarStyles = exports.blockedCalendarStyles = {
	  background: color.blocked_calendar.backgroundColor,
	  border: '1px solid ' + String(color.blocked_calendar.borderColor),
	  color: color.blocked_calendar.color,
	
	  hover: {
	    background: color.blocked_calendar.backgroundColor_hover,
	    border: '1px solid ' + String(color.blocked_calendar.borderColor),
	    color: color.blocked_calendar.color_active
	  }
	};
	
	var blockedOutOfRangeStyles = exports.blockedOutOfRangeStyles = {
	  background: color.blocked_out_of_range.backgroundColor,
	  border: '1px solid ' + String(color.blocked_out_of_range.borderColor),
	  color: color.blocked_out_of_range.color,
	
	  hover: {
	    background: color.blocked_out_of_range.backgroundColor_hover,
	    border: '1px solid ' + String(color.blocked_out_of_range.borderColor),
	    color: color.blocked_out_of_range.color_active
	  }
	};
	
	var hoveredSpanStyles = exports.hoveredSpanStyles = {
	  background: color.hoveredSpan.backgroundColor,
	  border: '1px solid ' + String(color.hoveredSpan.borderColor),
	  color: color.hoveredSpan.color,
	
	  hover: {
	    background: color.hoveredSpan.backgroundColor_hover,
	    border: '1px solid ' + String(color.hoveredSpan.borderColor),
	    color: color.hoveredSpan.color_active
	  }
	};
	
	var selectedSpanStyles = exports.selectedSpanStyles = {
	  background: color.selectedSpan.backgroundColor,
	  border: '1px solid ' + String(color.selectedSpan.borderColor),
	  color: color.selectedSpan.color,
	
	  hover: {
	    background: color.selectedSpan.backgroundColor_hover,
	    border: '1px solid ' + String(color.selectedSpan.borderColor),
	    color: color.selectedSpan.color_active
	  }
	};
	
	var lastInRangeStyles = exports.lastInRangeStyles = {
	  borderRight: color.core.primary
	};
	
	var selectedStyles = exports.selectedStyles = {
	  background: color.selected.backgroundColor,
	  border: '1px solid ' + String(color.selected.borderColor),
	  color: color.selected.color,
	
	  hover: {
	    background: color.selected.backgroundColor_hover,
	    border: '1px solid ' + String(color.selected.borderColor),
	    color: color.selected.color_active
	  }
	};
	
	var defaultProps = {
	  day: (0, _moment2['default'])(),
	  daySize: _constants.DAY_SIZE,
	  isOutsideDay: false,
	  modifiers: new Set(),
	  isFocused: false,
	  tabIndex: -1,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	
	  renderDayContents: null,
	  ariaLabelFormat: 'dddd, LL',
	
	  // style defaults
	  defaultStyles: defaultStyles,
	  outsideStyles: outsideStyles,
	  todayStyles: {},
	  highlightedCalendarStyles: highlightedCalendarStyles,
	  blockedMinNightsStyles: blockedMinNightsStyles,
	  blockedCalendarStyles: blockedCalendarStyles,
	  blockedOutOfRangeStyles: blockedOutOfRangeStyles,
	  hoveredSpanStyles: hoveredSpanStyles,
	  selectedSpanStyles: selectedSpanStyles,
	  lastInRangeStyles: lastInRangeStyles,
	  selectedStyles: selectedStyles,
	  selectedStartStyles: {},
	  selectedEndStyles: {},
	  afterHoveredStartStyles: {},
	  firstDayOfWeekStyles: {},
	  lastDayOfWeekStyles: {},
	
	  // internationalization
	  phrases: _defaultPhrases.CalendarDayPhrases
	};
	
	var CustomizableCalendarDay = function (_React$Component) {
	  _inherits(CustomizableCalendarDay, _React$Component);
	
	  function CustomizableCalendarDay() {
	    var _ref;
	
	    _classCallCheck(this, CustomizableCalendarDay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = CustomizableCalendarDay.__proto__ || Object.getPrototypeOf(CustomizableCalendarDay)).call.apply(_ref, [this].concat(args)));
	
	    _this.state = {
	      isHovered: false
	    };
	
	    _this.setButtonRef = _this.setButtonRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(CustomizableCalendarDay, [{
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _props = this.props,
	            isFocused = _props.isFocused,
	            tabIndex = _props.tabIndex;
	
	        if (tabIndex === 0) {
	          if (isFocused || tabIndex !== prevProps.tabIndex) {
	            this.buttonRef.focus();
	          }
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'onDayClick',
	    value: function () {
	      function onDayClick(day, e) {
	        var onDayClick = this.props.onDayClick;
	
	        onDayClick(day, e);
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: 'onDayMouseEnter',
	    value: function () {
	      function onDayMouseEnter(day, e) {
	        var onDayMouseEnter = this.props.onDayMouseEnter;
	
	        this.setState({ isHovered: true });
	        onDayMouseEnter(day, e);
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: 'onDayMouseLeave',
	    value: function () {
	      function onDayMouseLeave(day, e) {
	        var onDayMouseLeave = this.props.onDayMouseLeave;
	
	        this.setState({ isHovered: false });
	        onDayMouseLeave(day, e);
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: 'onKeyDown',
	    value: function () {
	      function onKeyDown(day, e) {
	        var onDayClick = this.props.onDayClick;
	        var key = e.key;
	
	        if (key === 'Enter' || key === ' ') {
	          onDayClick(day, e);
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: 'setButtonRef',
	    value: function () {
	      function setButtonRef(ref) {
	        this.buttonRef = ref;
	      }
	
	      return setButtonRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this2 = this;
	
	        var _props2 = this.props,
	            day = _props2.day,
	            ariaLabelFormat = _props2.ariaLabelFormat,
	            daySize = _props2.daySize,
	            isOutsideDay = _props2.isOutsideDay,
	            modifiers = _props2.modifiers,
	            tabIndex = _props2.tabIndex,
	            renderDayContents = _props2.renderDayContents,
	            styles = _props2.styles,
	            phrases = _props2.phrases,
	            defaultStylesWithHover = _props2.defaultStyles,
	            outsideStylesWithHover = _props2.outsideStyles,
	            todayStylesWithHover = _props2.todayStyles,
	            firstDayOfWeekStylesWithHover = _props2.firstDayOfWeekStyles,
	            lastDayOfWeekStylesWithHover = _props2.lastDayOfWeekStyles,
	            highlightedCalendarStylesWithHover = _props2.highlightedCalendarStyles,
	            blockedMinNightsStylesWithHover = _props2.blockedMinNightsStyles,
	            blockedCalendarStylesWithHover = _props2.blockedCalendarStyles,
	            blockedOutOfRangeStylesWithHover = _props2.blockedOutOfRangeStyles,
	            hoveredSpanStylesWithHover = _props2.hoveredSpanStyles,
	            selectedSpanStylesWithHover = _props2.selectedSpanStyles,
	            lastInRangeStylesWithHover = _props2.lastInRangeStyles,
	            selectedStylesWithHover = _props2.selectedStyles,
	            selectedStartStylesWithHover = _props2.selectedStartStyles,
	            selectedEndStylesWithHover = _props2.selectedEndStyles,
	            afterHoveredStartStylesWithHover = _props2.afterHoveredStartStyles;
	        var isHovered = this.state.isHovered;
	
	
	        if (!day) return _react2['default'].createElement('td', null);
	
	        var _getCalendarDaySettin = (0, _getCalendarDaySettings2['default'])(day, ariaLabelFormat, daySize, modifiers, phrases),
	            daySizeStyles = _getCalendarDaySettin.daySizeStyles,
	            useDefaultCursor = _getCalendarDaySettin.useDefaultCursor,
	            selected = _getCalendarDaySettin.selected,
	            hoveredSpan = _getCalendarDaySettin.hoveredSpan,
	            isOutsideRange = _getCalendarDaySettin.isOutsideRange,
	            ariaLabel = _getCalendarDaySettin.ariaLabel;
	
	        return _react2['default'].createElement(
	          'td',
	          _extends({}, (0, _reactWithStyles.css)(styles.CalendarDay, useDefaultCursor && styles.CalendarDay__defaultCursor, daySizeStyles, getStyles(defaultStylesWithHover, isHovered), isOutsideDay && getStyles(outsideStylesWithHover, isHovered), modifiers.has('today') && getStyles(todayStylesWithHover, isHovered), modifiers.has('first-day-of-week') && getStyles(firstDayOfWeekStylesWithHover, isHovered), modifiers.has('last-day-of-week') && getStyles(lastDayOfWeekStylesWithHover, isHovered), modifiers.has('highlighted-calendar') && getStyles(highlightedCalendarStylesWithHover, isHovered), modifiers.has('blocked-minimum-nights') && getStyles(blockedMinNightsStylesWithHover, isHovered), modifiers.has('blocked-calendar') && getStyles(blockedCalendarStylesWithHover, isHovered), hoveredSpan && getStyles(hoveredSpanStylesWithHover, isHovered), modifiers.has('after-hovered-start') && getStyles(afterHoveredStartStylesWithHover, isHovered), modifiers.has('selected-span') && getStyles(selectedSpanStylesWithHover, isHovered), modifiers.has('last-in-range') && getStyles(lastInRangeStylesWithHover, isHovered), selected && getStyles(selectedStylesWithHover, isHovered), modifiers.has('selected-start') && getStyles(selectedStartStylesWithHover, isHovered), modifiers.has('selected-end') && getStyles(selectedEndStylesWithHover, isHovered), isOutsideRange && getStyles(blockedOutOfRangeStylesWithHover, isHovered)), {
	            role: 'button' // eslint-disable-line jsx-a11y/no-noninteractive-element-to-interactive-role
	            , ref: this.setButtonRef,
	            'aria-label': ariaLabel,
	            onMouseEnter: function () {
	              function onMouseEnter(e) {
	                _this2.onDayMouseEnter(day, e);
	              }
	
	              return onMouseEnter;
	            }(),
	            onMouseLeave: function () {
	              function onMouseLeave(e) {
	                _this2.onDayMouseLeave(day, e);
	              }
	
	              return onMouseLeave;
	            }(),
	            onMouseUp: function () {
	              function onMouseUp(e) {
	                e.currentTarget.blur();
	              }
	
	              return onMouseUp;
	            }(),
	            onClick: function () {
	              function onClick(e) {
	                _this2.onDayClick(day, e);
	              }
	
	              return onClick;
	            }(),
	            onKeyDown: function () {
	              function onKeyDown(e) {
	                _this2.onKeyDown(day, e);
	              }
	
	              return onKeyDown;
	            }(),
	            tabIndex: tabIndex
	          }),
	          renderDayContents ? renderDayContents(day, modifiers) : day.format('D')
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return CustomizableCalendarDay;
	}(_react2['default'].Component);
	
	CustomizableCalendarDay.propTypes = propTypes;
	CustomizableCalendarDay.defaultProps = defaultProps;
	
	exports.PureCustomizableCalendarDay = CustomizableCalendarDay;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var font = _ref2.reactDates.font;
	  return {
	    CalendarDay: {
	      boxSizing: 'border-box',
	      cursor: 'pointer',
	      fontSize: font.size,
	      textAlign: 'center',
	
	      ':active': {
	        outline: 0
	      }
	    },
	
	    CalendarDay__defaultCursor: {
	      cursor: 'default'
	    }
	  };
	})(CustomizableCalendarDay);

/***/ }),

/***/ 231:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _reactWithStyles = __webpack_require__(26);
	
	var _throttle = __webpack_require__(210);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _isTouchDevice = __webpack_require__(51);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _getInputHeight = __webpack_require__(138);
	
	var _getInputHeight2 = _interopRequireDefault(_getInputHeight);
	
	var _OpenDirectionShape = __webpack_require__(55);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FANG_PATH_TOP = 'M0,' + String(_constants.FANG_HEIGHT_PX) + ' ' + String(_constants.FANG_WIDTH_PX) + ',' + String(_constants.FANG_HEIGHT_PX) + ' ' + _constants.FANG_WIDTH_PX / 2 + ',0z';
	var FANG_STROKE_TOP = 'M0,' + String(_constants.FANG_HEIGHT_PX) + ' ' + _constants.FANG_WIDTH_PX / 2 + ',0 ' + String(_constants.FANG_WIDTH_PX) + ',' + String(_constants.FANG_HEIGHT_PX);
	var FANG_PATH_BOTTOM = 'M0,0 ' + String(_constants.FANG_WIDTH_PX) + ',0 ' + _constants.FANG_WIDTH_PX / 2 + ',' + String(_constants.FANG_HEIGHT_PX) + 'z';
	var FANG_STROKE_BOTTOM = 'M0,0 ' + _constants.FANG_WIDTH_PX / 2 + ',' + String(_constants.FANG_HEIGHT_PX) + ' ' + String(_constants.FANG_WIDTH_PX) + ',0';
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  id: _propTypes2['default'].string.isRequired,
	  placeholder: _propTypes2['default'].string, // also used as label
	  displayValue: _propTypes2['default'].string,
	  screenReaderMessage: _propTypes2['default'].string,
	  focused: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  openDirection: _OpenDirectionShape2['default'],
	  showCaret: _propTypes2['default'].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	  small: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  regular: _propTypes2['default'].bool,
	
	  onChange: _propTypes2['default'].func,
	  onFocus: _propTypes2['default'].func,
	  onKeyDownShiftTab: _propTypes2['default'].func,
	  onKeyDownTab: _propTypes2['default'].func,
	
	  onKeyDownArrowDown: _propTypes2['default'].func,
	  onKeyDownQuestionMark: _propTypes2['default'].func,
	
	  // accessibility
	  isFocused: _propTypes2['default'].bool // describes actual DOM focus
	}));
	
	var defaultProps = {
	  placeholder: 'Select Date',
	  displayValue: '',
	  screenReaderMessage: '',
	  focused: false,
	  disabled: false,
	  required: false,
	  readOnly: null,
	  openDirection: _constants.OPEN_DOWN,
	  showCaret: false,
	  verticalSpacing: _constants.DEFAULT_VERTICAL_SPACING,
	  small: false,
	  block: false,
	  regular: false,
	
	  onChange: function () {
	    function onChange() {}
	
	    return onChange;
	  }(),
	  onFocus: function () {
	    function onFocus() {}
	
	    return onFocus;
	  }(),
	  onKeyDownShiftTab: function () {
	    function onKeyDownShiftTab() {}
	
	    return onKeyDownShiftTab;
	  }(),
	  onKeyDownTab: function () {
	    function onKeyDownTab() {}
	
	    return onKeyDownTab;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	
	
	  // accessibility
	  isFocused: false
	};
	
	var DateInput = function (_React$Component) {
	  _inherits(DateInput, _React$Component);
	
	  function DateInput(props) {
	    _classCallCheck(this, DateInput);
	
	    var _this = _possibleConstructorReturn(this, (DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call(this, props));
	
	    _this.state = {
	      dateString: '',
	      isTouchDevice: false
	    };
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.setInputRef = _this.setInputRef.bind(_this);
	    _this.throttledKeyDown = (0, _throttle2['default'])(_this.onFinalKeyDown, 300, { trailing: false });
	    return _this;
	  }
	
	  _createClass(DateInput, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.setState({ isTouchDevice: (0, _isTouchDevice2['default'])() });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        if (this.state.dateString && nextProps.displayValue) {
	          this.setState({
	            dateString: ''
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var _props = this.props,
	            focused = _props.focused,
	            isFocused = _props.isFocused;
	
	        if (prevProps.focused === focused && prevProps.isFocused === isFocused) return;
	
	        if (focused && isFocused) {
	          this.inputRef.focus();
	        } else {
	          this.inputRef.blur();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'onChange',
	    value: function () {
	      function onChange(e) {
	        var _props2 = this.props,
	            onChange = _props2.onChange,
	            onKeyDownQuestionMark = _props2.onKeyDownQuestionMark;
	
	        var dateString = e.target.value;
	
	        // In Safari, onKeyDown does not consistently fire ahead of onChange. As a result, we need to
	        // special case the `?` key so that it always triggers the appropriate callback, instead of
	        // modifying the input value
	        if (dateString[dateString.length - 1] === '?') {
	          onKeyDownQuestionMark(e);
	        } else {
	          this.setState({ dateString: dateString }, function () {
	            return onChange(dateString);
	          });
	        }
	      }
	
	      return onChange;
	    }()
	  }, {
	    key: 'onKeyDown',
	    value: function () {
	      function onKeyDown(e) {
	        e.stopPropagation();
	        if (!_constants.MODIFIER_KEY_NAMES.has(e.key)) {
	          this.throttledKeyDown(e);
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: 'onFinalKeyDown',
	    value: function () {
	      function onFinalKeyDown(e) {
	        var _props3 = this.props,
	            onKeyDownShiftTab = _props3.onKeyDownShiftTab,
	            onKeyDownTab = _props3.onKeyDownTab,
	            onKeyDownArrowDown = _props3.onKeyDownArrowDown,
	            onKeyDownQuestionMark = _props3.onKeyDownQuestionMark;
	        var key = e.key;
	
	
	        if (key === 'Tab') {
	          if (e.shiftKey) {
	            onKeyDownShiftTab(e);
	          } else {
	            onKeyDownTab(e);
	          }
	        } else if (key === 'ArrowDown') {
	          onKeyDownArrowDown(e);
	        } else if (key === '?') {
	          e.preventDefault();
	          onKeyDownQuestionMark(e);
	        }
	      }
	
	      return onFinalKeyDown;
	    }()
	  }, {
	    key: 'setInputRef',
	    value: function () {
	      function setInputRef(ref) {
	        this.inputRef = ref;
	      }
	
	      return setInputRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _state = this.state,
	            dateString = _state.dateString,
	            isTouch = _state.isTouchDevice;
	        var _props4 = this.props,
	            id = _props4.id,
	            placeholder = _props4.placeholder,
	            displayValue = _props4.displayValue,
	            screenReaderMessage = _props4.screenReaderMessage,
	            focused = _props4.focused,
	            showCaret = _props4.showCaret,
	            onFocus = _props4.onFocus,
	            disabled = _props4.disabled,
	            required = _props4.required,
	            readOnly = _props4.readOnly,
	            openDirection = _props4.openDirection,
	            verticalSpacing = _props4.verticalSpacing,
	            small = _props4.small,
	            regular = _props4.regular,
	            block = _props4.block,
	            styles = _props4.styles,
	            reactDates = _props4.theme.reactDates;
	
	
	        var value = displayValue || dateString || '';
	        var screenReaderMessageId = 'DateInput__screen-reader-message-' + String(id);
	
	        var withFang = showCaret && focused;
	
	        var inputHeight = (0, _getInputHeight2['default'])(reactDates, small);
	
	        return _react2['default'].createElement(
	          'div',
	          (0, _reactWithStyles.css)(styles.DateInput, small && styles.DateInput__small, block && styles.DateInput__block, withFang && styles.DateInput__withFang, disabled && styles.DateInput__disabled, withFang && openDirection === _constants.OPEN_DOWN && styles.DateInput__openDown, withFang && openDirection === _constants.OPEN_UP && styles.DateInput__openUp),
	          _react2['default'].createElement('input', _extends({}, (0, _reactWithStyles.css)(styles.DateInput_input, small && styles.DateInput_input__small, regular && styles.DateInput_input__regular, readOnly && styles.DateInput_input__readOnly, focused && styles.DateInput_input__focused, disabled && styles.DateInput_input__disabled), {
	            'aria-label': placeholder,
	            type: 'text',
	            id: id,
	            name: id,
	            ref: this.setInputRef,
	            value: value,
	            onChange: this.onChange,
	            onKeyDown: this.onKeyDown,
	            onFocus: onFocus,
	            placeholder: placeholder,
	            autoComplete: 'off',
	            disabled: disabled,
	            readOnly: typeof readOnly === 'boolean' ? readOnly : isTouch,
	            required: required,
	            'aria-describedby': screenReaderMessage && screenReaderMessageId
	          })),
	          withFang && _react2['default'].createElement(
	            'svg',
	            _extends({
	              role: 'presentation',
	              focusable: 'false'
	            }, (0, _reactWithStyles.css)(styles.DateInput_fang, openDirection === _constants.OPEN_DOWN && {
	              top: inputHeight + verticalSpacing - _constants.FANG_HEIGHT_PX - 1
	            }, openDirection === _constants.OPEN_UP && {
	              bottom: inputHeight + verticalSpacing - _constants.FANG_HEIGHT_PX - 1
	            })),
	            _react2['default'].createElement('path', _extends({}, (0, _reactWithStyles.css)(styles.DateInput_fangShape), {
	              d: openDirection === _constants.OPEN_DOWN ? FANG_PATH_TOP : FANG_PATH_BOTTOM
	            })),
	            _react2['default'].createElement('path', _extends({}, (0, _reactWithStyles.css)(styles.DateInput_fangStroke), {
	              d: openDirection === _constants.OPEN_DOWN ? FANG_STROKE_TOP : FANG_STROKE_BOTTOM
	            }))
	          ),
	          screenReaderMessage && _react2['default'].createElement(
	            'p',
	            _extends({}, (0, _reactWithStyles.css)(styles.DateInput_screenReaderMessage), { id: screenReaderMessageId }),
	            screenReaderMessage
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DateInput;
	}(_react2['default'].Component);
	
	DateInput.propTypes = propTypes;
	DateInput.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      border = _ref$reactDates.border,
	      color = _ref$reactDates.color,
	      sizing = _ref$reactDates.sizing,
	      spacing = _ref$reactDates.spacing,
	      font = _ref$reactDates.font,
	      zIndex = _ref$reactDates.zIndex;
	  return {
	    DateInput: {
	      margin: 0,
	      padding: spacing.inputPadding,
	      background: color.background,
	      position: 'relative',
	      display: 'inline-block',
	      width: sizing.inputWidth,
	      verticalAlign: 'middle'
	    },
	
	    DateInput__small: {
	      width: sizing.inputWidth_small
	    },
	
	    DateInput__block: {
	      width: '100%'
	    },
	
	    DateInput__disabled: {
	      background: color.disabled,
	      color: color.textDisabled
	    },
	
	    DateInput_input: {
	      fontWeight: 200,
	      fontSize: font.input.size,
	      lineHeight: font.input.lineHeight,
	      color: color.text,
	      backgroundColor: color.background,
	      width: '100%',
	      padding: String(spacing.displayTextPaddingVertical) + 'px ' + String(spacing.displayTextPaddingHorizontal) + 'px',
	      paddingTop: spacing.displayTextPaddingTop,
	      paddingBottom: spacing.displayTextPaddingBottom,
	      paddingLeft: spacing.displayTextPaddingLeft,
	      paddingRight: spacing.displayTextPaddingRight,
	      border: border.input.border,
	      borderTop: border.input.borderTop,
	      borderRight: border.input.borderRight,
	      borderBottom: border.input.borderBottom,
	      borderLeft: border.input.borderLeft,
	      borderRadius: border.input.borderRadius
	    },
	
	    DateInput_input__small: {
	      fontSize: font.input.size_small,
	      lineHeight: font.input.lineHeight_small,
	      letterSpacing: font.input.letterSpacing_small,
	      padding: String(spacing.displayTextPaddingVertical_small) + 'px ' + String(spacing.displayTextPaddingHorizontal_small) + 'px',
	      paddingTop: spacing.displayTextPaddingTop_small,
	      paddingBottom: spacing.displayTextPaddingBottom_small,
	      paddingLeft: spacing.displayTextPaddingLeft_small,
	      paddingRight: spacing.displayTextPaddingRight_small
	    },
	
	    DateInput_input__regular: {
	      fontWeight: 'auto'
	    },
	
	    DateInput_input__readOnly: {
	      userSelect: 'none'
	    },
	
	    DateInput_input__focused: {
	      outline: border.input.outlineFocused,
	      background: color.backgroundFocused,
	      border: border.input.borderFocused,
	      borderTop: border.input.borderTopFocused,
	      borderRight: border.input.borderRightFocused,
	      borderBottom: border.input.borderBottomFocused,
	      borderLeft: border.input.borderLeftFocused
	    },
	
	    DateInput_input__disabled: {
	      background: color.disabled,
	      fontStyle: font.input.styleDisabled
	    },
	
	    DateInput_screenReaderMessage: {
	      border: 0,
	      clip: 'rect(0, 0, 0, 0)',
	      height: 1,
	      margin: -1,
	      overflow: 'hidden',
	      padding: 0,
	      position: 'absolute',
	      width: 1
	    },
	
	    DateInput_fang: {
	      position: 'absolute',
	      width: _constants.FANG_WIDTH_PX,
	      height: _constants.FANG_HEIGHT_PX,
	      left: 22,
	      zIndex: zIndex + 2
	    },
	
	    DateInput_fangShape: {
	      fill: color.background
	    },
	
	    DateInput_fangStroke: {
	      stroke: color.core.border,
	      fill: 'transparent'
	    }
	  };
	})(DateInput);

/***/ }),

/***/ 527:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureDateRangePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsShallowCompare = __webpack_require__(54);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactWithStyles = __webpack_require__(26);
	
	var _reactPortal = __webpack_require__(258);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _consolidatedEvents = __webpack_require__(90);
	
	var _isTouchDevice = __webpack_require__(51);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _DateRangePickerShape = __webpack_require__(240);
	
	var _DateRangePickerShape2 = _interopRequireDefault(_DateRangePickerShape);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getResponsiveContainerStyles = __webpack_require__(250);
	
	var _getResponsiveContainerStyles2 = _interopRequireDefault(_getResponsiveContainerStyles);
	
	var _getDetachedContainerStyles = __webpack_require__(249);
	
	var _getDetachedContainerStyles2 = _interopRequireDefault(_getDetachedContainerStyles);
	
	var _getInputHeight = __webpack_require__(138);
	
	var _getInputHeight2 = _interopRequireDefault(_getInputHeight);
	
	var _isInclusivelyAfterDay = __webpack_require__(83);
	
	var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
	var _disableScroll2 = __webpack_require__(246);
	
	var _disableScroll3 = _interopRequireDefault(_disableScroll2);
	
	var _DateRangePickerInputController = __webpack_require__(233);
	
	var _DateRangePickerInputController2 = _interopRequireDefault(_DateRangePickerInputController);
	
	var _DayPickerRangeController = __webpack_require__(234);
	
	var _DayPickerRangeController2 = _interopRequireDefault(_DayPickerRangeController);
	
	var _OutsideClickHandler = __webpack_require__(96);
	
	var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
	var _CloseButton = __webpack_require__(78);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, _DateRangePickerShape2['default']));
	
	var defaultProps = {
	  // required props for a functional interactive DateRangePicker
	  startDate: null,
	  endDate: null,
	  focusedInput: null,
	
	  // input related props
	  startDatePlaceholderText: 'Start Date',
	  endDatePlaceholderText: 'End Date',
	  disabled: false,
	  required: false,
	  readOnly: false,
	  screenReaderInputMessage: '',
	  showClearDates: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customInputIcon: null,
	  customArrowIcon: null,
	  customCloseIcon: null,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  keepFocusOnInput: false,
	
	  // calendar presentation and interaction related props
	  renderMonth: null,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  anchorDirection: _constants.ANCHOR_LEFT,
	  openDirection: _constants.OPEN_DOWN,
	  horizontalMargin: 0,
	  withPortal: false,
	  withFullScreenPortal: false,
	  appendToBody: false,
	  disableScroll: false,
	  initialVisibleMonth: null,
	  numberOfMonths: 2,
	  keepOpenOnDateSelect: false,
	  reopenPickerOnClearDates: false,
	  renderCalendarInfo: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	  hideKeyboardShortcutsPanel: false,
	  daySize: _constants.DAY_SIZE,
	  isRTL: false,
	  firstDayOfWeek: null,
	  verticalHeight: null,
	  transitionDuration: undefined,
	  verticalSpacing: _constants.DEFAULT_VERTICAL_SPACING,
	
	  // navigation related props
	  navPrev: null,
	  navNext: null,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	
	
	  // day presentation and interaction related props
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  minimumNights: 1,
	  enableOutsideDays: false,
	  isDayBlocked: function () {
	    function isDayBlocked() {
	      return false;
	    }
	
	    return isDayBlocked;
	  }(),
	  isOutsideRange: function () {
	    function isOutsideRange(day) {
	      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
	    }
	
	    return isOutsideRange;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {
	      return false;
	    }
	
	    return isDayHighlighted;
	  }(),
	
	  // internationalization
	  displayFormat: function () {
	    function displayFormat() {
	      return _moment2['default'].localeData().longDateFormat('L');
	    }
	
	    return displayFormat;
	  }(),
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DateRangePickerPhrases,
	  dayAriaLabelFormat: undefined
	};
	
	var DateRangePicker = function (_React$Component) {
	  _inherits(DateRangePicker, _React$Component);
	
	  function DateRangePicker(props) {
	    _classCallCheck(this, DateRangePicker);
	
	    var _this = _possibleConstructorReturn(this, (DateRangePicker.__proto__ || Object.getPrototypeOf(DateRangePicker)).call(this, props));
	
	    _this.state = {
	      dayPickerContainerStyles: {},
	      isDateRangePickerInputFocused: false,
	      isDayPickerFocused: false,
	      showKeyboardShortcuts: false
	    };
	
	    _this.isTouchDevice = false;
	
	    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
	    _this.onDateRangePickerInputFocus = _this.onDateRangePickerInputFocus.bind(_this);
	    _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_this);
	    _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_this);
	    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind(_this);
	
	    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_this);
	    _this.disableScroll = _this.disableScroll.bind(_this);
	
	    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_this);
	    _this.setContainerRef = _this.setContainerRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateRangePicker, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, { passive: true });
	        this.responsivizePickerPosition();
	        this.disableScroll();
	
	        if (this.props.focusedInput) {
	          this.setState({
	            isDateRangePickerInputFocused: true
	          });
	        }
	
	        this.isTouchDevice = (0, _isTouchDevice2['default'])();
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        if (!prevProps.focusedInput && this.props.focusedInput && this.isOpened()) {
	          // The date picker just changed from being closed to being open.
	          this.responsivizePickerPosition();
	          this.disableScroll();
	        } else if (prevProps.focusedInput && !this.props.focusedInput && !this.isOpened()) {
	          // The date picker just changed from being open to being closed.
	          if (this.enableScroll) this.enableScroll();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeEventListener) this.removeEventListener();
	        if (this.enableScroll) this.enableScroll();
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onOutsideClick',
	    value: function () {
	      function onOutsideClick(event) {
	        var _props = this.props,
	            onFocusChange = _props.onFocusChange,
	            onClose = _props.onClose,
	            startDate = _props.startDate,
	            endDate = _props.endDate;
	
	        if (!this.isOpened()) return;
	        if (this.props.appendToBody && this.dayPickerContainer.contains(event.target)) return;
	
	        this.setState({
	          isDateRangePickerInputFocused: false,
	          isDayPickerFocused: false,
	          showKeyboardShortcuts: false
	        });
	
	        onFocusChange(null);
	        onClose({ startDate: startDate, endDate: endDate });
	      }
	
	      return onOutsideClick;
	    }()
	  }, {
	    key: 'onDateRangePickerInputFocus',
	    value: function () {
	      function onDateRangePickerInputFocus(focusedInput) {
	        var _props2 = this.props,
	            onFocusChange = _props2.onFocusChange,
	            readOnly = _props2.readOnly,
	            withPortal = _props2.withPortal,
	            withFullScreenPortal = _props2.withFullScreenPortal,
	            keepFocusOnInput = _props2.keepFocusOnInput;
	
	
	        if (focusedInput) {
	          var withAnyPortal = withPortal || withFullScreenPortal;
	          var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;
	
	          if (moveFocusToDayPicker) {
	            this.onDayPickerFocus();
	          } else {
	            this.onDayPickerBlur();
	          }
	        }
	
	        onFocusChange(focusedInput);
	      }
	
	      return onDateRangePickerInputFocus;
	    }()
	  }, {
	    key: 'onDayPickerFocus',
	    value: function () {
	      function onDayPickerFocus() {
	        var _props3 = this.props,
	            focusedInput = _props3.focusedInput,
	            onFocusChange = _props3.onFocusChange;
	
	        if (!focusedInput) onFocusChange(_constants.START_DATE);
	
	        this.setState({
	          isDateRangePickerInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerFocus;
	    }()
	  }, {
	    key: 'onDayPickerBlur',
	    value: function () {
	      function onDayPickerBlur() {
	        this.setState({
	          isDateRangePickerInputFocused: true,
	          isDayPickerFocused: false,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerBlur;
	    }()
	  }, {
	    key: 'setDayPickerContainerRef',
	    value: function () {
	      function setDayPickerContainerRef(ref) {
	        this.dayPickerContainer = ref;
	      }
	
	      return setDayPickerContainerRef;
	    }()
	  }, {
	    key: 'setContainerRef',
	    value: function () {
	      function setContainerRef(ref) {
	        this.container = ref;
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: 'isOpened',
	    value: function () {
	      function isOpened() {
	        var focusedInput = this.props.focusedInput;
	
	        return focusedInput === _constants.START_DATE || focusedInput === _constants.END_DATE;
	      }
	
	      return isOpened;
	    }()
	  }, {
	    key: 'disableScroll',
	    value: function () {
	      function disableScroll() {
	        if (!this.props.appendToBody && !this.props.disableScroll) return;
	        if (!this.isOpened()) return;
	
	        // Disable scroll for every ancestor of this DateRangePicker up to the
	        // document level. This ensures the input and the picker never move. Other
	        // sibling elements or the picker itself can scroll.
	        this.enableScroll = (0, _disableScroll3['default'])(this.container);
	      }
	
	      return disableScroll;
	    }()
	  }, {
	    key: 'responsivizePickerPosition',
	    value: function () {
	      function responsivizePickerPosition() {
	        // It's possible the portal props have been changed in response to window resizes
	        // So let's ensure we reset this back to the base state each time
	        this.setState({ dayPickerContainerStyles: {} });
	
	        if (!this.isOpened()) {
	          return;
	        }
	
	        var _props4 = this.props,
	            openDirection = _props4.openDirection,
	            anchorDirection = _props4.anchorDirection,
	            horizontalMargin = _props4.horizontalMargin,
	            withPortal = _props4.withPortal,
	            withFullScreenPortal = _props4.withFullScreenPortal,
	            appendToBody = _props4.appendToBody;
	        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;
	
	
	        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;
	        if (!withPortal && !withFullScreenPortal) {
	          var containerRect = this.dayPickerContainer.getBoundingClientRect();
	          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
	          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];
	
	          this.setState({
	            dayPickerContainerStyles: (0, _object2['default'])({}, (0, _getResponsiveContainerStyles2['default'])(anchorDirection, currentOffset, containerEdge, horizontalMargin), appendToBody && (0, _getDetachedContainerStyles2['default'])(openDirection, anchorDirection, this.container))
	          });
	        }
	      }
	
	      return responsivizePickerPosition;
	    }()
	  }, {
	    key: 'showKeyboardShortcutsPanel',
	    value: function () {
	      function showKeyboardShortcutsPanel() {
	        this.setState({
	          isDateRangePickerInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: true
	        });
	      }
	
	      return showKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: 'maybeRenderDayPickerWithPortal',
	    value: function () {
	      function maybeRenderDayPickerWithPortal() {
	        var _props5 = this.props,
	            withPortal = _props5.withPortal,
	            withFullScreenPortal = _props5.withFullScreenPortal,
	            appendToBody = _props5.appendToBody;
	
	
	        if (!this.isOpened()) {
	          return null;
	        }
	
	        if (withPortal || withFullScreenPortal || appendToBody) {
	          return _react2['default'].createElement(
	            _reactPortal.Portal,
	            null,
	            this.renderDayPicker()
	          );
	        }
	
	        return this.renderDayPicker();
	      }
	
	      return maybeRenderDayPickerWithPortal;
	    }()
	  }, {
	    key: 'renderDayPicker',
	    value: function () {
	      function renderDayPicker() {
	        var _props6 = this.props,
	            anchorDirection = _props6.anchorDirection,
	            openDirection = _props6.openDirection,
	            isDayBlocked = _props6.isDayBlocked,
	            isDayHighlighted = _props6.isDayHighlighted,
	            isOutsideRange = _props6.isOutsideRange,
	            numberOfMonths = _props6.numberOfMonths,
	            orientation = _props6.orientation,
	            monthFormat = _props6.monthFormat,
	            renderMonth = _props6.renderMonth,
	            navPrev = _props6.navPrev,
	            navNext = _props6.navNext,
	            onPrevMonthClick = _props6.onPrevMonthClick,
	            onNextMonthClick = _props6.onNextMonthClick,
	            onDatesChange = _props6.onDatesChange,
	            onFocusChange = _props6.onFocusChange,
	            withPortal = _props6.withPortal,
	            withFullScreenPortal = _props6.withFullScreenPortal,
	            daySize = _props6.daySize,
	            enableOutsideDays = _props6.enableOutsideDays,
	            focusedInput = _props6.focusedInput,
	            startDate = _props6.startDate,
	            endDate = _props6.endDate,
	            minimumNights = _props6.minimumNights,
	            keepOpenOnDateSelect = _props6.keepOpenOnDateSelect,
	            renderCalendarDay = _props6.renderCalendarDay,
	            renderDayContents = _props6.renderDayContents,
	            renderCalendarInfo = _props6.renderCalendarInfo,
	            calendarInfoPosition = _props6.calendarInfoPosition,
	            firstDayOfWeek = _props6.firstDayOfWeek,
	            initialVisibleMonth = _props6.initialVisibleMonth,
	            hideKeyboardShortcutsPanel = _props6.hideKeyboardShortcutsPanel,
	            customCloseIcon = _props6.customCloseIcon,
	            onClose = _props6.onClose,
	            phrases = _props6.phrases,
	            dayAriaLabelFormat = _props6.dayAriaLabelFormat,
	            isRTL = _props6.isRTL,
	            weekDayFormat = _props6.weekDayFormat,
	            styles = _props6.styles,
	            verticalHeight = _props6.verticalHeight,
	            transitionDuration = _props6.transitionDuration,
	            verticalSpacing = _props6.verticalSpacing,
	            small = _props6.small,
	            disabled = _props6.disabled,
	            reactDates = _props6.theme.reactDates;
	        var _state = this.state,
	            dayPickerContainerStyles = _state.dayPickerContainerStyles,
	            isDayPickerFocused = _state.isDayPickerFocused,
	            showKeyboardShortcuts = _state.showKeyboardShortcuts;
	
	
	        var onOutsideClick = !withFullScreenPortal && withPortal ? this.onOutsideClick : undefined;
	        var initialVisibleMonthThunk = initialVisibleMonth || function () {
	          return startDate || endDate || (0, _moment2['default'])();
	        };
	
	        var closeIcon = customCloseIcon || _react2['default'].createElement(_CloseButton2['default'], (0, _reactWithStyles.css)(styles.DateRangePicker_closeButton_svg));
	
	        var inputHeight = (0, _getInputHeight2['default'])(reactDates, small);
	
	        var withAnyPortal = withPortal || withFullScreenPortal;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({ // eslint-disable-line jsx-a11y/no-static-element-interactions
	            ref: this.setDayPickerContainerRef
	          }, (0, _reactWithStyles.css)(styles.DateRangePicker_picker, anchorDirection === _constants.ANCHOR_LEFT && styles.DateRangePicker_picker__directionLeft, anchorDirection === _constants.ANCHOR_RIGHT && styles.DateRangePicker_picker__directionRight, orientation === _constants.HORIZONTAL_ORIENTATION && styles.DateRangePicker_picker__horizontal, orientation === _constants.VERTICAL_ORIENTATION && styles.DateRangePicker_picker__vertical, !withAnyPortal && openDirection === _constants.OPEN_DOWN && {
	            top: inputHeight + verticalSpacing
	          }, !withAnyPortal && openDirection === _constants.OPEN_UP && {
	            bottom: inputHeight + verticalSpacing
	          }, withAnyPortal && styles.DateRangePicker_picker__portal, withFullScreenPortal && styles.DateRangePicker_picker__fullScreenPortal, isRTL && styles.DateRangePicker_picker__rtl, dayPickerContainerStyles), {
	            onClick: onOutsideClick
	          }),
	          _react2['default'].createElement(_DayPickerRangeController2['default'], {
	            orientation: orientation,
	            enableOutsideDays: enableOutsideDays,
	            numberOfMonths: numberOfMonths,
	            onPrevMonthClick: onPrevMonthClick,
	            onNextMonthClick: onNextMonthClick,
	            onDatesChange: onDatesChange,
	            onFocusChange: onFocusChange,
	            onClose: onClose,
	            focusedInput: focusedInput,
	            startDate: startDate,
	            endDate: endDate,
	            monthFormat: monthFormat,
	            renderMonth: renderMonth,
	            withPortal: withAnyPortal,
	            daySize: daySize,
	            initialVisibleMonth: initialVisibleMonthThunk,
	            hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	            navPrev: navPrev,
	            navNext: navNext,
	            minimumNights: minimumNights,
	            isOutsideRange: isOutsideRange,
	            isDayHighlighted: isDayHighlighted,
	            isDayBlocked: isDayBlocked,
	            keepOpenOnDateSelect: keepOpenOnDateSelect,
	            renderCalendarDay: renderCalendarDay,
	            renderDayContents: renderDayContents,
	            renderCalendarInfo: renderCalendarInfo,
	            calendarInfoPosition: calendarInfoPosition,
	            isFocused: isDayPickerFocused,
	            showKeyboardShortcuts: showKeyboardShortcuts,
	            onBlur: this.onDayPickerBlur,
	            phrases: phrases,
	            dayAriaLabelFormat: dayAriaLabelFormat,
	            isRTL: isRTL,
	            firstDayOfWeek: firstDayOfWeek,
	            weekDayFormat: weekDayFormat,
	            verticalHeight: verticalHeight,
	            transitionDuration: transitionDuration,
	            disabled: disabled
	          }),
	          withFullScreenPortal && _react2['default'].createElement(
	            'button',
	            _extends({}, (0, _reactWithStyles.css)(styles.DateRangePicker_closeButton), {
	              type: 'button',
	              onClick: this.onOutsideClick,
	              'aria-label': phrases.closeDatePicker
	            }),
	            closeIcon
	          )
	        );
	      }
	
	      return renderDayPicker;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props7 = this.props,
	            startDate = _props7.startDate,
	            startDateId = _props7.startDateId,
	            startDatePlaceholderText = _props7.startDatePlaceholderText,
	            endDate = _props7.endDate,
	            endDateId = _props7.endDateId,
	            endDatePlaceholderText = _props7.endDatePlaceholderText,
	            focusedInput = _props7.focusedInput,
	            screenReaderInputMessage = _props7.screenReaderInputMessage,
	            showClearDates = _props7.showClearDates,
	            showDefaultInputIcon = _props7.showDefaultInputIcon,
	            inputIconPosition = _props7.inputIconPosition,
	            customInputIcon = _props7.customInputIcon,
	            customArrowIcon = _props7.customArrowIcon,
	            customCloseIcon = _props7.customCloseIcon,
	            disabled = _props7.disabled,
	            required = _props7.required,
	            readOnly = _props7.readOnly,
	            openDirection = _props7.openDirection,
	            phrases = _props7.phrases,
	            isOutsideRange = _props7.isOutsideRange,
	            minimumNights = _props7.minimumNights,
	            withPortal = _props7.withPortal,
	            withFullScreenPortal = _props7.withFullScreenPortal,
	            displayFormat = _props7.displayFormat,
	            reopenPickerOnClearDates = _props7.reopenPickerOnClearDates,
	            keepOpenOnDateSelect = _props7.keepOpenOnDateSelect,
	            onDatesChange = _props7.onDatesChange,
	            onClose = _props7.onClose,
	            isRTL = _props7.isRTL,
	            noBorder = _props7.noBorder,
	            block = _props7.block,
	            verticalSpacing = _props7.verticalSpacing,
	            small = _props7.small,
	            regular = _props7.regular,
	            styles = _props7.styles;
	        var isDateRangePickerInputFocused = this.state.isDateRangePickerInputFocused;
	
	
	        var onOutsideClick = !withPortal && !withFullScreenPortal ? this.onOutsideClick : undefined;
	
	        var hideFang = verticalSpacing < _constants.FANG_HEIGHT_PX;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({
	            ref: this.setContainerRef
	          }, (0, _reactWithStyles.css)(styles.DateRangePicker, block && styles.DateRangePicker__block)),
	          _react2['default'].createElement(
	            _OutsideClickHandler2['default'],
	            { onOutsideClick: onOutsideClick },
	            _react2['default'].createElement(_DateRangePickerInputController2['default'], {
	              startDate: startDate,
	              startDateId: startDateId,
	              startDatePlaceholderText: startDatePlaceholderText,
	              isStartDateFocused: focusedInput === _constants.START_DATE,
	              endDate: endDate,
	              endDateId: endDateId,
	              endDatePlaceholderText: endDatePlaceholderText,
	              isEndDateFocused: focusedInput === _constants.END_DATE,
	              displayFormat: displayFormat,
	              showClearDates: showClearDates,
	              showCaret: !withPortal && !withFullScreenPortal && !hideFang,
	              showDefaultInputIcon: showDefaultInputIcon,
	              inputIconPosition: inputIconPosition,
	              customInputIcon: customInputIcon,
	              customArrowIcon: customArrowIcon,
	              customCloseIcon: customCloseIcon,
	              disabled: disabled,
	              required: required,
	              readOnly: readOnly,
	              openDirection: openDirection,
	              reopenPickerOnClearDates: reopenPickerOnClearDates,
	              keepOpenOnDateSelect: keepOpenOnDateSelect,
	              isOutsideRange: isOutsideRange,
	              minimumNights: minimumNights,
	              withFullScreenPortal: withFullScreenPortal,
	              onDatesChange: onDatesChange,
	              onFocusChange: this.onDateRangePickerInputFocus,
	              onKeyDownArrowDown: this.onDayPickerFocus,
	              onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
	              onClose: onClose,
	              phrases: phrases,
	              screenReaderMessage: screenReaderInputMessage,
	              isFocused: isDateRangePickerInputFocused,
	              isRTL: isRTL,
	              noBorder: noBorder,
	              block: block,
	              small: small,
	              regular: regular,
	              verticalSpacing: verticalSpacing
	            }),
	            this.maybeRenderDayPickerWithPortal()
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DateRangePicker;
	}(_react2['default'].Component);
	
	DateRangePicker.propTypes = propTypes;
	DateRangePicker.defaultProps = defaultProps;
	
	exports.PureDateRangePicker = DateRangePicker;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      zIndex = _ref$reactDates.zIndex;
	  return {
	    DateRangePicker: {
	      position: 'relative',
	      display: 'inline-block'
	    },
	
	    DateRangePicker__block: {
	      display: 'block'
	    },
	
	    DateRangePicker_picker: {
	      zIndex: zIndex + 1,
	      backgroundColor: color.background,
	      position: 'absolute'
	    },
	
	    DateRangePicker_picker__rtl: {
	      direction: 'rtl'
	    },
	
	    DateRangePicker_picker__directionLeft: {
	      left: 0
	    },
	
	    DateRangePicker_picker__directionRight: {
	      right: 0
	    },
	
	    DateRangePicker_picker__portal: {
	      backgroundColor: 'rgba(0, 0, 0, 0.3)',
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      height: '100%',
	      width: '100%'
	    },
	
	    DateRangePicker_picker__fullScreenPortal: {
	      backgroundColor: color.background
	    },
	
	    DateRangePicker_closeButton: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      cursor: 'pointer',
	
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      padding: 15,
	      zIndex: zIndex + 2,
	
	      ':hover': {
	        color: 'darken(' + String(color.core.grayLighter) + ', 10%)',
	        textDecoration: 'none'
	      },
	
	      ':focus': {
	        color: 'darken(' + String(color.core.grayLighter) + ', 10%)',
	        textDecoration: 'none'
	      }
	    },
	
	    DateRangePicker_closeButton_svg: {
	      height: 15,
	      width: 15,
	      fill: color.core.grayLighter
	    }
	  };
	})(DateRangePicker);

/***/ }),

/***/ 232:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _reactWithStyles = __webpack_require__(26);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _OpenDirectionShape = __webpack_require__(55);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _DateInput = __webpack_require__(231);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _IconPositionShape = __webpack_require__(80);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _DisabledShape = __webpack_require__(97);
	
	var _DisabledShape2 = _interopRequireDefault(_DisabledShape);
	
	var _RightArrow = __webpack_require__(237);
	
	var _RightArrow2 = _interopRequireDefault(_RightArrow);
	
	var _LeftArrow = __webpack_require__(236);
	
	var _LeftArrow2 = _interopRequireDefault(_LeftArrow);
	
	var _CloseButton = __webpack_require__(78);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _CalendarIcon = __webpack_require__(228);
	
	var _CalendarIcon2 = _interopRequireDefault(_CalendarIcon);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  startDateId: _propTypes2['default'].string,
	  startDatePlaceholderText: _propTypes2['default'].string,
	  screenReaderMessage: _propTypes2['default'].string,
	
	  endDateId: _propTypes2['default'].string,
	  endDatePlaceholderText: _propTypes2['default'].string,
	
	  onStartDateFocus: _propTypes2['default'].func,
	  onEndDateFocus: _propTypes2['default'].func,
	  onStartDateChange: _propTypes2['default'].func,
	  onEndDateChange: _propTypes2['default'].func,
	  onStartDateShiftTab: _propTypes2['default'].func,
	  onEndDateTab: _propTypes2['default'].func,
	  onClearDates: _propTypes2['default'].func,
	  onKeyDownArrowDown: _propTypes2['default'].func,
	  onKeyDownQuestionMark: _propTypes2['default'].func,
	
	  startDate: _propTypes2['default'].string,
	  endDate: _propTypes2['default'].string,
	
	  isStartDateFocused: _propTypes2['default'].bool,
	  isEndDateFocused: _propTypes2['default'].bool,
	  showClearDates: _propTypes2['default'].bool,
	  disabled: _DisabledShape2['default'],
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  openDirection: _OpenDirectionShape2['default'],
	  showCaret: _propTypes2['default'].bool,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  customInputIcon: _propTypes2['default'].node,
	  customArrowIcon: _propTypes2['default'].node,
	  customCloseIcon: _propTypes2['default'].node,
	  noBorder: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  small: _propTypes2['default'].bool,
	  regular: _propTypes2['default'].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  // accessibility
	  isFocused: _propTypes2['default'].bool, // describes actual DOM focus
	
	  // i18n
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerInputPhrases)),
	
	  isRTL: _propTypes2['default'].bool
	}));
	
	var defaultProps = {
	  startDateId: _constants.START_DATE,
	  endDateId: _constants.END_DATE,
	  startDatePlaceholderText: 'Start Date',
	  endDatePlaceholderText: 'End Date',
	  screenReaderMessage: '',
	  onStartDateFocus: function () {
	    function onStartDateFocus() {}
	
	    return onStartDateFocus;
	  }(),
	  onEndDateFocus: function () {
	    function onEndDateFocus() {}
	
	    return onEndDateFocus;
	  }(),
	  onStartDateChange: function () {
	    function onStartDateChange() {}
	
	    return onStartDateChange;
	  }(),
	  onEndDateChange: function () {
	    function onEndDateChange() {}
	
	    return onEndDateChange;
	  }(),
	  onStartDateShiftTab: function () {
	    function onStartDateShiftTab() {}
	
	    return onStartDateShiftTab;
	  }(),
	  onEndDateTab: function () {
	    function onEndDateTab() {}
	
	    return onEndDateTab;
	  }(),
	  onClearDates: function () {
	    function onClearDates() {}
	
	    return onClearDates;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	
	
	  startDate: '',
	  endDate: '',
	
	  isStartDateFocused: false,
	  isEndDateFocused: false,
	  showClearDates: false,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  openDirection: _constants.OPEN_DOWN,
	  showCaret: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customInputIcon: null,
	  customArrowIcon: null,
	  customCloseIcon: null,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  verticalSpacing: undefined,
	
	  // accessibility
	  isFocused: false,
	
	  // i18n
	  phrases: _defaultPhrases.DateRangePickerInputPhrases,
	
	  isRTL: false
	};
	
	function DateRangePickerInput(_ref) {
	  var startDate = _ref.startDate,
	      startDateId = _ref.startDateId,
	      startDatePlaceholderText = _ref.startDatePlaceholderText,
	      screenReaderMessage = _ref.screenReaderMessage,
	      isStartDateFocused = _ref.isStartDateFocused,
	      onStartDateChange = _ref.onStartDateChange,
	      onStartDateFocus = _ref.onStartDateFocus,
	      onStartDateShiftTab = _ref.onStartDateShiftTab,
	      endDate = _ref.endDate,
	      endDateId = _ref.endDateId,
	      endDatePlaceholderText = _ref.endDatePlaceholderText,
	      isEndDateFocused = _ref.isEndDateFocused,
	      onEndDateChange = _ref.onEndDateChange,
	      onEndDateFocus = _ref.onEndDateFocus,
	      onEndDateTab = _ref.onEndDateTab,
	      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
	      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
	      onClearDates = _ref.onClearDates,
	      showClearDates = _ref.showClearDates,
	      disabled = _ref.disabled,
	      required = _ref.required,
	      readOnly = _ref.readOnly,
	      showCaret = _ref.showCaret,
	      openDirection = _ref.openDirection,
	      showDefaultInputIcon = _ref.showDefaultInputIcon,
	      inputIconPosition = _ref.inputIconPosition,
	      customInputIcon = _ref.customInputIcon,
	      customArrowIcon = _ref.customArrowIcon,
	      customCloseIcon = _ref.customCloseIcon,
	      isFocused = _ref.isFocused,
	      phrases = _ref.phrases,
	      isRTL = _ref.isRTL,
	      noBorder = _ref.noBorder,
	      block = _ref.block,
	      verticalSpacing = _ref.verticalSpacing,
	      small = _ref.small,
	      regular = _ref.regular,
	      styles = _ref.styles;
	
	  var calendarIcon = customInputIcon || _react2['default'].createElement(_CalendarIcon2['default'], (0, _reactWithStyles.css)(styles.DateRangePickerInput_calendarIcon_svg));
	
	  var arrowIcon = customArrowIcon || _react2['default'].createElement(_RightArrow2['default'], (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow_svg));
	  if (isRTL) arrowIcon = _react2['default'].createElement(_LeftArrow2['default'], (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow_svg));
	  if (small) arrowIcon = '-';
	
	  var closeIcon = customCloseIcon || _react2['default'].createElement(_CloseButton2['default'], (0, _reactWithStyles.css)(styles.DateRangePickerInput_clearDates_svg, small && styles.DateRangePickerInput_clearDates_svg__small));
	  var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;
	  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react2['default'].createElement(
	    'button',
	    _extends({}, (0, _reactWithStyles.css)(styles.DateRangePickerInput_calendarIcon), {
	      type: 'button',
	      disabled: disabled,
	      'aria-label': phrases.focusStartDate,
	      onClick: onKeyDownArrowDown
	    }),
	    calendarIcon
	  );
	  var startDateDisabled = disabled === _constants.START_DATE || disabled === true;
	  var endDateDisabled = disabled === _constants.END_DATE || disabled === true;
	
	  return _react2['default'].createElement(
	    'div',
	    (0, _reactWithStyles.css)(styles.DateRangePickerInput, disabled && styles.DateRangePickerInput__disabled, isRTL && styles.DateRangePickerInput__rtl, !noBorder && styles.DateRangePickerInput__withBorder, block && styles.DateRangePickerInput__block, showClearDates && styles.DateRangePickerInput__showClearDates),
	    inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon,
	    _react2['default'].createElement(_DateInput2['default'], {
	      id: startDateId,
	      placeholder: startDatePlaceholderText,
	      displayValue: startDate,
	      screenReaderMessage: screenReaderText,
	      focused: isStartDateFocused,
	      isFocused: isFocused,
	      disabled: startDateDisabled,
	      required: required,
	      readOnly: readOnly,
	      showCaret: showCaret,
	      openDirection: openDirection,
	      onChange: onStartDateChange,
	      onFocus: onStartDateFocus,
	      onKeyDownShiftTab: onStartDateShiftTab,
	      onKeyDownArrowDown: onKeyDownArrowDown,
	      onKeyDownQuestionMark: onKeyDownQuestionMark,
	      verticalSpacing: verticalSpacing,
	      small: small,
	      regular: regular
	    }),
	    _react2['default'].createElement(
	      'div',
	      _extends({}, (0, _reactWithStyles.css)(styles.DateRangePickerInput_arrow), {
	        'aria-hidden': 'true',
	        role: 'presentation'
	      }),
	      arrowIcon
	    ),
	    _react2['default'].createElement(_DateInput2['default'], {
	      id: endDateId,
	      placeholder: endDatePlaceholderText,
	      displayValue: endDate,
	      screenReaderMessage: screenReaderText,
	      focused: isEndDateFocused,
	      isFocused: isFocused,
	      disabled: endDateDisabled,
	      required: required,
	      readOnly: readOnly,
	      showCaret: showCaret,
	      openDirection: openDirection,
	      onChange: onEndDateChange,
	      onFocus: onEndDateFocus,
	      onKeyDownTab: onEndDateTab,
	      onKeyDownArrowDown: onKeyDownArrowDown,
	      onKeyDownQuestionMark: onKeyDownQuestionMark,
	      verticalSpacing: verticalSpacing,
	      small: small,
	      regular: regular
	    }),
	    showClearDates && _react2['default'].createElement(
	      'button',
	      _extends({
	        type: 'button',
	        'aria-label': phrases.clearDates
	      }, (0, _reactWithStyles.css)(styles.DateRangePickerInput_clearDates, small && styles.DateRangePickerInput_clearDates__small, !customCloseIcon && styles.DateRangePickerInput_clearDates_default, !(startDate || endDate) && styles.DateRangePickerInput_clearDates__hide), {
	        onClick: onClearDates,
	        disabled: disabled
	      }),
	      closeIcon
	    ),
	    inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon
	  );
	}
	
	DateRangePickerInput.propTypes = propTypes;
	DateRangePickerInput.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      color = _ref2$reactDates.color,
	      sizing = _ref2$reactDates.sizing;
	  return {
	    DateRangePickerInput: {
	      backgroundColor: color.background,
	      display: 'inline-block'
	    },
	
	    DateRangePickerInput__disabled: {
	      background: color.disabled
	    },
	
	    DateRangePickerInput__withBorder: {
	      border: '1px solid ' + String(color.border),
	      borderRadius: 2
	    },
	
	    DateRangePickerInput__rtl: {
	      direction: 'rtl'
	    },
	
	    DateRangePickerInput__block: {
	      display: 'block'
	    },
	
	    DateRangePickerInput__showClearDates: {
	      paddingRight: 30
	    },
	
	    DateRangePickerInput_arrow: {
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      color: color.text
	    },
	
	    DateRangePickerInput_arrow_svg: {
	      verticalAlign: 'middle',
	      fill: color.text,
	      height: sizing.arrowWidth,
	      width: sizing.arrowWidth
	    },
	
	    DateRangePickerInput_clearDates: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	
	      cursor: 'pointer',
	      padding: 10,
	      margin: '0 10px 0 5px',
	      position: 'absolute',
	      right: 0,
	      top: '50%',
	      transform: 'translateY(-50%)'
	    },
	
	    DateRangePickerInput_clearDates__small: {
	      padding: 6
	    },
	
	    DateRangePickerInput_clearDates_default: {
	      ':focus': {
	        background: color.core.border,
	        borderRadius: '50%'
	      },
	
	      ':hover': {
	        background: color.core.border,
	        borderRadius: '50%'
	      }
	    },
	
	    DateRangePickerInput_clearDates__hide: {
	      visibility: 'hidden'
	    },
	
	    DateRangePickerInput_clearDates_svg: {
	      fill: color.core.grayLight,
	      height: 12,
	      width: 15,
	      verticalAlign: 'middle'
	    },
	
	    DateRangePickerInput_clearDates_svg__small: {
	      height: 9
	    },
	
	    DateRangePickerInput_calendarIcon: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	
	      cursor: 'pointer',
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      padding: 10,
	      margin: '0 5px 0 10px'
	    },
	
	    DateRangePickerInput_calendarIcon_svg: {
	      fill: color.core.grayLight,
	      height: 15,
	      width: 14,
	      verticalAlign: 'middle'
	    }
	  };
	})(DateRangePickerInput);

/***/ }),

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactMomentProptypes = __webpack_require__(38);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _OpenDirectionShape = __webpack_require__(55);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _DateRangePickerInput = __webpack_require__(232);
	
	var _DateRangePickerInput2 = _interopRequireDefault(_DateRangePickerInput);
	
	var _IconPositionShape = __webpack_require__(80);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _DisabledShape = __webpack_require__(97);
	
	var _DisabledShape2 = _interopRequireDefault(_DisabledShape);
	
	var _toMomentObject = __webpack_require__(58);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _toLocalizedDateString = __webpack_require__(140);
	
	var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);
	
	var _isInclusivelyAfterDay = __webpack_require__(83);
	
	var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
	var _isBeforeDay = __webpack_require__(82);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  startDate: _reactMomentProptypes2['default'].momentObj,
	  startDateId: _propTypes2['default'].string,
	  startDatePlaceholderText: _propTypes2['default'].string,
	  isStartDateFocused: _propTypes2['default'].bool,
	
	  endDate: _reactMomentProptypes2['default'].momentObj,
	  endDateId: _propTypes2['default'].string,
	  endDatePlaceholderText: _propTypes2['default'].string,
	  isEndDateFocused: _propTypes2['default'].bool,
	
	  screenReaderMessage: _propTypes2['default'].string,
	  showClearDates: _propTypes2['default'].bool,
	  showCaret: _propTypes2['default'].bool,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  disabled: _DisabledShape2['default'],
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  openDirection: _OpenDirectionShape2['default'],
	  noBorder: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  small: _propTypes2['default'].bool,
	  regular: _propTypes2['default'].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  reopenPickerOnClearDates: _propTypes2['default'].bool,
	  withFullScreenPortal: _propTypes2['default'].bool,
	  minimumNights: _airbnbPropTypes.nonNegativeInteger,
	  isOutsideRange: _propTypes2['default'].func,
	  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	
	  onFocusChange: _propTypes2['default'].func,
	  onClose: _propTypes2['default'].func,
	  onDatesChange: _propTypes2['default'].func,
	  onKeyDownArrowDown: _propTypes2['default'].func,
	  onKeyDownQuestionMark: _propTypes2['default'].func,
	
	  customInputIcon: _propTypes2['default'].node,
	  customArrowIcon: _propTypes2['default'].node,
	  customCloseIcon: _propTypes2['default'].node,
	
	  // accessibility
	  isFocused: _propTypes2['default'].bool,
	
	  // i18n
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerInputPhrases)),
	
	  isRTL: _propTypes2['default'].bool
	});
	
	var defaultProps = {
	  startDate: null,
	  startDateId: _constants.START_DATE,
	  startDatePlaceholderText: 'Start Date',
	  isStartDateFocused: false,
	
	  endDate: null,
	  endDateId: _constants.END_DATE,
	  endDatePlaceholderText: 'End Date',
	  isEndDateFocused: false,
	
	  screenReaderMessage: '',
	  showClearDates: false,
	  showCaret: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  openDirection: _constants.OPEN_DOWN,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  verticalSpacing: undefined,
	
	  keepOpenOnDateSelect: false,
	  reopenPickerOnClearDates: false,
	  withFullScreenPortal: false,
	  minimumNights: 1,
	  isOutsideRange: function () {
	    function isOutsideRange(day) {
	      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
	    }
	
	    return isOutsideRange;
	  }(),
	  displayFormat: function () {
	    function displayFormat() {
	      return _moment2['default'].localeData().longDateFormat('L');
	    }
	
	    return displayFormat;
	  }(),
	
	  onFocusChange: function () {
	    function onFocusChange() {}
	
	    return onFocusChange;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	  onDatesChange: function () {
	    function onDatesChange() {}
	
	    return onDatesChange;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	
	
	  customInputIcon: null,
	  customArrowIcon: null,
	  customCloseIcon: null,
	
	  // accessibility
	  isFocused: false,
	
	  // i18n
	  phrases: _defaultPhrases.DateRangePickerInputPhrases,
	
	  isRTL: false
	};
	
	var DateRangePickerInputController = function (_React$Component) {
	  _inherits(DateRangePickerInputController, _React$Component);
	
	  function DateRangePickerInputController(props) {
	    _classCallCheck(this, DateRangePickerInputController);
	
	    var _this = _possibleConstructorReturn(this, (DateRangePickerInputController.__proto__ || Object.getPrototypeOf(DateRangePickerInputController)).call(this, props));
	
	    _this.onClearFocus = _this.onClearFocus.bind(_this);
	    _this.onStartDateChange = _this.onStartDateChange.bind(_this);
	    _this.onStartDateFocus = _this.onStartDateFocus.bind(_this);
	    _this.onEndDateChange = _this.onEndDateChange.bind(_this);
	    _this.onEndDateFocus = _this.onEndDateFocus.bind(_this);
	    _this.clearDates = _this.clearDates.bind(_this);
	    return _this;
	  }
	
	  _createClass(DateRangePickerInputController, [{
	    key: 'onClearFocus',
	    value: function () {
	      function onClearFocus() {
	        var _props = this.props,
	            onFocusChange = _props.onFocusChange,
	            onClose = _props.onClose,
	            startDate = _props.startDate,
	            endDate = _props.endDate;
	
	
	        onFocusChange(null);
	        onClose({ startDate: startDate, endDate: endDate });
	      }
	
	      return onClearFocus;
	    }()
	  }, {
	    key: 'onEndDateChange',
	    value: function () {
	      function onEndDateChange(endDateString) {
	        var _props2 = this.props,
	            startDate = _props2.startDate,
	            isOutsideRange = _props2.isOutsideRange,
	            minimumNights = _props2.minimumNights,
	            keepOpenOnDateSelect = _props2.keepOpenOnDateSelect,
	            onDatesChange = _props2.onDatesChange;
	
	
	        var endDate = (0, _toMomentObject2['default'])(endDateString, this.getDisplayFormat());
	
	        var isEndDateValid = endDate && !isOutsideRange(endDate) && !(startDate && (0, _isBeforeDay2['default'])(endDate, startDate.clone().add(minimumNights, 'days')));
	        if (isEndDateValid) {
	          onDatesChange({ startDate: startDate, endDate: endDate });
	          if (!keepOpenOnDateSelect) this.onClearFocus();
	        } else {
	          onDatesChange({
	            startDate: startDate,
	            endDate: null
	          });
	        }
	      }
	
	      return onEndDateChange;
	    }()
	  }, {
	    key: 'onEndDateFocus',
	    value: function () {
	      function onEndDateFocus() {
	        var _props3 = this.props,
	            startDate = _props3.startDate,
	            onFocusChange = _props3.onFocusChange,
	            withFullScreenPortal = _props3.withFullScreenPortal,
	            disabled = _props3.disabled;
	
	
	        if (!startDate && withFullScreenPortal && (!disabled || disabled === _constants.END_DATE)) {
	          // When the datepicker is full screen, we never want to focus the end date first
	          // because there's no indication that that is the case once the datepicker is open and it
	          // might confuse the user
	          onFocusChange(_constants.START_DATE);
	        } else if (!disabled || disabled === _constants.START_DATE) {
	          onFocusChange(_constants.END_DATE);
	        }
	      }
	
	      return onEndDateFocus;
	    }()
	  }, {
	    key: 'onStartDateChange',
	    value: function () {
	      function onStartDateChange(startDateString) {
	        var endDate = this.props.endDate;
	        var _props4 = this.props,
	            isOutsideRange = _props4.isOutsideRange,
	            minimumNights = _props4.minimumNights,
	            onDatesChange = _props4.onDatesChange,
	            onFocusChange = _props4.onFocusChange,
	            disabled = _props4.disabled;
	
	
	        var startDate = (0, _toMomentObject2['default'])(startDateString, this.getDisplayFormat());
	        var isEndDateBeforeStartDate = startDate && (0, _isBeforeDay2['default'])(endDate, startDate.clone().add(minimumNights, 'days'));
	        var isStartDateValid = startDate && !isOutsideRange(startDate) && !(disabled === _constants.END_DATE && isEndDateBeforeStartDate);
	
	        if (isStartDateValid) {
	          if (isEndDateBeforeStartDate) {
	            endDate = null;
	          }
	
	          onDatesChange({ startDate: startDate, endDate: endDate });
	          onFocusChange(_constants.END_DATE);
	        } else {
	          onDatesChange({
	            startDate: null,
	            endDate: endDate
	          });
	        }
	      }
	
	      return onStartDateChange;
	    }()
	  }, {
	    key: 'onStartDateFocus',
	    value: function () {
	      function onStartDateFocus() {
	        var _props5 = this.props,
	            disabled = _props5.disabled,
	            onFocusChange = _props5.onFocusChange;
	
	        if (!disabled || disabled === _constants.END_DATE) {
	          onFocusChange(_constants.START_DATE);
	        }
	      }
	
	      return onStartDateFocus;
	    }()
	  }, {
	    key: 'getDisplayFormat',
	    value: function () {
	      function getDisplayFormat() {
	        var displayFormat = this.props.displayFormat;
	
	        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
	      }
	
	      return getDisplayFormat;
	    }()
	  }, {
	    key: 'getDateString',
	    value: function () {
	      function getDateString(date) {
	        var displayFormat = this.getDisplayFormat();
	        if (date && displayFormat) {
	          return date && date.format(displayFormat);
	        }
	        return (0, _toLocalizedDateString2['default'])(date);
	      }
	
	      return getDateString;
	    }()
	  }, {
	    key: 'clearDates',
	    value: function () {
	      function clearDates() {
	        var _props6 = this.props,
	            onDatesChange = _props6.onDatesChange,
	            reopenPickerOnClearDates = _props6.reopenPickerOnClearDates,
	            onFocusChange = _props6.onFocusChange;
	
	        onDatesChange({ startDate: null, endDate: null });
	        if (reopenPickerOnClearDates) {
	          onFocusChange(_constants.START_DATE);
	        }
	      }
	
	      return clearDates;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props7 = this.props,
	            startDate = _props7.startDate,
	            startDateId = _props7.startDateId,
	            startDatePlaceholderText = _props7.startDatePlaceholderText,
	            isStartDateFocused = _props7.isStartDateFocused,
	            endDate = _props7.endDate,
	            endDateId = _props7.endDateId,
	            endDatePlaceholderText = _props7.endDatePlaceholderText,
	            isEndDateFocused = _props7.isEndDateFocused,
	            screenReaderMessage = _props7.screenReaderMessage,
	            showClearDates = _props7.showClearDates,
	            showCaret = _props7.showCaret,
	            showDefaultInputIcon = _props7.showDefaultInputIcon,
	            inputIconPosition = _props7.inputIconPosition,
	            customInputIcon = _props7.customInputIcon,
	            customArrowIcon = _props7.customArrowIcon,
	            customCloseIcon = _props7.customCloseIcon,
	            disabled = _props7.disabled,
	            required = _props7.required,
	            readOnly = _props7.readOnly,
	            openDirection = _props7.openDirection,
	            isFocused = _props7.isFocused,
	            phrases = _props7.phrases,
	            onKeyDownArrowDown = _props7.onKeyDownArrowDown,
	            onKeyDownQuestionMark = _props7.onKeyDownQuestionMark,
	            isRTL = _props7.isRTL,
	            noBorder = _props7.noBorder,
	            block = _props7.block,
	            small = _props7.small,
	            regular = _props7.regular,
	            verticalSpacing = _props7.verticalSpacing;
	
	
	        var startDateString = this.getDateString(startDate);
	        var endDateString = this.getDateString(endDate);
	
	        return _react2['default'].createElement(_DateRangePickerInput2['default'], {
	          startDate: startDateString,
	          startDateId: startDateId,
	          startDatePlaceholderText: startDatePlaceholderText,
	          isStartDateFocused: isStartDateFocused,
	          endDate: endDateString,
	          endDateId: endDateId,
	          endDatePlaceholderText: endDatePlaceholderText,
	          isEndDateFocused: isEndDateFocused,
	          isFocused: isFocused,
	          disabled: disabled,
	          required: required,
	          readOnly: readOnly,
	          openDirection: openDirection,
	          showCaret: showCaret,
	          showDefaultInputIcon: showDefaultInputIcon,
	          inputIconPosition: inputIconPosition,
	          customInputIcon: customInputIcon,
	          customArrowIcon: customArrowIcon,
	          customCloseIcon: customCloseIcon,
	          phrases: phrases,
	          onStartDateChange: this.onStartDateChange,
	          onStartDateFocus: this.onStartDateFocus,
	          onStartDateShiftTab: this.onClearFocus,
	          onEndDateChange: this.onEndDateChange,
	          onEndDateFocus: this.onEndDateFocus,
	          onEndDateTab: this.onClearFocus,
	          showClearDates: showClearDates,
	          onClearDates: this.clearDates,
	          screenReaderMessage: screenReaderMessage,
	          onKeyDownArrowDown: onKeyDownArrowDown,
	          onKeyDownQuestionMark: onKeyDownQuestionMark,
	          isRTL: isRTL,
	          noBorder: noBorder,
	          block: block,
	          small: small,
	          regular: regular,
	          verticalSpacing: verticalSpacing
	        });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DateRangePickerInputController;
	}(_react2['default'].Component);
	
	exports['default'] = DateRangePickerInputController;
	
	
	DateRangePickerInputController.propTypes = propTypes;
	DateRangePickerInputController.defaultProps = defaultProps;

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureDayPicker = exports.defaultProps = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsShallowCompare = __webpack_require__(54);
	
	var _reactAddonsShallowCompare2 = _interopRequireDefault(_reactAddonsShallowCompare);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _reactWithStyles = __webpack_require__(26);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _throttle = __webpack_require__(210);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _isTouchDevice = __webpack_require__(51);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _OutsideClickHandler = __webpack_require__(96);
	
	var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
	var _CalendarMonthGrid = __webpack_require__(230);
	
	var _CalendarMonthGrid2 = _interopRequireDefault(_CalendarMonthGrid);
	
	var _DayPickerNavigation = __webpack_require__(529);
	
	var _DayPickerNavigation2 = _interopRequireDefault(_DayPickerNavigation);
	
	var _DayPickerKeyboardShortcuts = __webpack_require__(528);
	
	var _DayPickerKeyboardShortcuts2 = _interopRequireDefault(_DayPickerKeyboardShortcuts);
	
	var _getCalendarMonthWidth = __webpack_require__(248);
	
	var _getCalendarMonthWidth2 = _interopRequireDefault(_getCalendarMonthWidth);
	
	var _calculateDimension = __webpack_require__(245);
	
	var _calculateDimension2 = _interopRequireDefault(_calculateDimension);
	
	var _getActiveElement = __webpack_require__(534);
	
	var _getActiveElement2 = _interopRequireDefault(_getActiveElement);
	
	var _isDayVisible = __webpack_require__(139);
	
	var _isDayVisible2 = _interopRequireDefault(_isDayVisible);
	
	var _ScrollableOrientationShape = __webpack_require__(56);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(46);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _CalendarInfoPositionShape = __webpack_require__(79);
	
	var _CalendarInfoPositionShape2 = _interopRequireDefault(_CalendarInfoPositionShape);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MONTH_PADDING = 23;
	var DAY_PICKER_PADDING = 9;
	var PREV_TRANSITION = 'prev';
	var NEXT_TRANSITION = 'next';
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	
	  // calendar presentation props
	  enableOutsideDays: _propTypes2['default'].bool,
	  numberOfMonths: _propTypes2['default'].number,
	  orientation: _ScrollableOrientationShape2['default'],
	  withPortal: _propTypes2['default'].bool,
	  onOutsideClick: _propTypes2['default'].func,
	  hidden: _propTypes2['default'].bool,
	  initialVisibleMonth: _propTypes2['default'].func,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  renderCalendarInfo: _propTypes2['default'].func,
	  calendarInfoPosition: _CalendarInfoPositionShape2['default'],
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isRTL: _propTypes2['default'].bool,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  noBorder: _propTypes2['default'].bool,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  // navigation props
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	  noNavButtons: _propTypes2['default'].bool,
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	  onMultiplyScrollableMonths: _propTypes2['default'].func, // VERTICAL_SCROLLABLE daypickers only
	
	  // month props
	  renderMonth: _propTypes2['default'].func,
	
	  // day props
	  modifiers: _propTypes2['default'].object,
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  onDayClick: _propTypes2['default'].func,
	  onDayMouseEnter: _propTypes2['default'].func,
	  onDayMouseLeave: _propTypes2['default'].func,
	
	  // accessibility props
	  isFocused: _propTypes2['default'].bool,
	  getFirstFocusableDay: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  showKeyboardShortcuts: _propTypes2['default'].bool,
	
	  // internationalization
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string
	}));
	
	var defaultProps = exports.defaultProps = {
	  // calendar presentation props
	  enableOutsideDays: false,
	  numberOfMonths: 2,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  withPortal: false,
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }(),
	
	  hidden: false,
	  initialVisibleMonth: function () {
	    function initialVisibleMonth() {
	      return (0, _moment2['default'])();
	    }
	
	    return initialVisibleMonth;
	  }(),
	  firstDayOfWeek: null,
	  renderCalendarInfo: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	  hideKeyboardShortcutsPanel: false,
	  daySize: _constants.DAY_SIZE,
	  isRTL: false,
	  verticalHeight: null,
	  noBorder: false,
	  transitionDuration: undefined,
	  verticalBorderSpacing: undefined,
	
	  // navigation props
	  navPrev: null,
	  navNext: null,
	  noNavButtons: false,
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onMultiplyScrollableMonths: function () {
	    function onMultiplyScrollableMonths() {}
	
	    return onMultiplyScrollableMonths;
	  }(),
	
	
	  // month props
	  renderMonth: null,
	
	  // day props
	  modifiers: {},
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  onDayClick: function () {
	    function onDayClick() {}
	
	    return onDayClick;
	  }(),
	  onDayMouseEnter: function () {
	    function onDayMouseEnter() {}
	
	    return onDayMouseEnter;
	  }(),
	  onDayMouseLeave: function () {
	    function onDayMouseLeave() {}
	
	    return onDayMouseLeave;
	  }(),
	
	
	  // accessibility props
	  isFocused: false,
	  getFirstFocusableDay: null,
	  onBlur: function () {
	    function onBlur() {}
	
	    return onBlur;
	  }(),
	
	  showKeyboardShortcuts: false,
	
	  // internationalization
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DayPickerPhrases,
	  dayAriaLabelFormat: undefined
	};
	
	var DayPicker = function (_React$Component) {
	  _inherits(DayPicker, _React$Component);
	
	  function DayPicker(props) {
	    _classCallCheck(this, DayPicker);
	
	    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));
	
	    var currentMonth = props.hidden ? (0, _moment2['default'])() : props.initialVisibleMonth();
	
	    var focusedDate = currentMonth.clone().startOf('month');
	    if (props.getFirstFocusableDay) {
	      focusedDate = props.getFirstFocusableDay(currentMonth);
	    }
	
	    var translationValue = props.isRTL && _this.isHorizontal() ? -(0, _getCalendarMonthWidth2['default'])(props.daySize) : 0;
	
	    _this.hasSetInitialVisibleMonth = !props.hidden;
	    _this.state = {
	      currentMonth: currentMonth,
	      monthTransition: null,
	      translationValue: translationValue,
	      scrollableMonthMultiple: 1,
	      calendarMonthWidth: (0, _getCalendarMonthWidth2['default'])(props.daySize),
	      focusedDate: !props.hidden || props.isFocused ? focusedDate : null,
	      nextFocusedDate: null,
	      showKeyboardShortcuts: props.showKeyboardShortcuts,
	      onKeyboardShortcutsPanelClose: function () {
	        function onKeyboardShortcutsPanelClose() {}
	
	        return onKeyboardShortcutsPanelClose;
	      }(),
	
	      isTouchDevice: (0, _isTouchDevice2['default'])(),
	      withMouseInteractions: true,
	      hasSetHeight: false,
	      calendarInfoWidth: 0
	    };
	
	    _this.calendarMonthHeights = [];
	    _this.calendarMonthGridHeight = 0;
	    _this.setCalendarInfoWidthTimeout = null;
	
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.throttledKeyDown = (0, _throttle2['default'])(_this.onFinalKeyDown, 200, { trailing: false });
	    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
	    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
	    _this.multiplyScrollableMonths = _this.multiplyScrollableMonths.bind(_this);
	    _this.updateStateAfterMonthTransition = _this.updateStateAfterMonthTransition.bind(_this);
	
	    _this.openKeyboardShortcutsPanel = _this.openKeyboardShortcutsPanel.bind(_this);
	    _this.closeKeyboardShortcutsPanel = _this.closeKeyboardShortcutsPanel.bind(_this);
	
	    _this.setCalendarInfoRef = _this.setCalendarInfoRef.bind(_this);
	    _this.setContainerRef = _this.setContainerRef.bind(_this);
	    _this.setTransitionContainerRef = _this.setTransitionContainerRef.bind(_this);
	    _this.setCalendarMonthHeights = _this.setCalendarMonthHeights.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayPicker, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        if (this.calendarInfo) {
	          this.setState({
	            isTouchDevice: (0, _isTouchDevice2['default'])(),
	            calendarInfoWidth: (0, _calculateDimension2['default'])(this.calendarInfo, 'width', true, true)
	          });
	        } else {
	          this.setState({ isTouchDevice: (0, _isTouchDevice2['default'])() });
	        }
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var hidden = nextProps.hidden,
	            isFocused = nextProps.isFocused,
	            showKeyboardShortcuts = nextProps.showKeyboardShortcuts,
	            onBlur = nextProps.onBlur;
	        var currentMonth = this.state.currentMonth;
	
	
	        if (!hidden) {
	          if (!this.hasSetInitialVisibleMonth) {
	            this.hasSetInitialVisibleMonth = true;
	            this.setState({
	              currentMonth: nextProps.initialVisibleMonth()
	            });
	          }
	        }
	
	        if (nextProps.daySize !== this.props.daySize) {
	          this.setState({
	            calendarMonthWidth: (0, _getCalendarMonthWidth2['default'])(nextProps.daySize)
	          });
	        }
	
	        if (isFocused !== this.props.isFocused) {
	          if (isFocused) {
	            var focusedDate = this.getFocusedDay(currentMonth);
	
	            var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;
	
	            if (nextProps.showKeyboardShortcuts) {
	              // the ? shortcut came from the input and we should return input there once it is close
	              onKeyboardShortcutsPanelClose = onBlur;
	            }
	
	            this.setState({
	              showKeyboardShortcuts: showKeyboardShortcuts,
	              onKeyboardShortcutsPanelClose: onKeyboardShortcutsPanelClose,
	              focusedDate: focusedDate,
	              withMouseInteractions: false
	            });
	          } else {
	            this.setState({ focusedDate: null });
	          }
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function () {
	      function shouldComponentUpdate(nextProps, nextState) {
	        return (0, _reactAddonsShallowCompare2['default'])(this, nextProps, nextState);
	      }
	
	      return shouldComponentUpdate;
	    }()
	  }, {
	    key: 'componentWillUpdate',
	    value: function () {
	      function componentWillUpdate() {
	        var _this2 = this;
	
	        var transitionDuration = this.props.transitionDuration;
	        // Calculating the dimensions trigger a DOM repaint which
	        // breaks the CSS transition.
	        // The setTimeout will wait until the transition ends.
	
	        if (this.calendarInfo) {
	          var calendarInfoWidth = this.state.calendarInfoWidth;
	
	          this.setCalendarInfoWidthTimeout = setTimeout(function () {
	            var calendarInfoPanelWidth = (0, _calculateDimension2['default'])(_this2.calendarInfo, 'width', true, true);
	            if (calendarInfoWidth !== calendarInfoPanelWidth) {
	              _this2.setState({
	                calendarInfoWidth: calendarInfoPanelWidth
	              });
	            }
	          }, transitionDuration);
	        }
	      }
	
	      return componentWillUpdate;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        var isFocused = this.props.isFocused;
	        var focusedDate = this.state.focusedDate;
	
	
	        if (!prevProps.isFocused && isFocused && !focusedDate) {
	          this.container.focus();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        clearTimeout(this.setCalendarInfoWidthTimeout);
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onKeyDown',
	    value: function () {
	      function onKeyDown(e) {
	        e.stopPropagation();
	        if (!_constants.MODIFIER_KEY_NAMES.has(e.key)) {
	          this.throttledKeyDown(e);
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: 'onFinalKeyDown',
	    value: function () {
	      function onFinalKeyDown(e) {
	        this.setState({ withMouseInteractions: false });
	
	        var _props = this.props,
	            onBlur = _props.onBlur,
	            isRTL = _props.isRTL;
	        var _state = this.state,
	            focusedDate = _state.focusedDate,
	            showKeyboardShortcuts = _state.showKeyboardShortcuts;
	
	        if (!focusedDate) return;
	
	        var newFocusedDate = focusedDate.clone();
	
	        var didTransitionMonth = false;
	
	        // focus might be anywhere when the keyboard shortcuts panel is opened so we want to
	        // return it to wherever it was before when the panel was opened
	        var activeElement = (0, _getActiveElement2['default'])();
	        var onKeyboardShortcutsPanelClose = function () {
	          function onKeyboardShortcutsPanelClose() {
	            if (activeElement) activeElement.focus();
	          }
	
	          return onKeyboardShortcutsPanelClose;
	        }();
	
	        switch (e.key) {
	          case 'ArrowUp':
	            e.preventDefault();
	            newFocusedDate.subtract(1, 'week');
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	          case 'ArrowLeft':
	            e.preventDefault();
	            if (isRTL) {
	              newFocusedDate.add(1, 'day');
	            } else {
	              newFocusedDate.subtract(1, 'day');
	            }
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	          case 'Home':
	            e.preventDefault();
	            newFocusedDate.startOf('week');
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	          case 'PageUp':
	            e.preventDefault();
	            newFocusedDate.subtract(1, 'month');
	            didTransitionMonth = this.maybeTransitionPrevMonth(newFocusedDate);
	            break;
	
	          case 'ArrowDown':
	            e.preventDefault();
	            newFocusedDate.add(1, 'week');
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	          case 'ArrowRight':
	            e.preventDefault();
	            if (isRTL) {
	              newFocusedDate.subtract(1, 'day');
	            } else {
	              newFocusedDate.add(1, 'day');
	            }
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	          case 'End':
	            e.preventDefault();
	            newFocusedDate.endOf('week');
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	          case 'PageDown':
	            e.preventDefault();
	            newFocusedDate.add(1, 'month');
	            didTransitionMonth = this.maybeTransitionNextMonth(newFocusedDate);
	            break;
	
	          case '?':
	            this.openKeyboardShortcutsPanel(onKeyboardShortcutsPanelClose);
	            break;
	
	          case 'Escape':
	            if (showKeyboardShortcuts) {
	              this.closeKeyboardShortcutsPanel();
	            } else {
	              onBlur();
	            }
	            break;
	
	          default:
	            break;
	        }
	
	        // If there was a month transition, do not update the focused date until the transition has
	        // completed. Otherwise, attempting to focus on a DOM node may interrupt the CSS animation. If
	        // didTransitionMonth is true, the focusedDate gets updated in #updateStateAfterMonthTransition
	        if (!didTransitionMonth) {
	          this.setState({
	            focusedDate: newFocusedDate
	          });
	        }
	      }
	
	      return onFinalKeyDown;
	    }()
	  }, {
	    key: 'onPrevMonthClick',
	    value: function () {
	      function onPrevMonthClick(nextFocusedDate, e) {
	        var _props2 = this.props,
	            numberOfMonths = _props2.numberOfMonths,
	            isRTL = _props2.isRTL;
	        var calendarMonthWidth = this.state.calendarMonthWidth;
	
	
	        if (e) e.preventDefault();
	
	        var translationValue = this.isVertical() ? this.calendarMonthHeights[0] : calendarMonthWidth;
	
	        if (this.isHorizontal()) {
	          if (isRTL) {
	            translationValue = -2 * calendarMonthWidth;
	          }
	
	          var newMonthHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(this.calendarMonthHeights.slice(0, numberOfMonths))));
	          this.adjustDayPickerHeight(newMonthHeight);
	        }
	
	        this.setState({
	          monthTransition: PREV_TRANSITION,
	          translationValue: translationValue,
	          focusedDate: null,
	          nextFocusedDate: nextFocusedDate
	        });
	      }
	
	      return onPrevMonthClick;
	    }()
	  }, {
	    key: 'onNextMonthClick',
	    value: function () {
	      function onNextMonthClick(nextFocusedDate, e) {
	        var isRTL = this.props.isRTL;
	        var calendarMonthWidth = this.state.calendarMonthWidth;
	
	
	        if (e) e.preventDefault();
	
	        var translationValue = this.isVertical() ? -this.calendarMonthHeights[1] : -calendarMonthWidth;
	
	        if (this.isHorizontal()) {
	          if (isRTL) {
	            translationValue = 0;
	          }
	          var newMonthHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(this.calendarMonthHeights.slice(2))));
	          this.adjustDayPickerHeight(newMonthHeight);
	        }
	
	        this.setState({
	          monthTransition: NEXT_TRANSITION,
	          translationValue: translationValue,
	          focusedDate: null,
	          nextFocusedDate: nextFocusedDate
	        });
	      }
	
	      return onNextMonthClick;
	    }()
	  }, {
	    key: 'getFirstVisibleIndex',
	    value: function () {
	      function getFirstVisibleIndex() {
	        var orientation = this.props.orientation;
	        var monthTransition = this.state.monthTransition;
	
	
	        if (orientation === _constants.VERTICAL_SCROLLABLE) return 0;
	
	        var firstVisibleMonthIndex = 1;
	        if (monthTransition === PREV_TRANSITION) {
	          firstVisibleMonthIndex -= 1;
	        } else if (monthTransition === NEXT_TRANSITION) {
	          firstVisibleMonthIndex += 1;
	        }
	
	        return firstVisibleMonthIndex;
	      }
	
	      return getFirstVisibleIndex;
	    }()
	  }, {
	    key: 'getFocusedDay',
	    value: function () {
	      function getFocusedDay(newMonth) {
	        var _props3 = this.props,
	            getFirstFocusableDay = _props3.getFirstFocusableDay,
	            numberOfMonths = _props3.numberOfMonths;
	
	
	        var focusedDate = void 0;
	        if (getFirstFocusableDay) {
	          focusedDate = getFirstFocusableDay(newMonth);
	        }
	
	        if (newMonth && (!focusedDate || !(0, _isDayVisible2['default'])(focusedDate, newMonth, numberOfMonths))) {
	          focusedDate = newMonth.clone().startOf('month');
	        }
	
	        return focusedDate;
	      }
	
	      return getFocusedDay;
	    }()
	  }, {
	    key: 'setCalendarMonthHeights',
	    value: function () {
	      function setCalendarMonthHeights(calendarMonthHeights) {
	        var numberOfMonths = this.props.numberOfMonths;
	
	        var firstVisibleMonthIndex = this.getFirstVisibleIndex();
	        var lastVisibleMonthIndex = firstVisibleMonthIndex + numberOfMonths;
	
	        this.calendarMonthHeights = calendarMonthHeights;
	        var visibleCalendarMonthHeights = calendarMonthHeights.filter(function (_, i) {
	          return i >= firstVisibleMonthIndex && i < lastVisibleMonthIndex;
	        });
	        this.calendarMonthGridHeight = Math.max.apply(Math, [0].concat(_toConsumableArray(visibleCalendarMonthHeights))) + MONTH_PADDING;
	        this.setState({ hasSetHeight: true });
	      }
	
	      return setCalendarMonthHeights;
	    }()
	  }, {
	    key: 'setContainerRef',
	    value: function () {
	      function setContainerRef(ref) {
	        this.container = ref;
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: 'setCalendarInfoRef',
	    value: function () {
	      function setCalendarInfoRef(ref) {
	        this.calendarInfo = ref;
	      }
	
	      return setCalendarInfoRef;
	    }()
	  }, {
	    key: 'setTransitionContainerRef',
	    value: function () {
	      function setTransitionContainerRef(ref) {
	        this.transitionContainer = ref;
	      }
	
	      return setTransitionContainerRef;
	    }()
	  }, {
	    key: 'maybeTransitionNextMonth',
	    value: function () {
	      function maybeTransitionNextMonth(newFocusedDate) {
	        var numberOfMonths = this.props.numberOfMonths;
	        var _state2 = this.state,
	            currentMonth = _state2.currentMonth,
	            focusedDate = _state2.focusedDate;
	
	
	        var newFocusedDateMonth = newFocusedDate.month();
	        var focusedDateMonth = focusedDate.month();
	        var isNewFocusedDateVisible = (0, _isDayVisible2['default'])(newFocusedDate, currentMonth, numberOfMonths);
	        if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
	          this.onNextMonthClick(newFocusedDate);
	          return true;
	        }
	
	        return false;
	      }
	
	      return maybeTransitionNextMonth;
	    }()
	  }, {
	    key: 'maybeTransitionPrevMonth',
	    value: function () {
	      function maybeTransitionPrevMonth(newFocusedDate) {
	        var numberOfMonths = this.props.numberOfMonths;
	        var _state3 = this.state,
	            currentMonth = _state3.currentMonth,
	            focusedDate = _state3.focusedDate;
	
	
	        var newFocusedDateMonth = newFocusedDate.month();
	        var focusedDateMonth = focusedDate.month();
	        var isNewFocusedDateVisible = (0, _isDayVisible2['default'])(newFocusedDate, currentMonth, numberOfMonths);
	        if (newFocusedDateMonth !== focusedDateMonth && !isNewFocusedDateVisible) {
	          this.onPrevMonthClick(newFocusedDate);
	          return true;
	        }
	
	        return false;
	      }
	
	      return maybeTransitionPrevMonth;
	    }()
	  }, {
	    key: 'multiplyScrollableMonths',
	    value: function () {
	      function multiplyScrollableMonths(e) {
	        var onMultiplyScrollableMonths = this.props.onMultiplyScrollableMonths;
	
	        if (e) e.preventDefault();
	
	        if (onMultiplyScrollableMonths) onMultiplyScrollableMonths(e);
	
	        this.setState({
	          scrollableMonthMultiple: this.state.scrollableMonthMultiple + 1
	        });
	      }
	
	      return multiplyScrollableMonths;
	    }()
	  }, {
	    key: 'isHorizontal',
	    value: function () {
	      function isHorizontal() {
	        var orientation = this.props.orientation;
	
	        return orientation === _constants.HORIZONTAL_ORIENTATION;
	      }
	
	      return isHorizontal;
	    }()
	  }, {
	    key: 'isVertical',
	    value: function () {
	      function isVertical() {
	        var orientation = this.props.orientation;
	
	        return orientation === _constants.VERTICAL_ORIENTATION || orientation === _constants.VERTICAL_SCROLLABLE;
	      }
	
	      return isVertical;
	    }()
	  }, {
	    key: 'updateStateAfterMonthTransition',
	    value: function () {
	      function updateStateAfterMonthTransition() {
	        var _this3 = this;
	
	        var _props4 = this.props,
	            onPrevMonthClick = _props4.onPrevMonthClick,
	            onNextMonthClick = _props4.onNextMonthClick,
	            isRTL = _props4.isRTL;
	        var _state4 = this.state,
	            currentMonth = _state4.currentMonth,
	            monthTransition = _state4.monthTransition,
	            focusedDate = _state4.focusedDate,
	            nextFocusedDate = _state4.nextFocusedDate,
	            withMouseInteractions = _state4.withMouseInteractions,
	            calendarMonthWidth = _state4.calendarMonthWidth;
	
	
	        if (!monthTransition) return;
	
	        var newMonth = currentMonth.clone();
	        if (monthTransition === PREV_TRANSITION) {
	          if (onPrevMonthClick) onPrevMonthClick();
	          newMonth.subtract(1, 'month');
	        } else if (monthTransition === NEXT_TRANSITION) {
	          if (onNextMonthClick) onNextMonthClick();
	          newMonth.add(1, 'month');
	        }
	
	        var newFocusedDate = null;
	        if (nextFocusedDate) {
	          newFocusedDate = nextFocusedDate;
	        } else if (!focusedDate && !withMouseInteractions) {
	          newFocusedDate = this.getFocusedDay(newMonth);
	        }
	
	        this.setState({
	          currentMonth: newMonth,
	          monthTransition: null,
	          translationValue: isRTL && this.isHorizontal() ? -calendarMonthWidth : 0,
	          nextFocusedDate: null,
	          focusedDate: newFocusedDate
	        }, function () {
	          // we don't want to focus on the relevant calendar day after a month transition
	          // if the user is navigating around using a mouse
	          if (withMouseInteractions) {
	            var activeElement = (0, _getActiveElement2['default'])();
	            if (activeElement && activeElement !== document.body && _this3.container.contains(activeElement)) {
	              activeElement.blur();
	            }
	          }
	        });
	      }
	
	      return updateStateAfterMonthTransition;
	    }()
	  }, {
	    key: 'adjustDayPickerHeight',
	    value: function () {
	      function adjustDayPickerHeight(newMonthHeight) {
	        var monthHeight = newMonthHeight + MONTH_PADDING;
	        if (monthHeight !== this.calendarMonthGridHeight) {
	          this.calendarMonthGridHeight = monthHeight;
	          this.transitionContainer.style.height = String(monthHeight) + 'px';
	        }
	      }
	
	      return adjustDayPickerHeight;
	    }()
	  }, {
	    key: 'openKeyboardShortcutsPanel',
	    value: function () {
	      function openKeyboardShortcutsPanel(onCloseCallBack) {
	        this.setState({
	          showKeyboardShortcuts: true,
	          onKeyboardShortcutsPanelClose: onCloseCallBack
	        });
	      }
	
	      return openKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: 'closeKeyboardShortcutsPanel',
	    value: function () {
	      function closeKeyboardShortcutsPanel() {
	        var onKeyboardShortcutsPanelClose = this.state.onKeyboardShortcutsPanelClose;
	
	
	        if (onKeyboardShortcutsPanelClose) {
	          onKeyboardShortcutsPanelClose();
	        }
	
	        this.setState({
	          onKeyboardShortcutsPanelClose: null,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return closeKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: 'renderNavigation',
	    value: function () {
	      function renderNavigation() {
	        var _this4 = this;
	
	        var _props5 = this.props,
	            navPrev = _props5.navPrev,
	            navNext = _props5.navNext,
	            noNavButtons = _props5.noNavButtons,
	            orientation = _props5.orientation,
	            phrases = _props5.phrases,
	            isRTL = _props5.isRTL;
	
	
	        if (noNavButtons) {
	          return null;
	        }
	
	        var onNextMonthClick = void 0;
	        if (orientation === _constants.VERTICAL_SCROLLABLE) {
	          onNextMonthClick = this.multiplyScrollableMonths;
	        } else {
	          onNextMonthClick = function () {
	            function onNextMonthClick(e) {
	              _this4.onNextMonthClick(null, e);
	            }
	
	            return onNextMonthClick;
	          }();
	        }
	
	        return _react2['default'].createElement(_DayPickerNavigation2['default'], {
	          onPrevMonthClick: function () {
	            function onPrevMonthClick(e) {
	              _this4.onPrevMonthClick(null, e);
	            }
	
	            return onPrevMonthClick;
	          }(),
	          onNextMonthClick: onNextMonthClick,
	          navPrev: navPrev,
	          navNext: navNext,
	          orientation: orientation,
	          phrases: phrases,
	          isRTL: isRTL
	        });
	      }
	
	      return renderNavigation;
	    }()
	  }, {
	    key: 'renderWeekHeader',
	    value: function () {
	      function renderWeekHeader(index) {
	        var _props6 = this.props,
	            daySize = _props6.daySize,
	            orientation = _props6.orientation,
	            weekDayFormat = _props6.weekDayFormat,
	            styles = _props6.styles;
	        var calendarMonthWidth = this.state.calendarMonthWidth;
	
	        var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	        var horizontalStyle = {
	          left: index * calendarMonthWidth
	        };
	        var verticalStyle = {
	          marginLeft: -calendarMonthWidth / 2
	        };
	
	        var weekHeaderStyle = {}; // no styles applied to the vertical-scrollable orientation
	        if (this.isHorizontal()) {
	          weekHeaderStyle = horizontalStyle;
	        } else if (this.isVertical() && !verticalScrollable) {
	          weekHeaderStyle = verticalStyle;
	        }
	
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	
	        if (firstDayOfWeek == null) {
	          firstDayOfWeek = _moment2['default'].localeData().firstDayOfWeek();
	        }
	
	        var header = [];
	        for (var i = 0; i < 7; i += 1) {
	          header.push(_react2['default'].createElement(
	            'li',
	            _extends({ key: i }, (0, _reactWithStyles.css)(styles.DayPicker_weekHeader_li, { width: daySize })),
	            _react2['default'].createElement(
	              'small',
	              null,
	              (0, _moment2['default'])().day((i + firstDayOfWeek) % 7).format(weekDayFormat)
	            )
	          ));
	        }
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_weekHeader, this.isVertical() && styles.DayPicker_weekHeader__vertical, verticalScrollable && styles.DayPicker_weekHeader__verticalScrollable, weekHeaderStyle), {
	            key: 'week-' + String(index)
	          }),
	          _react2['default'].createElement(
	            'ul',
	            (0, _reactWithStyles.css)(styles.DayPicker_weekHeader_ul),
	            header
	          )
	        );
	      }
	
	      return renderWeekHeader;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this5 = this;
	
	        var _state5 = this.state,
	            calendarMonthWidth = _state5.calendarMonthWidth,
	            currentMonth = _state5.currentMonth,
	            monthTransition = _state5.monthTransition,
	            translationValue = _state5.translationValue,
	            scrollableMonthMultiple = _state5.scrollableMonthMultiple,
	            focusedDate = _state5.focusedDate,
	            showKeyboardShortcuts = _state5.showKeyboardShortcuts,
	            isTouch = _state5.isTouchDevice,
	            hasSetHeight = _state5.hasSetHeight,
	            calendarInfoWidth = _state5.calendarInfoWidth;
	        var _props7 = this.props,
	            enableOutsideDays = _props7.enableOutsideDays,
	            numberOfMonths = _props7.numberOfMonths,
	            orientation = _props7.orientation,
	            modifiers = _props7.modifiers,
	            withPortal = _props7.withPortal,
	            onDayClick = _props7.onDayClick,
	            onDayMouseEnter = _props7.onDayMouseEnter,
	            onDayMouseLeave = _props7.onDayMouseLeave,
	            firstDayOfWeek = _props7.firstDayOfWeek,
	            renderMonth = _props7.renderMonth,
	            renderCalendarDay = _props7.renderCalendarDay,
	            renderDayContents = _props7.renderDayContents,
	            renderCalendarInfo = _props7.renderCalendarInfo,
	            calendarInfoPosition = _props7.calendarInfoPosition,
	            hideKeyboardShortcutsPanel = _props7.hideKeyboardShortcutsPanel,
	            onOutsideClick = _props7.onOutsideClick,
	            monthFormat = _props7.monthFormat,
	            daySize = _props7.daySize,
	            isFocused = _props7.isFocused,
	            isRTL = _props7.isRTL,
	            styles = _props7.styles,
	            phrases = _props7.phrases,
	            verticalHeight = _props7.verticalHeight,
	            dayAriaLabelFormat = _props7.dayAriaLabelFormat,
	            noBorder = _props7.noBorder,
	            transitionDuration = _props7.transitionDuration,
	            verticalBorderSpacing = _props7.verticalBorderSpacing;
	
	
	        var isHorizontal = this.isHorizontal();
	
	        var numOfWeekHeaders = this.isVertical() ? 1 : numberOfMonths;
	        var weekHeaders = [];
	        for (var i = 0; i < numOfWeekHeaders; i += 1) {
	          weekHeaders.push(this.renderWeekHeader(i));
	        }
	
	        var verticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	        var height = void 0;
	        if (isHorizontal) {
	          height = this.calendarMonthGridHeight;
	        } else if (this.isVertical() && !verticalScrollable && !withPortal) {
	          // If the user doesn't set a desired height,
	          // we default back to this kind of made-up value that generally looks good
	          height = verticalHeight || 1.75 * calendarMonthWidth;
	        }
	
	        var isCalendarMonthGridAnimating = monthTransition !== null;
	        var transformType = this.isVertical() ? 'translateY' : 'translateX';
	        var transformValue = transformType + '(' + String(translationValue) + 'px)';
	
	        var shouldFocusDate = !isCalendarMonthGridAnimating && isFocused;
	
	        var keyboardShortcutButtonLocation = _DayPickerKeyboardShortcuts.BOTTOM_RIGHT;
	        if (this.isVertical()) {
	          keyboardShortcutButtonLocation = withPortal ? _DayPickerKeyboardShortcuts.TOP_LEFT : _DayPickerKeyboardShortcuts.TOP_RIGHT;
	        }
	
	        var isHorizontalAndAnimating = isHorizontal && isCalendarMonthGridAnimating;
	
	        var calendarInfoPositionTop = calendarInfoPosition === _constants.INFO_POSITION_TOP;
	        var calendarInfoPositionBottom = calendarInfoPosition === _constants.INFO_POSITION_BOTTOM;
	        var calendarInfoPositionBefore = calendarInfoPosition === _constants.INFO_POSITION_BEFORE;
	        var calendarInfoPositionAfter = calendarInfoPosition === _constants.INFO_POSITION_AFTER;
	        var calendarInfoIsInline = calendarInfoPositionBefore || calendarInfoPositionAfter;
	
	        var calendarInfo = renderCalendarInfo && _react2['default'].createElement(
	          'div',
	          _extends({
	            ref: this.setCalendarInfoRef
	          }, (0, _reactWithStyles.css)(calendarInfoIsInline && styles.DayPicker_calendarInfo__horizontal)),
	          renderCalendarInfo()
	        );
	
	        var calendarInfoPanelWidth = renderCalendarInfo && calendarInfoIsInline ? calendarInfoWidth : 0;
	
	        var firstVisibleMonthIndex = this.getFirstVisibleIndex();
	        var wrapperHorizontalWidth = calendarMonthWidth * numberOfMonths + 2 * DAY_PICKER_PADDING;
	        // Adding `1px` because of whitespace between 2 inline-block
	        var fullHorizontalWidth = wrapperHorizontalWidth + calendarInfoPanelWidth + 1;
	
	        var transitionContainerStyle = {
	          width: isHorizontal && wrapperHorizontalWidth,
	          height: height
	        };
	
	        var dayPickerWrapperStyle = {
	          width: isHorizontal && wrapperHorizontalWidth
	        };
	
	        var dayPickerStyle = {
	          width: isHorizontal && fullHorizontalWidth,
	
	          // These values are to center the datepicker (approximately) on the page
	          marginLeft: isHorizontal && withPortal ? -fullHorizontalWidth / 2 : null,
	          marginTop: isHorizontal && withPortal ? -calendarMonthWidth / 2 : null
	        };
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({
	            role: 'application',
	            'aria-label': phrases.calendarLabel
	          }, (0, _reactWithStyles.css)(styles.DayPicker, isHorizontal && styles.DayPicker__horizontal, verticalScrollable && styles.DayPicker__verticalScrollable, isHorizontal && withPortal && styles.DayPicker_portal__horizontal, this.isVertical() && withPortal && styles.DayPicker_portal__vertical, dayPickerStyle, !hasSetHeight && styles.DayPicker__hidden, !noBorder && styles.DayPicker__withBorder)),
	          _react2['default'].createElement(
	            _OutsideClickHandler2['default'],
	            { onOutsideClick: onOutsideClick },
	            (calendarInfoPositionTop || calendarInfoPositionBefore) && calendarInfo,
	            _react2['default'].createElement(
	              'div',
	              (0, _reactWithStyles.css)(dayPickerWrapperStyle, calendarInfoIsInline && isHorizontal && styles.DayPicker_wrapper__horizontal),
	              _react2['default'].createElement(
	                'div',
	                _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_weekHeaders, isHorizontal && styles.DayPicker_weekHeaders__horizontal), {
	                  'aria-hidden': 'true',
	                  role: 'presentation'
	                }),
	                weekHeaders
	              ),
	              _react2['default'].createElement(
	                'div',
	                _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_focusRegion), {
	                  ref: this.setContainerRef,
	                  onClick: function () {
	                    function onClick(e) {
	                      e.stopPropagation();
	                    }
	
	                    return onClick;
	                  }(),
	                  onKeyDown: this.onKeyDown,
	                  onMouseUp: function () {
	                    function onMouseUp() {
	                      _this5.setState({ withMouseInteractions: true });
	                    }
	
	                    return onMouseUp;
	                  }(),
	                  role: 'region',
	                  tabIndex: -1
	                }),
	                !verticalScrollable && this.renderNavigation(),
	                _react2['default'].createElement(
	                  'div',
	                  _extends({}, (0, _reactWithStyles.css)(styles.DayPicker_transitionContainer, isHorizontalAndAnimating && styles.DayPicker_transitionContainer__horizontal, this.isVertical() && styles.DayPicker_transitionContainer__vertical, verticalScrollable && styles.DayPicker_transitionContainer__verticalScrollable, transitionContainerStyle), {
	                    ref: this.setTransitionContainerRef
	                  }),
	                  _react2['default'].createElement(_CalendarMonthGrid2['default'], {
	                    setCalendarMonthHeights: this.setCalendarMonthHeights,
	                    transformValue: transformValue,
	                    enableOutsideDays: enableOutsideDays,
	                    firstVisibleMonthIndex: firstVisibleMonthIndex,
	                    initialMonth: currentMonth,
	                    isAnimating: isCalendarMonthGridAnimating,
	                    modifiers: modifiers,
	                    orientation: orientation,
	                    numberOfMonths: numberOfMonths * scrollableMonthMultiple,
	                    onDayClick: onDayClick,
	                    onDayMouseEnter: onDayMouseEnter,
	                    onDayMouseLeave: onDayMouseLeave,
	                    renderMonth: renderMonth,
	                    renderCalendarDay: renderCalendarDay,
	                    renderDayContents: renderDayContents,
	                    onMonthTransitionEnd: this.updateStateAfterMonthTransition,
	                    monthFormat: monthFormat,
	                    daySize: daySize,
	                    firstDayOfWeek: firstDayOfWeek,
	                    isFocused: shouldFocusDate,
	                    focusedDate: focusedDate,
	                    phrases: phrases,
	                    isRTL: isRTL,
	                    dayAriaLabelFormat: dayAriaLabelFormat,
	                    transitionDuration: transitionDuration,
	                    verticalBorderSpacing: verticalBorderSpacing
	                  }),
	                  verticalScrollable && this.renderNavigation()
	                ),
	                !isTouch && !hideKeyboardShortcutsPanel && _react2['default'].createElement(_DayPickerKeyboardShortcuts2['default'], {
	                  block: this.isVertical() && !withPortal,
	                  buttonLocation: keyboardShortcutButtonLocation,
	                  showKeyboardShortcutsPanel: showKeyboardShortcuts,
	                  openKeyboardShortcutsPanel: this.openKeyboardShortcutsPanel,
	                  closeKeyboardShortcutsPanel: this.closeKeyboardShortcutsPanel,
	                  phrases: phrases
	                })
	              )
	            ),
	            (calendarInfoPositionBottom || calendarInfoPositionAfter) && calendarInfo
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPicker;
	}(_react2['default'].Component);
	
	DayPicker.propTypes = propTypes;
	DayPicker.defaultProps = defaultProps;
	
	exports.PureDayPicker = DayPicker;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      font = _ref$reactDates.font,
	      zIndex = _ref$reactDates.zIndex;
	  return {
	    DayPicker: {
	      background: color.background,
	      position: 'relative',
	      textAlign: 'left'
	    },
	
	    DayPicker__horizontal: {
	      background: color.background
	    },
	
	    DayPicker__verticalScrollable: {
	      height: '100%'
	    },
	
	    DayPicker__hidden: {
	      visibility: 'hidden'
	    },
	
	    DayPicker__withBorder: {
	      boxShadow: '0 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.07)',
	      borderRadius: 3
	    },
	
	    DayPicker_portal__horizontal: {
	      boxShadow: 'none',
	      position: 'absolute',
	      left: '50%',
	      top: '50%'
	    },
	
	    DayPicker_portal__vertical: {
	      position: 'initial'
	    },
	
	    DayPicker_focusRegion: {
	      outline: 'none'
	    },
	
	    DayPicker_calendarInfo__horizontal: {
	      display: 'inline-block',
	      verticalAlign: 'top'
	    },
	
	    DayPicker_wrapper__horizontal: {
	      display: 'inline-block',
	      verticalAlign: 'top'
	    },
	
	    DayPicker_weekHeaders: {
	      position: 'relative'
	    },
	
	    DayPicker_weekHeaders__horizontal: {
	      marginLeft: 9
	    },
	
	    DayPicker_weekHeader: {
	      color: color.placeholderText,
	      position: 'absolute',
	      top: 62,
	      zIndex: zIndex + 2,
	      padding: '0 13px',
	      textAlign: 'left'
	    },
	
	    DayPicker_weekHeader__vertical: {
	      left: '50%'
	    },
	
	    DayPicker_weekHeader__verticalScrollable: {
	      top: 0,
	      display: 'table-row',
	      borderBottom: '1px solid ' + String(color.core.border),
	      background: color.background,
	      marginLeft: 0,
	      left: 0,
	      width: '100%',
	      textAlign: 'center'
	    },
	
	    DayPicker_weekHeader_ul: {
	      listStyle: 'none',
	      margin: '1px 0',
	      paddingLeft: 0,
	      paddingRight: 0,
	      fontSize: font.size
	    },
	
	    DayPicker_weekHeader_li: {
	      display: 'inline-block',
	      textAlign: 'center'
	    },
	
	    DayPicker_transitionContainer: {
	      position: 'relative',
	      overflow: 'hidden',
	      borderRadius: 3
	    },
	
	    DayPicker_transitionContainer__horizontal: {
	      transition: 'height 0.2s ease-in-out'
	    },
	
	    DayPicker_transitionContainer__vertical: {
	      width: '100%'
	    },
	
	    DayPicker_transitionContainer__verticalScrollable: {
	      paddingTop: 20,
	      height: '100%',
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0,
	      overflowY: 'scroll'
	    }
	  };
	})(DayPicker);

/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BOTTOM_RIGHT = exports.TOP_RIGHT = exports.TOP_LEFT = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _reactWithStyles = __webpack_require__(26);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _KeyboardShortcutRow = __webpack_require__(530);
	
	var _KeyboardShortcutRow2 = _interopRequireDefault(_KeyboardShortcutRow);
	
	var _CloseButton = __webpack_require__(78);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TOP_LEFT = exports.TOP_LEFT = 'top-left';
	var TOP_RIGHT = exports.TOP_RIGHT = 'top-right';
	var BOTTOM_RIGHT = exports.BOTTOM_RIGHT = 'bottom-right';
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  block: _propTypes2['default'].bool,
	  buttonLocation: _propTypes2['default'].oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_RIGHT]),
	  showKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  openKeyboardShortcutsPanel: _propTypes2['default'].func,
	  closeKeyboardShortcutsPanel: _propTypes2['default'].func,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerKeyboardShortcutsPhrases))
	}));
	
	var defaultProps = {
	  block: false,
	  buttonLocation: BOTTOM_RIGHT,
	  showKeyboardShortcutsPanel: false,
	  openKeyboardShortcutsPanel: function () {
	    function openKeyboardShortcutsPanel() {}
	
	    return openKeyboardShortcutsPanel;
	  }(),
	  closeKeyboardShortcutsPanel: function () {
	    function closeKeyboardShortcutsPanel() {}
	
	    return closeKeyboardShortcutsPanel;
	  }(),
	
	  phrases: _defaultPhrases.DayPickerKeyboardShortcutsPhrases
	};
	
	function getKeyboardShortcuts(phrases) {
	  return [{
	    unicode: '↵',
	    label: phrases.enterKey,
	    action: phrases.selectFocusedDate
	  }, {
	    unicode: '←/→',
	    label: phrases.leftArrowRightArrow,
	    action: phrases.moveFocusByOneDay
	  }, {
	    unicode: '↑/↓',
	    label: phrases.upArrowDownArrow,
	    action: phrases.moveFocusByOneWeek
	  }, {
	    unicode: 'PgUp/PgDn',
	    label: phrases.pageUpPageDown,
	    action: phrases.moveFocusByOneMonth
	  }, {
	    unicode: 'Home/End',
	    label: phrases.homeEnd,
	    action: phrases.moveFocustoStartAndEndOfWeek
	  }, {
	    unicode: 'Esc',
	    label: phrases.escape,
	    action: phrases.returnFocusToInput
	  }, {
	    unicode: '?',
	    label: phrases.questionMark,
	    action: phrases.openThisPanel
	  }];
	}
	
	var DayPickerKeyboardShortcuts = function (_React$Component) {
	  _inherits(DayPickerKeyboardShortcuts, _React$Component);
	
	  function DayPickerKeyboardShortcuts() {
	    var _ref;
	
	    _classCallCheck(this, DayPickerKeyboardShortcuts);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = DayPickerKeyboardShortcuts.__proto__ || Object.getPrototypeOf(DayPickerKeyboardShortcuts)).call.apply(_ref, [this].concat(args)));
	
	    _this.keyboardShortcuts = getKeyboardShortcuts(_this.props.phrases);
	
	    _this.onShowKeyboardShortcutsButtonClick = _this.onShowKeyboardShortcutsButtonClick.bind(_this);
	    _this.setShowKeyboardShortcutsButtonRef = _this.setShowKeyboardShortcutsButtonRef.bind(_this);
	    _this.setHideKeyboardShortcutsButtonRef = _this.setHideKeyboardShortcutsButtonRef.bind(_this);
	    _this.handleFocus = _this.handleFocus.bind(_this);
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayPickerKeyboardShortcuts, [{
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        if (nextProps.phrases !== this.props.phrases) {
	          this.keyboardShortcuts = getKeyboardShortcuts(nextProps.phrases);
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate() {
	        this.handleFocus();
	      }
	
	      return componentDidUpdate;
	    }()
	  }, {
	    key: 'onKeyDown',
	    value: function () {
	      function onKeyDown(e) {
	        e.stopPropagation();
	
	        var closeKeyboardShortcutsPanel = this.props.closeKeyboardShortcutsPanel;
	        // Because the close button is the only focusable element inside of the panel, this
	        // amounts to a very basic focus trap. The user can exit the panel by "pressing" the
	        // close button or hitting escape
	
	        switch (e.key) {
	          case 'Enter':
	          case ' ':
	          case 'Spacebar': // for older browsers
	          case 'Escape':
	            closeKeyboardShortcutsPanel();
	            break;
	
	          // do nothing - this allows the up and down arrows continue their
	          // default behavior of scrolling the content of the Keyboard Shortcuts Panel
	          // which is needed when only a single month is shown for instance.
	          case 'ArrowUp':
	          case 'ArrowDown':
	            break;
	
	          // completely block the rest of the keys that have functionality outside of this panel
	          case 'Tab':
	          case 'Home':
	          case 'End':
	          case 'PageUp':
	          case 'PageDown':
	          case 'ArrowLeft':
	          case 'ArrowRight':
	            e.preventDefault();
	            break;
	
	          default:
	            break;
	        }
	      }
	
	      return onKeyDown;
	    }()
	  }, {
	    key: 'onShowKeyboardShortcutsButtonClick',
	    value: function () {
	      function onShowKeyboardShortcutsButtonClick() {
	        var _this2 = this;
	
	        var openKeyboardShortcutsPanel = this.props.openKeyboardShortcutsPanel;
	
	        // we want to return focus to this button after closing the keyboard shortcuts panel
	
	        openKeyboardShortcutsPanel(function () {
	          _this2.showKeyboardShortcutsButton.focus();
	        });
	      }
	
	      return onShowKeyboardShortcutsButtonClick;
	    }()
	  }, {
	    key: 'setShowKeyboardShortcutsButtonRef',
	    value: function () {
	      function setShowKeyboardShortcutsButtonRef(ref) {
	        this.showKeyboardShortcutsButton = ref;
	      }
	
	      return setShowKeyboardShortcutsButtonRef;
	    }()
	  }, {
	    key: 'setHideKeyboardShortcutsButtonRef',
	    value: function () {
	      function setHideKeyboardShortcutsButtonRef(ref) {
	        this.hideKeyboardShortcutsButton = ref;
	      }
	
	      return setHideKeyboardShortcutsButtonRef;
	    }()
	  }, {
	    key: 'handleFocus',
	    value: function () {
	      function handleFocus() {
	        if (this.hideKeyboardShortcutsButton) {
	          // automatically move focus into the dialog by moving
	          // to the only interactive element, the hide button
	          this.hideKeyboardShortcutsButton.focus();
	        }
	      }
	
	      return handleFocus;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            block = _props.block,
	            buttonLocation = _props.buttonLocation,
	            showKeyboardShortcutsPanel = _props.showKeyboardShortcutsPanel,
	            closeKeyboardShortcutsPanel = _props.closeKeyboardShortcutsPanel,
	            styles = _props.styles,
	            phrases = _props.phrases;
	
	
	        var toggleButtonText = showKeyboardShortcutsPanel ? phrases.hideKeyboardShortcutsPanel : phrases.showKeyboardShortcutsPanel;
	
	        var bottomRight = buttonLocation === BOTTOM_RIGHT;
	        var topRight = buttonLocation === TOP_RIGHT;
	        var topLeft = buttonLocation === TOP_LEFT;
	
	        return _react2['default'].createElement(
	          'div',
	          null,
	          _react2['default'].createElement(
	            'button',
	            _extends({
	              ref: this.setShowKeyboardShortcutsButtonRef
	            }, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_show, bottomRight && styles.DayPickerKeyboardShortcuts_show__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_show__topRight, topLeft && styles.DayPickerKeyboardShortcuts_show__topLeft), {
	              type: 'button',
	              'aria-label': toggleButtonText,
	              onClick: this.onShowKeyboardShortcutsButtonClick,
	              onKeyDown: function () {
	                function onKeyDown(e) {
	                  if (e.key === 'Enter') {
	                    e.preventDefault();
	                  } else if (e.key === 'Space') {
	                    _this3.onShowKeyboardShortcutsButtonClick(e);
	                  }
	                }
	
	                return onKeyDown;
	              }(),
	              onMouseUp: function () {
	                function onMouseUp(e) {
	                  e.currentTarget.blur();
	                }
	
	                return onMouseUp;
	              }()
	            }),
	            _react2['default'].createElement(
	              'span',
	              (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_showSpan, bottomRight && styles.DayPickerKeyboardShortcuts_showSpan__bottomRight, topRight && styles.DayPickerKeyboardShortcuts_showSpan__topRight, topLeft && styles.DayPickerKeyboardShortcuts_showSpan__topLeft),
	              '?'
	            )
	          ),
	          showKeyboardShortcutsPanel && _react2['default'].createElement(
	            'div',
	            _extends({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_panel), {
	              role: 'dialog',
	              'aria-labelledby': 'DayPickerKeyboardShortcuts_title',
	              'aria-describedby': 'DayPickerKeyboardShortcuts_description'
	            }),
	            _react2['default'].createElement(
	              'div',
	              _extends({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_title), {
	                id: 'DayPickerKeyboardShortcuts_title'
	              }),
	              phrases.keyboardShortcuts
	            ),
	            _react2['default'].createElement(
	              'button',
	              _extends({
	                ref: this.setHideKeyboardShortcutsButtonRef
	              }, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_buttonReset, styles.DayPickerKeyboardShortcuts_close), {
	                type: 'button',
	                tabIndex: '0',
	                'aria-label': phrases.hideKeyboardShortcutsPanel,
	                onClick: closeKeyboardShortcutsPanel,
	                onKeyDown: this.onKeyDown
	              }),
	              _react2['default'].createElement(_CloseButton2['default'], (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_closeSvg))
	            ),
	            _react2['default'].createElement(
	              'ul',
	              _extends({}, (0, _reactWithStyles.css)(styles.DayPickerKeyboardShortcuts_list), {
	                id: 'DayPickerKeyboardShortcuts_description'
	              }),
	              this.keyboardShortcuts.map(function (_ref2) {
	                var unicode = _ref2.unicode,
	                    label = _ref2.label,
	                    action = _ref2.action;
	                return _react2['default'].createElement(_KeyboardShortcutRow2['default'], {
	                  key: label,
	                  unicode: unicode,
	                  label: label,
	                  action: action,
	                  block: block
	                });
	              })
	            )
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPickerKeyboardShortcuts;
	}(_react2['default'].Component);
	
	DayPickerKeyboardShortcuts.propTypes = propTypes;
	DayPickerKeyboardShortcuts.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref3) {
	  var _ref3$reactDates = _ref3.reactDates,
	      color = _ref3$reactDates.color,
	      font = _ref3$reactDates.font,
	      zIndex = _ref3$reactDates.zIndex;
	  return {
	    DayPickerKeyboardShortcuts_buttonReset: {
	      background: 'none',
	      border: 0,
	      borderRadius: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      padding: 0,
	      cursor: 'pointer',
	      fontSize: font.size,
	
	      ':active': {
	        outline: 'none'
	      }
	    },
	
	    DayPickerKeyboardShortcuts_show: {
	      width: 22,
	      position: 'absolute',
	      zIndex: zIndex + 2
	    },
	
	    DayPickerKeyboardShortcuts_show__bottomRight: {
	      borderTop: '26px solid transparent',
	      borderRight: '33px solid ' + String(color.core.primary),
	      bottom: 0,
	      right: 0,
	
	      ':hover': {
	        borderRight: '33px solid ' + String(color.core.primary_dark)
	      }
	    },
	
	    DayPickerKeyboardShortcuts_show__topRight: {
	      borderBottom: '26px solid transparent',
	      borderRight: '33px solid ' + String(color.core.primary),
	      top: 0,
	      right: 0,
	
	      ':hover': {
	        borderRight: '33px solid ' + String(color.core.primary_dark)
	      }
	    },
	
	    DayPickerKeyboardShortcuts_show__topLeft: {
	      borderBottom: '26px solid transparent',
	      borderLeft: '33px solid ' + String(color.core.primary),
	      top: 0,
	      left: 0,
	
	      ':hover': {
	        borderLeft: '33px solid ' + String(color.core.primary_dark)
	      }
	    },
	
	    DayPickerKeyboardShortcuts_showSpan: {
	      color: color.core.white,
	      position: 'absolute'
	    },
	
	    DayPickerKeyboardShortcuts_showSpan__bottomRight: {
	      bottom: 0,
	      right: -28
	    },
	
	    DayPickerKeyboardShortcuts_showSpan__topRight: {
	      top: 1,
	      right: -28
	    },
	
	    DayPickerKeyboardShortcuts_showSpan__topLeft: {
	      top: 1,
	      left: -28
	    },
	
	    DayPickerKeyboardShortcuts_panel: {
	      overflow: 'auto',
	      background: color.background,
	      border: '1px solid ' + String(color.core.border),
	      borderRadius: 2,
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0,
	      zIndex: zIndex + 2,
	      padding: 22,
	      margin: 33
	    },
	
	    DayPickerKeyboardShortcuts_title: {
	      fontSize: 16,
	      fontWeight: 'bold',
	      margin: 0
	    },
	
	    DayPickerKeyboardShortcuts_list: {
	      listStyle: 'none',
	      padding: 0,
	      fontSize: font.size
	    },
	
	    DayPickerKeyboardShortcuts_close: {
	      position: 'absolute',
	      right: 22,
	      top: 22,
	      zIndex: zIndex + 2,
	
	      ':active': {
	        outline: 'none'
	      }
	    },
	
	    DayPickerKeyboardShortcuts_closeSvg: {
	      height: 15,
	      width: 15,
	      fill: color.core.grayLighter,
	
	      ':hover': {
	        fill: color.core.grayLight
	      },
	
	      ':focus': {
	        fill: color.core.grayLight
	      }
	    }
	  };
	})(DayPickerKeyboardShortcuts);

/***/ }),

/***/ 529:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _reactWithStyles = __webpack_require__(26);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _LeftArrow = __webpack_require__(236);
	
	var _LeftArrow2 = _interopRequireDefault(_LeftArrow);
	
	var _RightArrow = __webpack_require__(237);
	
	var _RightArrow2 = _interopRequireDefault(_RightArrow);
	
	var _ChevronUp = __webpack_require__(525);
	
	var _ChevronUp2 = _interopRequireDefault(_ChevronUp);
	
	var _ChevronDown = __webpack_require__(524);
	
	var _ChevronDown2 = _interopRequireDefault(_ChevronDown);
	
	var _ScrollableOrientationShape = __webpack_require__(56);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	  orientation: _ScrollableOrientationShape2['default'],
	
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	
	  // internationalization
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerNavigationPhrases)),
	
	  isRTL: _propTypes2['default'].bool
	}));
	
	var defaultProps = {
	  navPrev: null,
	  navNext: null,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	
	
	  // internationalization
	  phrases: _defaultPhrases.DayPickerNavigationPhrases,
	  isRTL: false
	};
	
	function DayPickerNavigation(_ref) {
	  var navPrev = _ref.navPrev,
	      navNext = _ref.navNext,
	      onPrevMonthClick = _ref.onPrevMonthClick,
	      onNextMonthClick = _ref.onNextMonthClick,
	      orientation = _ref.orientation,
	      phrases = _ref.phrases,
	      isRTL = _ref.isRTL,
	      styles = _ref.styles;
	
	  var isHorizontal = orientation === _constants.HORIZONTAL_ORIENTATION;
	  var isVertical = orientation !== _constants.HORIZONTAL_ORIENTATION;
	  var isVerticalScrollable = orientation === _constants.VERTICAL_SCROLLABLE;
	
	  var navPrevIcon = navPrev;
	  var navNextIcon = navNext;
	  var isDefaultNavPrev = false;
	  var isDefaultNavNext = false;
	  if (!navPrevIcon) {
	    isDefaultNavPrev = true;
	    var Icon = isVertical ? _ChevronUp2['default'] : _LeftArrow2['default'];
	    if (isRTL && !isVertical) {
	      Icon = _RightArrow2['default'];
	    }
	    navPrevIcon = _react2['default'].createElement(Icon, (0, _reactWithStyles.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical));
	  }
	
	  if (!navNextIcon) {
	    isDefaultNavNext = true;
	    var _Icon = isVertical ? _ChevronDown2['default'] : _RightArrow2['default'];
	    if (isRTL && !isVertical) {
	      _Icon = _LeftArrow2['default'];
	    }
	    navNextIcon = _react2['default'].createElement(_Icon, (0, _reactWithStyles.css)(isHorizontal && styles.DayPickerNavigation_svg__horizontal, isVertical && styles.DayPickerNavigation_svg__vertical));
	  }
	
	  return _react2['default'].createElement(
	    'div',
	    (0, _reactWithStyles.css)(styles.DayPickerNavigation_container, isHorizontal && styles.DayPickerNavigation_container__horizontal, isVertical && styles.DayPickerNavigation_container__vertical, isVerticalScrollable && styles.DayPickerNavigation_container__verticalScrollable),
	    !isVerticalScrollable && _react2['default'].createElement(
	      'button',
	      _extends({}, _reactWithStyles.css.apply(undefined, [styles.DayPickerNavigation_button, isDefaultNavPrev && styles.DayPickerNavigation_button__default].concat(_toConsumableArray(isHorizontal && [styles.DayPickerNavigation_button__horizontal, !isRTL && styles.DayPickerNavigation_leftButton__horizontal, isRTL && styles.DayPickerNavigation_rightButton__horizontal]), _toConsumableArray(isVertical && [styles.DayPickerNavigation_button__vertical, styles.DayPickerNavigation_prevButton__vertical, isDefaultNavPrev && styles.DayPickerNavigation_button__vertical__default]))), {
	        type: 'button',
	        'aria-label': phrases.jumpToPrevMonth,
	        onClick: onPrevMonthClick,
	        onMouseUp: function () {
	          function onMouseUp(e) {
	            e.currentTarget.blur();
	          }
	
	          return onMouseUp;
	        }()
	      }),
	      navPrevIcon
	    ),
	    _react2['default'].createElement(
	      'button',
	      _extends({}, _reactWithStyles.css.apply(undefined, [styles.DayPickerNavigation_button, isDefaultNavNext && styles.DayPickerNavigation_button__default].concat(_toConsumableArray(isHorizontal && [styles.DayPickerNavigation_button__horizontal, isRTL && styles.DayPickerNavigation_leftButton__horizontal, !isRTL && styles.DayPickerNavigation_rightButton__horizontal]), _toConsumableArray(isVertical && [styles.DayPickerNavigation_button__vertical, styles.DayPickerNavigation_nextButton__vertical, isDefaultNavNext && styles.DayPickerNavigation_button__vertical__default, isDefaultNavNext && styles.DayPickerNavigation_nextButton__vertical__default]), [isVerticalScrollable && styles.DayPickerNavigation_nextButton__verticalScrollable])), {
	        type: 'button',
	        'aria-label': phrases.jumpToNextMonth,
	        onClick: onNextMonthClick,
	        onMouseUp: function () {
	          function onMouseUp(e) {
	            e.currentTarget.blur();
	          }
	
	          return onMouseUp;
	        }()
	      }),
	      navNextIcon
	    )
	  );
	}
	
	DayPickerNavigation.propTypes = propTypes;
	DayPickerNavigation.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var _ref2$reactDates = _ref2.reactDates,
	      color = _ref2$reactDates.color,
	      zIndex = _ref2$reactDates.zIndex;
	  return {
	    DayPickerNavigation_container: {
	      position: 'relative',
	      zIndex: zIndex + 2
	    },
	
	    DayPickerNavigation_container__horizontal: {},
	
	    DayPickerNavigation_container__vertical: {
	      background: color.background,
	      boxShadow: '0 0 5px 2px rgba(0, 0, 0, 0.1)',
	      position: 'absolute',
	      bottom: 0,
	      left: 0,
	      height: 52,
	      width: '100%'
	    },
	
	    DayPickerNavigation_container__verticalScrollable: {
	      position: 'relative'
	    },
	
	    DayPickerNavigation_button: {
	      cursor: 'pointer',
	      lineHeight: 0.78,
	      userSelect: 'none'
	    },
	
	    DayPickerNavigation_button__default: {
	      border: '1px solid ' + String(color.core.borderLight),
	      backgroundColor: color.background,
	      color: color.placeholderText,
	
	      ':focus': {
	        border: '1px solid ' + String(color.core.borderMedium)
	      },
	
	      ':hover': {
	        border: '1px solid ' + String(color.core.borderMedium)
	      },
	
	      ':active': {
	        background: color.backgroundDark
	      }
	    },
	
	    DayPickerNavigation_button__horizontal: {
	      borderRadius: 3,
	      padding: '6px 9px',
	      top: 18,
	      position: 'absolute'
	    },
	
	    DayPickerNavigation_leftButton__horizontal: {
	      left: 22
	    },
	
	    DayPickerNavigation_rightButton__horizontal: {
	      right: 22
	    },
	
	    DayPickerNavigation_button__vertical: {
	      display: 'inline-block',
	      position: 'relative',
	      height: '100%',
	      width: '50%'
	    },
	
	    DayPickerNavigation_button__vertical__default: {
	      padding: 5
	    },
	
	    DayPickerNavigation_nextButton__vertical__default: {
	      borderLeft: 0
	    },
	
	    DayPickerNavigation_nextButton__verticalScrollable: {
	      width: '100%'
	    },
	
	    DayPickerNavigation_svg__horizontal: {
	      height: 19,
	      width: 19,
	      fill: color.core.grayLight
	    },
	
	    DayPickerNavigation_svg__vertical: {
	      height: 42,
	      width: 42,
	      fill: color.text
	    }
	  };
	})(DayPickerNavigation);

/***/ }),

/***/ 234:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMomentProptypes = __webpack_require__(38);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _object3 = __webpack_require__(216);
	
	var _object4 = _interopRequireDefault(_object3);
	
	var _isTouchDevice = __webpack_require__(51);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _isInclusivelyAfterDay = __webpack_require__(83);
	
	var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
	var _isNextDay = __webpack_require__(252);
	
	var _isNextDay2 = _interopRequireDefault(_isNextDay);
	
	var _isSameDay = __webpack_require__(57);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _isAfterDay = __webpack_require__(81);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	var _isBeforeDay = __webpack_require__(82);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	var _getVisibleDays = __webpack_require__(251);
	
	var _getVisibleDays2 = _interopRequireDefault(_getVisibleDays);
	
	var _isDayVisible = __webpack_require__(139);
	
	var _isDayVisible2 = _interopRequireDefault(_isDayVisible);
	
	var _getSelectedDateOffset = __webpack_require__(537);
	
	var _getSelectedDateOffset2 = _interopRequireDefault(_getSelectedDateOffset);
	
	var _toISODateString = __webpack_require__(98);
	
	var _toISODateString2 = _interopRequireDefault(_toISODateString);
	
	var _toISOMonthString = __webpack_require__(99);
	
	var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);
	
	var _DisabledShape = __webpack_require__(97);
	
	var _DisabledShape2 = _interopRequireDefault(_DisabledShape);
	
	var _FocusedInputShape = __webpack_require__(241);
	
	var _FocusedInputShape2 = _interopRequireDefault(_FocusedInputShape);
	
	var _ScrollableOrientationShape = __webpack_require__(56);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(46);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _CalendarInfoPositionShape = __webpack_require__(79);
	
	var _CalendarInfoPositionShape2 = _interopRequireDefault(_CalendarInfoPositionShape);
	
	var _constants = __webpack_require__(7);
	
	var _DayPicker = __webpack_require__(137);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  startDate: _reactMomentProptypes2['default'].momentObj,
	  endDate: _reactMomentProptypes2['default'].momentObj,
	  onDatesChange: _propTypes2['default'].func,
	  startDateOffset: _propTypes2['default'].func,
	  endDateOffset: _propTypes2['default'].func,
	
	  focusedInput: _FocusedInputShape2['default'],
	  onFocusChange: _propTypes2['default'].func,
	  onClose: _propTypes2['default'].func,
	
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  minimumNights: _propTypes2['default'].number,
	  disabled: _DisabledShape2['default'],
	  isOutsideRange: _propTypes2['default'].func,
	  isDayBlocked: _propTypes2['default'].func,
	  isDayHighlighted: _propTypes2['default'].func,
	
	  // DayPicker props
	  renderMonth: _propTypes2['default'].func,
	  enableOutsideDays: _propTypes2['default'].bool,
	  numberOfMonths: _propTypes2['default'].number,
	  orientation: _ScrollableOrientationShape2['default'],
	  withPortal: _propTypes2['default'].bool,
	  initialVisibleMonth: _propTypes2['default'].func,
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  noBorder: _propTypes2['default'].bool,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	  noNavButtons: _propTypes2['default'].bool,
	
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	  onOutsideClick: _propTypes2['default'].func,
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  renderCalendarInfo: _propTypes2['default'].func,
	  calendarInfoPosition: _CalendarInfoPositionShape2['default'],
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	
	  // accessibility
	  onBlur: _propTypes2['default'].func,
	  isFocused: _propTypes2['default'].bool,
	  showKeyboardShortcuts: _propTypes2['default'].bool,
	
	  // i18n
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string,
	
	  isRTL: _propTypes2['default'].bool
	});
	
	var defaultProps = {
	  startDate: undefined, // TODO: use null
	  endDate: undefined, // TODO: use null
	  onDatesChange: function () {
	    function onDatesChange() {}
	
	    return onDatesChange;
	  }(),
	
	  startDateOffset: undefined,
	  endDateOffset: undefined,
	
	  focusedInput: null,
	  onFocusChange: function () {
	    function onFocusChange() {}
	
	    return onFocusChange;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	
	
	  keepOpenOnDateSelect: false,
	  minimumNights: 1,
	  disabled: false,
	  isOutsideRange: function () {
	    function isOutsideRange() {}
	
	    return isOutsideRange;
	  }(),
	  isDayBlocked: function () {
	    function isDayBlocked() {}
	
	    return isDayBlocked;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {}
	
	    return isDayHighlighted;
	  }(),
	
	
	  // DayPicker props
	  renderMonth: null,
	  enableOutsideDays: false,
	  numberOfMonths: 1,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  withPortal: false,
	  hideKeyboardShortcutsPanel: false,
	  initialVisibleMonth: null,
	  daySize: _constants.DAY_SIZE,
	
	  navPrev: null,
	  navNext: null,
	  noNavButtons: false,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }(),
	
	
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  renderCalendarInfo: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	  firstDayOfWeek: null,
	  verticalHeight: null,
	  noBorder: false,
	  transitionDuration: undefined,
	  verticalBorderSpacing: undefined,
	
	  // accessibility
	  onBlur: function () {
	    function onBlur() {}
	
	    return onBlur;
	  }(),
	
	  isFocused: false,
	  showKeyboardShortcuts: false,
	
	  // i18n
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DayPickerPhrases,
	  dayAriaLabelFormat: undefined,
	
	  isRTL: false
	};
	
	var getChooseAvailableDatePhrase = function getChooseAvailableDatePhrase(phrases, focusedInput) {
	  if (focusedInput === _constants.START_DATE) {
	    return phrases.chooseAvailableStartDate;
	  } else if (focusedInput === _constants.END_DATE) {
	    return phrases.chooseAvailableEndDate;
	  }
	  return phrases.chooseAvailableDate;
	};
	
	var DayPickerRangeController = function (_React$Component) {
	  _inherits(DayPickerRangeController, _React$Component);
	
	  function DayPickerRangeController(props) {
	    _classCallCheck(this, DayPickerRangeController);
	
	    var _this = _possibleConstructorReturn(this, (DayPickerRangeController.__proto__ || Object.getPrototypeOf(DayPickerRangeController)).call(this, props));
	
	    _this.isTouchDevice = (0, _isTouchDevice2['default'])();
	    _this.today = (0, _moment2['default'])();
	    _this.modifiers = {
	      today: function () {
	        function today(day) {
	          return _this.isToday(day);
	        }
	
	        return today;
	      }(),
	      blocked: function () {
	        function blocked(day) {
	          return _this.isBlocked(day);
	        }
	
	        return blocked;
	      }(),
	      'blocked-calendar': function () {
	        function blockedCalendar(day) {
	          return props.isDayBlocked(day);
	        }
	
	        return blockedCalendar;
	      }(),
	      'blocked-out-of-range': function () {
	        function blockedOutOfRange(day) {
	          return props.isOutsideRange(day);
	        }
	
	        return blockedOutOfRange;
	      }(),
	      'highlighted-calendar': function () {
	        function highlightedCalendar(day) {
	          return props.isDayHighlighted(day);
	        }
	
	        return highlightedCalendar;
	      }(),
	      valid: function () {
	        function valid(day) {
	          return !_this.isBlocked(day);
	        }
	
	        return valid;
	      }(),
	      'selected-start': function () {
	        function selectedStart(day) {
	          return _this.isStartDate(day);
	        }
	
	        return selectedStart;
	      }(),
	      'selected-end': function () {
	        function selectedEnd(day) {
	          return _this.isEndDate(day);
	        }
	
	        return selectedEnd;
	      }(),
	      'blocked-minimum-nights': function () {
	        function blockedMinimumNights(day) {
	          return _this.doesNotMeetMinimumNights(day);
	        }
	
	        return blockedMinimumNights;
	      }(),
	      'selected-span': function () {
	        function selectedSpan(day) {
	          return _this.isInSelectedSpan(day);
	        }
	
	        return selectedSpan;
	      }(),
	      'last-in-range': function () {
	        function lastInRange(day) {
	          return _this.isLastInRange(day);
	        }
	
	        return lastInRange;
	      }(),
	      hovered: function () {
	        function hovered(day) {
	          return _this.isHovered(day);
	        }
	
	        return hovered;
	      }(),
	      'hovered-span': function () {
	        function hoveredSpan(day) {
	          return _this.isInHoveredSpan(day);
	        }
	
	        return hoveredSpan;
	      }(),
	      'hovered-offset': function () {
	        function hoveredOffset(day) {
	          return _this.isInHoveredSpan(day);
	        }
	
	        return hoveredOffset;
	      }(),
	      'after-hovered-start': function () {
	        function afterHoveredStart(day) {
	          return _this.isDayAfterHoveredStartDate(day);
	        }
	
	        return afterHoveredStart;
	      }(),
	      'first-day-of-week': function () {
	        function firstDayOfWeek(day) {
	          return _this.isFirstDayOfWeek(day);
	        }
	
	        return firstDayOfWeek;
	      }(),
	      'last-day-of-week': function () {
	        function lastDayOfWeek(day) {
	          return _this.isLastDayOfWeek(day);
	        }
	
	        return lastDayOfWeek;
	      }()
	    };
	
	    var _this$getStateForNewM = _this.getStateForNewMonth(props),
	        currentMonth = _this$getStateForNewM.currentMonth,
	        visibleDays = _this$getStateForNewM.visibleDays;
	
	    // initialize phrases
	    // set the appropriate CalendarDay phrase based on focusedInput
	
	
	    var chooseAvailableDate = getChooseAvailableDatePhrase(props.phrases, props.focusedInput);
	
	    _this.state = {
	      hoverDate: null,
	      currentMonth: currentMonth,
	      phrases: (0, _object2['default'])({}, props.phrases, {
	        chooseAvailableDate: chooseAvailableDate
	      }),
	      visibleDays: visibleDays
	    };
	
	    _this.onDayClick = _this.onDayClick.bind(_this);
	    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
	    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
	    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
	    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
	    _this.onMultiplyScrollableMonths = _this.onMultiplyScrollableMonths.bind(_this);
	    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_this);
	    _this.setDayPickerRef = _this.setDayPickerRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayPickerRangeController, [{
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var startDate = nextProps.startDate,
	            endDate = nextProps.endDate,
	            focusedInput = nextProps.focusedInput,
	            minimumNights = nextProps.minimumNights,
	            isOutsideRange = nextProps.isOutsideRange,
	            isDayBlocked = nextProps.isDayBlocked,
	            isDayHighlighted = nextProps.isDayHighlighted,
	            phrases = nextProps.phrases,
	            initialVisibleMonth = nextProps.initialVisibleMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays;
	        var _props = this.props,
	            prevStartDate = _props.startDate,
	            prevEndDate = _props.endDate,
	            prevFocusedInput = _props.focusedInput,
	            prevMinimumNights = _props.minimumNights,
	            prevIsOutsideRange = _props.isOutsideRange,
	            prevIsDayBlocked = _props.isDayBlocked,
	            prevIsDayHighlighted = _props.isDayHighlighted,
	            prevPhrases = _props.phrases,
	            prevInitialVisibleMonth = _props.initialVisibleMonth,
	            prevNumberOfMonths = _props.numberOfMonths,
	            prevEnableOutsideDays = _props.enableOutsideDays;
	        var visibleDays = this.state.visibleDays;
	
	
	        var recomputeOutsideRange = false;
	        var recomputeDayBlocked = false;
	        var recomputeDayHighlighted = false;
	
	        if (isOutsideRange !== prevIsOutsideRange) {
	          this.modifiers['blocked-out-of-range'] = function (day) {
	            return isOutsideRange(day);
	          };
	          recomputeOutsideRange = true;
	        }
	
	        if (isDayBlocked !== prevIsDayBlocked) {
	          this.modifiers['blocked-calendar'] = function (day) {
	            return isDayBlocked(day);
	          };
	          recomputeDayBlocked = true;
	        }
	
	        if (isDayHighlighted !== prevIsDayHighlighted) {
	          this.modifiers['highlighted-calendar'] = function (day) {
	            return isDayHighlighted(day);
	          };
	          recomputeDayHighlighted = true;
	        }
	
	        var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;
	
	        var didStartDateChange = startDate !== prevStartDate;
	        var didEndDateChange = endDate !== prevEndDate;
	        var didFocusChange = focusedInput !== prevFocusedInput;
	
	        if (numberOfMonths !== prevNumberOfMonths || enableOutsideDays !== prevEnableOutsideDays || initialVisibleMonth !== prevInitialVisibleMonth && !prevFocusedInput && didFocusChange) {
	          var newMonthState = this.getStateForNewMonth(nextProps);
	          var currentMonth = newMonthState.currentMonth;
	          visibleDays = newMonthState.visibleDays;
	
	          this.setState({
	            currentMonth: currentMonth,
	            visibleDays: visibleDays
	          });
	        }
	
	        var modifiers = {};
	
	        if (didStartDateChange) {
	          modifiers = this.deleteModifier(modifiers, prevStartDate, 'selected-start');
	          modifiers = this.addModifier(modifiers, startDate, 'selected-start');
	
	          if (prevStartDate) {
	            var startSpan = prevStartDate.clone().add(1, 'day');
	            var endSpan = prevStartDate.clone().add(prevMinimumNights + 1, 'days');
	            modifiers = this.deleteModifierFromRange(modifiers, startSpan, endSpan, 'after-hovered-start');
	          }
	        }
	
	        if (didEndDateChange) {
	          modifiers = this.deleteModifier(modifiers, prevEndDate, 'selected-end');
	          modifiers = this.addModifier(modifiers, endDate, 'selected-end');
	        }
	
	        if (didStartDateChange || didEndDateChange) {
	          if (prevStartDate && prevEndDate) {
	            modifiers = this.deleteModifierFromRange(modifiers, prevStartDate, prevEndDate.clone().add(1, 'day'), 'selected-span');
	          }
	
	          if (startDate && endDate) {
	            modifiers = this.deleteModifierFromRange(modifiers, startDate, endDate.clone().add(1, 'day'), 'hovered-span');
	
	            modifiers = this.addModifierToRange(modifiers, startDate.clone().add(1, 'day'), endDate, 'selected-span');
	          }
	        }
	
	        if (!this.isTouchDevice && didStartDateChange && startDate && !endDate) {
	          var _startSpan = startDate.clone().add(1, 'day');
	          var _endSpan = startDate.clone().add(minimumNights + 1, 'days');
	          modifiers = this.addModifierToRange(modifiers, _startSpan, _endSpan, 'after-hovered-start');
	        }
	
	        if (prevMinimumNights > 0) {
	          if (didFocusChange || didStartDateChange || minimumNights !== prevMinimumNights) {
	            var _startSpan2 = prevStartDate || this.today;
	            modifiers = this.deleteModifierFromRange(modifiers, _startSpan2, _startSpan2.clone().add(prevMinimumNights, 'days'), 'blocked-minimum-nights');
	
	            modifiers = this.deleteModifierFromRange(modifiers, _startSpan2, _startSpan2.clone().add(prevMinimumNights, 'days'), 'blocked');
	          }
	        }
	
	        if (minimumNights > 0 && startDate && focusedInput === _constants.END_DATE) {
	          modifiers = this.addModifierToRange(modifiers, startDate, startDate.clone().add(minimumNights, 'days'), 'blocked-minimum-nights');
	        }
	
	        if (didFocusChange || recomputePropModifiers) {
	          (0, _object4['default'])(visibleDays).forEach(function (days) {
	            Object.keys(days).forEach(function (day) {
	              var momentObj = (0, _moment2['default'])(day);
	
	              if (_this2.isBlocked(momentObj)) {
	                modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
	              } else {
	                modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
	              }
	
	              if (didFocusChange || recomputeOutsideRange) {
	                if (isOutsideRange(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
	                }
	              }
	
	              if (didFocusChange || recomputeDayBlocked) {
	                if (isDayBlocked(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
	                }
	              }
	
	              if (didFocusChange || recomputeDayHighlighted) {
	                if (isDayHighlighted(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
	                }
	              }
	            });
	          });
	        }
	
	        var today = (0, _moment2['default'])();
	        if (!(0, _isSameDay2['default'])(this.today, today)) {
	          modifiers = this.deleteModifier(modifiers, this.today, 'today');
	          modifiers = this.addModifier(modifiers, today, 'today');
	          this.today = today;
	        }
	
	        if (Object.keys(modifiers).length > 0) {
	          this.setState({
	            visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	          });
	        }
	
	        if (didFocusChange || phrases !== prevPhrases) {
	          // set the appropriate CalendarDay phrase based on focusedInput
	          var chooseAvailableDate = getChooseAvailableDatePhrase(phrases, focusedInput);
	
	          this.setState({
	            phrases: (0, _object2['default'])({}, phrases, {
	              chooseAvailableDate: chooseAvailableDate
	            })
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'onDayClick',
	    value: function () {
	      function onDayClick(day, e) {
	        var _props2 = this.props,
	            keepOpenOnDateSelect = _props2.keepOpenOnDateSelect,
	            minimumNights = _props2.minimumNights,
	            onBlur = _props2.onBlur,
	            focusedInput = _props2.focusedInput,
	            onFocusChange = _props2.onFocusChange,
	            onClose = _props2.onClose,
	            onDatesChange = _props2.onDatesChange,
	            startDateOffset = _props2.startDateOffset,
	            endDateOffset = _props2.endDateOffset,
	            disabled = _props2.disabled;
	
	
	        if (e) e.preventDefault();
	        if (this.isBlocked(day)) return;
	
	        var _props3 = this.props,
	            startDate = _props3.startDate,
	            endDate = _props3.endDate;
	
	
	        if (startDateOffset || endDateOffset) {
	          startDate = (0, _getSelectedDateOffset2['default'])(startDateOffset, day);
	          endDate = (0, _getSelectedDateOffset2['default'])(endDateOffset, day);
	
	          if (!keepOpenOnDateSelect) {
	            onFocusChange(null);
	            onClose({ startDate: startDate, endDate: endDate });
	          }
	        } else if (focusedInput === _constants.START_DATE) {
	          var lastAllowedStartDate = endDate && endDate.clone().subtract(minimumNights, 'days');
	          var isStartDateAfterEndDate = (0, _isBeforeDay2['default'])(lastAllowedStartDate, day) || (0, _isAfterDay2['default'])(startDate, endDate);
	          var isEndDateDisabled = disabled === _constants.END_DATE;
	
	          if (!isEndDateDisabled || !isStartDateAfterEndDate) {
	            startDate = day;
	            if (isStartDateAfterEndDate) {
	              endDate = null;
	            }
	          }
	
	          if (isEndDateDisabled && !isStartDateAfterEndDate) {
	            onFocusChange(null);
	            onClose({ startDate: startDate, endDate: endDate });
	          } else if (!isEndDateDisabled) {
	            onFocusChange(_constants.END_DATE);
	          }
	        } else if (focusedInput === _constants.END_DATE) {
	          var firstAllowedEndDate = startDate && startDate.clone().add(minimumNights, 'days');
	
	          if (!startDate) {
	            endDate = day;
	            onFocusChange(_constants.START_DATE);
	          } else if ((0, _isInclusivelyAfterDay2['default'])(day, firstAllowedEndDate)) {
	            endDate = day;
	            if (!keepOpenOnDateSelect) {
	              onFocusChange(null);
	              onClose({ startDate: startDate, endDate: endDate });
	            }
	          } else if (disabled !== _constants.START_DATE) {
	            startDate = day;
	            endDate = null;
	          }
	        }
	
	        onDatesChange({ startDate: startDate, endDate: endDate });
	        onBlur();
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: 'onDayMouseEnter',
	    value: function () {
	      function onDayMouseEnter(day) {
	        if (this.isTouchDevice) return;
	        var _props4 = this.props,
	            startDate = _props4.startDate,
	            endDate = _props4.endDate,
	            focusedInput = _props4.focusedInput,
	            minimumNights = _props4.minimumNights,
	            startDateOffset = _props4.startDateOffset,
	            endDateOffset = _props4.endDateOffset;
	        var _state = this.state,
	            hoverDate = _state.hoverDate,
	            visibleDays = _state.visibleDays;
	
	        var dateOffset = null;
	
	        if (focusedInput) {
	          var hasOffset = startDateOffset || endDateOffset;
	          var modifiers = {};
	
	          if (hasOffset) {
	            var start = (0, _getSelectedDateOffset2['default'])(startDateOffset, day);
	            var end = (0, _getSelectedDateOffset2['default'])(endDateOffset, day, function (rangeDay) {
	              return rangeDay.add(1, 'day');
	            });
	
	            dateOffset = {
	              start: start,
	              end: end
	            };
	
	            if (this.state.dateOffset && this.state.dateOffset.start && this.state.dateOffset.end) {
	              modifiers = this.deleteModifierFromRange(modifiers, this.state.dateOffset.start, this.state.dateOffset.end, 'hovered-offset');
	            }
	            modifiers = this.addModifierToRange(modifiers, start, end, 'hovered-offset');
	          }
	
	          if (!hasOffset) {
	            modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
	            modifiers = this.addModifier(modifiers, day, 'hovered');
	
	            if (startDate && !endDate && focusedInput === _constants.END_DATE) {
	              if ((0, _isAfterDay2['default'])(hoverDate, startDate)) {
	                var endSpan = hoverDate.clone().add(1, 'day');
	                modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
	              }
	
	              if (!this.isBlocked(day) && (0, _isAfterDay2['default'])(day, startDate)) {
	                var _endSpan2 = day.clone().add(1, 'day');
	                modifiers = this.addModifierToRange(modifiers, startDate, _endSpan2, 'hovered-span');
	              }
	            }
	
	            if (!startDate && endDate && focusedInput === _constants.START_DATE) {
	              if ((0, _isBeforeDay2['default'])(hoverDate, endDate)) {
	                modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
	              }
	
	              if (!this.isBlocked(day) && (0, _isBeforeDay2['default'])(day, endDate)) {
	                modifiers = this.addModifierToRange(modifiers, day, endDate, 'hovered-span');
	              }
	            }
	
	            if (startDate) {
	              var startSpan = startDate.clone().add(1, 'day');
	              var _endSpan3 = startDate.clone().add(minimumNights + 1, 'days');
	              modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan3, 'after-hovered-start');
	
	              if ((0, _isSameDay2['default'])(day, startDate)) {
	                var newStartSpan = startDate.clone().add(1, 'day');
	                var newEndSpan = startDate.clone().add(minimumNights + 1, 'days');
	                modifiers = this.addModifierToRange(modifiers, newStartSpan, newEndSpan, 'after-hovered-start');
	              }
	            }
	          }
	
	          this.setState({
	            hoverDate: day,
	            dateOffset: dateOffset,
	            visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	          });
	        }
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: 'onDayMouseLeave',
	    value: function () {
	      function onDayMouseLeave(day) {
	        var _props5 = this.props,
	            startDate = _props5.startDate,
	            endDate = _props5.endDate,
	            minimumNights = _props5.minimumNights;
	        var _state2 = this.state,
	            hoverDate = _state2.hoverDate,
	            visibleDays = _state2.visibleDays,
	            dateOffset = _state2.dateOffset;
	
	        if (this.isTouchDevice || !hoverDate) return;
	
	        var modifiers = {};
	        modifiers = this.deleteModifier(modifiers, hoverDate, 'hovered');
	
	        if (dateOffset) {
	          modifiers = this.deleteModifierFromRange(modifiers, this.state.dateOffset.start, this.state.dateOffset.end, 'hovered-offset');
	        }
	
	        if (startDate && !endDate && (0, _isAfterDay2['default'])(hoverDate, startDate)) {
	          var endSpan = hoverDate.clone().add(1, 'day');
	          modifiers = this.deleteModifierFromRange(modifiers, startDate, endSpan, 'hovered-span');
	        }
	
	        if (!startDate && endDate && (0, _isAfterDay2['default'])(endDate, hoverDate)) {
	          modifiers = this.deleteModifierFromRange(modifiers, hoverDate, endDate, 'hovered-span');
	        }
	
	        if (startDate && (0, _isSameDay2['default'])(day, startDate)) {
	          var startSpan = startDate.clone().add(1, 'day');
	          var _endSpan4 = startDate.clone().add(minimumNights + 1, 'days');
	          modifiers = this.deleteModifierFromRange(modifiers, startSpan, _endSpan4, 'after-hovered-start');
	        }
	
	        this.setState({
	          hoverDate: null,
	          visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	        });
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: 'onPrevMonthClick',
	    value: function () {
	      function onPrevMonthClick() {
	        var _props6 = this.props,
	            onPrevMonthClick = _props6.onPrevMonthClick,
	            numberOfMonths = _props6.numberOfMonths,
	            enableOutsideDays = _props6.enableOutsideDays;
	        var _state3 = this.state,
	            currentMonth = _state3.currentMonth,
	            visibleDays = _state3.visibleDays;
	
	
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	
	        var prevMonth = currentMonth.clone().subtract(2, 'months');
	        var prevMonthVisibleDays = (0, _getVisibleDays2['default'])(prevMonth, 1, enableOutsideDays, true);
	
	        var newCurrentMonth = currentMonth.clone().subtract(1, 'month');
	        this.setState({
	          currentMonth: newCurrentMonth,
	          visibleDays: (0, _object2['default'])({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
	        }, function () {
	          onPrevMonthClick(newCurrentMonth.clone());
	        });
	      }
	
	      return onPrevMonthClick;
	    }()
	  }, {
	    key: 'onNextMonthClick',
	    value: function () {
	      function onNextMonthClick() {
	        var _props7 = this.props,
	            onNextMonthClick = _props7.onNextMonthClick,
	            numberOfMonths = _props7.numberOfMonths,
	            enableOutsideDays = _props7.enableOutsideDays;
	        var _state4 = this.state,
	            currentMonth = _state4.currentMonth,
	            visibleDays = _state4.visibleDays;
	
	
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	
	        var nextMonth = currentMonth.clone().add(numberOfMonths + 1, 'month');
	        var nextMonthVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, 1, enableOutsideDays, true);
	
	        var newCurrentMonth = currentMonth.clone().add(1, 'month');
	        this.setState({
	          currentMonth: newCurrentMonth,
	          visibleDays: (0, _object2['default'])({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
	        }, function () {
	          onNextMonthClick(newCurrentMonth.clone());
	        });
	      }
	
	      return onNextMonthClick;
	    }()
	  }, {
	    key: 'onMultiplyScrollableMonths',
	    value: function () {
	      function onMultiplyScrollableMonths() {
	        var _props8 = this.props,
	            numberOfMonths = _props8.numberOfMonths,
	            enableOutsideDays = _props8.enableOutsideDays;
	        var _state5 = this.state,
	            currentMonth = _state5.currentMonth,
	            visibleDays = _state5.visibleDays;
	
	
	        var numberOfVisibleMonths = Object.keys(visibleDays).length;
	        var nextMonth = currentMonth.clone().add(numberOfVisibleMonths, 'month');
	        var newVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, numberOfMonths, enableOutsideDays, true);
	
	        this.setState({
	          visibleDays: (0, _object2['default'])({}, visibleDays, this.getModifiers(newVisibleDays))
	        });
	      }
	
	      return onMultiplyScrollableMonths;
	    }()
	  }, {
	    key: 'getFirstFocusableDay',
	    value: function () {
	      function getFirstFocusableDay(newMonth) {
	        var _this3 = this;
	
	        var _props9 = this.props,
	            startDate = _props9.startDate,
	            endDate = _props9.endDate,
	            focusedInput = _props9.focusedInput,
	            minimumNights = _props9.minimumNights,
	            numberOfMonths = _props9.numberOfMonths;
	
	
	        var focusedDate = newMonth.clone().startOf('month');
	        if (focusedInput === _constants.START_DATE && startDate) {
	          focusedDate = startDate.clone();
	        } else if (focusedInput === _constants.END_DATE && !endDate && startDate) {
	          focusedDate = startDate.clone().add(minimumNights, 'days');
	        } else if (focusedInput === _constants.END_DATE && endDate) {
	          focusedDate = endDate.clone();
	        }
	
	        if (this.isBlocked(focusedDate)) {
	          var days = [];
	          var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
	          var currentDay = focusedDate.clone();
	          while (!(0, _isAfterDay2['default'])(currentDay, lastVisibleDay)) {
	            currentDay = currentDay.clone().add(1, 'day');
	            days.push(currentDay);
	          }
	
	          var viableDays = days.filter(function (day) {
	            return !_this3.isBlocked(day);
	          });
	
	          if (viableDays.length > 0) {
	            var _viableDays = _slicedToArray(viableDays, 1);
	
	            focusedDate = _viableDays[0];
	          }
	        }
	
	        return focusedDate;
	      }
	
	      return getFirstFocusableDay;
	    }()
	  }, {
	    key: 'getModifiers',
	    value: function () {
	      function getModifiers(visibleDays) {
	        var _this4 = this;
	
	        var modifiers = {};
	        Object.keys(visibleDays).forEach(function (month) {
	          modifiers[month] = {};
	          visibleDays[month].forEach(function (day) {
	            modifiers[month][(0, _toISODateString2['default'])(day)] = _this4.getModifiersForDay(day);
	          });
	        });
	
	        return modifiers;
	      }
	
	      return getModifiers;
	    }()
	  }, {
	    key: 'getModifiersForDay',
	    value: function () {
	      function getModifiersForDay(day) {
	        var _this5 = this;
	
	        return new Set(Object.keys(this.modifiers).filter(function (modifier) {
	          return _this5.modifiers[modifier](day);
	        }));
	      }
	
	      return getModifiersForDay;
	    }()
	  }, {
	    key: 'getStateForNewMonth',
	    value: function () {
	      function getStateForNewMonth(nextProps) {
	        var _this6 = this;
	
	        var initialVisibleMonth = nextProps.initialVisibleMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays,
	            orientation = nextProps.orientation,
	            startDate = nextProps.startDate;
	
	        var initialVisibleMonthThunk = initialVisibleMonth || (startDate ? function () {
	          return startDate;
	        } : function () {
	          return _this6.today;
	        });
	        var currentMonth = initialVisibleMonthThunk();
	        var withoutTransitionMonths = orientation === _constants.VERTICAL_SCROLLABLE;
	        var visibleDays = this.getModifiers((0, _getVisibleDays2['default'])(currentMonth, numberOfMonths, enableOutsideDays, withoutTransitionMonths));
	        return { currentMonth: currentMonth, visibleDays: visibleDays };
	      }
	
	      return getStateForNewMonth;
	    }()
	  }, {
	    key: 'setDayPickerRef',
	    value: function () {
	      function setDayPickerRef(ref) {
	        this.dayPicker = ref;
	      }
	
	      return setDayPickerRef;
	    }()
	  }, {
	    key: 'addModifier',
	    value: function () {
	      function addModifier(updatedDays, day, modifier) {
	        var _props10 = this.props,
	            numberOfVisibleMonths = _props10.numberOfMonths,
	            enableOutsideDays = _props10.enableOutsideDays,
	            orientation = _props10.orientation;
	        var _state6 = this.state,
	            firstVisibleMonth = _state6.currentMonth,
	            visibleDays = _state6.visibleDays;
	
	
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString2['default'])(day);
	
	        var updatedDaysAfterAddition = (0, _object2['default'])({}, updatedDays);
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	
	          updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers.add(modifier);
	            return (0, _object2['default'])({}, days, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterAddition);
	        } else {
	          var monthIso = (0, _toISOMonthString2['default'])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	
	          var modifiers = new Set(month[iso]);
	          modifiers.add(modifier);
	          updatedDaysAfterAddition = (0, _object2['default'])({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterAddition;
	      }
	
	      return addModifier;
	    }()
	  }, {
	    key: 'addModifierToRange',
	    value: function () {
	      function addModifierToRange(updatedDays, start, end, modifier) {
	        var days = updatedDays;
	
	        var spanStart = start.clone();
	        while ((0, _isBeforeDay2['default'])(spanStart, end)) {
	          days = this.addModifier(days, spanStart, modifier);
	          spanStart = spanStart.clone().add(1, 'day');
	        }
	
	        return days;
	      }
	
	      return addModifierToRange;
	    }()
	  }, {
	    key: 'deleteModifier',
	    value: function () {
	      function deleteModifier(updatedDays, day, modifier) {
	        var _props11 = this.props,
	            numberOfVisibleMonths = _props11.numberOfMonths,
	            enableOutsideDays = _props11.enableOutsideDays,
	            orientation = _props11.orientation;
	        var _state7 = this.state,
	            firstVisibleMonth = _state7.currentMonth,
	            visibleDays = _state7.visibleDays;
	
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString2['default'])(day);
	
	        var updatedDaysAfterDeletion = (0, _object2['default'])({}, updatedDays);
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	
	          updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers['delete'](modifier);
	            return (0, _object2['default'])({}, days, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterDeletion);
	        } else {
	          var monthIso = (0, _toISOMonthString2['default'])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	
	          var modifiers = new Set(month[iso]);
	          modifiers['delete'](modifier);
	          updatedDaysAfterDeletion = (0, _object2['default'])({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterDeletion;
	      }
	
	      return deleteModifier;
	    }()
	  }, {
	    key: 'deleteModifierFromRange',
	    value: function () {
	      function deleteModifierFromRange(updatedDays, start, end, modifier) {
	        var days = updatedDays;
	
	        var spanStart = start.clone();
	        while ((0, _isBeforeDay2['default'])(spanStart, end)) {
	          days = this.deleteModifier(days, spanStart, modifier);
	          spanStart = spanStart.clone().add(1, 'day');
	        }
	
	        return days;
	      }
	
	      return deleteModifierFromRange;
	    }()
	  }, {
	    key: 'doesNotMeetMinimumNights',
	    value: function () {
	      function doesNotMeetMinimumNights(day) {
	        var _props12 = this.props,
	            startDate = _props12.startDate,
	            isOutsideRange = _props12.isOutsideRange,
	            focusedInput = _props12.focusedInput,
	            minimumNights = _props12.minimumNights;
	
	        if (focusedInput !== _constants.END_DATE) return false;
	
	        if (startDate) {
	          var dayDiff = day.diff(startDate.clone().startOf('day').hour(12), 'days');
	          return dayDiff < minimumNights && dayDiff >= 0;
	        }
	        return isOutsideRange((0, _moment2['default'])(day).subtract(minimumNights, 'days'));
	      }
	
	      return doesNotMeetMinimumNights;
	    }()
	  }, {
	    key: 'isDayAfterHoveredStartDate',
	    value: function () {
	      function isDayAfterHoveredStartDate(day) {
	        var _props13 = this.props,
	            startDate = _props13.startDate,
	            endDate = _props13.endDate,
	            minimumNights = _props13.minimumNights;
	
	        var _ref = this.state || {},
	            hoverDate = _ref.hoverDate;
	
	        return !!startDate && !endDate && !this.isBlocked(day) && (0, _isNextDay2['default'])(hoverDate, day) && minimumNights > 0 && (0, _isSameDay2['default'])(hoverDate, startDate);
	      }
	
	      return isDayAfterHoveredStartDate;
	    }()
	  }, {
	    key: 'isEndDate',
	    value: function () {
	      function isEndDate(day) {
	        return (0, _isSameDay2['default'])(day, this.props.endDate);
	      }
	
	      return isEndDate;
	    }()
	  }, {
	    key: 'isHovered',
	    value: function () {
	      function isHovered(day) {
	        var _ref2 = this.state || {},
	            hoverDate = _ref2.hoverDate;
	
	        var focusedInput = this.props.focusedInput;
	
	        return !!focusedInput && (0, _isSameDay2['default'])(day, hoverDate);
	      }
	
	      return isHovered;
	    }()
	  }, {
	    key: 'isInHoveredSpan',
	    value: function () {
	      function isInHoveredSpan(day) {
	        var _props14 = this.props,
	            startDate = _props14.startDate,
	            endDate = _props14.endDate;
	
	        var _ref3 = this.state || {},
	            hoverDate = _ref3.hoverDate;
	
	        var isForwardRange = !!startDate && !endDate && (day.isBetween(startDate, hoverDate) || (0, _isSameDay2['default'])(hoverDate, day));
	        var isBackwardRange = !!endDate && !startDate && (day.isBetween(hoverDate, endDate) || (0, _isSameDay2['default'])(hoverDate, day));
	
	        var isValidDayHovered = hoverDate && !this.isBlocked(hoverDate);
	
	        return (isForwardRange || isBackwardRange) && isValidDayHovered;
	      }
	
	      return isInHoveredSpan;
	    }()
	  }, {
	    key: 'isInSelectedSpan',
	    value: function () {
	      function isInSelectedSpan(day) {
	        var _props15 = this.props,
	            startDate = _props15.startDate,
	            endDate = _props15.endDate;
	
	        return day.isBetween(startDate, endDate);
	      }
	
	      return isInSelectedSpan;
	    }()
	  }, {
	    key: 'isLastInRange',
	    value: function () {
	      function isLastInRange(day) {
	        return this.isInSelectedSpan(day) && (0, _isNextDay2['default'])(day, this.props.endDate);
	      }
	
	      return isLastInRange;
	    }()
	  }, {
	    key: 'isStartDate',
	    value: function () {
	      function isStartDate(day) {
	        return (0, _isSameDay2['default'])(day, this.props.startDate);
	      }
	
	      return isStartDate;
	    }()
	  }, {
	    key: 'isBlocked',
	    value: function () {
	      function isBlocked(day) {
	        var _props16 = this.props,
	            isDayBlocked = _props16.isDayBlocked,
	            isOutsideRange = _props16.isOutsideRange;
	
	        return isDayBlocked(day) || isOutsideRange(day) || this.doesNotMeetMinimumNights(day);
	      }
	
	      return isBlocked;
	    }()
	  }, {
	    key: 'isToday',
	    value: function () {
	      function isToday(day) {
	        return (0, _isSameDay2['default'])(day, this.today);
	      }
	
	      return isToday;
	    }()
	  }, {
	    key: 'isFirstDayOfWeek',
	    value: function () {
	      function isFirstDayOfWeek(day) {
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	
	        return day.day() === (firstDayOfWeek || _moment2['default'].localeData().firstDayOfWeek());
	      }
	
	      return isFirstDayOfWeek;
	    }()
	  }, {
	    key: 'isLastDayOfWeek',
	    value: function () {
	      function isLastDayOfWeek(day) {
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	
	        return day.day() === ((firstDayOfWeek || _moment2['default'].localeData().firstDayOfWeek()) + 6) % 7;
	      }
	
	      return isLastDayOfWeek;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props17 = this.props,
	            numberOfMonths = _props17.numberOfMonths,
	            orientation = _props17.orientation,
	            monthFormat = _props17.monthFormat,
	            renderMonth = _props17.renderMonth,
	            navPrev = _props17.navPrev,
	            navNext = _props17.navNext,
	            noNavButtons = _props17.noNavButtons,
	            onOutsideClick = _props17.onOutsideClick,
	            withPortal = _props17.withPortal,
	            enableOutsideDays = _props17.enableOutsideDays,
	            firstDayOfWeek = _props17.firstDayOfWeek,
	            hideKeyboardShortcutsPanel = _props17.hideKeyboardShortcutsPanel,
	            daySize = _props17.daySize,
	            focusedInput = _props17.focusedInput,
	            renderCalendarDay = _props17.renderCalendarDay,
	            renderDayContents = _props17.renderDayContents,
	            renderCalendarInfo = _props17.renderCalendarInfo,
	            calendarInfoPosition = _props17.calendarInfoPosition,
	            onBlur = _props17.onBlur,
	            isFocused = _props17.isFocused,
	            showKeyboardShortcuts = _props17.showKeyboardShortcuts,
	            isRTL = _props17.isRTL,
	            weekDayFormat = _props17.weekDayFormat,
	            dayAriaLabelFormat = _props17.dayAriaLabelFormat,
	            verticalHeight = _props17.verticalHeight,
	            noBorder = _props17.noBorder,
	            transitionDuration = _props17.transitionDuration,
	            verticalBorderSpacing = _props17.verticalBorderSpacing;
	        var _state8 = this.state,
	            currentMonth = _state8.currentMonth,
	            phrases = _state8.phrases,
	            visibleDays = _state8.visibleDays;
	
	
	        return _react2['default'].createElement(_DayPicker2['default'], {
	          ref: this.setDayPickerRef,
	          orientation: orientation,
	          enableOutsideDays: enableOutsideDays,
	          modifiers: visibleDays,
	          numberOfMonths: numberOfMonths,
	          onDayClick: this.onDayClick,
	          onDayMouseEnter: this.onDayMouseEnter,
	          onDayMouseLeave: this.onDayMouseLeave,
	          onPrevMonthClick: this.onPrevMonthClick,
	          onNextMonthClick: this.onNextMonthClick,
	          onMultiplyScrollableMonths: this.onMultiplyScrollableMonths,
	          monthFormat: monthFormat,
	          renderMonth: renderMonth,
	          withPortal: withPortal,
	          hidden: !focusedInput,
	          initialVisibleMonth: function () {
	            function initialVisibleMonth() {
	              return currentMonth;
	            }
	
	            return initialVisibleMonth;
	          }(),
	          daySize: daySize,
	          onOutsideClick: onOutsideClick,
	          navPrev: navPrev,
	          navNext: navNext,
	          noNavButtons: noNavButtons,
	          renderCalendarDay: renderCalendarDay,
	          renderDayContents: renderDayContents,
	          renderCalendarInfo: renderCalendarInfo,
	          calendarInfoPosition: calendarInfoPosition,
	          firstDayOfWeek: firstDayOfWeek,
	          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	          isFocused: isFocused,
	          getFirstFocusableDay: this.getFirstFocusableDay,
	          onBlur: onBlur,
	          showKeyboardShortcuts: showKeyboardShortcuts,
	          phrases: phrases,
	          isRTL: isRTL,
	          weekDayFormat: weekDayFormat,
	          dayAriaLabelFormat: dayAriaLabelFormat,
	          verticalHeight: verticalHeight,
	          verticalBorderSpacing: verticalBorderSpacing,
	          noBorder: noBorder,
	          transitionDuration: transitionDuration
	        });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPickerRangeController;
	}(_react2['default'].Component);
	
	exports['default'] = DayPickerRangeController;
	
	
	DayPickerRangeController.propTypes = propTypes;
	DayPickerRangeController.defaultProps = defaultProps;

/***/ }),

/***/ 235:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMomentProptypes = __webpack_require__(38);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _object3 = __webpack_require__(216);
	
	var _object4 = _interopRequireDefault(_object3);
	
	var _isTouchDevice = __webpack_require__(51);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _isSameDay = __webpack_require__(57);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	var _isAfterDay = __webpack_require__(81);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	var _getVisibleDays = __webpack_require__(251);
	
	var _getVisibleDays2 = _interopRequireDefault(_getVisibleDays);
	
	var _isDayVisible = __webpack_require__(139);
	
	var _isDayVisible2 = _interopRequireDefault(_isDayVisible);
	
	var _toISODateString = __webpack_require__(98);
	
	var _toISODateString2 = _interopRequireDefault(_toISODateString);
	
	var _toISOMonthString = __webpack_require__(99);
	
	var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);
	
	var _ScrollableOrientationShape = __webpack_require__(56);
	
	var _ScrollableOrientationShape2 = _interopRequireDefault(_ScrollableOrientationShape);
	
	var _DayOfWeekShape = __webpack_require__(46);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _CalendarInfoPositionShape = __webpack_require__(79);
	
	var _CalendarInfoPositionShape2 = _interopRequireDefault(_CalendarInfoPositionShape);
	
	var _constants = __webpack_require__(7);
	
	var _DayPicker = __webpack_require__(137);
	
	var _DayPicker2 = _interopRequireDefault(_DayPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)({
	  date: _reactMomentProptypes2['default'].momentObj,
	  onDateChange: _propTypes2['default'].func,
	
	  focused: _propTypes2['default'].bool,
	  onFocusChange: _propTypes2['default'].func,
	  onClose: _propTypes2['default'].func,
	
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  isOutsideRange: _propTypes2['default'].func,
	  isDayBlocked: _propTypes2['default'].func,
	  isDayHighlighted: _propTypes2['default'].func,
	
	  // DayPicker props
	  renderMonth: _propTypes2['default'].func,
	  enableOutsideDays: _propTypes2['default'].bool,
	  numberOfMonths: _propTypes2['default'].number,
	  orientation: _ScrollableOrientationShape2['default'],
	  withPortal: _propTypes2['default'].bool,
	  initialVisibleMonth: _propTypes2['default'].func,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  noBorder: _propTypes2['default'].bool,
	  verticalBorderSpacing: _airbnbPropTypes.nonNegativeInteger,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	  onOutsideClick: _propTypes2['default'].func,
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  renderCalendarInfo: _propTypes2['default'].func,
	  calendarInfoPosition: _CalendarInfoPositionShape2['default'],
	
	  // accessibility
	  onBlur: _propTypes2['default'].func,
	  isFocused: _propTypes2['default'].bool,
	  showKeyboardShortcuts: _propTypes2['default'].bool,
	
	  // i18n
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DayPickerPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string,
	
	  isRTL: _propTypes2['default'].bool
	});
	
	var defaultProps = {
	  date: undefined, // TODO: use null
	  onDateChange: function () {
	    function onDateChange() {}
	
	    return onDateChange;
	  }(),
	
	
	  focused: false,
	  onFocusChange: function () {
	    function onFocusChange() {}
	
	    return onFocusChange;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	
	
	  keepOpenOnDateSelect: false,
	  isOutsideRange: function () {
	    function isOutsideRange() {}
	
	    return isOutsideRange;
	  }(),
	  isDayBlocked: function () {
	    function isDayBlocked() {}
	
	    return isDayBlocked;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {}
	
	    return isDayHighlighted;
	  }(),
	
	
	  // DayPicker props
	  renderMonth: null,
	  enableOutsideDays: false,
	  numberOfMonths: 1,
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  withPortal: false,
	  hideKeyboardShortcutsPanel: false,
	  initialVisibleMonth: null,
	  firstDayOfWeek: null,
	  daySize: _constants.DAY_SIZE,
	  verticalHeight: null,
	  noBorder: false,
	  verticalBorderSpacing: undefined,
	  transitionDuration: undefined,
	
	  navPrev: null,
	  navNext: null,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }(),
	
	
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  renderCalendarInfo: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	
	  // accessibility
	  onBlur: function () {
	    function onBlur() {}
	
	    return onBlur;
	  }(),
	
	  isFocused: false,
	  showKeyboardShortcuts: false,
	
	  // i18n
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.DayPickerPhrases,
	  dayAriaLabelFormat: undefined,
	
	  isRTL: false
	};
	
	var DayPickerSingleDateController = function (_React$Component) {
	  _inherits(DayPickerSingleDateController, _React$Component);
	
	  function DayPickerSingleDateController(props) {
	    _classCallCheck(this, DayPickerSingleDateController);
	
	    var _this = _possibleConstructorReturn(this, (DayPickerSingleDateController.__proto__ || Object.getPrototypeOf(DayPickerSingleDateController)).call(this, props));
	
	    _this.isTouchDevice = false;
	    _this.today = (0, _moment2['default'])();
	
	    _this.modifiers = {
	      today: function () {
	        function today(day) {
	          return _this.isToday(day);
	        }
	
	        return today;
	      }(),
	      blocked: function () {
	        function blocked(day) {
	          return _this.isBlocked(day);
	        }
	
	        return blocked;
	      }(),
	      'blocked-calendar': function () {
	        function blockedCalendar(day) {
	          return props.isDayBlocked(day);
	        }
	
	        return blockedCalendar;
	      }(),
	      'blocked-out-of-range': function () {
	        function blockedOutOfRange(day) {
	          return props.isOutsideRange(day);
	        }
	
	        return blockedOutOfRange;
	      }(),
	      'highlighted-calendar': function () {
	        function highlightedCalendar(day) {
	          return props.isDayHighlighted(day);
	        }
	
	        return highlightedCalendar;
	      }(),
	      valid: function () {
	        function valid(day) {
	          return !_this.isBlocked(day);
	        }
	
	        return valid;
	      }(),
	      hovered: function () {
	        function hovered(day) {
	          return _this.isHovered(day);
	        }
	
	        return hovered;
	      }(),
	      selected: function () {
	        function selected(day) {
	          return _this.isSelected(day);
	        }
	
	        return selected;
	      }(),
	      'first-day-of-week': function () {
	        function firstDayOfWeek(day) {
	          return _this.isFirstDayOfWeek(day);
	        }
	
	        return firstDayOfWeek;
	      }(),
	      'last-day-of-week': function () {
	        function lastDayOfWeek(day) {
	          return _this.isLastDayOfWeek(day);
	        }
	
	        return lastDayOfWeek;
	      }()
	    };
	
	    var _this$getStateForNewM = _this.getStateForNewMonth(props),
	        currentMonth = _this$getStateForNewM.currentMonth,
	        visibleDays = _this$getStateForNewM.visibleDays;
	
	    _this.state = {
	      hoverDate: null,
	      currentMonth: currentMonth,
	      visibleDays: visibleDays
	    };
	
	    _this.onDayMouseEnter = _this.onDayMouseEnter.bind(_this);
	    _this.onDayMouseLeave = _this.onDayMouseLeave.bind(_this);
	    _this.onDayClick = _this.onDayClick.bind(_this);
	
	    _this.onPrevMonthClick = _this.onPrevMonthClick.bind(_this);
	    _this.onNextMonthClick = _this.onNextMonthClick.bind(_this);
	
	    _this.getFirstFocusableDay = _this.getFirstFocusableDay.bind(_this);
	    return _this;
	  }
	
	  _createClass(DayPickerSingleDateController, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.isTouchDevice = (0, _isTouchDevice2['default'])();
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function () {
	      function componentWillReceiveProps(nextProps) {
	        var _this2 = this;
	
	        var date = nextProps.date,
	            focused = nextProps.focused,
	            isOutsideRange = nextProps.isOutsideRange,
	            isDayBlocked = nextProps.isDayBlocked,
	            isDayHighlighted = nextProps.isDayHighlighted,
	            initialVisibleMonth = nextProps.initialVisibleMonth,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays;
	        var visibleDays = this.state.visibleDays;
	
	
	        var recomputeOutsideRange = false;
	        var recomputeDayBlocked = false;
	        var recomputeDayHighlighted = false;
	
	        if (isOutsideRange !== this.props.isOutsideRange) {
	          this.modifiers['blocked-out-of-range'] = function (day) {
	            return isOutsideRange(day);
	          };
	          recomputeOutsideRange = true;
	        }
	
	        if (isDayBlocked !== this.props.isDayBlocked) {
	          this.modifiers['blocked-calendar'] = function (day) {
	            return isDayBlocked(day);
	          };
	          recomputeDayBlocked = true;
	        }
	
	        if (isDayHighlighted !== this.props.isDayHighlighted) {
	          this.modifiers['highlighted-calendar'] = function (day) {
	            return isDayHighlighted(day);
	          };
	          recomputeDayHighlighted = true;
	        }
	
	        var recomputePropModifiers = recomputeOutsideRange || recomputeDayBlocked || recomputeDayHighlighted;
	
	        if (numberOfMonths !== this.props.numberOfMonths || enableOutsideDays !== this.props.enableOutsideDays || initialVisibleMonth !== this.props.initialVisibleMonth && !this.props.focused && focused) {
	          var newMonthState = this.getStateForNewMonth(nextProps);
	          var currentMonth = newMonthState.currentMonth;
	          visibleDays = newMonthState.visibleDays;
	
	          this.setState({
	            currentMonth: currentMonth,
	            visibleDays: visibleDays
	          });
	        }
	
	        var didDateChange = date !== this.props.date;
	        var didFocusChange = focused !== this.props.focused;
	
	        var modifiers = {};
	
	        if (didDateChange) {
	          modifiers = this.deleteModifier(modifiers, this.props.date, 'selected');
	          modifiers = this.addModifier(modifiers, date, 'selected');
	        }
	
	        if (didFocusChange || recomputePropModifiers) {
	          (0, _object4['default'])(visibleDays).forEach(function (days) {
	            Object.keys(days).forEach(function (day) {
	              var momentObj = (0, _moment2['default'])(day);
	              if (_this2.isBlocked(momentObj)) {
	                modifiers = _this2.addModifier(modifiers, momentObj, 'blocked');
	              } else {
	                modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked');
	              }
	
	              if (didFocusChange || recomputeOutsideRange) {
	                if (isOutsideRange(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-out-of-range');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-out-of-range');
	                }
	              }
	
	              if (didFocusChange || recomputeDayBlocked) {
	                if (isDayBlocked(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'blocked-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'blocked-calendar');
	                }
	              }
	
	              if (didFocusChange || recomputeDayHighlighted) {
	                if (isDayHighlighted(momentObj)) {
	                  modifiers = _this2.addModifier(modifiers, momentObj, 'highlighted-calendar');
	                } else {
	                  modifiers = _this2.deleteModifier(modifiers, momentObj, 'highlighted-calendar');
	                }
	              }
	            });
	          });
	        }
	
	        var today = (0, _moment2['default'])();
	        if (!(0, _isSameDay2['default'])(this.today, today)) {
	          modifiers = this.deleteModifier(modifiers, this.today, 'today');
	          modifiers = this.addModifier(modifiers, today, 'today');
	          this.today = today;
	        }
	
	        if (Object.keys(modifiers).length > 0) {
	          this.setState({
	            visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	          });
	        }
	      }
	
	      return componentWillReceiveProps;
	    }()
	  }, {
	    key: 'componentWillUpdate',
	    value: function () {
	      function componentWillUpdate() {
	        this.today = (0, _moment2['default'])();
	      }
	
	      return componentWillUpdate;
	    }()
	  }, {
	    key: 'onDayClick',
	    value: function () {
	      function onDayClick(day, e) {
	        if (e) e.preventDefault();
	        if (this.isBlocked(day)) return;
	        var _props = this.props,
	            onDateChange = _props.onDateChange,
	            keepOpenOnDateSelect = _props.keepOpenOnDateSelect,
	            onFocusChange = _props.onFocusChange,
	            onClose = _props.onClose;
	
	
	        onDateChange(day);
	        if (!keepOpenOnDateSelect) {
	          onFocusChange({ focused: false });
	          onClose({ date: day });
	        }
	      }
	
	      return onDayClick;
	    }()
	  }, {
	    key: 'onDayMouseEnter',
	    value: function () {
	      function onDayMouseEnter(day) {
	        if (this.isTouchDevice) return;
	        var _state = this.state,
	            hoverDate = _state.hoverDate,
	            visibleDays = _state.visibleDays;
	
	
	        var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
	        modifiers = this.addModifier(modifiers, day, 'hovered');
	
	        this.setState({
	          hoverDate: day,
	          visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	        });
	      }
	
	      return onDayMouseEnter;
	    }()
	  }, {
	    key: 'onDayMouseLeave',
	    value: function () {
	      function onDayMouseLeave() {
	        var _state2 = this.state,
	            hoverDate = _state2.hoverDate,
	            visibleDays = _state2.visibleDays;
	
	        if (this.isTouchDevice || !hoverDate) return;
	
	        var modifiers = this.deleteModifier({}, hoverDate, 'hovered');
	
	        this.setState({
	          hoverDate: null,
	          visibleDays: (0, _object2['default'])({}, visibleDays, modifiers)
	        });
	      }
	
	      return onDayMouseLeave;
	    }()
	  }, {
	    key: 'onPrevMonthClick',
	    value: function () {
	      function onPrevMonthClick() {
	        var _props2 = this.props,
	            onPrevMonthClick = _props2.onPrevMonthClick,
	            numberOfMonths = _props2.numberOfMonths,
	            enableOutsideDays = _props2.enableOutsideDays;
	        var _state3 = this.state,
	            currentMonth = _state3.currentMonth,
	            visibleDays = _state3.visibleDays;
	
	
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(0, numberOfMonths + 1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	
	        var prevMonth = currentMonth.clone().subtract(1, 'month');
	        var prevMonthVisibleDays = (0, _getVisibleDays2['default'])(prevMonth, 1, enableOutsideDays);
	
	        this.setState({
	          currentMonth: prevMonth,
	          visibleDays: (0, _object2['default'])({}, newVisibleDays, this.getModifiers(prevMonthVisibleDays))
	        }, function () {
	          onPrevMonthClick(prevMonth.clone());
	        });
	      }
	
	      return onPrevMonthClick;
	    }()
	  }, {
	    key: 'onNextMonthClick',
	    value: function () {
	      function onNextMonthClick() {
	        var _props3 = this.props,
	            onNextMonthClick = _props3.onNextMonthClick,
	            numberOfMonths = _props3.numberOfMonths,
	            enableOutsideDays = _props3.enableOutsideDays;
	        var _state4 = this.state,
	            currentMonth = _state4.currentMonth,
	            visibleDays = _state4.visibleDays;
	
	
	        var newVisibleDays = {};
	        Object.keys(visibleDays).sort().slice(1).forEach(function (month) {
	          newVisibleDays[month] = visibleDays[month];
	        });
	
	        var nextMonth = currentMonth.clone().add(numberOfMonths, 'month');
	        var nextMonthVisibleDays = (0, _getVisibleDays2['default'])(nextMonth, 1, enableOutsideDays);
	
	        var newCurrentMonth = currentMonth.clone().add(1, 'month');
	        this.setState({
	          currentMonth: newCurrentMonth,
	          visibleDays: (0, _object2['default'])({}, newVisibleDays, this.getModifiers(nextMonthVisibleDays))
	        }, function () {
	          onNextMonthClick(newCurrentMonth.clone());
	        });
	      }
	
	      return onNextMonthClick;
	    }()
	  }, {
	    key: 'getFirstFocusableDay',
	    value: function () {
	      function getFirstFocusableDay(newMonth) {
	        var _this3 = this;
	
	        var _props4 = this.props,
	            date = _props4.date,
	            numberOfMonths = _props4.numberOfMonths;
	
	
	        var focusedDate = newMonth.clone().startOf('month');
	        if (date) {
	          focusedDate = date.clone();
	        }
	
	        if (this.isBlocked(focusedDate)) {
	          var days = [];
	          var lastVisibleDay = newMonth.clone().add(numberOfMonths - 1, 'months').endOf('month');
	          var currentDay = focusedDate.clone();
	          while (!(0, _isAfterDay2['default'])(currentDay, lastVisibleDay)) {
	            currentDay = currentDay.clone().add(1, 'day');
	            days.push(currentDay);
	          }
	
	          var viableDays = days.filter(function (day) {
	            return !_this3.isBlocked(day) && (0, _isAfterDay2['default'])(day, focusedDate);
	          });
	          if (viableDays.length > 0) {
	            var _viableDays = _slicedToArray(viableDays, 1);
	
	            focusedDate = _viableDays[0];
	          }
	        }
	
	        return focusedDate;
	      }
	
	      return getFirstFocusableDay;
	    }()
	  }, {
	    key: 'getModifiers',
	    value: function () {
	      function getModifiers(visibleDays) {
	        var _this4 = this;
	
	        var modifiers = {};
	        Object.keys(visibleDays).forEach(function (month) {
	          modifiers[month] = {};
	          visibleDays[month].forEach(function (day) {
	            modifiers[month][(0, _toISODateString2['default'])(day)] = _this4.getModifiersForDay(day);
	          });
	        });
	
	        return modifiers;
	      }
	
	      return getModifiers;
	    }()
	  }, {
	    key: 'getModifiersForDay',
	    value: function () {
	      function getModifiersForDay(day) {
	        var _this5 = this;
	
	        return new Set(Object.keys(this.modifiers).filter(function (modifier) {
	          return _this5.modifiers[modifier](day);
	        }));
	      }
	
	      return getModifiersForDay;
	    }()
	  }, {
	    key: 'getStateForNewMonth',
	    value: function () {
	      function getStateForNewMonth(nextProps) {
	        var _this6 = this;
	
	        var initialVisibleMonth = nextProps.initialVisibleMonth,
	            date = nextProps.date,
	            numberOfMonths = nextProps.numberOfMonths,
	            enableOutsideDays = nextProps.enableOutsideDays;
	
	        var initialVisibleMonthThunk = initialVisibleMonth || (date ? function () {
	          return date;
	        } : function () {
	          return _this6.today;
	        });
	        var currentMonth = initialVisibleMonthThunk();
	        var visibleDays = this.getModifiers((0, _getVisibleDays2['default'])(currentMonth, numberOfMonths, enableOutsideDays));
	        return { currentMonth: currentMonth, visibleDays: visibleDays };
	      }
	
	      return getStateForNewMonth;
	    }()
	  }, {
	    key: 'addModifier',
	    value: function () {
	      function addModifier(updatedDays, day, modifier) {
	        var _props5 = this.props,
	            numberOfVisibleMonths = _props5.numberOfMonths,
	            enableOutsideDays = _props5.enableOutsideDays,
	            orientation = _props5.orientation;
	        var _state5 = this.state,
	            firstVisibleMonth = _state5.currentMonth,
	            visibleDays = _state5.visibleDays;
	
	
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString2['default'])(day);
	
	        var updatedDaysAfterAddition = (0, _object2['default'])({}, updatedDays);
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	
	          updatedDaysAfterAddition = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers.add(modifier);
	            return (0, _object2['default'])({}, days, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterAddition);
	        } else {
	          var monthIso = (0, _toISOMonthString2['default'])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	
	          var modifiers = new Set(month[iso]);
	          modifiers.add(modifier);
	          updatedDaysAfterAddition = (0, _object2['default'])({}, updatedDaysAfterAddition, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterAddition;
	      }
	
	      return addModifier;
	    }()
	  }, {
	    key: 'deleteModifier',
	    value: function () {
	      function deleteModifier(updatedDays, day, modifier) {
	        var _props6 = this.props,
	            numberOfVisibleMonths = _props6.numberOfMonths,
	            enableOutsideDays = _props6.enableOutsideDays,
	            orientation = _props6.orientation;
	        var _state6 = this.state,
	            firstVisibleMonth = _state6.currentMonth,
	            visibleDays = _state6.visibleDays;
	
	
	        var currentMonth = firstVisibleMonth;
	        var numberOfMonths = numberOfVisibleMonths;
	        if (orientation !== _constants.VERTICAL_SCROLLABLE) {
	          currentMonth = currentMonth.clone().subtract(1, 'month');
	          numberOfMonths += 2;
	        }
	        if (!day || !(0, _isDayVisible2['default'])(day, currentMonth, numberOfMonths, enableOutsideDays)) {
	          return updatedDays;
	        }
	
	        var iso = (0, _toISODateString2['default'])(day);
	
	        var updatedDaysAfterDeletion = (0, _object2['default'])({}, updatedDays);
	        if (enableOutsideDays) {
	          var monthsToUpdate = Object.keys(visibleDays).filter(function (monthKey) {
	            return Object.keys(visibleDays[monthKey]).indexOf(iso) > -1;
	          });
	
	          updatedDaysAfterDeletion = monthsToUpdate.reduce(function (days, monthIso) {
	            var month = updatedDays[monthIso] || visibleDays[monthIso];
	            var modifiers = new Set(month[iso]);
	            modifiers['delete'](modifier);
	            return (0, _object2['default'])({}, days, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	          }, updatedDaysAfterDeletion);
	        } else {
	          var monthIso = (0, _toISOMonthString2['default'])(day);
	          var month = updatedDays[monthIso] || visibleDays[monthIso];
	
	          var modifiers = new Set(month[iso]);
	          modifiers['delete'](modifier);
	          updatedDaysAfterDeletion = (0, _object2['default'])({}, updatedDaysAfterDeletion, _defineProperty({}, monthIso, (0, _object2['default'])({}, month, _defineProperty({}, iso, modifiers))));
	        }
	
	        return updatedDaysAfterDeletion;
	      }
	
	      return deleteModifier;
	    }()
	  }, {
	    key: 'isBlocked',
	    value: function () {
	      function isBlocked(day) {
	        var _props7 = this.props,
	            isDayBlocked = _props7.isDayBlocked,
	            isOutsideRange = _props7.isOutsideRange;
	
	        return isDayBlocked(day) || isOutsideRange(day);
	      }
	
	      return isBlocked;
	    }()
	  }, {
	    key: 'isHovered',
	    value: function () {
	      function isHovered(day) {
	        var _ref = this.state || {},
	            hoverDate = _ref.hoverDate;
	
	        return (0, _isSameDay2['default'])(day, hoverDate);
	      }
	
	      return isHovered;
	    }()
	  }, {
	    key: 'isSelected',
	    value: function () {
	      function isSelected(day) {
	        return (0, _isSameDay2['default'])(day, this.props.date);
	      }
	
	      return isSelected;
	    }()
	  }, {
	    key: 'isToday',
	    value: function () {
	      function isToday(day) {
	        return (0, _isSameDay2['default'])(day, this.today);
	      }
	
	      return isToday;
	    }()
	  }, {
	    key: 'isFirstDayOfWeek',
	    value: function () {
	      function isFirstDayOfWeek(day) {
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	
	        return day.day() === (firstDayOfWeek || _moment2['default'].localeData().firstDayOfWeek());
	      }
	
	      return isFirstDayOfWeek;
	    }()
	  }, {
	    key: 'isLastDayOfWeek',
	    value: function () {
	      function isLastDayOfWeek(day) {
	        var firstDayOfWeek = this.props.firstDayOfWeek;
	
	        return day.day() === ((firstDayOfWeek || _moment2['default'].localeData().firstDayOfWeek()) + 6) % 7;
	      }
	
	      return isLastDayOfWeek;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props8 = this.props,
	            numberOfMonths = _props8.numberOfMonths,
	            orientation = _props8.orientation,
	            monthFormat = _props8.monthFormat,
	            renderMonth = _props8.renderMonth,
	            navPrev = _props8.navPrev,
	            navNext = _props8.navNext,
	            onOutsideClick = _props8.onOutsideClick,
	            withPortal = _props8.withPortal,
	            focused = _props8.focused,
	            enableOutsideDays = _props8.enableOutsideDays,
	            hideKeyboardShortcutsPanel = _props8.hideKeyboardShortcutsPanel,
	            daySize = _props8.daySize,
	            firstDayOfWeek = _props8.firstDayOfWeek,
	            renderCalendarDay = _props8.renderCalendarDay,
	            renderDayContents = _props8.renderDayContents,
	            renderCalendarInfo = _props8.renderCalendarInfo,
	            calendarInfoPosition = _props8.calendarInfoPosition,
	            isFocused = _props8.isFocused,
	            isRTL = _props8.isRTL,
	            phrases = _props8.phrases,
	            dayAriaLabelFormat = _props8.dayAriaLabelFormat,
	            onBlur = _props8.onBlur,
	            showKeyboardShortcuts = _props8.showKeyboardShortcuts,
	            weekDayFormat = _props8.weekDayFormat,
	            verticalHeight = _props8.verticalHeight,
	            noBorder = _props8.noBorder,
	            transitionDuration = _props8.transitionDuration,
	            verticalBorderSpacing = _props8.verticalBorderSpacing;
	        var _state7 = this.state,
	            currentMonth = _state7.currentMonth,
	            visibleDays = _state7.visibleDays;
	
	
	        return _react2['default'].createElement(_DayPicker2['default'], {
	          orientation: orientation,
	          enableOutsideDays: enableOutsideDays,
	          modifiers: visibleDays,
	          numberOfMonths: numberOfMonths,
	          onDayClick: this.onDayClick,
	          onDayMouseEnter: this.onDayMouseEnter,
	          onDayMouseLeave: this.onDayMouseLeave,
	          onPrevMonthClick: this.onPrevMonthClick,
	          onNextMonthClick: this.onNextMonthClick,
	          monthFormat: monthFormat,
	          withPortal: withPortal,
	          hidden: !focused,
	          hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	          initialVisibleMonth: function () {
	            function initialVisibleMonth() {
	              return currentMonth;
	            }
	
	            return initialVisibleMonth;
	          }(),
	          firstDayOfWeek: firstDayOfWeek,
	          onOutsideClick: onOutsideClick,
	          navPrev: navPrev,
	          navNext: navNext,
	          renderMonth: renderMonth,
	          renderCalendarDay: renderCalendarDay,
	          renderDayContents: renderDayContents,
	          renderCalendarInfo: renderCalendarInfo,
	          calendarInfoPosition: calendarInfoPosition,
	          isFocused: isFocused,
	          getFirstFocusableDay: this.getFirstFocusableDay,
	          onBlur: onBlur,
	          phrases: phrases,
	          daySize: daySize,
	          isRTL: isRTL,
	          showKeyboardShortcuts: showKeyboardShortcuts,
	          weekDayFormat: weekDayFormat,
	          dayAriaLabelFormat: dayAriaLabelFormat,
	          verticalHeight: verticalHeight,
	          noBorder: noBorder,
	          transitionDuration: transitionDuration,
	          verticalBorderSpacing: verticalBorderSpacing
	        });
	      }
	
	      return render;
	    }()
	  }]);
	
	  return DayPickerSingleDateController;
	}(_react2['default'].Component);
	
	exports['default'] = DayPickerSingleDateController;
	
	
	DayPickerSingleDateController.propTypes = propTypes;
	DayPickerSingleDateController.defaultProps = defaultProps;

/***/ }),

/***/ 530:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _reactWithStyles = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  unicode: _propTypes2['default'].string.isRequired,
	  label: _propTypes2['default'].string.isRequired,
	  action: _propTypes2['default'].string.isRequired,
	  block: _propTypes2['default'].bool
	}));
	
	var defaultProps = {
	  block: false
	};
	
	function KeyboardShortcutRow(_ref) {
	  var unicode = _ref.unicode,
	      label = _ref.label,
	      action = _ref.action,
	      block = _ref.block,
	      styles = _ref.styles;
	
	  return _react2['default'].createElement(
	    'li',
	    (0, _reactWithStyles.css)(styles.KeyboardShortcutRow, block && styles.KeyboardShortcutRow__block),
	    _react2['default'].createElement(
	      'div',
	      (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_keyContainer, block && styles.KeyboardShortcutRow_keyContainer__block),
	      _react2['default'].createElement(
	        'span',
	        _extends({}, (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_key), {
	          role: 'img',
	          'aria-label': String(label) + ',' // add comma so screen readers will pause before reading action
	        }),
	        unicode
	      )
	    ),
	    _react2['default'].createElement(
	      'div',
	      (0, _reactWithStyles.css)(styles.KeyboardShortcutRow_action),
	      action
	    )
	  );
	}
	
	KeyboardShortcutRow.propTypes = propTypes;
	KeyboardShortcutRow.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var color = _ref2.reactDates.color;
	  return {
	    KeyboardShortcutRow: {
	      listStyle: 'none',
	      margin: '6px 0'
	    },
	
	    KeyboardShortcutRow__block: {
	      marginBottom: 16
	    },
	
	    KeyboardShortcutRow_keyContainer: {
	      display: 'inline-block',
	      whiteSpace: 'nowrap',
	      textAlign: 'right',
	      marginRight: 6
	    },
	
	    KeyboardShortcutRow_keyContainer__block: {
	      textAlign: 'left',
	      display: 'inline'
	    },
	
	    KeyboardShortcutRow_key: {
	      fontFamily: 'monospace',
	      fontSize: 12,
	      textTransform: 'uppercase',
	      background: color.core.grayLightest,
	      padding: '2px 6px'
	    },
	
	    KeyboardShortcutRow_action: {
	      display: 'inline',
	      wordBreak: 'break-word',
	      marginLeft: 8
	    }
	  };
	})(KeyboardShortcutRow);

/***/ }),

/***/ 236:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LeftArrow = function () {
	  function LeftArrow(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M336.2 274.5l-210.1 210h805.4c13 0 23 10 23 23s-10 23-23 23H126.1l210.1 210.1c11 11 11 21 0 32-5 5-10 7-16 7s-11-2-16-7l-249.1-249c-11-11-11-21 0-32l249.1-249.1c21-21.1 53 10.9 32 32z'
	      })
	    );
	  }
	
	  return LeftArrow;
	}();
	
	LeftArrow.defaultProps = {
	  viewBox: '0 0 1000 1000'
	};
	exports['default'] = LeftArrow;

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _consolidatedEvents = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { forbidExtraProps } from 'airbnb-prop-types'; // TODO: add to propTypes; semver-major
	
	
	var propTypes = {
	  children: _propTypes2['default'].node,
	  onOutsideClick: _propTypes2['default'].func
	};
	
	var defaultProps = {
	  children: _react2['default'].createElement('span', null),
	  onOutsideClick: function () {
	    function onOutsideClick() {}
	
	    return onOutsideClick;
	  }()
	};
	
	var OutsideClickHandler = function (_React$Component) {
	  _inherits(OutsideClickHandler, _React$Component);
	
	  function OutsideClickHandler() {
	    var _ref;
	
	    _classCallCheck(this, OutsideClickHandler);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = OutsideClickHandler.__proto__ || Object.getPrototypeOf(OutsideClickHandler)).call.apply(_ref, [this].concat(args)));
	
	    _this.onOutsideClick = _this.onOutsideClick.bind(_this);
	    _this.setChildNodeRef = _this.setChildNodeRef.bind(_this);
	    return _this;
	  }
	
	  _createClass(OutsideClickHandler, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        // `capture` flag is set to true so that a `stopPropagation` in the children
	        // will not prevent all outside click handlers from firing - maja
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(document, 'click', this.onOutsideClick, { capture: true });
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeEventListener) {
	          this.removeEventListener();
	        }
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onOutsideClick',
	    value: function () {
	      function onOutsideClick(e) {
	        var onOutsideClick = this.props.onOutsideClick;
	        var childNode = this.childNode;
	
	        var isDescendantOfRoot = childNode && childNode.contains(e.target);
	        if (!isDescendantOfRoot) {
	          onOutsideClick(e);
	        }
	      }
	
	      return onOutsideClick;
	    }()
	  }, {
	    key: 'setChildNodeRef',
	    value: function () {
	      function setChildNodeRef(ref) {
	        this.childNode = ref;
	      }
	
	      return setChildNodeRef;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        return _react2['default'].createElement(
	          'div',
	          { ref: this.setChildNodeRef },
	          this.props.children
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return OutsideClickHandler;
	}(_react2['default'].Component);
	
	exports['default'] = OutsideClickHandler;
	
	
	OutsideClickHandler.propTypes = propTypes;
	OutsideClickHandler.defaultProps = defaultProps;

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var RightArrow = function () {
	  function RightArrow(props) {
	    return _react2['default'].createElement(
	      'svg',
	      props,
	      _react2['default'].createElement('path', {
	        d: 'M694.4 242.4l249.1 249.1c11 11 11 21 0 32L694.4 772.7c-5 5-10 7-16 7s-11-2-16-7c-11-11-11-21 0-32l210.1-210.1H67.1c-13 0-23-10-23-23s10-23 23-23h805.4L662.4 274.5c-21-21.1 11-53.1 32-32.1z'
	      })
	    );
	  }
	
	  return RightArrow;
	}();
	
	RightArrow.defaultProps = {
	  viewBox: '0 0 1000 1000'
	};
	exports['default'] = RightArrow;

/***/ }),

/***/ 531:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PureSingleDatePicker = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactWithStyles = __webpack_require__(26);
	
	var _reactPortal = __webpack_require__(258);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _consolidatedEvents = __webpack_require__(90);
	
	var _isTouchDevice = __webpack_require__(51);
	
	var _isTouchDevice2 = _interopRequireDefault(_isTouchDevice);
	
	var _SingleDatePickerShape = __webpack_require__(243);
	
	var _SingleDatePickerShape2 = _interopRequireDefault(_SingleDatePickerShape);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _toMomentObject = __webpack_require__(58);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _toLocalizedDateString = __webpack_require__(140);
	
	var _toLocalizedDateString2 = _interopRequireDefault(_toLocalizedDateString);
	
	var _getResponsiveContainerStyles = __webpack_require__(250);
	
	var _getResponsiveContainerStyles2 = _interopRequireDefault(_getResponsiveContainerStyles);
	
	var _getDetachedContainerStyles = __webpack_require__(249);
	
	var _getDetachedContainerStyles2 = _interopRequireDefault(_getDetachedContainerStyles);
	
	var _getInputHeight = __webpack_require__(138);
	
	var _getInputHeight2 = _interopRequireDefault(_getInputHeight);
	
	var _isInclusivelyAfterDay = __webpack_require__(83);
	
	var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);
	
	var _disableScroll2 = __webpack_require__(246);
	
	var _disableScroll3 = _interopRequireDefault(_disableScroll2);
	
	var _SingleDatePickerInput = __webpack_require__(238);
	
	var _SingleDatePickerInput2 = _interopRequireDefault(_SingleDatePickerInput);
	
	var _DayPickerSingleDateController = __webpack_require__(235);
	
	var _DayPickerSingleDateController2 = _interopRequireDefault(_DayPickerSingleDateController);
	
	var _OutsideClickHandler = __webpack_require__(96);
	
	var _OutsideClickHandler2 = _interopRequireDefault(_OutsideClickHandler);
	
	var _CloseButton = __webpack_require__(78);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, _SingleDatePickerShape2['default']));
	
	var defaultProps = {
	  // required props for a functional interactive SingleDatePicker
	  date: null,
	  focused: false,
	
	  // input related props
	  id: 'date',
	  placeholder: 'Date',
	  disabled: false,
	  required: false,
	  readOnly: false,
	  screenReaderInputMessage: '',
	  showClearDate: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customInputIcon: null,
	  customCloseIcon: null,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  verticalSpacing: _constants.DEFAULT_VERTICAL_SPACING,
	  keepFocusOnInput: false,
	
	  // calendar presentation and interaction related props
	  orientation: _constants.HORIZONTAL_ORIENTATION,
	  anchorDirection: _constants.ANCHOR_LEFT,
	  openDirection: _constants.OPEN_DOWN,
	  horizontalMargin: 0,
	  withPortal: false,
	  withFullScreenPortal: false,
	  appendToBody: false,
	  disableScroll: false,
	  initialVisibleMonth: null,
	  firstDayOfWeek: null,
	  numberOfMonths: 2,
	  keepOpenOnDateSelect: false,
	  reopenPickerOnClearDate: false,
	  renderCalendarInfo: null,
	  calendarInfoPosition: _constants.INFO_POSITION_BOTTOM,
	  hideKeyboardShortcutsPanel: false,
	  daySize: _constants.DAY_SIZE,
	  isRTL: false,
	  verticalHeight: null,
	  transitionDuration: undefined,
	
	  // navigation related props
	  navPrev: null,
	  navNext: null,
	
	  onPrevMonthClick: function () {
	    function onPrevMonthClick() {}
	
	    return onPrevMonthClick;
	  }(),
	  onNextMonthClick: function () {
	    function onNextMonthClick() {}
	
	    return onNextMonthClick;
	  }(),
	  onClose: function () {
	    function onClose() {}
	
	    return onClose;
	  }(),
	
	
	  // month presentation and interaction related props
	  renderMonth: null,
	
	  // day presentation and interaction related props
	  renderCalendarDay: undefined,
	  renderDayContents: null,
	  enableOutsideDays: false,
	  isDayBlocked: function () {
	    function isDayBlocked() {
	      return false;
	    }
	
	    return isDayBlocked;
	  }(),
	  isOutsideRange: function () {
	    function isOutsideRange(day) {
	      return !(0, _isInclusivelyAfterDay2['default'])(day, (0, _moment2['default'])());
	    }
	
	    return isOutsideRange;
	  }(),
	  isDayHighlighted: function () {
	    function isDayHighlighted() {}
	
	    return isDayHighlighted;
	  }(),
	
	  // internationalization props
	  displayFormat: function () {
	    function displayFormat() {
	      return _moment2['default'].localeData().longDateFormat('L');
	    }
	
	    return displayFormat;
	  }(),
	  monthFormat: 'MMMM YYYY',
	  weekDayFormat: 'dd',
	  phrases: _defaultPhrases.SingleDatePickerPhrases,
	  dayAriaLabelFormat: undefined
	};
	
	var SingleDatePicker = function (_React$Component) {
	  _inherits(SingleDatePicker, _React$Component);
	
	  function SingleDatePicker(props) {
	    _classCallCheck(this, SingleDatePicker);
	
	    var _this = _possibleConstructorReturn(this, (SingleDatePicker.__proto__ || Object.getPrototypeOf(SingleDatePicker)).call(this, props));
	
	    _this.isTouchDevice = false;
	
	    _this.state = {
	      dayPickerContainerStyles: {},
	      isDayPickerFocused: false,
	      isInputFocused: false,
	      showKeyboardShortcuts: false
	    };
	
	    _this.onDayPickerFocus = _this.onDayPickerFocus.bind(_this);
	    _this.onDayPickerBlur = _this.onDayPickerBlur.bind(_this);
	    _this.showKeyboardShortcutsPanel = _this.showKeyboardShortcutsPanel.bind(_this);
	
	    _this.onChange = _this.onChange.bind(_this);
	    _this.onFocus = _this.onFocus.bind(_this);
	    _this.onClearFocus = _this.onClearFocus.bind(_this);
	    _this.clearDate = _this.clearDate.bind(_this);
	
	    _this.responsivizePickerPosition = _this.responsivizePickerPosition.bind(_this);
	    _this.disableScroll = _this.disableScroll.bind(_this);
	
	    _this.setDayPickerContainerRef = _this.setDayPickerContainerRef.bind(_this);
	    _this.setContainerRef = _this.setContainerRef.bind(_this);
	    return _this;
	  }
	
	  /* istanbul ignore next */
	
	
	  _createClass(SingleDatePicker, [{
	    key: 'componentDidMount',
	    value: function () {
	      function componentDidMount() {
	        this.removeEventListener = (0, _consolidatedEvents.addEventListener)(window, 'resize', this.responsivizePickerPosition, { passive: true });
	        this.responsivizePickerPosition();
	        this.disableScroll();
	
	        if (this.props.focused) {
	          this.setState({
	            isInputFocused: true
	          });
	        }
	
	        this.isTouchDevice = (0, _isTouchDevice2['default'])();
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentDidUpdate',
	    value: function () {
	      function componentDidUpdate(prevProps) {
	        if (!prevProps.focused && this.props.focused) {
	          this.responsivizePickerPosition();
	          this.disableScroll();
	        } else if (prevProps.focused && !this.props.focused) {
	          if (this.enableScroll) this.enableScroll();
	        }
	      }
	
	      return componentDidUpdate;
	    }()
	
	    /* istanbul ignore next */
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function () {
	      function componentWillUnmount() {
	        if (this.removeEventListener) this.removeEventListener();
	        if (this.enableScroll) this.enableScroll();
	      }
	
	      return componentWillUnmount;
	    }()
	  }, {
	    key: 'onChange',
	    value: function () {
	      function onChange(dateString) {
	        var _props = this.props,
	            isOutsideRange = _props.isOutsideRange,
	            keepOpenOnDateSelect = _props.keepOpenOnDateSelect,
	            onDateChange = _props.onDateChange,
	            onFocusChange = _props.onFocusChange,
	            onClose = _props.onClose;
	
	        var newDate = (0, _toMomentObject2['default'])(dateString, this.getDisplayFormat());
	
	        var isValid = newDate && !isOutsideRange(newDate);
	        if (isValid) {
	          onDateChange(newDate);
	          if (!keepOpenOnDateSelect) {
	            onFocusChange({ focused: false });
	            onClose({ date: newDate });
	          }
	        } else {
	          onDateChange(null);
	        }
	      }
	
	      return onChange;
	    }()
	  }, {
	    key: 'onFocus',
	    value: function () {
	      function onFocus() {
	        var _props2 = this.props,
	            disabled = _props2.disabled,
	            onFocusChange = _props2.onFocusChange,
	            readOnly = _props2.readOnly,
	            withPortal = _props2.withPortal,
	            withFullScreenPortal = _props2.withFullScreenPortal,
	            keepFocusOnInput = _props2.keepFocusOnInput;
	
	
	        var withAnyPortal = withPortal || withFullScreenPortal;
	        var moveFocusToDayPicker = withAnyPortal || readOnly && !keepFocusOnInput || this.isTouchDevice && !keepFocusOnInput;
	
	        if (moveFocusToDayPicker) {
	          this.onDayPickerFocus();
	        } else {
	          this.onDayPickerBlur();
	        }
	
	        if (!disabled) {
	          onFocusChange({ focused: true });
	        }
	      }
	
	      return onFocus;
	    }()
	  }, {
	    key: 'onClearFocus',
	    value: function () {
	      function onClearFocus(event) {
	        var _props3 = this.props,
	            date = _props3.date,
	            focused = _props3.focused,
	            onFocusChange = _props3.onFocusChange,
	            onClose = _props3.onClose;
	
	        if (!focused) return;
	        if (this.props.appendToBody && this.dayPickerContainer.contains(event.target)) return;
	
	        this.setState({
	          isInputFocused: false,
	          isDayPickerFocused: false
	        });
	
	        onFocusChange({ focused: false });
	        onClose({ date: date });
	      }
	
	      return onClearFocus;
	    }()
	  }, {
	    key: 'onDayPickerFocus',
	    value: function () {
	      function onDayPickerFocus() {
	        this.setState({
	          isInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerFocus;
	    }()
	  }, {
	    key: 'onDayPickerBlur',
	    value: function () {
	      function onDayPickerBlur() {
	        this.setState({
	          isInputFocused: true,
	          isDayPickerFocused: false,
	          showKeyboardShortcuts: false
	        });
	      }
	
	      return onDayPickerBlur;
	    }()
	  }, {
	    key: 'getDateString',
	    value: function () {
	      function getDateString(date) {
	        var displayFormat = this.getDisplayFormat();
	        if (date && displayFormat) {
	          return date && date.format(displayFormat);
	        }
	        return (0, _toLocalizedDateString2['default'])(date);
	      }
	
	      return getDateString;
	    }()
	  }, {
	    key: 'getDisplayFormat',
	    value: function () {
	      function getDisplayFormat() {
	        var displayFormat = this.props.displayFormat;
	
	        return typeof displayFormat === 'string' ? displayFormat : displayFormat();
	      }
	
	      return getDisplayFormat;
	    }()
	  }, {
	    key: 'setDayPickerContainerRef',
	    value: function () {
	      function setDayPickerContainerRef(ref) {
	        this.dayPickerContainer = ref;
	      }
	
	      return setDayPickerContainerRef;
	    }()
	  }, {
	    key: 'setContainerRef',
	    value: function () {
	      function setContainerRef(ref) {
	        this.container = ref;
	      }
	
	      return setContainerRef;
	    }()
	  }, {
	    key: 'clearDate',
	    value: function () {
	      function clearDate() {
	        var _props4 = this.props,
	            onDateChange = _props4.onDateChange,
	            reopenPickerOnClearDate = _props4.reopenPickerOnClearDate,
	            onFocusChange = _props4.onFocusChange;
	
	        onDateChange(null);
	        if (reopenPickerOnClearDate) {
	          onFocusChange({ focused: true });
	        }
	      }
	
	      return clearDate;
	    }()
	  }, {
	    key: 'disableScroll',
	    value: function () {
	      function disableScroll() {
	        if (!this.props.appendToBody && !this.props.disableScroll) return;
	        if (!this.props.focused) return;
	
	        // Disable scroll for every ancestor of this <SingleDatePicker> up to the
	        // document level. This ensures the input and the picker never move. Other
	        // sibling elements or the picker itself can scroll.
	        this.enableScroll = (0, _disableScroll3['default'])(this.container);
	      }
	
	      return disableScroll;
	    }()
	
	    /* istanbul ignore next */
	
	  }, {
	    key: 'responsivizePickerPosition',
	    value: function () {
	      function responsivizePickerPosition() {
	        // It's possible the portal props have been changed in response to window resizes
	        // So let's ensure we reset this back to the base state each time
	        this.setState({ dayPickerContainerStyles: {} });
	
	        var _props5 = this.props,
	            openDirection = _props5.openDirection,
	            anchorDirection = _props5.anchorDirection,
	            horizontalMargin = _props5.horizontalMargin,
	            withPortal = _props5.withPortal,
	            withFullScreenPortal = _props5.withFullScreenPortal,
	            appendToBody = _props5.appendToBody,
	            focused = _props5.focused;
	        var dayPickerContainerStyles = this.state.dayPickerContainerStyles;
	
	
	        if (!focused) {
	          return;
	        }
	
	        var isAnchoredLeft = anchorDirection === _constants.ANCHOR_LEFT;
	
	        if (!withPortal && !withFullScreenPortal) {
	          var containerRect = this.dayPickerContainer.getBoundingClientRect();
	          var currentOffset = dayPickerContainerStyles[anchorDirection] || 0;
	          var containerEdge = isAnchoredLeft ? containerRect[_constants.ANCHOR_RIGHT] : containerRect[_constants.ANCHOR_LEFT];
	
	          this.setState({
	            dayPickerContainerStyles: (0, _object2['default'])({}, (0, _getResponsiveContainerStyles2['default'])(anchorDirection, currentOffset, containerEdge, horizontalMargin), appendToBody && (0, _getDetachedContainerStyles2['default'])(openDirection, anchorDirection, this.container))
	          });
	        }
	      }
	
	      return responsivizePickerPosition;
	    }()
	  }, {
	    key: 'showKeyboardShortcutsPanel',
	    value: function () {
	      function showKeyboardShortcutsPanel() {
	        this.setState({
	          isInputFocused: false,
	          isDayPickerFocused: true,
	          showKeyboardShortcuts: true
	        });
	      }
	
	      return showKeyboardShortcutsPanel;
	    }()
	  }, {
	    key: 'maybeRenderDayPickerWithPortal',
	    value: function () {
	      function maybeRenderDayPickerWithPortal() {
	        var _props6 = this.props,
	            focused = _props6.focused,
	            withPortal = _props6.withPortal,
	            withFullScreenPortal = _props6.withFullScreenPortal,
	            appendToBody = _props6.appendToBody;
	
	
	        if (!focused) {
	          return null;
	        }
	
	        if (withPortal || withFullScreenPortal || appendToBody) {
	          return _react2['default'].createElement(
	            _reactPortal.Portal,
	            null,
	            this.renderDayPicker()
	          );
	        }
	
	        return this.renderDayPicker();
	      }
	
	      return maybeRenderDayPickerWithPortal;
	    }()
	  }, {
	    key: 'renderDayPicker',
	    value: function () {
	      function renderDayPicker() {
	        var _props7 = this.props,
	            anchorDirection = _props7.anchorDirection,
	            openDirection = _props7.openDirection,
	            onDateChange = _props7.onDateChange,
	            date = _props7.date,
	            onFocusChange = _props7.onFocusChange,
	            focused = _props7.focused,
	            enableOutsideDays = _props7.enableOutsideDays,
	            numberOfMonths = _props7.numberOfMonths,
	            orientation = _props7.orientation,
	            monthFormat = _props7.monthFormat,
	            navPrev = _props7.navPrev,
	            navNext = _props7.navNext,
	            onPrevMonthClick = _props7.onPrevMonthClick,
	            onNextMonthClick = _props7.onNextMonthClick,
	            onClose = _props7.onClose,
	            withPortal = _props7.withPortal,
	            withFullScreenPortal = _props7.withFullScreenPortal,
	            keepOpenOnDateSelect = _props7.keepOpenOnDateSelect,
	            initialVisibleMonth = _props7.initialVisibleMonth,
	            renderMonth = _props7.renderMonth,
	            renderCalendarDay = _props7.renderCalendarDay,
	            renderDayContents = _props7.renderDayContents,
	            renderCalendarInfo = _props7.renderCalendarInfo,
	            calendarInfoPosition = _props7.calendarInfoPosition,
	            hideKeyboardShortcutsPanel = _props7.hideKeyboardShortcutsPanel,
	            firstDayOfWeek = _props7.firstDayOfWeek,
	            customCloseIcon = _props7.customCloseIcon,
	            phrases = _props7.phrases,
	            dayAriaLabelFormat = _props7.dayAriaLabelFormat,
	            daySize = _props7.daySize,
	            isRTL = _props7.isRTL,
	            isOutsideRange = _props7.isOutsideRange,
	            isDayBlocked = _props7.isDayBlocked,
	            isDayHighlighted = _props7.isDayHighlighted,
	            weekDayFormat = _props7.weekDayFormat,
	            styles = _props7.styles,
	            verticalHeight = _props7.verticalHeight,
	            transitionDuration = _props7.transitionDuration,
	            verticalSpacing = _props7.verticalSpacing,
	            small = _props7.small,
	            reactDates = _props7.theme.reactDates;
	        var _state = this.state,
	            dayPickerContainerStyles = _state.dayPickerContainerStyles,
	            isDayPickerFocused = _state.isDayPickerFocused,
	            showKeyboardShortcuts = _state.showKeyboardShortcuts;
	
	
	        var onOutsideClick = !withFullScreenPortal && withPortal ? this.onClearFocus : undefined;
	        var closeIcon = customCloseIcon || _react2['default'].createElement(_CloseButton2['default'], null);
	
	        var inputHeight = (0, _getInputHeight2['default'])(reactDates, small);
	
	        var withAnyPortal = withPortal || withFullScreenPortal;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({ // eslint-disable-line jsx-a11y/no-static-element-interactions
	            ref: this.setDayPickerContainerRef
	          }, (0, _reactWithStyles.css)(styles.SingleDatePicker_picker, anchorDirection === _constants.ANCHOR_LEFT && styles.SingleDatePicker_picker__directionLeft, anchorDirection === _constants.ANCHOR_RIGHT && styles.SingleDatePicker_picker__directionRight, openDirection === _constants.OPEN_DOWN && styles.SingleDatePicker_picker__openDown, openDirection === _constants.OPEN_UP && styles.SingleDatePicker_picker__openUp, !withAnyPortal && openDirection === _constants.OPEN_DOWN && {
	            top: inputHeight + verticalSpacing
	          }, !withAnyPortal && openDirection === _constants.OPEN_UP && {
	            bottom: inputHeight + verticalSpacing
	          }, orientation === _constants.HORIZONTAL_ORIENTATION && styles.SingleDatePicker_picker__horizontal, orientation === _constants.VERTICAL_ORIENTATION && styles.SingleDatePicker_picker__vertical, withAnyPortal && styles.SingleDatePicker_picker__portal, withFullScreenPortal && styles.SingleDatePicker_picker__fullScreenPortal, isRTL && styles.SingleDatePicker_picker__rtl, dayPickerContainerStyles), {
	            onClick: onOutsideClick
	          }),
	          _react2['default'].createElement(_DayPickerSingleDateController2['default'], {
	            date: date,
	            onDateChange: onDateChange,
	            onFocusChange: onFocusChange,
	            orientation: orientation,
	            enableOutsideDays: enableOutsideDays,
	            numberOfMonths: numberOfMonths,
	            monthFormat: monthFormat,
	            withPortal: withAnyPortal,
	            focused: focused,
	            keepOpenOnDateSelect: keepOpenOnDateSelect,
	            hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	            initialVisibleMonth: initialVisibleMonth,
	            navPrev: navPrev,
	            navNext: navNext,
	            onPrevMonthClick: onPrevMonthClick,
	            onNextMonthClick: onNextMonthClick,
	            onClose: onClose,
	            renderMonth: renderMonth,
	            renderCalendarDay: renderCalendarDay,
	            renderDayContents: renderDayContents,
	            renderCalendarInfo: renderCalendarInfo,
	            calendarInfoPosition: calendarInfoPosition,
	            isFocused: isDayPickerFocused,
	            showKeyboardShortcuts: showKeyboardShortcuts,
	            onBlur: this.onDayPickerBlur,
	            phrases: phrases,
	            dayAriaLabelFormat: dayAriaLabelFormat,
	            daySize: daySize,
	            isRTL: isRTL,
	            isOutsideRange: isOutsideRange,
	            isDayBlocked: isDayBlocked,
	            isDayHighlighted: isDayHighlighted,
	            firstDayOfWeek: firstDayOfWeek,
	            weekDayFormat: weekDayFormat,
	            verticalHeight: verticalHeight,
	            transitionDuration: transitionDuration
	          }),
	          withFullScreenPortal && _react2['default'].createElement(
	            'button',
	            _extends({}, (0, _reactWithStyles.css)(styles.SingleDatePicker_closeButton), {
	              'aria-label': phrases.closeDatePicker,
	              type: 'button',
	              onClick: this.onClearFocus
	            }),
	            _react2['default'].createElement(
	              'div',
	              (0, _reactWithStyles.css)(styles.SingleDatePicker_closeButton_svg),
	              closeIcon
	            )
	          )
	        );
	      }
	
	      return renderDayPicker;
	    }()
	  }, {
	    key: 'render',
	    value: function () {
	      function render() {
	        var _props8 = this.props,
	            id = _props8.id,
	            placeholder = _props8.placeholder,
	            disabled = _props8.disabled,
	            focused = _props8.focused,
	            required = _props8.required,
	            readOnly = _props8.readOnly,
	            openDirection = _props8.openDirection,
	            showClearDate = _props8.showClearDate,
	            showDefaultInputIcon = _props8.showDefaultInputIcon,
	            inputIconPosition = _props8.inputIconPosition,
	            customCloseIcon = _props8.customCloseIcon,
	            customInputIcon = _props8.customInputIcon,
	            date = _props8.date,
	            phrases = _props8.phrases,
	            withPortal = _props8.withPortal,
	            withFullScreenPortal = _props8.withFullScreenPortal,
	            screenReaderInputMessage = _props8.screenReaderInputMessage,
	            isRTL = _props8.isRTL,
	            noBorder = _props8.noBorder,
	            block = _props8.block,
	            small = _props8.small,
	            regular = _props8.regular,
	            verticalSpacing = _props8.verticalSpacing,
	            styles = _props8.styles;
	        var isInputFocused = this.state.isInputFocused;
	
	
	        var displayValue = this.getDateString(date);
	
	        var onOutsideClick = !withPortal && !withFullScreenPortal ? this.onClearFocus : undefined;
	
	        var hideFang = verticalSpacing < _constants.FANG_HEIGHT_PX;
	
	        return _react2['default'].createElement(
	          'div',
	          _extends({
	            ref: this.setContainerRef
	          }, (0, _reactWithStyles.css)(styles.SingleDatePicker, block && styles.SingleDatePicker__block)),
	          _react2['default'].createElement(
	            _OutsideClickHandler2['default'],
	            { onOutsideClick: onOutsideClick },
	            _react2['default'].createElement(_SingleDatePickerInput2['default'], {
	              id: id,
	              placeholder: placeholder,
	              focused: focused,
	              isFocused: isInputFocused,
	              disabled: disabled,
	              required: required,
	              readOnly: readOnly,
	              openDirection: openDirection,
	              showCaret: !withPortal && !withFullScreenPortal && !hideFang,
	              onClearDate: this.clearDate,
	              showClearDate: showClearDate,
	              showDefaultInputIcon: showDefaultInputIcon,
	              inputIconPosition: inputIconPosition,
	              customCloseIcon: customCloseIcon,
	              customInputIcon: customInputIcon,
	              displayValue: displayValue,
	              onChange: this.onChange,
	              onFocus: this.onFocus,
	              onKeyDownShiftTab: this.onClearFocus,
	              onKeyDownTab: this.onClearFocus,
	              onKeyDownArrowDown: this.onDayPickerFocus,
	              onKeyDownQuestionMark: this.showKeyboardShortcutsPanel,
	              screenReaderMessage: screenReaderInputMessage,
	              phrases: phrases,
	              isRTL: isRTL,
	              noBorder: noBorder,
	              block: block,
	              small: small,
	              regular: regular,
	              verticalSpacing: verticalSpacing
	            }),
	            this.maybeRenderDayPickerWithPortal()
	          )
	        );
	      }
	
	      return render;
	    }()
	  }]);
	
	  return SingleDatePicker;
	}(_react2['default'].Component);
	
	SingleDatePicker.propTypes = propTypes;
	SingleDatePicker.defaultProps = defaultProps;
	
	exports.PureSingleDatePicker = SingleDatePicker;
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref) {
	  var _ref$reactDates = _ref.reactDates,
	      color = _ref$reactDates.color,
	      zIndex = _ref$reactDates.zIndex;
	  return {
	    SingleDatePicker: {
	      position: 'relative',
	      display: 'inline-block'
	    },
	
	    SingleDatePicker__block: {
	      display: 'block'
	    },
	
	    SingleDatePicker_picker: {
	      zIndex: zIndex + 1,
	      backgroundColor: color.background,
	      position: 'absolute'
	    },
	
	    SingleDatePicker_picker__rtl: {
	      direction: 'rtl'
	    },
	
	    SingleDatePicker_picker__directionLeft: {
	      left: 0
	    },
	
	    SingleDatePicker_picker__directionRight: {
	      right: 0
	    },
	
	    SingleDatePicker_picker__portal: {
	      backgroundColor: 'rgba(0, 0, 0, 0.3)',
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      height: '100%',
	      width: '100%'
	    },
	
	    SingleDatePicker_picker__fullScreenPortal: {
	      backgroundColor: color.background
	    },
	
	    SingleDatePicker_closeButton: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	      cursor: 'pointer',
	
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      padding: 15,
	      zIndex: zIndex + 2,
	
	      ':hover': {
	        color: 'darken(' + String(color.core.grayLighter) + ', 10%)',
	        textDecoration: 'none'
	      },
	
	      ':focus': {
	        color: 'darken(' + String(color.core.grayLighter) + ', 10%)',
	        textDecoration: 'none'
	      }
	    },
	
	    SingleDatePicker_closeButton_svg: {
	      height: 15,
	      width: 15,
	      fill: color.core.grayLighter
	    }
	  };
	})(SingleDatePicker);

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _reactWithStyles = __webpack_require__(26);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _DateInput = __webpack_require__(231);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _IconPositionShape = __webpack_require__(80);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _CloseButton = __webpack_require__(78);
	
	var _CloseButton2 = _interopRequireDefault(_CloseButton);
	
	var _CalendarIcon = __webpack_require__(228);
	
	var _CalendarIcon2 = _interopRequireDefault(_CalendarIcon);
	
	var _OpenDirectionShape = __webpack_require__(55);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var propTypes = (0, _airbnbPropTypes.forbidExtraProps)((0, _object2['default'])({}, _reactWithStyles.withStylesPropTypes, {
	  id: _propTypes2['default'].string.isRequired,
	  placeholder: _propTypes2['default'].string, // also used as label
	  displayValue: _propTypes2['default'].string,
	  screenReaderMessage: _propTypes2['default'].string,
	  focused: _propTypes2['default'].bool,
	  isFocused: _propTypes2['default'].bool, // describes actual DOM focus
	  disabled: _propTypes2['default'].bool,
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  openDirection: _OpenDirectionShape2['default'],
	  showCaret: _propTypes2['default'].bool,
	  showClearDate: _propTypes2['default'].bool,
	  customCloseIcon: _propTypes2['default'].node,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  customInputIcon: _propTypes2['default'].node,
	  isRTL: _propTypes2['default'].bool,
	  noBorder: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  small: _propTypes2['default'].bool,
	  regular: _propTypes2['default'].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  onChange: _propTypes2['default'].func,
	  onClearDate: _propTypes2['default'].func,
	  onFocus: _propTypes2['default'].func,
	  onKeyDownShiftTab: _propTypes2['default'].func,
	  onKeyDownTab: _propTypes2['default'].func,
	  onKeyDownArrowDown: _propTypes2['default'].func,
	  onKeyDownQuestionMark: _propTypes2['default'].func,
	
	  // i18n
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.SingleDatePickerInputPhrases))
	}));
	
	var defaultProps = {
	  placeholder: 'Select Date',
	  displayValue: '',
	  screenReaderMessage: '',
	  focused: false,
	  isFocused: false,
	  disabled: false,
	  required: false,
	  readOnly: false,
	  openDirection: _constants.OPEN_DOWN,
	  showCaret: false,
	  showClearDate: false,
	  showDefaultInputIcon: false,
	  inputIconPosition: _constants.ICON_BEFORE_POSITION,
	  customCloseIcon: null,
	  customInputIcon: null,
	  isRTL: false,
	  noBorder: false,
	  block: false,
	  small: false,
	  regular: false,
	  verticalSpacing: undefined,
	
	  onChange: function () {
	    function onChange() {}
	
	    return onChange;
	  }(),
	  onClearDate: function () {
	    function onClearDate() {}
	
	    return onClearDate;
	  }(),
	  onFocus: function () {
	    function onFocus() {}
	
	    return onFocus;
	  }(),
	  onKeyDownShiftTab: function () {
	    function onKeyDownShiftTab() {}
	
	    return onKeyDownShiftTab;
	  }(),
	  onKeyDownTab: function () {
	    function onKeyDownTab() {}
	
	    return onKeyDownTab;
	  }(),
	  onKeyDownArrowDown: function () {
	    function onKeyDownArrowDown() {}
	
	    return onKeyDownArrowDown;
	  }(),
	  onKeyDownQuestionMark: function () {
	    function onKeyDownQuestionMark() {}
	
	    return onKeyDownQuestionMark;
	  }(),
	
	
	  // i18n
	  phrases: _defaultPhrases.SingleDatePickerInputPhrases
	};
	
	function SingleDatePickerInput(_ref) {
	  var id = _ref.id,
	      placeholder = _ref.placeholder,
	      displayValue = _ref.displayValue,
	      focused = _ref.focused,
	      isFocused = _ref.isFocused,
	      disabled = _ref.disabled,
	      required = _ref.required,
	      readOnly = _ref.readOnly,
	      showCaret = _ref.showCaret,
	      showClearDate = _ref.showClearDate,
	      showDefaultInputIcon = _ref.showDefaultInputIcon,
	      inputIconPosition = _ref.inputIconPosition,
	      phrases = _ref.phrases,
	      onClearDate = _ref.onClearDate,
	      onChange = _ref.onChange,
	      onFocus = _ref.onFocus,
	      onKeyDownShiftTab = _ref.onKeyDownShiftTab,
	      onKeyDownTab = _ref.onKeyDownTab,
	      onKeyDownArrowDown = _ref.onKeyDownArrowDown,
	      onKeyDownQuestionMark = _ref.onKeyDownQuestionMark,
	      screenReaderMessage = _ref.screenReaderMessage,
	      customCloseIcon = _ref.customCloseIcon,
	      customInputIcon = _ref.customInputIcon,
	      openDirection = _ref.openDirection,
	      isRTL = _ref.isRTL,
	      noBorder = _ref.noBorder,
	      block = _ref.block,
	      small = _ref.small,
	      regular = _ref.regular,
	      verticalSpacing = _ref.verticalSpacing,
	      styles = _ref.styles;
	
	  var calendarIcon = customInputIcon || _react2['default'].createElement(_CalendarIcon2['default'], (0, _reactWithStyles.css)(styles.SingleDatePickerInput_calendarIcon_svg));
	  var closeIcon = customCloseIcon || _react2['default'].createElement(_CloseButton2['default'], (0, _reactWithStyles.css)(styles.SingleDatePickerInput_clearDate_svg, small && styles.SingleDatePickerInput_clearDate_svg__small));
	
	  var screenReaderText = screenReaderMessage || phrases.keyboardNavigationInstructions;
	  var inputIcon = (showDefaultInputIcon || customInputIcon !== null) && _react2['default'].createElement(
	    'button',
	    _extends({}, (0, _reactWithStyles.css)(styles.SingleDatePickerInput_calendarIcon), {
	      type: 'button',
	      disabled: disabled,
	      'aria-label': phrases.focusStartDate,
	      onClick: onFocus
	    }),
	    calendarIcon
	  );
	
	  return _react2['default'].createElement(
	    'div',
	    (0, _reactWithStyles.css)(styles.SingleDatePickerInput, disabled && styles.SingleDatePickerInput__disabled, isRTL && styles.SingleDatePickerInput__rtl, !noBorder && styles.SingleDatePickerInput__withBorder, block && styles.SingleDatePickerInput__block, showClearDate && styles.SingleDatePickerInput__showClearDate),
	    inputIconPosition === _constants.ICON_BEFORE_POSITION && inputIcon,
	    _react2['default'].createElement(_DateInput2['default'], {
	      id: id,
	      placeholder: placeholder // also used as label
	      , displayValue: displayValue,
	      screenReaderMessage: screenReaderText,
	      focused: focused,
	      isFocused: isFocused,
	      disabled: disabled,
	      required: required,
	      readOnly: readOnly,
	      showCaret: showCaret,
	      onChange: onChange,
	      onFocus: onFocus,
	      onKeyDownShiftTab: onKeyDownShiftTab,
	      onKeyDownTab: onKeyDownTab,
	      onKeyDownArrowDown: onKeyDownArrowDown,
	      onKeyDownQuestionMark: onKeyDownQuestionMark,
	      openDirection: openDirection,
	      verticalSpacing: verticalSpacing,
	      small: small,
	      regular: regular,
	      block: block
	    }),
	    showClearDate && _react2['default'].createElement(
	      'button',
	      _extends({}, (0, _reactWithStyles.css)(styles.SingleDatePickerInput_clearDate, small && styles.SingleDatePickerInput_clearDate__small, !customCloseIcon && styles.SingleDatePickerInput_clearDate__default, !displayValue && styles.SingleDatePickerInput_clearDate__hide), {
	        type: 'button',
	        'aria-label': phrases.clearDate,
	        disabled: disabled,
	        onMouseEnter: this.onClearDateMouseEnter,
	        onMouseLeave: this.onClearDateMouseLeave,
	        onClick: onClearDate
	      }),
	      closeIcon
	    ),
	    inputIconPosition === _constants.ICON_AFTER_POSITION && inputIcon
	  );
	}
	
	SingleDatePickerInput.propTypes = propTypes;
	SingleDatePickerInput.defaultProps = defaultProps;
	
	exports['default'] = (0, _reactWithStyles.withStyles)(function (_ref2) {
	  var color = _ref2.reactDates.color;
	  return {
	    SingleDatePickerInput: {
	      display: 'inline-block',
	      backgroundColor: color.background
	    },
	
	    SingleDatePickerInput__withBorder: {
	      border: '1px solid ' + String(color.core.border)
	    },
	
	    SingleDatePickerInput__rtl: {
	      direction: 'rtl'
	    },
	
	    SingleDatePickerInput__disabled: {
	      backgroundColor: color.disabled
	    },
	
	    SingleDatePickerInput__block: {
	      display: 'block'
	    },
	
	    SingleDatePickerInput__showClearDate: {
	      paddingRight: 30
	    },
	
	    SingleDatePickerInput_clearDate: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	
	      cursor: 'pointer',
	      padding: 10,
	      margin: '0 10px 0 5px',
	      position: 'absolute',
	      right: 0,
	      top: '50%',
	      transform: 'translateY(-50%)'
	    },
	
	    SingleDatePickerInput_clearDate__default: {
	      ':focus': {
	        background: color.core.border,
	        borderRadius: '50%'
	      },
	
	      ':hover': {
	        background: color.core.border,
	        borderRadius: '50%'
	      }
	    },
	
	    SingleDatePickerInput_clearDate__small: {
	      padding: 6
	    },
	
	    SingleDatePickerInput_clearDate__hide: {
	      visibility: 'hidden'
	    },
	
	    SingleDatePickerInput_clearDate_svg: {
	      fill: color.core.grayLight,
	      height: 12,
	      width: 15,
	      verticalAlign: 'middle'
	    },
	
	    SingleDatePickerInput_clearDate_svg__small: {
	      height: 9
	    },
	
	    SingleDatePickerInput_calendarIcon: {
	      background: 'none',
	      border: 0,
	      color: 'inherit',
	      font: 'inherit',
	      lineHeight: 'normal',
	      overflow: 'visible',
	
	      cursor: 'pointer',
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      padding: 10,
	      margin: '0 5px 0 10px'
	    },
	
	    SingleDatePickerInput_calendarIcon_svg: {
	      fill: color.core.grayLight,
	      height: 15,
	      width: 14,
	      verticalAlign: 'middle'
	    }
	  };
	})(SingleDatePickerInput);

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DISPLAY_FORMAT = exports.DISPLAY_FORMAT = 'L';
	var ISO_FORMAT = exports.ISO_FORMAT = 'YYYY-MM-DD';
	var ISO_MONTH_FORMAT = exports.ISO_MONTH_FORMAT = 'YYYY-MM';
	
	var START_DATE = exports.START_DATE = 'startDate';
	var END_DATE = exports.END_DATE = 'endDate';
	
	var HORIZONTAL_ORIENTATION = exports.HORIZONTAL_ORIENTATION = 'horizontal';
	var VERTICAL_ORIENTATION = exports.VERTICAL_ORIENTATION = 'vertical';
	var VERTICAL_SCROLLABLE = exports.VERTICAL_SCROLLABLE = 'verticalScrollable';
	
	var ICON_BEFORE_POSITION = exports.ICON_BEFORE_POSITION = 'before';
	var ICON_AFTER_POSITION = exports.ICON_AFTER_POSITION = 'after';
	
	var INFO_POSITION_TOP = exports.INFO_POSITION_TOP = 'top';
	var INFO_POSITION_BOTTOM = exports.INFO_POSITION_BOTTOM = 'bottom';
	var INFO_POSITION_BEFORE = exports.INFO_POSITION_BEFORE = 'before';
	var INFO_POSITION_AFTER = exports.INFO_POSITION_AFTER = 'after';
	
	var ANCHOR_LEFT = exports.ANCHOR_LEFT = 'left';
	var ANCHOR_RIGHT = exports.ANCHOR_RIGHT = 'right';
	
	var OPEN_DOWN = exports.OPEN_DOWN = 'down';
	var OPEN_UP = exports.OPEN_UP = 'up';
	
	var DAY_SIZE = exports.DAY_SIZE = 39;
	var BLOCKED_MODIFIER = exports.BLOCKED_MODIFIER = 'blocked';
	var WEEKDAYS = exports.WEEKDAYS = [0, 1, 2, 3, 4, 5, 6];
	
	var FANG_WIDTH_PX = exports.FANG_WIDTH_PX = 20;
	var FANG_HEIGHT_PX = exports.FANG_HEIGHT_PX = 10;
	var DEFAULT_VERTICAL_SPACING = exports.DEFAULT_VERTICAL_SPACING = 22;
	
	var MODIFIER_KEY_NAMES = exports.MODIFIER_KEY_NAMES = new Set(['Shift', 'Control', 'Alt', 'Meta']);

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var calendarLabel = 'Calendar';
	var closeDatePicker = 'Close';
	var focusStartDate = 'Interact with the calendar and add the check-in date for your trip.';
	var clearDate = 'Clear Date';
	var clearDates = 'Clear Dates';
	var jumpToPrevMonth = 'Move backward to switch to the previous month.';
	var jumpToNextMonth = 'Move forward to switch to the next month.';
	var keyboardShortcuts = 'Keyboard Shortcuts';
	var showKeyboardShortcutsPanel = 'Open the keyboard shortcuts panel.';
	var hideKeyboardShortcutsPanel = 'Close the shortcuts panel.';
	var openThisPanel = 'Open this panel.';
	var enterKey = 'Enter key';
	var leftArrowRightArrow = 'Right and left arrow keys';
	var upArrowDownArrow = 'up and down arrow keys';
	var pageUpPageDown = 'page up and page down keys';
	var homeEnd = 'Home and end keys';
	var escape = 'Escape key';
	var questionMark = 'Question mark';
	var selectFocusedDate = 'Select the date in focus.';
	var moveFocusByOneDay = 'Move backward (left) and forward (right) by one day.';
	var moveFocusByOneWeek = 'Move backward (up) and forward (down) by one week.';
	var moveFocusByOneMonth = 'Switch months.';
	var moveFocustoStartAndEndOfWeek = 'Go to the first or last day of a week.';
	var returnFocusToInput = 'Return to the date input field.';
	var keyboardNavigationInstructions = 'Press the down arrow key to interact with the calendar and\n  select a date. Press the question mark key to get the keyboard shortcuts for changing dates.';
	
	var chooseAvailableStartDate = function chooseAvailableStartDate(_ref) {
	  var date = _ref.date;
	  return 'Choose ' + String(date) + ' as your check-in date. It\'s available.';
	};
	var chooseAvailableEndDate = function chooseAvailableEndDate(_ref2) {
	  var date = _ref2.date;
	  return 'Choose ' + String(date) + ' as your check-out date. It\'s available.';
	};
	var chooseAvailableDate = function chooseAvailableDate(_ref3) {
	  var date = _ref3.date;
	  return date;
	};
	var dateIsUnavailable = function dateIsUnavailable(_ref4) {
	  var date = _ref4.date;
	  return 'Not available. ' + String(date);
	};
	var dateIsSelected = function dateIsSelected(_ref5) {
	  var date = _ref5.date;
	  return 'Selected. ' + String(date);
	};
	
	exports['default'] = {
	  calendarLabel: calendarLabel,
	  closeDatePicker: closeDatePicker,
	  focusStartDate: focusStartDate,
	  clearDate: clearDate,
	  clearDates: clearDates,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  keyboardNavigationInstructions: keyboardNavigationInstructions,
	
	  chooseAvailableStartDate: chooseAvailableStartDate,
	  chooseAvailableEndDate: chooseAvailableEndDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected
	};
	var DateRangePickerPhrases = exports.DateRangePickerPhrases = {
	  calendarLabel: calendarLabel,
	  closeDatePicker: closeDatePicker,
	  clearDates: clearDates,
	  focusStartDate: focusStartDate,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  keyboardNavigationInstructions: keyboardNavigationInstructions,
	  chooseAvailableStartDate: chooseAvailableStartDate,
	  chooseAvailableEndDate: chooseAvailableEndDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected
	};
	
	var DateRangePickerInputPhrases = exports.DateRangePickerInputPhrases = {
	  focusStartDate: focusStartDate,
	  clearDates: clearDates,
	  keyboardNavigationInstructions: keyboardNavigationInstructions
	};
	
	var SingleDatePickerPhrases = exports.SingleDatePickerPhrases = {
	  calendarLabel: calendarLabel,
	  closeDatePicker: closeDatePicker,
	  clearDate: clearDate,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  keyboardNavigationInstructions: keyboardNavigationInstructions,
	  chooseAvailableDate: chooseAvailableDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected
	};
	
	var SingleDatePickerInputPhrases = exports.SingleDatePickerInputPhrases = {
	  clearDate: clearDate,
	  keyboardNavigationInstructions: keyboardNavigationInstructions
	};
	
	var DayPickerPhrases = exports.DayPickerPhrases = {
	  calendarLabel: calendarLabel,
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth,
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput,
	  chooseAvailableStartDate: chooseAvailableStartDate,
	  chooseAvailableEndDate: chooseAvailableEndDate,
	  chooseAvailableDate: chooseAvailableDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected
	};
	
	var DayPickerKeyboardShortcutsPhrases = exports.DayPickerKeyboardShortcutsPhrases = {
	  keyboardShortcuts: keyboardShortcuts,
	  showKeyboardShortcutsPanel: showKeyboardShortcutsPanel,
	  hideKeyboardShortcutsPanel: hideKeyboardShortcutsPanel,
	  openThisPanel: openThisPanel,
	  enterKey: enterKey,
	  leftArrowRightArrow: leftArrowRightArrow,
	  upArrowDownArrow: upArrowDownArrow,
	  pageUpPageDown: pageUpPageDown,
	  homeEnd: homeEnd,
	  escape: escape,
	  questionMark: questionMark,
	  selectFocusedDate: selectFocusedDate,
	  moveFocusByOneDay: moveFocusByOneDay,
	  moveFocusByOneWeek: moveFocusByOneWeek,
	  moveFocusByOneMonth: moveFocusByOneMonth,
	  moveFocustoStartAndEndOfWeek: moveFocustoStartAndEndOfWeek,
	  returnFocusToInput: returnFocusToInput
	};
	
	var DayPickerNavigationPhrases = exports.DayPickerNavigationPhrases = {
	  jumpToPrevMonth: jumpToPrevMonth,
	  jumpToNextMonth: jumpToNextMonth
	};
	
	var CalendarDayPhrases = exports.CalendarDayPhrases = {
	  chooseAvailableDate: chooseAvailableDate,
	  dateIsUnavailable: dateIsUnavailable,
	  dateIsSelected: dateIsSelected
	};

/***/ }),

/***/ 532:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _CalendarDay = __webpack_require__(136);
	
	Object.defineProperty(exports, 'CalendarDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_CalendarDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _CalendarMonth = __webpack_require__(229);
	
	Object.defineProperty(exports, 'CalendarMonth', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_CalendarMonth)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _CalendarMonthGrid = __webpack_require__(230);
	
	Object.defineProperty(exports, 'CalendarMonthGrid', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_CalendarMonthGrid)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DateRangePicker = __webpack_require__(527);
	
	Object.defineProperty(exports, 'DateRangePicker', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DateRangePicker)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DateRangePickerInput = __webpack_require__(232);
	
	Object.defineProperty(exports, 'DateRangePickerInput', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DateRangePickerInput)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DateRangePickerInputController = __webpack_require__(233);
	
	Object.defineProperty(exports, 'DateRangePickerInputController', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DateRangePickerInputController)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DateRangePickerShape = __webpack_require__(240);
	
	Object.defineProperty(exports, 'DateRangePickerShape', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DateRangePickerShape)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DayPicker = __webpack_require__(137);
	
	Object.defineProperty(exports, 'DayPicker', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DayPicker)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DayPickerRangeController = __webpack_require__(234);
	
	Object.defineProperty(exports, 'DayPickerRangeController', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DayPickerRangeController)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _DayPickerSingleDateController = __webpack_require__(235);
	
	Object.defineProperty(exports, 'DayPickerSingleDateController', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_DayPickerSingleDateController)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _OutsideClickHandler = __webpack_require__(96);
	
	Object.defineProperty(exports, 'OutsideClickHandler', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_OutsideClickHandler)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _SingleDatePicker = __webpack_require__(531);
	
	Object.defineProperty(exports, 'SingleDatePicker', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_SingleDatePicker)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _SingleDatePickerInput = __webpack_require__(238);
	
	Object.defineProperty(exports, 'SingleDatePickerInput', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_SingleDatePickerInput)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _SingleDatePickerShape = __webpack_require__(243);
	
	Object.defineProperty(exports, 'SingleDatePickerShape', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_SingleDatePickerShape)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _isInclusivelyAfterDay = __webpack_require__(83);
	
	Object.defineProperty(exports, 'isInclusivelyAfterDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_isInclusivelyAfterDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _isInclusivelyBeforeDay = __webpack_require__(539);
	
	Object.defineProperty(exports, 'isInclusivelyBeforeDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_isInclusivelyBeforeDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _isNextDay = __webpack_require__(252);
	
	Object.defineProperty(exports, 'isNextDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_isNextDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _isSameDay = __webpack_require__(57);
	
	Object.defineProperty(exports, 'isSameDay', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_isSameDay)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _toISODateString = __webpack_require__(98);
	
	Object.defineProperty(exports, 'toISODateString', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_toISODateString)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _toLocalizedDateString = __webpack_require__(140);
	
	Object.defineProperty(exports, 'toLocalizedDateString', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_toLocalizedDateString)['default'];
	    }
	
	    return get;
	  }()
	});
	
	var _toMomentObject = __webpack_require__(58);
	
	Object.defineProperty(exports, 'toMomentObject', {
	  enumerable: true,
	  get: function () {
	    function get() {
	      return _interopRequireDefault(_toMomentObject)['default'];
	    }
	
	    return get;
	  }()
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/***/ }),

/***/ 533:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _registerCSSInterfaceWithDefaultTheme = __webpack_require__(541);
	
	var _registerCSSInterfaceWithDefaultTheme2 = _interopRequireDefault(_registerCSSInterfaceWithDefaultTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	(0, _registerCSSInterfaceWithDefaultTheme2['default'])();

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.ANCHOR_LEFT, _constants.ANCHOR_RIGHT]);

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.INFO_POSITION_TOP, _constants.INFO_POSITION_BOTTOM, _constants.INFO_POSITION_BEFORE, _constants.INFO_POSITION_AFTER]);

/***/ }),

/***/ 240:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMomentProptypes = __webpack_require__(38);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _FocusedInputShape = __webpack_require__(241);
	
	var _FocusedInputShape2 = _interopRequireDefault(_FocusedInputShape);
	
	var _IconPositionShape = __webpack_require__(80);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _OrientationShape = __webpack_require__(242);
	
	var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
	var _DisabledShape = __webpack_require__(97);
	
	var _DisabledShape2 = _interopRequireDefault(_DisabledShape);
	
	var _AnchorDirectionShape = __webpack_require__(239);
	
	var _AnchorDirectionShape2 = _interopRequireDefault(_AnchorDirectionShape);
	
	var _OpenDirectionShape = __webpack_require__(55);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _DayOfWeekShape = __webpack_require__(46);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _CalendarInfoPositionShape = __webpack_require__(79);
	
	var _CalendarInfoPositionShape2 = _interopRequireDefault(_CalendarInfoPositionShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  // required props for a functional interactive DateRangePicker
	  startDate: _reactMomentProptypes2['default'].momentObj,
	  endDate: _reactMomentProptypes2['default'].momentObj,
	  onDatesChange: _propTypes2['default'].func.isRequired,
	
	  focusedInput: _FocusedInputShape2['default'],
	  onFocusChange: _propTypes2['default'].func.isRequired,
	
	  onClose: _propTypes2['default'].func,
	
	  // input related props
	  startDateId: _propTypes2['default'].string.isRequired,
	  startDatePlaceholderText: _propTypes2['default'].string,
	  endDateId: _propTypes2['default'].string.isRequired,
	  endDatePlaceholderText: _propTypes2['default'].string,
	  disabled: _DisabledShape2['default'],
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  screenReaderInputMessage: _propTypes2['default'].string,
	  showClearDates: _propTypes2['default'].bool,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  customInputIcon: _propTypes2['default'].node,
	  customArrowIcon: _propTypes2['default'].node,
	  customCloseIcon: _propTypes2['default'].node,
	  noBorder: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  small: _propTypes2['default'].bool,
	  regular: _propTypes2['default'].bool,
	  keepFocusOnInput: _propTypes2['default'].bool,
	
	  // calendar presentation and interaction related props
	  renderMonth: _propTypes2['default'].func,
	  orientation: _OrientationShape2['default'],
	  anchorDirection: _AnchorDirectionShape2['default'],
	  openDirection: _OpenDirectionShape2['default'],
	  horizontalMargin: _propTypes2['default'].number,
	  withPortal: _propTypes2['default'].bool,
	  withFullScreenPortal: _propTypes2['default'].bool,
	  appendToBody: _propTypes2['default'].bool,
	  disableScroll: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isRTL: _propTypes2['default'].bool,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  initialVisibleMonth: _propTypes2['default'].func,
	  numberOfMonths: _propTypes2['default'].number,
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  reopenPickerOnClearDates: _propTypes2['default'].bool,
	  renderCalendarInfo: _propTypes2['default'].func,
	  calendarInfoPosition: _CalendarInfoPositionShape2['default'],
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	
	  // navigation related props
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	
	  // day presentation and interaction related props
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  minimumNights: _propTypes2['default'].number,
	  enableOutsideDays: _propTypes2['default'].bool,
	  isDayBlocked: _propTypes2['default'].func,
	  isOutsideRange: _propTypes2['default'].func,
	  isDayHighlighted: _propTypes2['default'].func,
	
	  // internationalization props
	  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.DateRangePickerPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string
	};

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf(_constants.WEEKDAYS);

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].oneOf([_constants.START_DATE, _constants.END_DATE])]);

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.START_DATE, _constants.END_DATE]);

/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.ICON_BEFORE_POSITION, _constants.ICON_AFTER_POSITION]);

/***/ }),

/***/ 55:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.OPEN_DOWN, _constants.OPEN_UP]);

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION]);

/***/ }),

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].oneOf([_constants.HORIZONTAL_ORIENTATION, _constants.VERTICAL_ORIENTATION, _constants.VERTICAL_SCROLLABLE]);

/***/ }),

/***/ 243:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactMomentProptypes = __webpack_require__(38);
	
	var _reactMomentProptypes2 = _interopRequireDefault(_reactMomentProptypes);
	
	var _airbnbPropTypes = __webpack_require__(14);
	
	var _defaultPhrases = __webpack_require__(20);
	
	var _getPhrasePropTypes = __webpack_require__(25);
	
	var _getPhrasePropTypes2 = _interopRequireDefault(_getPhrasePropTypes);
	
	var _IconPositionShape = __webpack_require__(80);
	
	var _IconPositionShape2 = _interopRequireDefault(_IconPositionShape);
	
	var _OrientationShape = __webpack_require__(242);
	
	var _OrientationShape2 = _interopRequireDefault(_OrientationShape);
	
	var _AnchorDirectionShape = __webpack_require__(239);
	
	var _AnchorDirectionShape2 = _interopRequireDefault(_AnchorDirectionShape);
	
	var _OpenDirectionShape = __webpack_require__(55);
	
	var _OpenDirectionShape2 = _interopRequireDefault(_OpenDirectionShape);
	
	var _DayOfWeekShape = __webpack_require__(46);
	
	var _DayOfWeekShape2 = _interopRequireDefault(_DayOfWeekShape);
	
	var _CalendarInfoPositionShape = __webpack_require__(79);
	
	var _CalendarInfoPositionShape2 = _interopRequireDefault(_CalendarInfoPositionShape);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  // required props for a functional interactive SingleDatePicker
	  date: _reactMomentProptypes2['default'].momentObj,
	  onDateChange: _propTypes2['default'].func.isRequired,
	
	  focused: _propTypes2['default'].bool,
	  onFocusChange: _propTypes2['default'].func.isRequired,
	
	  // input related props
	  id: _propTypes2['default'].string.isRequired,
	  placeholder: _propTypes2['default'].string,
	  disabled: _propTypes2['default'].bool,
	  required: _propTypes2['default'].bool,
	  readOnly: _propTypes2['default'].bool,
	  screenReaderInputMessage: _propTypes2['default'].string,
	  showClearDate: _propTypes2['default'].bool,
	  customCloseIcon: _propTypes2['default'].node,
	  showDefaultInputIcon: _propTypes2['default'].bool,
	  inputIconPosition: _IconPositionShape2['default'],
	  customInputIcon: _propTypes2['default'].node,
	  noBorder: _propTypes2['default'].bool,
	  block: _propTypes2['default'].bool,
	  small: _propTypes2['default'].bool,
	  regular: _propTypes2['default'].bool,
	  verticalSpacing: _airbnbPropTypes.nonNegativeInteger,
	  keepFocusOnInput: _propTypes2['default'].bool,
	
	  // calendar presentation and interaction related props
	  renderMonth: _propTypes2['default'].func,
	  orientation: _OrientationShape2['default'],
	  anchorDirection: _AnchorDirectionShape2['default'],
	  openDirection: _OpenDirectionShape2['default'],
	  horizontalMargin: _propTypes2['default'].number,
	  withPortal: _propTypes2['default'].bool,
	  withFullScreenPortal: _propTypes2['default'].bool,
	  appendToBody: _propTypes2['default'].bool,
	  disableScroll: _propTypes2['default'].bool,
	  initialVisibleMonth: _propTypes2['default'].func,
	  firstDayOfWeek: _DayOfWeekShape2['default'],
	  numberOfMonths: _propTypes2['default'].number,
	  keepOpenOnDateSelect: _propTypes2['default'].bool,
	  reopenPickerOnClearDate: _propTypes2['default'].bool,
	  renderCalendarInfo: _propTypes2['default'].func,
	  calendarInfoPosition: _CalendarInfoPositionShape2['default'],
	  hideKeyboardShortcutsPanel: _propTypes2['default'].bool,
	  daySize: _airbnbPropTypes.nonNegativeInteger,
	  isRTL: _propTypes2['default'].bool,
	  verticalHeight: _airbnbPropTypes.nonNegativeInteger,
	  transitionDuration: _airbnbPropTypes.nonNegativeInteger,
	
	  // navigation related props
	  navPrev: _propTypes2['default'].node,
	  navNext: _propTypes2['default'].node,
	
	  onPrevMonthClick: _propTypes2['default'].func,
	  onNextMonthClick: _propTypes2['default'].func,
	  onClose: _propTypes2['default'].func,
	
	  // day presentation and interaction related props
	  renderCalendarDay: _propTypes2['default'].func,
	  renderDayContents: _propTypes2['default'].func,
	  enableOutsideDays: _propTypes2['default'].bool,
	  isDayBlocked: _propTypes2['default'].func,
	  isOutsideRange: _propTypes2['default'].func,
	  isDayHighlighted: _propTypes2['default'].func,
	
	  // internationalization props
	  displayFormat: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	  monthFormat: _propTypes2['default'].string,
	  weekDayFormat: _propTypes2['default'].string,
	  phrases: _propTypes2['default'].shape((0, _getPhrasePropTypes2['default'])(_defaultPhrases.SingleDatePickerPhrases)),
	  dayAriaLabelFormat: _propTypes2['default'].string
	};

/***/ }),

/***/ 244:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var core = {
	  white: '#fff',
	  gray: '#484848',
	  grayLight: '#82888a',
	  grayLighter: '#cacccd',
	  grayLightest: '#f2f2f2',
	
	  borderMedium: '#c4c4c4',
	  border: '#dbdbdb',
	  borderLight: '#e4e7e7',
	  borderLighter: '#eceeee',
	  borderBright: '#f4f5f5',
	
	  primary: '#00a699',
	  primaryShade_1: '#33dacd',
	  primaryShade_2: '#66e2da',
	  primaryShade_3: '#80e8e0',
	  primaryShade_4: '#b2f1ec',
	  primary_dark: '#008489',
	
	  secondary: '#007a87',
	
	  yellow: '#ffe8bc',
	  yellow_dark: '#ffce71'
	};
	
	exports['default'] = {
	  reactDates: {
	    zIndex: 0,
	    border: {
	      input: {
	        border: 0,
	        borderTop: 0,
	        borderRight: 0,
	        borderBottom: '2px solid transparent',
	        borderLeft: 0,
	        outlineFocused: 0,
	        borderFocused: 0,
	        borderTopFocused: 0,
	        borderLeftFocused: 0,
	        borderBottomFocused: '2px solid ' + String(core.primary_dark),
	        borderRightFocused: 0,
	        borderRadius: 0
	      }
	    },
	
	    color: {
	      core: core,
	
	      disabled: core.grayLightest,
	
	      background: core.white,
	      backgroundDark: '#f2f2f2',
	      backgroundFocused: core.white,
	      border: 'rgb(219, 219, 219)',
	      text: core.gray,
	      textDisabled: core.border,
	      textFocused: '#007a87',
	      placeholderText: '#757575',
	
	      outside: {
	        backgroundColor: core.white,
	        backgroundColor_active: core.white,
	        backgroundColor_hover: core.white,
	        color: core.gray,
	        color_active: core.gray,
	        color_hover: core.gray
	      },
	
	      highlighted: {
	        backgroundColor: core.yellow,
	        backgroundColor_active: core.yellow_dark,
	        backgroundColor_hover: core.yellow_dark,
	        color: core.gray,
	        color_active: core.gray,
	        color_hover: core.gray
	      },
	
	      minimumNights: {
	        backgroundColor: core.white,
	        backgroundColor_active: core.white,
	        backgroundColor_hover: core.white,
	        borderColor: core.borderLighter,
	        color: core.grayLighter,
	        color_active: core.grayLighter,
	        color_hover: core.grayLighter
	      },
	
	      hoveredSpan: {
	        backgroundColor: core.primaryShade_4,
	        backgroundColor_active: core.primaryShade_3,
	        backgroundColor_hover: core.primaryShade_4,
	        borderColor: core.primaryShade_3,
	        borderColor_active: core.primaryShade_3,
	        borderColor_hover: core.primaryShade_3,
	        color: core.secondary,
	        color_active: core.secondary,
	        color_hover: core.secondary
	      },
	
	      selectedSpan: {
	        backgroundColor: core.primaryShade_2,
	        backgroundColor_active: core.primaryShade_1,
	        backgroundColor_hover: core.primaryShade_1,
	        borderColor: core.primaryShade_1,
	        borderColor_active: core.primary,
	        borderColor_hover: core.primary,
	        color: core.white,
	        color_active: core.white,
	        color_hover: core.white
	      },
	
	      selected: {
	        backgroundColor: core.primary,
	        backgroundColor_active: core.primary,
	        backgroundColor_hover: core.primary,
	        borderColor: core.primary,
	        borderColor_active: core.primary,
	        borderColor_hover: core.primary,
	        color: core.white,
	        color_active: core.white,
	        color_hover: core.white
	      },
	
	      blocked_calendar: {
	        backgroundColor: core.grayLighter,
	        backgroundColor_active: core.grayLighter,
	        backgroundColor_hover: core.grayLighter,
	        borderColor: core.grayLighter,
	        borderColor_active: core.grayLighter,
	        borderColor_hover: core.grayLighter,
	        color: core.grayLight,
	        color_active: core.grayLight,
	        color_hover: core.grayLight
	      },
	
	      blocked_out_of_range: {
	        backgroundColor: core.white,
	        backgroundColor_active: core.white,
	        backgroundColor_hover: core.white,
	        borderColor: core.borderLight,
	        borderColor_active: core.borderLight,
	        borderColor_hover: core.borderLight,
	        color: core.grayLighter,
	        color_active: core.grayLighter,
	        color_hover: core.grayLighter
	      }
	    },
	
	    spacing: {
	      captionPaddingTop: 22,
	      captionPaddingBottom: 37,
	      inputPadding: 0,
	      displayTextPaddingVertical: undefined,
	      displayTextPaddingTop: 11,
	      displayTextPaddingBottom: 9,
	      displayTextPaddingHorizontal: undefined,
	      displayTextPaddingLeft: 11,
	      displayTextPaddingRight: 11,
	      displayTextPaddingVertical_small: undefined,
	      displayTextPaddingTop_small: 7,
	      displayTextPaddingBottom_small: 5,
	      displayTextPaddingHorizontal_small: undefined,
	      displayTextPaddingLeft_small: 7,
	      displayTextPaddingRight_small: 7
	    },
	
	    sizing: {
	      inputWidth: 130,
	      inputWidth_small: 97,
	      arrowWidth: 24
	    },
	
	    font: {
	      size: 14,
	      captionSize: 18,
	      input: {
	        size: 19,
	        lineHeight: '24px',
	        size_small: 15,
	        lineHeight_small: '18px',
	        letterSpacing_small: '0.2px',
	        styleDisabled: 'italic'
	      }
	    }
	  }
	};

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = calculateDimension;
	function calculateDimension(el, axis) {
	  var borderBox = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  var withMargin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	  if (!el) {
	    return 0;
	  }
	
	  var axisStart = axis === 'width' ? 'Left' : 'Top';
	  var axisEnd = axis === 'width' ? 'Right' : 'Bottom';
	
	  // Only read styles if we need to
	  var style = !borderBox || withMargin ? window.getComputedStyle(el) : null;
	
	  // Offset includes border and padding
	  var offsetWidth = el.offsetWidth,
	      offsetHeight = el.offsetHeight;
	
	  var size = axis === 'width' ? offsetWidth : offsetHeight;
	
	  // Get the inner size
	  if (!borderBox) {
	    size -= parseFloat(style['padding' + axisStart]) + parseFloat(style['padding' + axisEnd]) + parseFloat(style['border' + axisStart + 'Width']) + parseFloat(style['border' + axisEnd + 'Width']);
	  }
	
	  // Apply margin
	  if (withMargin) {
	    size += parseFloat(style['margin' + axisStart]) + parseFloat(style['margin' + axisEnd]);
	  }
	
	  return size;
	}

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getScrollParent = getScrollParent;
	exports.getScrollAncestorsOverflowY = getScrollAncestorsOverflowY;
	exports['default'] = disableScroll;
	var getScrollingRoot = function getScrollingRoot() {
	  return document.scrollingElement || document.documentElement;
	};
	
	/**
	 * Recursively finds the scroll parent of a node. The scroll parrent of a node
	 * is the closest node that is scrollable. A node is scrollable if:
	 *  - it is allowed to scroll via CSS ('overflow-y' not visible or hidden);
	 *  - and its children/content are "bigger" than the node's box height.
	 *
	 * The root of the document always scrolls by default.
	 *
	 * @param {HTMLElement} node Any DOM element.
	 * @return {HTMLElement} The scroll parent element.
	 */
	function getScrollParent(node) {
	  var parent = node.parentElement;
	
	  if (parent == null) return getScrollingRoot();
	
	  var _window$getComputedSt = window.getComputedStyle(parent),
	      overflowY = _window$getComputedSt.overflowY;
	
	  var canScroll = overflowY !== 'visible' && overflowY !== 'hidden';
	
	  if (canScroll && parent.scrollHeight > parent.clientHeight) {
	    return parent;
	  }
	
	  return getScrollParent(parent);
	}
	
	/**
	 * Recursively traverses the tree upwards from the given node, capturing all
	 * ancestor nodes that scroll along with their current 'overflow-y' CSS
	 * property.
	 *
	 * @param {HTMLElement} node Any DOM element.
	 * @param {Map<HTMLElement,string>} [acc] Accumulator map.
	 * @return {Map<HTMLElement,string>} Map of ancestors with their 'overflow-y' value.
	 */
	function getScrollAncestorsOverflowY(node) {
	  var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Map();
	
	  var scrollingRoot = getScrollingRoot();
	  var scrollParent = getScrollParent(node);
	  acc.set(scrollParent, scrollParent.style.overflowY);
	
	  if (scrollParent === scrollingRoot) return acc;
	  return getScrollAncestorsOverflowY(scrollParent, acc);
	}
	
	/**
	 * Disabling the scroll on a node involves finding all the scrollable ancestors
	 * and set their 'overflow-y' CSS property to 'hidden'. When all ancestors have
	 * 'overflow-y: hidden' (up to the document element) there is no scroll
	 * container, thus all the scroll outside of the node is disabled. In order to
	 * enable scroll again, we store the previous value of the 'overflow-y' for
	 * every ancestor in a closure and reset it back.
	 *
	 * @param {HTMLElement} node Any DOM element.
	 */
	function disableScroll(node) {
	  var scrollAncestorsOverflowY = getScrollAncestorsOverflowY(node);
	  var toggle = function toggle(on) {
	    return scrollAncestorsOverflowY.forEach(function (overflowY, ancestor) {
	      ancestor.style.setProperty('overflow-y', on ? 'hidden' : overflowY);
	    });
	  };
	
	  toggle(true);
	  return function () {
	    return toggle(false);
	  };
	}

/***/ }),

/***/ 534:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getActiveElement;
	function getActiveElement() {
	  return typeof document !== 'undefined' && document.activeElement;
	}

/***/ }),

/***/ 247:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getCalendarDaySettings;
	
	var _getPhrase = __webpack_require__(536);
	
	var _getPhrase2 = _interopRequireDefault(_getPhrase);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getCalendarDaySettings(day, ariaLabelFormat, daySize, modifiers, phrases) {
	  var chooseAvailableDate = phrases.chooseAvailableDate,
	      dateIsUnavailable = phrases.dateIsUnavailable,
	      dateIsSelected = phrases.dateIsSelected;
	
	
	  var daySizeStyles = {
	    width: daySize,
	    height: daySize - 1
	  };
	
	  var useDefaultCursor = modifiers.has('blocked-minimum-nights') || modifiers.has('blocked-calendar') || modifiers.has('blocked-out-of-range');
	
	  var selected = modifiers.has('selected') || modifiers.has('selected-start') || modifiers.has('selected-end');
	
	  var hoveredSpan = !selected && (modifiers.has('hovered-span') || modifiers.has('after-hovered-start'));
	
	  var isOutsideRange = modifiers.has('blocked-out-of-range');
	
	  var formattedDate = { date: day.format(ariaLabelFormat) };
	
	  var ariaLabel = (0, _getPhrase2['default'])(chooseAvailableDate, formattedDate);
	  if (modifiers.has(_constants.BLOCKED_MODIFIER)) {
	    ariaLabel = (0, _getPhrase2['default'])(dateIsUnavailable, formattedDate);
	  } else if (selected) {
	    ariaLabel = (0, _getPhrase2['default'])(dateIsSelected, formattedDate);
	  }
	
	  return {
	    daySizeStyles: daySizeStyles,
	    useDefaultCursor: useDefaultCursor,
	    selected: selected,
	    hoveredSpan: hoveredSpan,
	    isOutsideRange: isOutsideRange,
	    ariaLabel: ariaLabel
	  };
	}

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getCalendarMonthWeeks;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getCalendarMonthWeeks(month, enableOutsideDays) {
	  var firstDayOfWeek = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _moment2['default'].localeData().firstDayOfWeek();
	
	  if (!_moment2['default'].isMoment(month) || !month.isValid()) {
	    throw new TypeError('`month` must be a valid moment object');
	  }
	  if (_constants.WEEKDAYS.indexOf(firstDayOfWeek) === -1) {
	    throw new TypeError('`firstDayOfWeek` must be an integer between 0 and 6');
	  }
	
	  // set utc offset to get correct dates in future (when timezone changes)
	  var firstOfMonth = month.clone().startOf('month').hour(12);
	  var lastOfMonth = month.clone().endOf('month').hour(12);
	
	  // calculate the exact first and last days to fill the entire matrix
	  // (considering days outside month)
	  var prevDays = (firstOfMonth.day() + 7 - firstDayOfWeek) % 7;
	  var nextDays = (firstDayOfWeek + 6 - lastOfMonth.day()) % 7;
	  var firstDay = firstOfMonth.clone().subtract(prevDays, 'day');
	  var lastDay = lastOfMonth.clone().add(nextDays, 'day');
	
	  var totalDays = lastDay.diff(firstDay, 'days') + 1;
	
	  var currentDay = firstDay.clone();
	  var weeksInMonth = [];
	
	  for (var i = 0; i < totalDays; i += 1) {
	    if (i % 7 === 0) {
	      weeksInMonth.push([]);
	    }
	
	    var day = null;
	    if (i >= prevDays && i < totalDays - nextDays || enableOutsideDays) {
	      day = currentDay.clone();
	    }
	
	    weeksInMonth[weeksInMonth.length - 1].push(day);
	
	    currentDay.add(1, 'day');
	  }
	
	  return weeksInMonth;
	}

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getCalendarMonthWidth;
	var CALENDAR_MONTH_PADDING = 9;
	
	function getCalendarMonthWidth(daySize) {
	  return 7 * (daySize + 1) + 2 * (CALENDAR_MONTH_PADDING + 1);
	}

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getDetachedContainerStyles;
	
	var _constants = __webpack_require__(7);
	
	/**
	 * Calculate and return a CSS transform style to position a detached element
	 * next to a reference element. The open and anchor direction indicate wether
	 * it should be positioned above/below and/or to the left/right of the
	 * reference element.
	 *
	 * Assuming r(0,0), r(1,1), d(0,0), d(1,1) for the bottom-left and top-right
	 * corners of the reference and detached elements, respectively:
	 *  - openDirection = DOWN, anchorDirection = LEFT => d(0,1) == r(0,1)
	 *  - openDirection = UP, anchorDirection = LEFT => d(0,0) == r(0,0)
	 *  - openDirection = DOWN, anchorDirection = RIGHT => d(1,1) == r(1,1)
	 *  - openDirection = UP, anchorDirection = RIGHT => d(1,0) == r(1,0)
	 *
	 * By using a CSS transform, we allow to further position it using
	 * top/bottom CSS properties for the anchor gutter.
	 *
	 * @param {string} openDirection The vertical positioning of the popup
	 * @param {string} anchorDirection The horizontal position of the popup
	 * @param {HTMLElement} referenceEl The reference element
	 */
	function getDetachedContainerStyles(openDirection, anchorDirection, referenceEl) {
	  var referenceRect = referenceEl.getBoundingClientRect();
	  var offsetX = referenceRect.left;
	  var offsetY = referenceRect.top;
	
	  if (openDirection === _constants.OPEN_UP) {
	    offsetY = -(window.innerHeight - referenceRect.bottom);
	  }
	
	  if (anchorDirection === _constants.ANCHOR_RIGHT) {
	    offsetX = -(window.innerWidth - referenceRect.right);
	  }
	
	  return {
	    transform: 'translate3d(' + String(Math.round(offsetX)) + 'px, ' + String(Math.round(offsetY)) + 'px, 0)'
	  };
	}

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getInputHeight;
	/* eslint-disable camelcase */
	
	function getPadding(vertical, top, bottom) {
	  var isTopDefined = typeof top === 'number';
	  var isBottomDefined = typeof bottom === 'number';
	  var isVerticalDefined = typeof vertical === 'number';
	
	  if (isTopDefined && isBottomDefined) {
	    return top + bottom;
	  }
	
	  if (isTopDefined && isVerticalDefined) {
	    return top + vertical;
	  }
	
	  if (isTopDefined) {
	    return top;
	  }
	
	  if (isBottomDefined && isVerticalDefined) {
	    return bottom + vertical;
	  }
	
	  if (isBottomDefined) {
	    return bottom;
	  }
	
	  if (isVerticalDefined) {
	    return 2 * vertical;
	  }
	
	  return 0;
	}
	
	function getInputHeight(_ref, small) {
	  var _ref$font$input = _ref.font.input,
	      lineHeight = _ref$font$input.lineHeight,
	      lineHeight_small = _ref$font$input.lineHeight_small,
	      _ref$spacing = _ref.spacing,
	      inputPadding = _ref$spacing.inputPadding,
	      displayTextPaddingVertical = _ref$spacing.displayTextPaddingVertical,
	      displayTextPaddingTop = _ref$spacing.displayTextPaddingTop,
	      displayTextPaddingBottom = _ref$spacing.displayTextPaddingBottom,
	      displayTextPaddingVertical_small = _ref$spacing.displayTextPaddingVertical_small,
	      displayTextPaddingTop_small = _ref$spacing.displayTextPaddingTop_small,
	      displayTextPaddingBottom_small = _ref$spacing.displayTextPaddingBottom_small;
	
	  var calcLineHeight = small ? lineHeight_small : lineHeight;
	
	  var padding = small ? getPadding(displayTextPaddingVertical_small, displayTextPaddingTop_small, displayTextPaddingBottom_small) : getPadding(displayTextPaddingVertical, displayTextPaddingTop, displayTextPaddingBottom);
	
	  return parseInt(calcLineHeight, 10) + 2 * inputPadding + padding;
	}

/***/ }),

/***/ 536:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getPhrase;
	function getPhrase(phrase, args) {
	  if (typeof phrase === 'string') return phrase;
	
	  if (typeof phrase === 'function') {
	    return phrase(args);
	  }
	
	  return '';
	}

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getPhrasePropTypes;
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getPhrasePropTypes(defaultPhrases) {
	  return Object.keys(defaultPhrases).reduce(function (phrases, key) {
	    return (0, _object2['default'])({}, phrases, _defineProperty({}, key, _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func, _propTypes2['default'].node])));
	  }, {});
	}

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getResponsiveContainerStyles;
	
	var _constants = __webpack_require__(7);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function getResponsiveContainerStyles(anchorDirection, currentOffset, containerEdge, margin) {
	  var windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;
	  var calculatedOffset = anchorDirection === _constants.ANCHOR_LEFT ? windowWidth - containerEdge : containerEdge;
	  var calculatedMargin = margin || 0;
	
	  return _defineProperty({}, anchorDirection, Math.min(currentOffset + calculatedOffset - calculatedMargin, 0));
	}

/***/ }),

/***/ 537:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getSelectedDateOffset;
	var defaultModifier = function defaultModifier(day) {
	  return day;
	};
	
	function getSelectedDateOffset(fn, day) {
	  var modifier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultModifier;
	
	  if (!fn) return day;
	  return modifier(fn(day.clone()));
	}

/***/ }),

/***/ 538:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getTransformStyles;
	function getTransformStyles(transformValue) {
	  return {
	    transform: transformValue,
	    msTransform: transformValue,
	    MozTransform: transformValue,
	    WebkitTransform: transformValue
	  };
	}

/***/ }),

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getVisibleDays;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toISOMonthString = __webpack_require__(99);
	
	var _toISOMonthString2 = _interopRequireDefault(_toISOMonthString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getVisibleDays(month, numberOfMonths, enableOutsideDays, withoutTransitionMonths) {
	  if (!_moment2['default'].isMoment(month)) return {};
	
	  var visibleDaysByMonth = {};
	  var currentMonth = withoutTransitionMonths ? month.clone() : month.clone().subtract(1, 'month');
	  for (var i = 0; i < (withoutTransitionMonths ? numberOfMonths : numberOfMonths + 2); i += 1) {
	    var visibleDays = [];
	
	    // set utc offset to get correct dates in future (when timezone changes)
	    var baseDate = currentMonth.clone();
	    var firstOfMonth = baseDate.clone().startOf('month').hour(12);
	    var lastOfMonth = baseDate.clone().endOf('month').hour(12);
	
	    var currentDay = firstOfMonth.clone();
	
	    // days belonging to the previous month
	    if (enableOutsideDays) {
	      for (var j = 0; j < currentDay.weekday(); j += 1) {
	        var prevDay = currentDay.clone().subtract(j + 1, 'day');
	        visibleDays.unshift(prevDay);
	      }
	    }
	
	    while (currentDay < lastOfMonth) {
	      visibleDays.push(currentDay.clone());
	      currentDay.add(1, 'day');
	    }
	
	    if (enableOutsideDays) {
	      // weekday() returns the index of the day of the week according to the locale
	      // this means if the week starts on Monday, weekday() will return 0 for a Monday date, not 1
	      if (currentDay.weekday() !== 0) {
	        // days belonging to the next month
	        for (var k = currentDay.weekday(), count = 0; k < 7; k += 1, count += 1) {
	          var nextDay = currentDay.clone().add(count, 'day');
	          visibleDays.push(nextDay);
	        }
	      }
	    }
	
	    visibleDaysByMonth[(0, _toISOMonthString2['default'])(currentMonth)] = visibleDays;
	    currentMonth = currentMonth.clone().add(1, 'month');
	  }
	
	  return visibleDaysByMonth;
	}

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isAfterDay;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isBeforeDay = __webpack_require__(82);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	var _isSameDay = __webpack_require__(57);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isAfterDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return !(0, _isBeforeDay2['default'])(a, b) && !(0, _isSameDay2['default'])(a, b);
	}

/***/ }),

/***/ 82:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isBeforeDay;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isBeforeDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	
	  var aYear = a.year();
	  var aMonth = a.month();
	
	  var bYear = b.year();
	  var bMonth = b.month();
	
	  var isSameYear = aYear === bYear;
	  var isSameMonth = aMonth === bMonth;
	
	  if (isSameYear && isSameMonth) return a.date() < b.date();
	  if (isSameYear) return aMonth < bMonth;
	  return aYear < bYear;
	}

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isDayVisible;
	
	var _isBeforeDay = __webpack_require__(82);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	var _isAfterDay = __webpack_require__(81);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isDayVisible(day, month, numberOfMonths, enableOutsideDays) {
	  var firstDayOfFirstMonth = month.clone().startOf('month');
	  if (enableOutsideDays) firstDayOfFirstMonth = firstDayOfFirstMonth.startOf('week');
	  if ((0, _isBeforeDay2['default'])(day, firstDayOfFirstMonth)) return false;
	
	  var lastDayOfLastMonth = month.clone().add(numberOfMonths - 1, 'months').endOf('month');
	  if (enableOutsideDays) lastDayOfLastMonth = lastDayOfLastMonth.endOf('week');
	  return !(0, _isAfterDay2['default'])(day, lastDayOfLastMonth);
	}

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isInclusivelyAfterDay;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isBeforeDay = __webpack_require__(82);
	
	var _isBeforeDay2 = _interopRequireDefault(_isBeforeDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isInclusivelyAfterDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return !(0, _isBeforeDay2['default'])(a, b);
	}

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isInclusivelyBeforeDay;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isAfterDay = __webpack_require__(81);
	
	var _isAfterDay2 = _interopRequireDefault(_isAfterDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isInclusivelyBeforeDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  return !(0, _isAfterDay2['default'])(a, b);
	}

/***/ }),

/***/ 252:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isNextDay;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _isSameDay = __webpack_require__(57);
	
	var _isSameDay2 = _interopRequireDefault(_isSameDay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isNextDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  var nextDay = (0, _moment2['default'])(a).add(1, 'day');
	  return (0, _isSameDay2['default'])(nextDay, b);
	}

/***/ }),

/***/ 57:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isSameDay;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isSameDay(a, b) {
	  if (!_moment2['default'].isMoment(a) || !_moment2['default'].isMoment(b)) return false;
	  // Compare least significant, most likely to change units first
	  // Moment's isSame clones moment inputs and is a tad slow
	  return a.date() === b.date() && a.month() === b.month() && a.year() === b.year();
	}

/***/ }),

/***/ 540:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = isTransitionEndSupported;
	function isTransitionEndSupported() {
	  return !!(typeof window !== 'undefined' && 'TransitionEvent' in window);
	}

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = registerCSSInterfaceWithDefaultTheme;
	
	var _reactWithStylesInterfaceCss = __webpack_require__(563);
	
	var _reactWithStylesInterfaceCss2 = _interopRequireDefault(_reactWithStylesInterfaceCss);
	
	var _registerInterfaceWithDefaultTheme = __webpack_require__(542);
	
	var _registerInterfaceWithDefaultTheme2 = _interopRequireDefault(_registerInterfaceWithDefaultTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function registerCSSInterfaceWithDefaultTheme() {
	  (0, _registerInterfaceWithDefaultTheme2['default'])(_reactWithStylesInterfaceCss2['default']);
	}

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = registerInterfaceWithDefaultTheme;
	
	var _ThemedStyleSheet = __webpack_require__(266);
	
	var _ThemedStyleSheet2 = _interopRequireDefault(_ThemedStyleSheet);
	
	var _DefaultTheme = __webpack_require__(244);
	
	var _DefaultTheme2 = _interopRequireDefault(_DefaultTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function registerInterfaceWithDefaultTheme(reactWithStylesInterface) {
	  _ThemedStyleSheet2['default'].registerInterface(reactWithStylesInterface);
	  _ThemedStyleSheet2['default'].registerTheme(_DefaultTheme2['default']);
	}

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toISODateString;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toMomentObject = __webpack_require__(58);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toISODateString(date, currentFormat) {
	  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
	  if (!dateObj) return null;
	
	  return dateObj.format(_constants.ISO_FORMAT);
	}

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toISOMonthString;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toMomentObject = __webpack_require__(58);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toISOMonthString(date, currentFormat) {
	  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
	  if (!dateObj) return null;
	
	  return dateObj.format(_constants.ISO_MONTH_FORMAT);
	}

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toLocalizedDateString;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _toMomentObject = __webpack_require__(58);
	
	var _toMomentObject2 = _interopRequireDefault(_toMomentObject);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toLocalizedDateString(date, currentFormat) {
	  var dateObj = _moment2['default'].isMoment(date) ? date : (0, _toMomentObject2['default'])(date, currentFormat);
	  if (!dateObj) return null;
	
	  return dateObj.format(_constants.DISPLAY_FORMAT);
	}

/***/ }),

/***/ 58:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toMomentObject;
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _constants = __webpack_require__(7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toMomentObject(dateString, customFormat) {
	  var dateFormats = customFormat ? [customFormat, _constants.DISPLAY_FORMAT, _constants.ISO_FORMAT] : [_constants.DISPLAY_FORMAT, _constants.ISO_FORMAT];
	
	  var date = (0, _moment2['default'])(dateString, dateFormats, true);
	  return date.isValid() ? date.hour(12) : null;
	}

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(37);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var useCreatePortal = typeof _reactDom2.default.createPortal === 'function';
	var isBrowser = typeof window !== 'undefined';
	
	var Portal = function (_Component) {
	  _inherits(Portal, _Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (isBrowser) {
	        if (!this.props.container) {
	          this.container = document.createElement('div');
	          document.body.appendChild(this.container);
	        } else {
	          this.container = this.props.container;
	        }
	        this.renderLayer();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!useCreatePortal) {
	        _reactDom2.default.unmountComponentAtNode(this.container);
	      }
	      if (!this.props.container) {
	        document.body.removeChild(this.container);
	      }
	    }
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      if (!useCreatePortal) {
	        _reactDom2.default.unstable_renderSubtreeIntoContainer(this, this.props.children, this.container);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (useCreatePortal) {
	        return _reactDom2.default.createPortal(this.props.children, this.container);
	      }
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node, // eslint-disable-line
	  container: _propTypes2.default.object // eslint-disable-line
	};
	
	exports.default = Portal;

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

	var messages = {
	  invalidPredicate: '`predicate` must be a function',
	  invalidPropValidator: '`propValidator` must be a function',
	  requiredCore: 'is marked as required',
	  invalidTypeCore: 'Invalid input type',
	  predicateFailureCore: 'Failed to succeed with predicate',
	  anonymousMessage: '<<anonymous>>',
	  baseInvalidMessage: 'Invalid ',
	};
	
	function constructPropValidatorVariations(propValidator) {
	  if (typeof propValidator !== 'function') {
	    throw new Error(messages.invalidPropValidator);
	  }
	
	  var requiredPropValidator = propValidator.bind(null, false, null);
	  requiredPropValidator.isRequired = propValidator.bind(null, true, null);
	
	  requiredPropValidator.withPredicate = function predicateApplication(predicate) {
	    if (typeof predicate !== 'function') {
	      throw new Error(messages.invalidPredicate);
	    }
	    var basePropValidator = propValidator.bind(null, false, predicate);
	    basePropValidator.isRequired = propValidator.bind(null, true, predicate);
	    return basePropValidator;
	  };
	
	  return requiredPropValidator;
	}
	
	function createInvalidRequiredErrorMessage(propName, componentName, value) {
	  return new Error(
	    'The prop `' + propName + '` ' + messages.requiredCore +
	    ' in `' + componentName + '`, but its value is `' + value + '`.'
	  );
	}
	
	var independentGuardianValue = -1;
	
	function preValidationRequireCheck(isRequired, componentName, propFullName, propValue) {
	  var isPropValueUndefined = typeof propValue === 'undefined';
	  var isPropValueNull = propValue === null;
	
	  if (isRequired) {
	    if (isPropValueUndefined) {
	      return createInvalidRequiredErrorMessage(propFullName, componentName, 'undefined');
	    } else if (isPropValueNull) {
	      return createInvalidRequiredErrorMessage(propFullName, componentName, 'null');
	    }
	  }
	
	  if (isPropValueUndefined || isPropValueNull) {
	    return null;
	  }
	
	  return independentGuardianValue;
	}
	
	function createMomentChecker(type, typeValidator, validator, momentType) {
	
	  function propValidator(
	    isRequired, // Bound parameter to indicate with the propType is required
	    predicate, // Bound parameter to allow user to add dynamic validation
	    props,
	    propName,
	    componentName,
	    location,
	    propFullName
	  ) {
	    var propValue = props[ propName ];
	    var propType = typeof propValue;
	
	    componentName = componentName || messages.anonymousMessage;
	    propFullName = propFullName || propName;
	
	    var preValidationRequireCheckValue = preValidationRequireCheck(
	      isRequired, componentName, propFullName, propValue
	    );
	
	    if (preValidationRequireCheckValue !== independentGuardianValue) {
	      return preValidationRequireCheckValue;
	    }
	
	    if (typeValidator && !typeValidator(propValue)) {
	      return new Error(
	        messages.invalidTypeCore + ': `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + type + '`.'
	      );
	    }
	
	    if (!validator(propValue)) {
	      return new Error(
	        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`, expected `' + momentType + '`.'
	      );
	    }
	
	    if (predicate && !predicate(propValue)) {
	      var predicateName = predicate.name || messages.anonymousMessage;
	      return new Error(
	        messages.baseInvalidMessage + location + ' `' + propName + '` of type `' + propType + '` ' +
	        'supplied to `' + componentName + '`. ' + messages.predicateFailureCore + ' `' +
	        predicateName + '`.'
	      );
	    }
	
	    return null;
	
	  }
	
	  return constructPropValidatorVariations(propValidator);
	
	}
	
	module.exports = {
	  constructPropValidatorVariations: constructPropValidatorVariations,
	  createMomentChecker: createMomentChecker,
	  messages: messages,
	};


/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(8);
	var momentValidationWrapper = __webpack_require__(545);
	var core = __webpack_require__(544);
	
	module.exports = {
	
	  momentObj : core.createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(value);
	    },
	    'Moment'
	  ),
	
	  momentString : core.createMomentChecker(
	    'string',
	    function(str) {
	      return typeof str === 'string';
	    },
	    function isValid(value) {
	      return momentValidationWrapper.isValidMoment(moment(value));
	    },
	    'Moment'
	  ),
	
	  momentDurationObj : core.createMomentChecker(
	    'object',
	    function(obj) {
	      return typeof obj === 'object';
	    },
	    function isValid(value) {
	      return moment.isDuration(value);
	    },
	    'Duration'
	  ),
	
	};


/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	var moment = __webpack_require__(8);
	
	function isValidMoment(testMoment) {
	  if (typeof moment.isMoment === 'function' && !moment.isMoment(testMoment)) {
	    return false;
	  }
	
	  /* istanbul ignore else  */
	  if (typeof testMoment.isValid === 'function') {
	    // moment 1.7.0+
	    return testMoment.isValid();
	  }
	
	  /* istanbul ignore next */
	  return !isNaN(testMoment);
	}
	
	module.exports = {
	  isValidMoment : isValidMoment,
	};


/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(37);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This file is a fallback for a consumer who is not yet on React 16
	// as createPortal was introduced in React 16
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(props) {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _reactDom2.default.unmountComponentAtNode(this.defaultNode || this.props.node);
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	      this.portal = null;
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	
	      var children = this.props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof this.props.children.type === 'function') {
	        children = _react2.default.cloneElement(this.props.children);
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};

/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(37);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(549);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!_utils.canUseDOM) {
	        return null;
	      }
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	      return _reactDom2.default.createPortal(this.props.children, this.props.node || this.defaultNode);
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};
	
	exports.default = Portal;

/***/ }),

/***/ 257:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(37);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Portal = __webpack_require__(547);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _LegacyPortal = __webpack_require__(546);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Portal = void 0;
	
	if (_reactDom2.default.createPortal) {
	  Portal = _Portal2.default;
	} else {
	  Portal = _LegacyPortal2.default;
	}
	
	exports.default = Portal;

/***/ }),

/***/ 548:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PortalCompat = __webpack_require__(257);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var PortalWithState = function (_React$Component) {
	  _inherits(PortalWithState, _React$Component);
	
	  function PortalWithState(props) {
	    _classCallCheck(this, PortalWithState);
	
	    var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));
	
	    _this.portalNode = null;
	    _this.state = { active: !!props.defaultOpen };
	    _this.openPortal = _this.openPortal.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    return _this;
	  }
	
	  _createClass(PortalWithState, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal(e) {
	      if (this.state.active) {
	        return;
	      }
	      if (e && e.nativeEvent) {
	        e.nativeEvent.stopImmediatePropagation();
	      }
	      this.setState({ active: true }, this.props.onOpen);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      if (!this.state.active) {
	        return;
	      }
	      this.setState({ active: false }, this.props.onClose);
	    }
	  }, {
	    key: 'wrapWithPortal',
	    value: function wrapWithPortal(children) {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _PortalCompat2.default,
	        {
	          node: this.props.node,
	          key: 'react-portal',
	          ref: function ref(portalNode) {
	            return _this2.portalNode = portalNode;
	          }
	        },
	        children
	      );
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	      var root = this.portalNode.props.node || this.portalNode.defaultNode;
	      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        openPortal: this.openPortal,
	        closePortal: this.closePortal,
	        portal: this.wrapWithPortal,
	        isOpen: this.state.active
	      });
	    }
	  }]);
	
	  return PortalWithState;
	}(_react2.default.Component);
	
	PortalWithState.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  defaultOpen: _propTypes2.default.bool,
	  node: _propTypes2.default.any,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func
	};
	
	PortalWithState.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {}
	};
	
	exports.default = PortalWithState;

/***/ }),

/***/ 258:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PortalWithState = exports.Portal = undefined;
	
	var _PortalCompat = __webpack_require__(257);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	var _PortalWithState = __webpack_require__(548);
	
	var _PortalWithState2 = _interopRequireDefault(_PortalWithState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Portal = _PortalCompat2.default;
	exports.PortalWithState = _PortalWithState2.default;

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var PropTypes = _interopDefault(__webpack_require__(3));
	var reactLifecyclesCompat = __webpack_require__(111);
	var Portal = _interopDefault(__webpack_require__(256));
	var CSSTransition = _interopDefault(__webpack_require__(264));
	var cx = _interopDefault(__webpack_require__(15));
	var noScroll = _interopDefault(__webpack_require__(211));
	var FocusTrap = _interopDefault(__webpack_require__(204));
	
	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	    var ownKeys = Object.keys(source);
	
	    if (typeof Object.getOwnPropertySymbols === 'function') {
	      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
	      }));
	    }
	
	    ownKeys.forEach(function (key) {
	      _defineProperty(target, key, source[key]);
	    });
	  }
	
	  return target;
	}
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf(subClass, superClass);
	}
	
	function _getPrototypeOf(o) {
	  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	function _setPrototypeOf(o, p) {
	  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (typeof call === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return _assertThisInitialized(self);
	}
	
	var CloseIcon = function CloseIcon(_ref) {
	  var classes = _ref.classes,
	      classNames = _ref.classNames,
	      styles = _ref.styles,
	      closeIconSize = _ref.closeIconSize,
	      closeIconSvgPath = _ref.closeIconSvgPath,
	      onClickCloseIcon = _ref.onClickCloseIcon,
	      id = _ref.id;
	  return React__default.createElement("button", {
	    className: cx(classes.closeButton, classNames.closeButton),
	    style: styles.closeButton,
	    onClick: onClickCloseIcon,
	    id: id
	  }, React__default.createElement("svg", {
	    className: cx(classes.closeIcon, classNames.closeIcon),
	    style: styles.closeIcon,
	    xmlns: "http://www.w3.org/2000/svg",
	    width: closeIconSize,
	    height: closeIconSize,
	    viewBox: "0 0 36 36"
	  }, closeIconSvgPath));
	};
	
	CloseIcon.propTypes = {
	  classNames: PropTypes.object.isRequired,
	  styles: PropTypes.object.isRequired,
	  classes: PropTypes.object.isRequired,
	  closeIconSize: PropTypes.number.isRequired,
	  closeIconSvgPath: PropTypes.node.isRequired,
	  onClickCloseIcon: PropTypes.func.isRequired,
	  id: PropTypes.string
	};
	CloseIcon.defaultProps = {
	  id: null
	};
	
	var _modals = [];
	/**
	 * Handle the order of the modals.
	 * Inspired by the material-ui implementation.
	 */
	
	var modalManager = {
	  /**
	   * Return the modals array
	   */
	  modals: function modals() {
	    return _modals;
	  },
	
	  /**
	   * Register a new modal
	   */
	  add: function add(modal) {
	    if (_modals.indexOf(modal) === -1) {
	      _modals.push(modal);
	    }
	  },
	
	  /**
	   * Remove a modal
	   */
	  remove: function remove(modal) {
	    var index = _modals.indexOf(modal);
	
	    if (index !== -1) {
	      _modals.splice(index, 1);
	    }
	  },
	
	  /**
	   * Check if the modal is the first one on the screen
	   */
	  isTopModal: function isTopModal(modal) {
	    return !!_modals.length && _modals[_modals.length - 1] === modal;
	  }
	};
	
	function styleInject(css, ref) {
	  if ( ref === void 0 ) ref = {};
	  var insertAt = ref.insertAt;
	
	  if (!css || typeof document === 'undefined') { return; }
	
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}
	
	var css = ".styles_overlay__CLSq- {\n  background: rgba(0, 0, 0, 0.75);\n  display: flex;\n  align-items: flex-start;\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  z-index: 1000;\n  padding: 1.2rem;\n}\n.styles_overlayCenter__YHoO7 {\n  align-items: center;\n}\n.styles_modal__gNwvD {\n  max-width: 800px;\n  position: relative;\n  padding: 1.2rem;\n  background: #ffffff;\n  background-clip: padding-box;\n  box-shadow: 0 12px 15px 0 rgba(0, 0, 0, 0.25);\n  margin: auto;\n}\n.styles_closeButton__20ID4 {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  border: none;\n  padding: 0;\n  background-color: transparent;\n  display: flex;\n}\n.styles_closeIcon__1QwbI {\n}\n.styles_transitionEnter__3j_-a {\n  opacity: 0.01;\n}\n.styles_transitionEnterActive___eQs7 {\n  opacity: 1;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n.styles_transitionExit__1KmEf {\n  opacity: 1;\n}\n.styles_transitionExitActive__1nQXw {\n  opacity: 0.01;\n  transition: opacity 500ms cubic-bezier(0.23, 1, 0.32, 1);\n}\n";
	var cssClasses = {"overlay":"styles_overlay__CLSq-","overlayCenter":"styles_overlayCenter__YHoO7","modal":"styles_modal__gNwvD","closeButton":"styles_closeButton__20ID4","closeIcon":"styles_closeIcon__1QwbI","transitionEnter":"styles_transitionEnter__3j_-a","transitionEnterActive":"styles_transitionEnterActive___eQs7","transitionExit":"styles_transitionExit__1KmEf","transitionExitActive":"styles_transitionExitActive__1nQXw"};
	styleInject(css,{"insertAt":"top"});
	
	var Modal =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Modal)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "shouldClose", null);
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	      showPortal: _this.props.open
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleOpen", function () {
	      modalManager.add(_assertThisInitialized(_assertThisInitialized(_this)));
	
	      if (_this.props.blockScroll) {
	        Modal.blockScroll();
	      }
	
	      document.addEventListener('keydown', _this.handleKeydown);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClose", function () {
	      modalManager.remove(_assertThisInitialized(_assertThisInitialized(_this)));
	
	      if (_this.props.blockScroll) {
	        _this.unblockScroll();
	      }
	
	      document.removeEventListener('keydown', _this.handleKeydown);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickOverlay", function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (!_this.shouldClose) {
	        _this.shouldClose = null;
	        return;
	      }
	
	      if (_this.props.onOverlayClick) {
	        _this.props.onOverlayClick(event);
	      }
	
	      if (_this.props.closeOnOverlayClick) {
	        _this.props.onClose(event);
	      }
	
	      _this.shouldClose = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleClickCloseIcon", function (event) {
	      _this.props.onClose(event);
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleKeydown", function (event) {
	      // Only the last modal need to be escaped when pressing the esc key
	      if (event.keyCode !== 27 || !modalManager.isTopModal(_assertThisInitialized(_assertThisInitialized(_this)))) {
	        return;
	      }
	
	      if (_this.props.onEscKeyDown) {
	        _this.props.onEscKeyDown(event);
	      }
	
	      if (_this.props.closeOnEsc) {
	        _this.props.onClose(event);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleModalEvent", function () {
	      _this.shouldClose = false;
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleEntered", function () {
	      if (_this.props.onEntered) {
	        _this.props.onEntered();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleExited", function () {
	      if (_this.props.onExited) {
	        _this.props.onExited();
	      }
	
	      _this.setState({
	        showPortal: false
	      });
	
	      if (_this.props.blockScroll) {
	        _this.unblockScroll();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "unblockScroll", function () {
	      // Restore the scroll only if there is no modal on the screen
	      if (modalManager.modals().length === 0) {
	        noScroll.off();
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // Block scroll when initial prop is open
	      if (this.props.open) {
	        this.handleOpen();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.showPortal && !this.state.showPortal) {
	        this.handleClose();
	      } else if (!prevProps.open && this.props.open) {
	        this.handleOpen();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.props.open) {
	        this.handleClose();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          open = _this$props.open,
	          center = _this$props.center,
	          classes = _this$props.classes,
	          classNames = _this$props.classNames,
	          styles = _this$props.styles,
	          showCloseIcon = _this$props.showCloseIcon,
	          closeIconSize = _this$props.closeIconSize,
	          closeIconSvgPath = _this$props.closeIconSvgPath,
	          animationDuration = _this$props.animationDuration,
	          container = _this$props.container,
	          focusTrapped = _this$props.focusTrapped,
	          focusTrapOptions = _this$props.focusTrapOptions,
	          overlayId = _this$props.overlayId,
	          modalId = _this$props.modalId,
	          closeIconId = _this$props.closeIconId;
	      var showPortal = this.state.showPortal;
	
	      if (!showPortal) {
	        return null;
	      }
	
	      return React__default.createElement(Portal, {
	        container: container
	      }, React__default.createElement(CSSTransition, {
	        in: open,
	        appear: true,
	        classNames: {
	          appear: classNames.transitionEnter || classes.transitionEnter,
	          appearActive: classNames.transitionEnterActive || classes.transitionEnterActive,
	          enter: classNames.transitionEnter || classes.transitionEnter,
	          enterActive: classNames.transitionEnterActive || classes.transitionEnterActive,
	          exit: classNames.transitionExit || classes.transitionExit,
	          exitActive: classNames.transitionExitActive || classes.transitionExitActive
	        },
	        timeout: animationDuration,
	        onEntered: this.handleEntered,
	        onExited: this.handleExited
	      }, React__default.createElement("div", {
	        className: cx(classes.overlay, center ? classes.overlayCenter : null, classNames.overlay),
	        onClick: this.handleClickOverlay,
	        style: styles.overlay,
	        id: overlayId
	      }, focusTrapped ? React__default.createElement("div", {
	        className: cx(classes.modal, classNames.modal),
	        style: styles.modal,
	        onMouseDown: this.handleModalEvent,
	        onMouseUp: this.handleModalEvent,
	        onClick: this.handleModalEvent,
	        id: modalId
	      }, React__default.createElement(FocusTrap, {
	        focusTrapOptions: _objectSpread({}, {
	          clickOutsideDeactivates: true
	        }, focusTrapOptions)
	      }, this.props.children, showCloseIcon && React__default.createElement(CloseIcon, {
	        classes: classes,
	        classNames: classNames,
	        styles: styles,
	        closeIconSize: closeIconSize,
	        closeIconSvgPath: closeIconSvgPath,
	        onClickCloseIcon: this.handleClickCloseIcon,
	        id: closeIconId
	      }))) : React__default.createElement("div", {
	        className: cx(classes.modal, classNames.modal),
	        style: styles.modal,
	        onMouseDown: this.handleModalEvent,
	        onMouseUp: this.handleModalEvent,
	        onClick: this.handleModalEvent,
	        id: modalId
	      }, this.props.children, showCloseIcon && React__default.createElement(CloseIcon, {
	        classes: classes,
	        classNames: classNames,
	        styles: styles,
	        closeIconSize: closeIconSize,
	        closeIconSvgPath: closeIconSvgPath,
	        onClickCloseIcon: this.handleClickCloseIcon,
	        id: closeIconId
	      })))));
	    }
	  }], [{
	    key: "blockScroll",
	    value: function blockScroll() {
	      noScroll.on();
	    }
	  }, {
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (!prevState.showPortal && nextProps.open) {
	        return {
	          showPortal: true
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Modal;
	}(React.Component);
	
	Modal.propTypes = {
	  /**
	   * Is the modal closable when user press esc key.
	   */
	  closeOnEsc: PropTypes.bool,
	
	  /**
	   * Is the modal closable when user click on overlay.
	   */
	  closeOnOverlayClick: PropTypes.bool,
	
	  /**
	   * Callback fired when the Modal is open and the animation is finished.
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired when the Modal has exited and the animation is finished.
	   */
	  onExited: PropTypes.func,
	
	  /**
	   * Callback fired when the Modal is requested to be closed by a click on the overlay or when user press esc key.
	   */
	  onClose: PropTypes.func.isRequired,
	
	  /**
	   * Callback fired when the escape key is pressed.
	   */
	  onEscKeyDown: PropTypes.func,
	
	  /**
	   * Callback fired when the overlay is clicked.
	   */
	  onOverlayClick: PropTypes.func,
	
	  /**
	   * Control if the modal is open or not.
	   */
	  open: PropTypes.bool.isRequired,
	
	  /**
	   * An object containing classNames to style the modal, can have properties 'overlay' (classname for overlay div), 'modal' (classname for modal content div), 'closeButton' (classname for the button that contain the close icon), 'closeIcon' (classname for close icon svg). You can customize the transition with 'transitionEnter', 'transitionEnterActive', 'transitionExit', 'transitionExitActive'
	   */
	  classNames: PropTypes.object,
	
	  /**
	   * An object containing the styles objects to style the modal, can have properties 'overlay', 'modal', 'closeButton', 'closeIcon'.
	   */
	  styles: PropTypes.object,
	
	  /**
	   * The content of the modal.
	   */
	  children: PropTypes.node,
	
	  /**
	   * @internal
	   */
	  classes: PropTypes.object,
	
	  /**
	   * Should the dialog be centered.
	   */
	  center: PropTypes.bool,
	
	  /**
	   * Show the close icon.
	   */
	  showCloseIcon: PropTypes.bool,
	
	  /**
	   * Close icon size.
	   */
	  closeIconSize: PropTypes.number,
	
	  /**
	   * A valid svg path to show as icon.
	   */
	  closeIconSvgPath: PropTypes.node,
	
	  /**
	   * Animation duration in milliseconds.
	   */
	  animationDuration: PropTypes.number,
	
	  /**
	   * You can specify a container prop which should be of type `Element`. The portal will be rendered inside that element. The default behavior will create a div node and render it at the at the end of document.body.
	   */
	  container: PropTypes.object,
	  // eslint-disable-line
	
	  /**
	   * Whether to block scrolling when dialog is open
	   */
	  blockScroll: PropTypes.bool,
	
	  /**
	   * When the modal is open, trap focus within it
	   */
	  focusTrapped: PropTypes.bool,
	
	  /**
	   * Options to be passed to the focus trap, details available at https://github.com/davidtheclark/focus-trap#focustrap--createfocustrapelement-createoptions
	   */
	  focusTrapOptions: PropTypes.object,
	
	  /**
	   * id attribute for overlay
	   */
	  overlayId: PropTypes.string,
	
	  /**
	   * id attribute for modal
	   */
	  modalId: PropTypes.string,
	
	  /**
	   * id attribute for close icon
	   */
	  closeIconId: PropTypes.string
	};
	Modal.defaultProps = {
	  classes: cssClasses,
	  closeOnEsc: true,
	  closeOnOverlayClick: true,
	  onEntered: null,
	  onExited: null,
	  onEscKeyDown: null,
	  onOverlayClick: null,
	  showCloseIcon: true,
	  closeIconSize: 28,
	  closeIconSvgPath: React__default.createElement("path", {
	    d: "M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
	  }),
	  classNames: {},
	  styles: {},
	  children: null,
	  center: false,
	  animationDuration: 500,
	  blockScroll: true,
	  focusTrapped: false,
	  focusTrapOptions: {},
	  overlayId: null,
	  modalId: null,
	  closeIconId: null
	};
	reactLifecyclesCompat.polyfill(Modal);
	
	module.exports = Modal;
	//# sourceMappingURL=index.js.map


/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(3));
	
	var _addClass = _interopRequireDefault(__webpack_require__(449));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(450));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Transition = _interopRequireDefault(__webpack_require__(265));
	
	var _PropTypes = __webpack_require__(112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(3));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(37));
	
	var _reactLifecyclesCompat = __webpack_require__(111);
	
	var _PropTypes = __webpack_require__(112);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(3));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CHANNEL = exports.CHANNEL = '__direction__';
	
	var DIRECTIONS = exports.DIRECTIONS = {
	  LTR: 'ltr',
	  RTL: 'rtl'
	};

/***/ }),

/***/ 558:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _propTypes2['default'].shape({
	  getState: _propTypes2['default'].func,
	  setState: _propTypes2['default'].func,
	  subscribe: _propTypes2['default'].func
	});

/***/ }),

/***/ 559:
/***/ (function(module, exports, __webpack_require__) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _arrayPrototype = __webpack_require__(320);
	
	var _arrayPrototype2 = _interopRequireDefault(_arrayPrototype);
	
	var _globalCache = __webpack_require__(486);
	
	var _globalCache2 = _interopRequireDefault(_globalCache);
	
	var _constants = __webpack_require__(560);
	
	var _getClassName = __webpack_require__(561);
	
	var _getClassName2 = _interopRequireDefault(_getClassName);
	
	var _separateStyles2 = __webpack_require__(562);
	
	var _separateStyles3 = _interopRequireDefault(_separateStyles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Function required as part of the react-with-styles interface. Parses the styles provided by
	 * react-with-styles to produce class names based on the style name and optionally the namespace if
	 * available.
	 *
	 * stylesObject {Object} The styles object passed to withStyles.
	 *
	 * Return an object mapping style names to class names.
	 */
	function create(stylesObject) {
	  var stylesToClasses = {};
	  var styleNames = Object.keys(stylesObject);
	  var sharedState = _globalCache2['default'].get(_constants.GLOBAL_CACHE_KEY) || {};
	  var _sharedState$namespac = sharedState.namespace,
	      namespace = _sharedState$namespac === undefined ? '' : _sharedState$namespac;
	
	  styleNames.forEach(function (styleName) {
	    var className = (0, _getClassName2['default'])(namespace, styleName);
	    stylesToClasses[styleName] = className;
	  });
	  return stylesToClasses;
	}
	
	/**
	 * Process styles to be consumed by a component.
	 *
	 * stylesArray {Array} Array of the following: values returned by create, plain JavaScript objects
	 * representing inline styles, or arrays thereof.
	 *
	 * Return an object with optional className and style properties to be spread on a component.
	 */
	function resolve(stylesArray) {
	  var flattenedStyles = (0, _arrayPrototype2['default'])(stylesArray, Infinity);
	
	  var _separateStyles = (0, _separateStyles3['default'])(flattenedStyles),
	      classNames = _separateStyles.classNames,
	      hasInlineStyles = _separateStyles.hasInlineStyles,
	      inlineStyles = _separateStyles.inlineStyles;
	
	  var specificClassNames = classNames.map(function (name, index) {
	    return String(name) + ' ' + String(name) + '_' + String(index + 1);
	  });
	  var className = specificClassNames.join(' ');
	
	  var result = { className: className };
	  if (hasInlineStyles) result.style = inlineStyles;
	  return result;
	}
	
	exports['default'] = { create: create, resolve: resolve };

/***/ }),

/***/ 560:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var GLOBAL_CACHE_KEY = 'reactWithStylesInterfaceCSS';
	var MAX_SPECIFICITY = 20;
	
	exports.GLOBAL_CACHE_KEY = GLOBAL_CACHE_KEY;
	exports.MAX_SPECIFICITY = MAX_SPECIFICITY;

/***/ }),

/***/ 561:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = getClassName;
	/**
	 * Construct a class name.
	 *
	 * namespace {String} Used to construct unique class names.
	 * styleName {String} Name identifying the specific style.
	 *
	 * Return the class name.
	 */
	function getClassName(namespace, styleName) {
	  var namespaceSegment = namespace.length > 0 ? String(namespace) + '__' : '';
	  return '' + namespaceSegment + String(styleName);
	}

/***/ }),

/***/ 562:
/***/ (function(module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// This function takes an array of styles and separates them into styles that
	// are handled by Aphrodite and inline styles.
	function separateStyles(stylesArray) {
	  var classNames = [];
	
	  // Since determining if an Object is empty requires collecting all of its
	  // keys, and we want the best performance in this code because we are in the
	  // render path, we are going to do a little bookkeeping ourselves.
	  var hasInlineStyles = false;
	  var inlineStyles = {};
	
	  // This is run on potentially every node in the tree when rendering, where
	  // performance is critical. Normally we would prefer using `forEach`, but
	  // old-fashioned for loops are faster so that's what we have chosen here.
	  for (var i = 0; i < stylesArray.length; i++) {
	    // eslint-disable-line no-plusplus
	    var style = stylesArray[i];
	
	    // If this  style is falsy, we just want to disregard it. This allows for
	    // syntax like:
	    //
	    //   css(isFoo && styles.foo)
	    if (style) {
	      if (typeof style === 'string') {
	        classNames.push(style);
	      } else {
	        Object.assign(inlineStyles, style);
	        hasInlineStyles = true;
	      }
	    }
	  }
	
	  return {
	    classNames: classNames,
	    hasInlineStyles: hasInlineStyles,
	    inlineStyles: inlineStyles
	  };
	}
	
	exports['default'] = separateStyles;

/***/ }),

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	// eslint-disable-next-line import/no-unresolved
	module.exports = __webpack_require__(559).default;


/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var styleInterface = void 0;
	var styleTheme = void 0;
	
	var START_MARK = 'react-with-styles.resolve.start';
	var END_MARK = 'react-with-styles.resolve.end';
	var MEASURE_MARK = '\uD83D\uDC69\u200D\uD83C\uDFA8 [resolve]';
	
	function registerTheme(theme) {
	  styleTheme = theme;
	}
	
	function registerInterface(interfaceToRegister) {
	  styleInterface = interfaceToRegister;
	}
	
	function create(makeFromTheme, createWithDirection) {
	  var styles = createWithDirection(makeFromTheme(styleTheme));
	  return function () {
	    return styles;
	  };
	}
	
	function createLTR(makeFromTheme) {
	  return create(makeFromTheme, styleInterface.createLTR || styleInterface.create);
	}
	
	function createRTL(makeFromTheme) {
	  return create(makeFromTheme, styleInterface.createRTL || styleInterface.create);
	}
	
	function get() {
	  return styleTheme;
	}
	
	function resolve() {
	  if (false) {
	    performance.clearMarks(START_MARK);
	    performance.mark(START_MARK);
	  }
	
	  for (var _len = arguments.length, styles = Array(_len), _key = 0; _key < _len; _key++) {
	    styles[_key] = arguments[_key];
	  }
	
	  var result = styleInterface.resolve(styles);
	
	  if (false) {
	    performance.clearMarks(END_MARK);
	    performance.mark(END_MARK);
	
	    performance.measure(MEASURE_MARK, START_MARK, END_MARK);
	    performance.clearMarks(MEASURE_MARK);
	  }
	
	  return result;
	}
	
	function resolveLTR() {
	  for (var _len2 = arguments.length, styles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    styles[_key2] = arguments[_key2];
	  }
	
	  if (styleInterface.resolveLTR) {
	    return styleInterface.resolveLTR(styles);
	  }
	
	  return resolve(styles);
	}
	
	function resolveRTL() {
	  for (var _len3 = arguments.length, styles = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    styles[_key3] = arguments[_key3];
	  }
	
	  if (styleInterface.resolveRTL) {
	    return styleInterface.resolveRTL(styles);
	  }
	
	  return resolve(styles);
	}
	
	function flush() {
	  if (styleInterface.flush) {
	    styleInterface.flush();
	  }
	}
	
	exports['default'] = {
	  registerTheme: registerTheme,
	  registerInterface: registerInterface,
	  create: createLTR,
	  createLTR: createLTR,
	  createRTL: createRTL,
	  get: get,
	  resolve: resolveLTR,
	  resolveLTR: resolveLTR,
	  resolveRTL: resolveRTL,
	  flush: flush
	};

/***/ }),

/***/ 26:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withStylesPropTypes = exports.css = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.withStyles = withStyles;
	
	var _object = __webpack_require__(19);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(159);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _constants = __webpack_require__(557);
	
	var _brcast = __webpack_require__(558);
	
	var _brcast2 = _interopRequireDefault(_brcast);
	
	var _ThemedStyleSheet = __webpack_require__(266);
	
	var _ThemedStyleSheet2 = _interopRequireDefault(_ThemedStyleSheet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint react/forbid-foreign-prop-types: off */
	
	// Add some named exports to assist in upgrading and for convenience
	var css = exports.css = _ThemedStyleSheet2['default'].resolveLTR;
	var withStylesPropTypes = exports.withStylesPropTypes = {
	  styles: _propTypes2['default'].object.isRequired, // eslint-disable-line react/forbid-prop-types
	  theme: _propTypes2['default'].object.isRequired, // eslint-disable-line react/forbid-prop-types
	  css: _propTypes2['default'].func.isRequired
	};
	
	var EMPTY_STYLES = {};
	var EMPTY_STYLES_FN = function EMPTY_STYLES_FN() {
	  return EMPTY_STYLES;
	};
	
	var START_MARK = 'react-with-styles.createStyles.start';
	var END_MARK = 'react-with-styles.createStyles.end';
	
	function baseClass(pureComponent) {
	  if (pureComponent) {
	    if (!_react2['default'].PureComponent) {
	      throw new ReferenceError('withStyles() pureComponent option requires React 15.3.0 or later');
	    }
	
	    return _react2['default'].PureComponent;
	  }
	
	  return _react2['default'].Component;
	}
	
	var contextTypes = _defineProperty({}, _constants.CHANNEL, _brcast2['default']);
	
	var defaultDirection = _constants.DIRECTIONS.LTR;
	
	function withStyles(styleFn) {
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$stylesPropName = _ref.stylesPropName,
	      stylesPropName = _ref$stylesPropName === undefined ? 'styles' : _ref$stylesPropName,
	      _ref$themePropName = _ref.themePropName,
	      themePropName = _ref$themePropName === undefined ? 'theme' : _ref$themePropName,
	      _ref$cssPropName = _ref.cssPropName,
	      cssPropName = _ref$cssPropName === undefined ? 'css' : _ref$cssPropName,
	      _ref$flushBefore = _ref.flushBefore,
	      flushBefore = _ref$flushBefore === undefined ? false : _ref$flushBefore,
	      _ref$pureComponent = _ref.pureComponent,
	      pureComponent = _ref$pureComponent === undefined ? false : _ref$pureComponent;
	
	  var styleDefLTR = void 0;
	  var styleDefRTL = void 0;
	  var currentThemeLTR = void 0;
	  var currentThemeRTL = void 0;
	  var BaseClass = baseClass(pureComponent);
	
	  function getResolveMethod(direction) {
	    return direction === _constants.DIRECTIONS.LTR ? _ThemedStyleSheet2['default'].resolveLTR : _ThemedStyleSheet2['default'].resolveRTL;
	  }
	
	  function getCurrentTheme(direction) {
	    return direction === _constants.DIRECTIONS.LTR ? currentThemeLTR : currentThemeRTL;
	  }
	
	  function getStyleDef(direction, wrappedComponentName) {
	    var currentTheme = getCurrentTheme(direction);
	    var styleDef = direction === _constants.DIRECTIONS.LTR ? styleDefLTR : styleDefRTL;
	
	    var registeredTheme = _ThemedStyleSheet2['default'].get();
	
	    // Return the existing styles if they've already been defined
	    // and if the theme used to create them corresponds to the theme
	    // registered with ThemedStyleSheet
	    if (styleDef && currentTheme === registeredTheme) {
	      return styleDef;
	    }
	
	    if (false) {
	      performance.clearMarks(START_MARK);
	      performance.mark(START_MARK);
	    }
	
	    var isRTL = direction === _constants.DIRECTIONS.RTL;
	
	    if (isRTL) {
	      styleDefRTL = styleFn ? _ThemedStyleSheet2['default'].createRTL(styleFn) : EMPTY_STYLES_FN;
	
	      currentThemeRTL = registeredTheme;
	      styleDef = styleDefRTL;
	    } else {
	      styleDefLTR = styleFn ? _ThemedStyleSheet2['default'].createLTR(styleFn) : EMPTY_STYLES_FN;
	
	      currentThemeLTR = registeredTheme;
	      styleDef = styleDefLTR;
	    }
	
	    if (false) {
	      performance.clearMarks(END_MARK);
	      performance.mark(END_MARK);
	
	      var measureName = '\uD83D\uDC69\u200D\uD83C\uDFA8 withStyles(' + String(wrappedComponentName) + ') [create styles]';
	
	      performance.measure(measureName, START_MARK, END_MARK);
	      performance.clearMarks(measureName);
	    }
	
	    return styleDef;
	  }
	
	  function getState(direction, wrappedComponentName) {
	    return {
	      resolveMethod: getResolveMethod(direction),
	      styleDef: getStyleDef(direction, wrappedComponentName)
	    };
	  }
	
	  return function () {
	    function withStylesHOC(WrappedComponent) {
	      var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	      // NOTE: Use a class here so components are ref-able if need be:
	      // eslint-disable-next-line react/prefer-stateless-function
	
	      var WithStyles = function (_BaseClass) {
	        _inherits(WithStyles, _BaseClass);
	
	        function WithStyles(props, context) {
	          _classCallCheck(this, WithStyles);
	
	          var _this = _possibleConstructorReturn(this, (WithStyles.__proto__ || Object.getPrototypeOf(WithStyles)).call(this, props, context));
	
	          var direction = _this.context[_constants.CHANNEL] ? _this.context[_constants.CHANNEL].getState() : defaultDirection;
	
	          _this.state = getState(direction, wrappedComponentName);
	          return _this;
	        }
	
	        _createClass(WithStyles, [{
	          key: 'componentDidMount',
	          value: function () {
	            function componentDidMount() {
	              var _this2 = this;
	
	              if (this.context[_constants.CHANNEL]) {
	                // subscribe to future direction changes
	                this.channelUnsubscribe = this.context[_constants.CHANNEL].subscribe(function (direction) {
	                  _this2.setState(getState(direction, wrappedComponentName));
	                });
	              }
	            }
	
	            return componentDidMount;
	          }()
	        }, {
	          key: 'componentWillUnmount',
	          value: function () {
	            function componentWillUnmount() {
	              if (this.channelUnsubscribe) {
	                this.channelUnsubscribe();
	              }
	            }
	
	            return componentWillUnmount;
	          }()
	        }, {
	          key: 'render',
	          value: function () {
	            function render() {
	              var _ref2;
	
	              // As some components will depend on previous styles in
	              // the component tree, we provide the option of flushing the
	              // buffered styles (i.e. to a style tag) **before** the rendering
	              // cycle begins.
	              //
	              // The interfaces provide the optional "flush" method which
	              // is run in turn by ThemedStyleSheet.flush.
	              if (flushBefore) {
	                _ThemedStyleSheet2['default'].flush();
	              }
	
	              var _state = this.state,
	                  resolveMethod = _state.resolveMethod,
	                  styleDef = _state.styleDef;
	
	
	              return _react2['default'].createElement(WrappedComponent, _extends({}, this.props, (_ref2 = {}, _defineProperty(_ref2, themePropName, _ThemedStyleSheet2['default'].get()), _defineProperty(_ref2, stylesPropName, styleDef()), _defineProperty(_ref2, cssPropName, resolveMethod), _ref2)));
	            }
	
	            return render;
	          }()
	        }]);
	
	        return WithStyles;
	      }(BaseClass);
	
	      WithStyles.WrappedComponent = WrappedComponent;
	      WithStyles.displayName = 'withStyles(' + String(wrappedComponentName) + ')';
	      WithStyles.contextTypes = contextTypes;
	      if (WrappedComponent.propTypes) {
	        WithStyles.propTypes = (0, _object2['default'])({}, WrappedComponent.propTypes);
	        delete WithStyles.propTypes[stylesPropName];
	        delete WithStyles.propTypes[themePropName];
	        delete WithStyles.propTypes[cssPropName];
	      }
	      if (WrappedComponent.defaultProps) {
	        WithStyles.defaultProps = (0, _object2['default'])({}, WrappedComponent.defaultProps);
	      }
	
	      return (0, _hoistNonReactStatics2['default'])(WithStyles, WrappedComponent);
	    }
	
	    return withStylesHOC;
	  }();
	}

/***/ }),

/***/ 267:
/***/ (function(module, exports) {

	var candidateSelectors = [
	  'input',
	  'select',
	  'textarea',
	  'a[href]',
	  'button',
	  '[tabindex]',
	  'audio[controls]',
	  'video[controls]',
	  '[contenteditable]:not([contenteditable="false"])',
	];
	var candidateSelector = candidateSelectors.join(',');
	
	var matches = typeof Element === 'undefined'
	  ? function () {}
	  : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
	
	function tabbable(el, options) {
	  options = options || {};
	
	  var elementDocument = el.ownerDocument || el;
	  var regularTabbables = [];
	  var orderedTabbables = [];
	
	  var untouchabilityChecker = new UntouchabilityChecker(elementDocument);
	  var candidates = el.querySelectorAll(candidateSelector);
	
	  if (options.includeContainer) {
	    if (matches.call(el, candidateSelector)) {
	      candidates = Array.prototype.slice.apply(candidates);
	      candidates.unshift(el);
	    }
	  }
	
	  var i, candidate, candidateTabindex;
	  for (i = 0; i < candidates.length; i++) {
	    candidate = candidates[i];
	
	    if (!isNodeMatchingSelectorTabbable(candidate, untouchabilityChecker)) continue;
	
	    candidateTabindex = getTabindex(candidate);
	    if (candidateTabindex === 0) {
	      regularTabbables.push(candidate);
	    } else {
	      orderedTabbables.push({
	        documentOrder: i,
	        tabIndex: candidateTabindex,
	        node: candidate,
	      });
	    }
	  }
	
	  var tabbableNodes = orderedTabbables
	    .sort(sortOrderedTabbables)
	    .map(function(a) { return a.node })
	    .concat(regularTabbables);
	
	  return tabbableNodes;
	}
	
	tabbable.isTabbable = isTabbable;
	tabbable.isFocusable = isFocusable;
	
	function isNodeMatchingSelectorTabbable(node, untouchabilityChecker) {
	  if (
	    !isNodeMatchingSelectorFocusable(node, untouchabilityChecker)
	    || isNonTabbableRadio(node)
	    || getTabindex(node) < 0
	  ) {
	    return false;
	  }
	  return true;
	}
	
	function isTabbable(node, untouchabilityChecker) {
	  if (!node) throw new Error('No node provided');
	  if (matches.call(node, candidateSelector) === false) return false;
	  return isNodeMatchingSelectorTabbable(node, untouchabilityChecker);
	}
	
	function isNodeMatchingSelectorFocusable(node, untouchabilityChecker) {
	  untouchabilityChecker = untouchabilityChecker || new UntouchabilityChecker(node.ownerDocument || node);
	  if (
	    node.disabled
	    || isHiddenInput(node)
	    || untouchabilityChecker.isUntouchable(node)
	  ) {
	    return false;
	  }
	  return true;
	}
	
	var focusableCandidateSelector = candidateSelectors.concat('iframe').join(',');
	function isFocusable(node, untouchabilityChecker) {
	  if (!node) throw new Error('No node provided');
	  if (matches.call(node, focusableCandidateSelector) === false) return false;
	  return isNodeMatchingSelectorFocusable(node, untouchabilityChecker);
	}
	
	function getTabindex(node) {
	  var tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);
	  if (!isNaN(tabindexAttr)) return tabindexAttr;
	  // Browsers do not return `tabIndex` correctly for contentEditable nodes;
	  // so if they don't have a tabindex attribute specifically set, assume it's 0.
	  if (isContentEditable(node)) return 0;
	  return node.tabIndex;
	}
	
	function sortOrderedTabbables(a, b) {
	  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
	}
	
	// Array.prototype.find not available in IE.
	function find(list, predicate) {
	  for (var i = 0, length = list.length; i < length; i++) {
	    if (predicate(list[i])) return list[i];
	  }
	}
	
	function isContentEditable(node) {
	  return node.contentEditable === 'true';
	}
	
	function isInput(node) {
	  return node.tagName === 'INPUT';
	}
	
	function isHiddenInput(node) {
	  return isInput(node) && node.type === 'hidden';
	}
	
	function isRadio(node) {
	  return isInput(node) && node.type === 'radio';
	}
	
	function isNonTabbableRadio(node) {
	  return isRadio(node) && !isTabbableRadio(node);
	}
	
	function getCheckedRadio(nodes) {
	  for (var i = 0; i < nodes.length; i++) {
	    if (nodes[i].checked) {
	      return nodes[i];
	    }
	  }
	}
	
	function isTabbableRadio(node) {
	  if (!node.name) return true;
	  // This won't account for the edge case where you have radio groups with the same
	  // in separate forms on the same page.
	  var radioSet = node.ownerDocument.querySelectorAll('input[type="radio"][name="' + node.name + '"]');
	  var checked = getCheckedRadio(radioSet);
	  return !checked || checked === node;
	}
	
	// An element is "untouchable" if *it or one of its ancestors* has
	// `visibility: hidden` or `display: none`.
	function UntouchabilityChecker(elementDocument) {
	  this.doc = elementDocument;
	  // Node cache must be refreshed on every check, in case
	  // the content of the element has changed. The cache contains tuples
	  // mapping nodes to their boolean result.
	  this.cache = [];
	}
	
	// getComputedStyle accurately reflects `visibility: hidden` of ancestors
	// but not `display: none`, so we need to recursively check parents.
	UntouchabilityChecker.prototype.hasDisplayNone = function hasDisplayNone(node, nodeComputedStyle) {
	  if (node.nodeType !== Node.ELEMENT_NODE) return false;
	
	    // Search for a cached result.
	    var cached = find(this.cache, function(item) {
	      return item === node;
	    });
	    if (cached) return cached[1];
	
	    nodeComputedStyle = nodeComputedStyle || this.doc.defaultView.getComputedStyle(node);
	
	    var result = false;
	
	    if (nodeComputedStyle.display === 'none') {
	      result = true;
	    } else if (node.parentNode) {
	      result = this.hasDisplayNone(node.parentNode);
	    }
	
	    this.cache.push([node, result]);
	
	    return result;
	}
	
	UntouchabilityChecker.prototype.isUntouchable = function isUntouchable(node) {
	  if (node === this.doc.documentElement) return false;
	  var computedStyle = this.doc.defaultView.getComputedStyle(node);
	  if (this.hasDisplayNone(node, computedStyle)) return true;
	  return computedStyle.visibility === 'hidden';
	}
	
	module.exports = tabbable;


/***/ }),

/***/ 268:
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),

/***/ 891:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("g", {
	  fill: "#58595B",
	  fillRule: "evenodd"
	}, _react2.default.createElement("path", {
	  d: "M11.142 24.142v-24h2v24z"
	}), _react2.default.createElement("path", {
	  d: "M.142 11.142h24v2h-24z"
	}));
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 25 25",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjVweCIgaGVpZ2h0PSIyNXB4IiB2aWV3Qm94PSIwIDAgMjUgMjUiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogc2tldGNodG9vbCA1MC4yICg1NTA0NykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+MDAzNTIzQ0MtOEIxOS00RUVCLUExRTEtQUFGN0UwRDI3NjI2PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBza2V0Y2h0b29sLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJCb2lsZXItdGVtcGxhdGUiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJCU1MtLS1Cb2lsZXItdGVtcGxhdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03MjkuMDAwMDAwLCAtMTI2MTguMDAwMDAwKSIgZmlsbD0iIzU4NTk1QiI+CiAgICAgICAgICAgIDxnIGlkPSJJY29ucyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTMwLjAwMDAwMCwgMTI1MDEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iSWNvbi0tLWFkZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNTk3LjAwMDAwMCwgMTE1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE0LjE0MjEzNiwgMTQuMTQyMTM2KSByb3RhdGUoLTMxNS4wMDAwMDApIHRyYW5zbGF0ZSgtMTQuMTQyMTM2LCAtMTQuMTQyMTM2KSB0cmFuc2xhdGUoNC4xNDIxMzYsIDQuMTQyMTM2KSI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJSZWN0YW5nbGUtNSIgcG9pbnRzPSIxNy43NzgxNzQ2IDE5LjE5MjM4ODIgMC44MDc2MTE4NDUgMi4yMjE4MjU0MSAyLjIyMTgyNTQxIDAuODA3NjExODQ1IDE5LjE5MjM4ODIgMTcuNzc4MTc0NiI+PC9wb2x5Z29uPgogICAgICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iUmVjdGFuZ2xlLTUtQ29weS0yIiBwb2ludHM9IjAuODA3NjExODQ1IDE3Ljc3ODE3NDYgMTcuNzc4MTc0NiAwLjgwNzYxMTg0NSAxOS4xOTIzODgyIDIuMjIxODI1NDEgMi4yMjE4MjU0MSAxOS4xOTIzODgyIj48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M0 0h24v2H0z",
	  fill: "#58595B",
	  fillRule: "evenodd"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 24 2",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIycHgiIHZpZXdCb3g9IjAgMCAyNCAyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IHNrZXRjaHRvb2wgNTAuMiAoNTUwNDcpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPkEyMDgzRERBLTZFOTgtNDMyOS1BMjY5LTVFOTlDRUM3RjgzNTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggc2tldGNodG9vbC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iQm9pbGVyLXRlbXBsYXRlIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQlNTLS0tQm9pbGVyLXRlbXBsYXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzc1LjAwMDAwMCwgLTEyNjMwLjAwMDAwMCkiIGZpbGw9IiM1ODU5NUIiPgogICAgICAgICAgICA8ZyBpZD0iSWNvbnMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMC4wMDAwMDAsIDEyNTAxLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikljb24tLS1taW51cyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjQyLjAwMDAwMCwgMTE1LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE1LjAwMDAwMCwgMTUuMDAwMDAwKSByb3RhdGUoLTMxNS4wMDAwMDApIHRyYW5zbGF0ZSgtMTUuMDAwMDAwLCAtMTUuMDAwMDAwKSB0cmFuc2xhdGUoNS4wMDAwMDAsIDUuMDAwMDAwKSIgaWQ9IlJlY3RhbmdsZS01LUNvcHktMiI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwb2x5Z29uIHBvaW50cz0iMC44MDc2MTE4NDUgMTcuNzc4MTc0NiAxNy43NzgxNzQ2IDAuODA3NjExODQ1IDE5LjE5MjM4ODIgMi4yMjE4MjU0MSAyLjIyMTgyNTQxIDE5LjE5MjM4ODIiPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ReactComponent = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }return target;
	  };return _extends.apply(this, arguments);
	}
	
	var _ref =
	/*#__PURE__*/
	_react2.default.createElement("path", {
	  d: "M17.337 2.415c.208.209.313.461.313.76 0 .297-.105.55-.313.758L7.74 13.531a1.033 1.033 0 01-.76.313c-.297 0-.55-.104-.758-.313L.663 7.973a1.033 1.033 0 01-.313-.759c0-.297.105-.55.313-.759L2.18 4.937c.208-.208.461-.312.759-.312.297 0 .55.104.759.313l3.28 3.292L14.302.897c.209-.208.462-.312.76-.312.297 0 .55.104.758.312l1.518 1.518z",
	  fill: "#417505",
	  fillRule: "evenodd"
	});
	
	var SvgComponent = function SvgComponent(props) {
	  return _react2.default.createElement("svg", _extends({
	    viewBox: "0 0 18 14",
	    width: "1em",
	    height: "1em"
	  }, props), _ref);
	};
	
	exports.default = "data:image/svg+xml;base64,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";
	exports.ReactComponent = SvgComponent;

/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactResponsiveModal = __webpack_require__(263);
	
	var _reactResponsiveModal2 = _interopRequireDefault(_reactResponsiveModal);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _ProductSummary = __webpack_require__(821);
	
	var _ProductSummary2 = _interopRequireDefault(_ProductSummary);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _DateRangeForm = __webpack_require__(272);
	
	var _DateRangeForm2 = _interopRequireDefault(_DateRangeForm);
	
	var _BasketHelper = __webpack_require__(101);
	
	var _BasketHelper2 = _interopRequireDefault(_BasketHelper);
	
	var _routes = __webpack_require__(17);
	
	__webpack_require__(1164);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getPpe = R.pipe(R.pathOr([], ['product', 'ppe']), R.map(R.prop('title')));
	
	var BookingForm = function (_Component) {
	  _inherits(BookingForm, _Component);
	
	  function BookingForm() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BookingForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      open: false,
	      redirect: false,
	      startDateFocused: false,
	      endDateFocused: false,
	      product: {
	        title: R.pathOr('', ['product', 'title'], _this.props),
	        slug: R.pathOr('', ['product', 'slug'], _this.props),
	        ppe: getPpe(_this.props),
	        image: R.pathOr(null, ['product', 'image', 'resize', 'src'], _this.props),
	        optionalExtras: R.pathOr([], ['product', 'optionalExtras'], _this.props),
	        productCode: R.path(['product', 'productCode'], _this.props),
	        quantity: '1',
	        startDate: (0, _moment2.default)(),
	        endDate: (0, _moment2.default)().add(1, 'day')
	      }
	    }, _this.onClick = function () {
	      var product = _this.state.product;
	
	      var items = _BasketHelper2.default.getItems();
	
	      items.push(product);
	      _BasketHelper2.default.addItems(items);
	
	      _this.setState({ addedToBasket: true });
	    }, _this.addProduct = function () {
	      var product = _this.state.product;
	
	      var items = _BasketHelper2.default.getItems();
	
	      items.push(product);
	      _BasketHelper2.default.addItems(items);
	
	      _this.setState({ open: true });
	    }, _this.onCloseModal = function () {
	      _this.setState({ open: false });
	    }, _this.onExitModal = function () {
	      var redirect = _this.state.redirect;
	
	
	      redirect && (0, _gatsbyLink.navigateTo)(_routes.basketRoute);
	    }, _this.addOptionalExtras = function (extras) {
	      var redirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var items = _BasketHelper2.default.getItems();
	      items.push.apply(items, extras);
	      _BasketHelper2.default.addItems(items);
	
	      _this.onCloseModal();
	
	      _this.setState({ redirect: redirect });
	    }, _this.onQuantityChange = function (e) {
	      var product = _this.state.product;
	
	      var quantity = e.target.value;
	
	      _this.setState({
	        product: _extends({}, product, {
	          quantity: quantity
	        })
	      });
	    }, _this.onStartDateChange = function (startDate) {
	      var product = _this.state.product;
	
	      var newState = { startDate: startDate };
	      var endDate = R.prop('endDate', product);
	
	      if (startDate.isSameOrAfter(endDate, 'day')) {
	        newState.endDate = (0, _moment2.default)(startDate).add(1, 'days');
	      }
	
	      _this.setState({
	        product: _extends({}, product, newState)
	      });
	    }, _this.onStartDateFocusChange = function (_ref) {
	      var focused = _ref.focused;
	
	      _this.setState({ startDateFocused: focused });
	    }, _this.onEndDateChange = function (endDate) {
	      var product = _this.state.product;
	
	      var newState = { endDate: endDate };
	      var startDate = R.prop('startDate', product);
	
	      if (endDate.isSameOrBefore(startDate, 'day')) {
	        newState.startDate = (0, _moment2.default)(endDate).add(-1, 'days');
	      }
	
	      _this.setState({
	        product: _extends({}, product, newState)
	      });
	    }, _this.onEndDateFocusChange = function (_ref2) {
	      var focused = _ref2.focused;
	
	      _this.setState({ endDateFocused: focused });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BookingForm.prototype.componentDidMount = function componentDidMount() {
	    this.setState({ items: _BasketHelper2.default.getItems });
	  };
	
	  BookingForm.prototype.render = function render() {
	    var _state = this.state,
	        open = _state.open,
	        product = _state.product,
	        startDateFocused = _state.startDateFocused,
	        endDateFocused = _state.endDateFocused;
	
	    var startDate = R.prop('startDate', product);
	    var endDate = R.prop('endDate', product);
	    var quantity = R.prop('quantity', product);
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'src-components-BookingForm----BookingForm-module---container---11iWf' },
	      _react2.default.createElement(_DateRangeForm2.default, {
	        startDate: startDate,
	        startDateFocused: startDateFocused,
	        onStartDateChange: this.onStartDateChange,
	        onStartDateFocusChange: this.onStartDateFocusChange,
	        endDate: endDate,
	        endDateFocused: endDateFocused,
	        onEndDateChange: this.onEndDateChange,
	        onEndDateFocusChange: this.onEndDateFocusChange,
	        onQuantityChange: this.onQuantityChange,
	        quantity: quantity
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'src-components-BookingForm----BookingForm-module---buttonWrapper---2QEAz' },
	        _react2.default.createElement(
	          _Button2.default,
	          { click: this.addProduct },
	          'Add to Hire Quote List'
	        )
	      ),
	      _react2.default.createElement(
	        _reactResponsiveModal2.default,
	        {
	          open: open,
	          onClose: this.onCloseModal,
	          onExited: this.onExitModal,
	          classNames: { overlay: 'bss-overlay', modal: 'bss-modal' }
	        },
	        _react2.default.createElement(_ProductSummary2.default, {
	          product: product,
	          addOptionalExtras: this.addOptionalExtras
	        })
	      )
	    );
	  };
	
	  return BookingForm;
	}(_react.Component);
	
	BookingForm.propTypes = {
	  product: _propTypes2.default.object.isRequired
	};
	
	exports.default = BookingForm;
	module.exports = exports['default'];

/***/ }),

/***/ 1164:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-BookingForm----BookingForm-module---container---11iWf","buttonWrapper":"src-components-BookingForm----BookingForm-module---buttonWrapper---2QEAz"};

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _BookingForm = __webpack_require__(749);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_BookingForm).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(522);
	
	var _reactDates = __webpack_require__(521);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ComboBox = __webpack_require__(145);
	
	var _ComboBox2 = _interopRequireDefault(_ComboBox);
	
	var _ComboBoxHelper = __webpack_require__(390);
	
	__webpack_require__(474);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// shared props used by both DatePickers
	var baseProps = {
	  showDefaultInputIcon: true,
	  inputIconPosition: 'after',
	  displayFormat: 'DD/MM/YYYY',
	  numberOfMonths: 1,
	  readOnly: true,
	  block: true
	};
	
	var options = (0, _ComboBoxHelper.generateQuantityValues)();
	
	var DateRangeForm = function DateRangeForm(_ref) {
	  var startDate = _ref.startDate,
	      startDateFocused = _ref.startDateFocused,
	      onStartDateChange = _ref.onStartDateChange,
	      onStartDateFocusChange = _ref.onStartDateFocusChange,
	      endDate = _ref.endDate,
	      endDateFocused = _ref.endDateFocused,
	      onEndDateChange = _ref.onEndDateChange,
	      onEndDateFocusChange = _ref.onEndDateFocusChange,
	      onQuantityChange = _ref.onQuantityChange,
	      quantity = _ref.quantity;
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'src-components-DateRangeForm----DateRangeForm-module---dateWrapper---1cwbP' },
	      _react2.default.createElement(
	        'div',
	        { className: 'src-components-DateRangeForm----DateRangeForm-module---label---29Mfc' },
	        'Expected Start Date'
	      ),
	      _react2.default.createElement(_reactDates.SingleDatePicker, _extends({}, baseProps, {
	        id: 'date',
	        date: startDate,
	        focused: startDateFocused,
	        onDateChange: onStartDateChange,
	        onFocusChange: onStartDateFocusChange
	      }))
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'src-components-DateRangeForm----DateRangeForm-module---dateWrapper---1cwbP' },
	      _react2.default.createElement(
	        'div',
	        { className: 'src-components-DateRangeForm----DateRangeForm-module---label---29Mfc' },
	        'Expected End Date'
	      ),
	      _react2.default.createElement(_reactDates.SingleDatePicker, _extends({}, baseProps, {
	        id: 'date2',
	        date: endDate,
	        focused: endDateFocused,
	        onDateChange: onEndDateChange,
	        onFocusChange: onEndDateFocusChange,
	        isOutsideRange: function isOutsideRange(day) {
	          return (0, _moment2.default)().add(1, 'day').isAfter(day, 'day');
	        }
	      }))
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'src-components-DateRangeForm----DateRangeForm-module---quantityWrapper---2lgk2' },
	      _react2.default.createElement(
	        'div',
	        { className: 'src-components-DateRangeForm----DateRangeForm-module---label---29Mfc' },
	        'Quantity'
	      ),
	      _react2.default.createElement(_ComboBox2.default, { options: options, change: onQuantityChange, selectedValue: quantity })
	    )
	  );
	};
	
	DateRangeForm.propTypes = {
	  startDate: _propTypes2.default.instanceOf(_moment2.default).isRequired,
	  startDateFocused: _propTypes2.default.bool.isRequired,
	  onStartDateChange: _propTypes2.default.func.isRequired,
	  onStartDateFocusChange: _propTypes2.default.func.isRequired,
	  endDate: _propTypes2.default.instanceOf(_moment2.default).isRequired,
	  endDateFocused: _propTypes2.default.bool.isRequired,
	  onEndDateChange: _propTypes2.default.func.isRequired,
	  onEndDateFocusChange: _propTypes2.default.func.isRequired,
	  onQuantityChange: _propTypes2.default.func.isRequired,
	  quantity: _propTypes2.default.string.isRequired
	};
	
	exports.default = DateRangeForm;
	module.exports = exports['default'];

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"label":"src-components-DateRangeForm----DateRangeForm-module---label---29Mfc","dateWrapper":"src-components-DateRangeForm----DateRangeForm-module---dateWrapper---1cwbP","quantityWrapper":"src-components-DateRangeForm----DateRangeForm-module---quantityWrapper---2lgk2"};

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _DateRangeForm = __webpack_require__(371);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_DateRangeForm).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 804:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(1193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PpeItem = function PpeItem(_ref) {
	  var title = _ref.title,
	      description = _ref.description;
	  return _react2.default.createElement(
	    'div',
	    { className: 'src-components-PpeItemList-PpeItem----PpeItem-module---item---2wri9' },
	    _react2.default.createElement(
	      'h4',
	      { className: 'src-components-PpeItemList-PpeItem----PpeItem-module---title---3dNoW' },
	      title
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'src-components-PpeItemList-PpeItem----PpeItem-module---description---2fPPn' },
	      description
	    )
	  );
	};
	
	PpeItem.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  description: _propTypes2.default.string.isRequired
	};
	
	exports.default = PpeItem;
	module.exports = exports['default'];

/***/ }),

/***/ 1193:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"item":"src-components-PpeItemList-PpeItem----PpeItem-module---item---2wri9","title":"src-components-PpeItemList-PpeItem----PpeItem-module---title---3dNoW","description":"src-components-PpeItemList-PpeItem----PpeItem-module---description---2fPPn"};

/***/ }),

/***/ 805:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PpeItem = __webpack_require__(804);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PpeItem).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 806:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	var _helpers = __webpack_require__(16);
	
	var _BlockTitle = __webpack_require__(22);
	
	var _BlockTitle2 = _interopRequireDefault(_BlockTitle);
	
	var _PpeItem = __webpack_require__(805);
	
	var _PpeItem2 = _interopRequireDefault(_PpeItem);
	
	__webpack_require__(1194);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderPpeItems = (0, _helpers.indexMap)(function (item, index) {
	  return _react2.default.createElement(_PpeItem2.default, {
	    key: R.propOr(index, 'contentful_id', item),
	    title: R.prop('title', item),
	    description: R.pathOr('', ['description', 'description'], item)
	  });
	});
	
	var PpeItemList = function PpeItemList(_ref) {
	  var items = _ref.items;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_BlockTitle2.default, { title: 'PPE Requirements', size: 'medium', background: 'blue' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'src-components-PpeItemList----PpeItemList-module---item-list---3ph60' },
	      renderPpeItems(items)
	    )
	  );
	};
	
	PpeItemList.propTypes = {
	  items: _propTypes2.default.array
	};
	
	PpeItemList.defaultProps = {
	  items: []
	};
	
	exports.default = PpeItemList;
	module.exports = exports['default'];

/***/ }),

/***/ 1194:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"item-list":"src-components-PpeItemList----PpeItemList-module---item-list---3ph60"};

/***/ }),

/***/ 807:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PpeItemList = __webpack_require__(806);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_PpeItemList).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _placeholder = __webpack_require__(102);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	__webpack_require__(479);
	
	__webpack_require__(33);
	
	__webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductImage = function ProductImage(_ref) {
	  var src = _ref.src,
	      alt = _ref.alt;
	  return _react2.default.createElement('img', { 'data-src': src || _placeholder2.default, alt: alt, className: 'lazyload src-components-ProductImage----ProductImage-module---image---3sv5Q' });
	};
	// import a plugin
	
	
	ProductImage.propTypes = {
	  src: _propTypes2.default.string,
	  alt: _propTypes2.default.string.isRequired
	};
	
	exports.default = ProductImage;
	module.exports = exports['default'];

/***/ }),

/***/ 479:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"image":"src-components-ProductImage----ProductImage-module---image---3sv5Q"};

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ProductImage = __webpack_require__(380);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ProductImage).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ProductImage = __webpack_require__(274);
	
	var _ProductImage2 = _interopRequireDefault(_ProductImage);
	
	var _DateRangeForm = __webpack_require__(272);
	
	var _DateRangeForm2 = _interopRequireDefault(_DateRangeForm);
	
	__webpack_require__(480);
	
	var _webp = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Used by Product Summary and BasketList components
	
	
	var Product = function Product(_ref) {
	  var product = _ref.product,
	      editMode = _ref.editMode,
	      props = _objectWithoutProperties(_ref, ['product', 'editMode']);
	
	  var _useState = (0, _react.useState)('jpg'),
	      format = _useState[0],
	      setFormat = _useState[1];
	
	  (0, _webp.supportsWebp)(function (isSupported) {
	    if (isSupported) {
	      setFormat('webp');
	    }
	  });
	  var title = R.prop('title', product);
	  var productCode = R.prop('productCode', product);
	  var ppe = R.propOr([], 'ppe', product);
	  var image = R.prop('image', product);
	  if (!image.includes('progressive')) {
	    image = image + ('&fm=' + format);
	  }
	  var quantity = R.prop('quantity', product);
	  var startDate = R.prop('startDate', product);
	  var endDate = R.prop('endDate', product);
	  var ppeItems = ppe.join(', ') + '.' || [];
	
	  return _react2.default.createElement(
	    'section',
	    { className: 'src-components-ProductListing----ProductListing-module---container---2DS39' },
	    _react2.default.createElement(
	      'div',
	      { className: 'src-components-ProductListing----ProductListing-module---image---QDJeq' },
	      _react2.default.createElement(_ProductImage2.default, { src: image, alt: title })
	    ),
	    editMode ? _react2.default.createElement(
	      'div',
	      { className: 'src-components-ProductListing----ProductListing-module---info---2-Tfu' },
	      title && _react2.default.createElement(
	        'h5',
	        { className: 'src-components-ProductListing----ProductListing-module---title---3wUhg' },
	        title
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'src-components-ProductListing----ProductListing-module---editItem---2-0cd' },
	        _react2.default.createElement(_DateRangeForm2.default, props)
	      )
	    ) : _react2.default.createElement(
	      'div',
	      { className: 'src-components-ProductListing----ProductListing-module---info---2-Tfu' },
	      title && _react2.default.createElement(
	        'h5',
	        { className: 'src-components-ProductListing----ProductListing-module---title---3wUhg' },
	        title
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'Quantity:'
	          ),
	          ' ',
	          quantity
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'Product Code:'
	          ),
	          ' ',
	          productCode
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'b',
	            null,
	            'Expected Hire Date:'
	          ),
	          ' ',
	          (0, _moment2.default)(startDate).format('D MMM YYYY'),
	          ' - ',
	          (0, _moment2.default)(endDate).format('D MMM YYYY')
	        )
	      ),
	      R.not(R.isEmpty(ppe)) && _react2.default.createElement(
	        'p',
	        null,
	        _react2.default.createElement(
	          'b',
	          null,
	          'PPE needed:'
	        ),
	        ' ',
	        ppeItems
	      )
	    )
	  );
	};
	
	Product.propTypes = {
	  product: _propTypes2.default.object.isRequired,
	  editMode: _propTypes2.default.bool,
	  editProps: _propTypes2.default.object
	};
	
	exports.default = Product;
	module.exports = exports['default'];

/***/ }),

/***/ 480:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-ProductListing----ProductListing-module---container---2DS39","image":"src-components-ProductListing----ProductListing-module---image---QDJeq","info":"src-components-ProductListing----ProductListing-module---info---2-Tfu","title":"src-components-ProductListing----ProductListing-module---title---3wUhg","editItem":"src-components-ProductListing----ProductListing-module---editItem---2-0cd"};

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ProductListing = __webpack_require__(381);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ProductListing).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 816:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	var _add = __webpack_require__(891);
	
	var _minus = __webpack_require__(900);
	
	var _placeholder = __webpack_require__(102);
	
	var _placeholder2 = _interopRequireDefault(_placeholder);
	
	__webpack_require__(1199);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var OptionalExtra = function OptionalExtra(_ref) {
	  var extra = _ref.extra,
	      increment = _ref.increment,
	      decrement = _ref.decrement;
	
	  var title = R.prop('title', extra);
	  var productCode = R.prop('productCode', extra);
	  var quantity = R.prop('quantity', extra);
	  var imageSrc = R.propOr(_placeholder2.default, 'image', extra);
	
	  return _react2.default.createElement(
	    'div',
	    { className: 'src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---product---1QCtX' },
	    _react2.default.createElement(
	      'div',
	      { className: 'src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---imageBox---IB9ek' },
	      _react2.default.createElement('div', { className: 'src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---image---2BMD6', style: { backgroundImage: 'url(' + imageSrc + ')' } })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---title---1rusg' },
	      title
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---code---3uv9Q' },
	      'Product Code: ',
	      productCode
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---controls---1zzxi' },
	      _react2.default.createElement(
	        'div',
	        { className: 'src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---control---2s3p1 src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---button---1suj2', onClick: decrement },
	        _react2.default.createElement(_minus.ReactComponent, null)
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---control---2s3p1' },
	        quantity
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---control---2s3p1 src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---button---1suj2', onClick: increment },
	        _react2.default.createElement(_add.ReactComponent, null)
	      )
	    )
	  );
	};
	
	OptionalExtra.propTypes = {
	  extra: _propTypes2.default.object.isRequired,
	  increment: _propTypes2.default.func.isRequired,
	  decrement: _propTypes2.default.func.isRequired
	};
	
	exports.default = OptionalExtra;
	module.exports = exports['default'];

/***/ }),

/***/ 1199:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"product":"src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---product---1QCtX","imageBox":"src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---imageBox---IB9ek","image":"src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---image---2BMD6","title":"src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---title---1rusg","code":"src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---code---3uv9Q","controls":"src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---controls---1zzxi","control":"src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---control---2s3p1","button":"src-components-ProductSummary-OptionalExtras-OptionalExtra----OptionalExtra-module---button---1suj2"};

/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _OptionalExtra = __webpack_require__(816);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OptionalExtra).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 818:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	var _helpers = __webpack_require__(16);
	
	var _OptionalExtra = __webpack_require__(817);
	
	var _OptionalExtra2 = _interopRequireDefault(_OptionalExtra);
	
	__webpack_require__(1200);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderExtras = function renderExtras(extras, _ref) {
	  var _increment = _ref.increment,
	      _decrement = _ref.decrement;
	  return (0, _helpers.indexMap)(function (extra, index) {
	    return _react2.default.createElement(_OptionalExtra2.default, {
	      extra: extra,
	      key: index,
	      increment: function increment() {
	        return _increment(index);
	      },
	      decrement: function decrement() {
	        return _decrement(index);
	      } });
	  }, extras);
	};
	
	var OptionalExtras = function OptionalExtras(_ref2) {
	  var extras = _ref2.extras,
	      increment = _ref2.increment,
	      decrement = _ref2.decrement;
	  return _react2.default.createElement(
	    'div',
	    { className: 'src-components-ProductSummary-OptionalExtras----OptionalExtras-module---optional-extras---1noGM' },
	    R.not(R.isEmpty(extras)) && _react2.default.createElement(
	      'h2',
	      null,
	      'Select optional extras'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'src-components-ProductSummary-OptionalExtras----OptionalExtras-module---wrapper---1KiGO' },
	      renderExtras(extras, { increment: increment, decrement: decrement })
	    )
	  );
	};
	
	OptionalExtras.propTypes = {
	  extras: _propTypes2.default.array,
	  increment: _propTypes2.default.func.isRequired,
	  decrement: _propTypes2.default.func.isRequired
	};
	
	OptionalExtras.defaultProps = {
	  extras: []
	};
	
	exports.default = OptionalExtras;
	module.exports = exports['default'];

/***/ }),

/***/ 1200:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"optional-extras":"src-components-ProductSummary-OptionalExtras----OptionalExtras-module---optional-extras---1noGM","wrapper":"src-components-ProductSummary-OptionalExtras----OptionalExtras-module---wrapper---1KiGO"};

/***/ }),

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _OptionalExtras = __webpack_require__(818);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_OptionalExtras).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ProductListing = __webpack_require__(382);
	
	var _ProductListing2 = _interopRequireDefault(_ProductListing);
	
	var _OptionalExtras = __webpack_require__(819);
	
	var _OptionalExtras2 = _interopRequireDefault(_OptionalExtras);
	
	var _tick = __webpack_require__(903);
	
	__webpack_require__(1201);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductSummary = function (_Component) {
	  _inherits(ProductSummary, _Component);
	
	  function ProductSummary() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ProductSummary);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      extras: [],
	      added: 0
	    }, _this.continueBrowsing = function () {
	      _this.addAddedExtras();
	    }, _this.goToBasket = function () {
	      _this.addAddedExtras(true);
	    }, _this.addAddedExtras = function () {
	      var redirect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	      var extras = _this.state.extras;
	      var addOptionalExtras = _this.props.addOptionalExtras;
	
	      var addedExtras = R.filter(function (extra) {
	        return R.gt(extra.quantity, 0);
	      }, extras);
	
	      addOptionalExtras(addedExtras, redirect);
	    }, _this.increment = function (index) {
	      var _this$state = _this.state,
	          extras = _this$state.extras,
	          added = _this$state.added;
	
	      var extra = R.prop(index, extras);
	      var quantity = Number(R.prop('quantity', extra));
	
	      if (quantity < 25) {
	        quantity += 1;
	        added += 1;
	      }
	
	      extra.quantity = String(quantity);
	      extras[index] = extra;
	
	      _this.setState({ extras: extras, added: added });
	    }, _this.decrement = function (index) {
	      var _this$state2 = _this.state,
	          extras = _this$state2.extras,
	          added = _this$state2.added;
	
	      var extra = R.prop(index, extras);
	      var quantity = Number(R.prop('quantity', extra));
	
	      if (quantity > 0) {
	        quantity -= 1;
	        added -= 1;
	      }
	
	      extra.quantity = String(quantity);
	      extras[index] = extra;
	
	      _this.setState({ extras: extras, added: added });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ProductSummary.prototype.componentDidMount = function componentDidMount() {
	    var product = this.props.product;
	
	    var optionalExtras = R.prop('optionalExtras', product);
	    var extras = this.flattenOptionalExtras(optionalExtras);
	    this.setState({ extras: extras });
	  };
	
	  ProductSummary.prototype.flattenOptionalExtras = function flattenOptionalExtras(optionalExtras) {
	    var product = this.props.product;
	
	    var startDate = R.prop('startDate', product);
	    var endDate = R.prop('endDate', product);
	
	    return R.map(function (extra) {
	      var item = {};
	
	      item.slug = R.prop('slug', extra);
	      item.title = R.prop('title', extra);
	      item.productCode = R.path(['template', '0', 'productCode'], extra);
	      item.image = R.pathOr(null, ['template', '0', 'image', 'resize', 'src'], extra);
	      item.ppe = R.pipe(R.pathOr([], ['template', '0', 'ppe']), R.map(R.prop('title')))(extra);
	      item.quantity = '0';
	      item.startDate = startDate;
	      item.endDate = endDate;
	
	      return item;
	    }, optionalExtras);
	  };
	
	  ProductSummary.prototype.render = function render() {
	    var _state = this.state,
	        extras = _state.extras,
	        added = _state.added;
	    var product = this.props.product;
	
	
	    return _react2.default.createElement(
	      _react.Fragment,
	      null,
	      _react2.default.createElement(
	        'h4',
	        { className: 'src-components-ProductSummary----ProductSummary-module---cornerTitle---2ogic' },
	        'Add to Hire Quote List'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'src-components-ProductSummary----ProductSummary-module---container---3j76G' },
	        _react2.default.createElement(
	          'section',
	          { className: 'src-components-ProductSummary----ProductSummary-module---header---3eoMp' },
	          _react2.default.createElement(
	            'div',
	            { className: 'src-components-ProductSummary----ProductSummary-module---phoneInfo---1Qe2E' },
	            _react2.default.createElement(
	              'span',
	              { className: 'src-components-ProductSummary----ProductSummary-module---phoneLabel---34_Sr' },
	              'Need help? Call us'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:033448921878', className: 'src-components-ProductSummary----ProductSummary-module---phoneNo---MSAdh' },
	              '03344 892 1878'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'src-components-ProductSummary----ProductSummary-module---buttons---3kGTi' },
	            added > 0 && _react2.default.createElement(
	              'p',
	              { className: 'src-components-ProductSummary----ProductSummary-module---added---kge6s' },
	              _react2.default.createElement(_tick.ReactComponent, null),
	              'Adding ',
	              added,
	              ' extra items'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'src-components-ProductSummary----ProductSummary-module---buttonWrapper---3Wk73' },
	              _react2.default.createElement(
	                _Button2.default,
	                { type: 'alt', click: this.continueBrowsing },
	                'Continue Browsing'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'src-components-ProductSummary----ProductSummary-module---buttonWrapper---3Wk73' },
	              _react2.default.createElement(
	                _Button2.default,
	                { click: this.goToBasket },
	                'Proceed to Quote List'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'src-components-ProductSummary----ProductSummary-module---productWrapper---3Ptp6' },
	          product && _react2.default.createElement(_ProductListing2.default, { product: product })
	        ),
	        _react2.default.createElement(_OptionalExtras2.default, {
	          extras: extras,
	          increment: this.increment,
	          decrement: this.decrement
	        }),
	        _react2.default.createElement(
	          'section',
	          { className: 'src-components-ProductSummary----ProductSummary-module---footer---2t9T9' },
	          _react2.default.createElement(
	            'div',
	            { className: 'src-components-ProductSummary----ProductSummary-module---buttons---3kGTi' },
	            added > 0 && _react2.default.createElement(
	              'p',
	              { className: 'src-components-ProductSummary----ProductSummary-module---added---kge6s' },
	              _react2.default.createElement(_tick.ReactComponent, null),
	              'Adding ',
	              added,
	              ' extra items'
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'src-components-ProductSummary----ProductSummary-module---buttonWrapper---3Wk73' },
	              _react2.default.createElement(
	                _Button2.default,
	                { type: 'alt', click: this.continueBrowsing },
	                'Continue Browsing'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'src-components-ProductSummary----ProductSummary-module---buttonWrapper---3Wk73' },
	              _react2.default.createElement(
	                _Button2.default,
	                { click: this.goToBasket },
	                'Proceed to Quote List'
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return ProductSummary;
	}(_react.Component);
	
	ProductSummary.propTypes = {
	  product: _propTypes2.default.object.isRequired,
	  addOptionalExtras: _propTypes2.default.func.isRequired
	};
	
	exports.default = ProductSummary;
	module.exports = exports['default'];

/***/ }),

/***/ 1201:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-ProductSummary----ProductSummary-module---container---3j76G","cornerTitle":"src-components-ProductSummary----ProductSummary-module---cornerTitle---2ogic","header":"src-components-ProductSummary----ProductSummary-module---header---3eoMp","footer":"src-components-ProductSummary----ProductSummary-module---footer---2t9T9","productWrapper":"src-components-ProductSummary----ProductSummary-module---productWrapper---3Ptp6","phoneInfo":"src-components-ProductSummary----ProductSummary-module---phoneInfo---1Qe2E","phoneLabel":"src-components-ProductSummary----ProductSummary-module---phoneLabel---34_Sr","phoneNo":"src-components-ProductSummary----ProductSummary-module---phoneNo---MSAdh","buttons":"src-components-ProductSummary----ProductSummary-module---buttons---3kGTi","buttonWrapper":"src-components-ProductSummary----ProductSummary-module---buttonWrapper---3Wk73","added":"src-components-ProductSummary----ProductSummary-module---added---kge6s"};

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _ProductSummary = __webpack_require__(820);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_ProductSummary).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getClassName2 = __webpack_require__(12);
	
	var _getClassName3 = _interopRequireDefault(_getClassName2);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BlockTitle = __webpack_require__(22);
	
	var _BlockTitle2 = _interopRequireDefault(_BlockTitle);
	
	var _helpers = __webpack_require__(16);
	
	__webpack_require__(1207);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _styleModuleImportMap = {
	  './TechSpecTable.module.scss': {
	    'table': 'src-components-TechSpecTable----TechSpecTable-module---table---19E07',
	    'selected': 'src-components-TechSpecTable----TechSpecTable-module---selected---3j0jQ',
	    'heading': 'src-components-TechSpecTable----TechSpecTable-module---heading---3EKNT',
	    'cell': 'src-components-TechSpecTable----TechSpecTable-module---cell---BeHnE',
	    'row': 'src-components-TechSpecTable----TechSpecTable-module---row---Sdgoa'
	  }
	};
	
	
	var TechSpecTable = function TechSpecTable(_ref) {
	  var headings = _ref.headings,
	      links = _ref.links,
	      rows = _ref.rows,
	      slug = _ref.slug;
	
	  var numCols = headings.length;
	  var colWidthPercentage = 100 / numCols;
	  var pos = links.indexOf(slug) + 1;
	  var selectedStyle = {
	    left: 'calc(' + pos * colWidthPercentage + '% - 1rem)',
	    width: 'calc(' + colWidthPercentage + '% - 1rem)'
	  };
	  var title = links.length > 1 ? 'Compare Technical Specifications' : 'Technical Specifications';
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_BlockTitle2.default, { title: title, size: 'medium', background: 'blue' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'src-components-TechSpecTable----TechSpecTable-module---table---19E07' },
	      _react2.default.createElement('div', {
	        style: selectedStyle,
	        className: (0, _getClassName3.default)(links.length > 1 ? 'selected' : '', _styleModuleImportMap)
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: 'src-components-TechSpecTable----TechSpecTable-module---heading---3EKNT' },
	        (0, _helpers.indexMap)(function (heading, index) {
	          return _react2.default.createElement(
	            'div',
	            { className: 'src-components-TechSpecTable----TechSpecTable-module---cell---BeHnE', key: index },
	            heading && _react2.default.createElement(
	              'span',
	              null,
	              heading
	            )
	          );
	        }, headings)
	      ),
	      (0, _helpers.indexMap)(function (row, index) {
	        return _react2.default.createElement(
	          'div',
	          { className: 'src-components-TechSpecTable----TechSpecTable-module---row---Sdgoa', key: index },
	          (0, _helpers.indexMap)(function (cell, index) {
	            return _react2.default.createElement(
	              'div',
	              { className: 'src-components-TechSpecTable----TechSpecTable-module---cell---BeHnE', key: index },
	              cell
	            );
	          }, row)
	        );
	      }, rows)
	    )
	  );
	};
	
	TechSpecTable.propTypes = {
	  headings: _propTypes2.default.array,
	  links: _propTypes2.default.array,
	  rows: _propTypes2.default.array,
	  slug: _propTypes2.default.string.isRequired
	};
	
	TechSpecTable.defaultProps = {
	  headings: [],
	  links: [],
	  rows: []
	};
	
	exports.default = TechSpecTable;
	module.exports = exports['default'];

/***/ }),

/***/ 1207:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"table":"src-components-TechSpecTable----TechSpecTable-module---table---19E07","selected":"src-components-TechSpecTable----TechSpecTable-module---selected---3j0jQ","heading":"src-components-TechSpecTable----TechSpecTable-module---heading---3EKNT","cell":"src-components-TechSpecTable----TechSpecTable-module---cell---BeHnE","row":"src-components-TechSpecTable----TechSpecTable-module---row---Sdgoa"};

/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _TechSpecTable = __webpack_require__(832);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TechSpecTable).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports['default'];

/***/ }),

/***/ 858:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	var _gatsbyLink = __webpack_require__(11);
	
	var _BlockTitle = __webpack_require__(22);
	
	var _BlockTitle2 = _interopRequireDefault(_BlockTitle);
	
	var _ComboBox = __webpack_require__(145);
	
	var _ComboBox2 = _interopRequireDefault(_ComboBox);
	
	var _Markdown = __webpack_require__(68);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _PageWrap = __webpack_require__(24);
	
	var _PageWrap2 = _interopRequireDefault(_PageWrap);
	
	var _ProductImage = __webpack_require__(274);
	
	var _ProductImage2 = _interopRequireDefault(_ProductImage);
	
	var _PpeItemList = __webpack_require__(807);
	
	var _PpeItemList2 = _interopRequireDefault(_PpeItemList);
	
	var _BookingForm = __webpack_require__(750);
	
	var _BookingForm2 = _interopRequireDefault(_BookingForm);
	
	var _TechSpecTable = __webpack_require__(833);
	
	var _TechSpecTable2 = _interopRequireDefault(_TechSpecTable);
	
	var _routes = __webpack_require__(17);
	
	var _RenderHireProductLink = __webpack_require__(275);
	
	__webpack_require__(1219);
	
	var _webp = __webpack_require__(30);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Product = function (_Component) {
	  _inherits(Product, _Component);
	
	  function Product() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Product);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      format: 'jpg'
	    }, _this.getOptions = R.map(function (variant) {
	      return {
	        value: R.prop('slug', variant),
	        text: R.path(['template', '0', 'shortName'], variant)
	      };
	    }), _this.getSpecs = R.pipe(R.defaultTo({}), R.mapObjIndexed(function (value, key) {
	      return R.ifElse(function (v) {
	        return Boolean(v);
	      }, function (v) {
	        return {
	          key: key,
	          name: _this.convertCamelCaseToTitle(key),
	          value: v
	        };
	      }, R.always(null))(value);
	    }), R.filter(function (item) {
	      return R.not(R.isNil(R.prop('value', item)));
	    }), R.values), _this.getHeadings = R.ifElse(function (variants) {
	      return R.gt(R.propOr(0, 'length', variants), 1);
	    }, R.pipe(R.map(R.path(['template', '0', 'shortName'])), R.prepend('')), R.always([''])), _this.getLinks = R.map(R.prop('slug')), _this.onChange = function (e) {
	      var value = e.target.value;
	      var product = _this.props.product;
	
	      if (R.equals(value, 'Select Variant')) {
	        return;
	      }
	
	      (0, _gatsbyLink.navigateTo)((0, _routes.productRoute)((0, _RenderHireProductLink.renderHireProductLink)(value, R.prop('category', product))));
	    }, _this.convertCamelCaseToTitle = function (camelCase) {
	      return camelCase.replace(/([A-Z])/g, function (match) {
	        return ' ' + match;
	      }).replace(/^./, function (match) {
	        return match.toUpperCase();
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Product.prototype.buildRows = function buildRows(variants) {
	    var _this2 = this;
	
	    var specArray = R.map(R.ifElse(R.pathOr(null, ['template', '0', 'spec']), function (item) {
	      return _this2.getSpecs(R.path(['template', '0', 'spec'], item));
	    }, R.always([])), variants);
	
	    var specs = R.reduce(function (prev, next) {
	      return R.ifElse(function (_ref) {
	        var prev = _ref.prev,
	            next = _ref.next;
	        return R.gt(R.propOr(0, 'length', prev), R.propOr(0, 'length', next));
	      }, R.prop('prev'), R.prop('next'))({ prev: prev, next: next });
	    }, [], specArray);
	
	    var getSpecValues = function getSpecValues(variants, spec) {
	      return R.pipe(R.defaultTo([]), R.map(R.path(['template', '0', 'spec', spec.key])))(variants);
	    };
	
	    var getRows = function getRows(specs, variants) {
	      return R.map(function (spec) {
	        return R.concat([R.prop('name', spec)], getSpecValues(variants, spec));
	      }, specs);
	    };
	
	    return getRows(specs, variants);
	  };
	
	  Product.prototype.componentDidMount = function componentDidMount() {
	    var _this3 = this;
	
	    (0, _webp.supportsWebp)(function (isSupported) {
	      if (isSupported) {
	        _this3.setState({ format: 'webp' });
	      }
	    });
	  };
	
	  Product.prototype.render = function render() {
	    var product = this.props.product;
	    var format = this.state.format;
	
	    if (R.or(R.not(product), R.isEmpty(product))) {
	      return null;
	    }
	
	    var productCode = R.propOr('', 'productCode', product);
	    var title = R.prop('title', product);
	    var shortName = R.prop('shortName', product);
	    var slug = R.prop('slug', product);
	    var description = R.prop('description', product);
	    var imageSrc = R.path(['image', 'resize', 'src'], product);
	    if (!imageSrc.includes('progressive')) {
	      imageSrc = imageSrc + ('&fm=' + format);
	    }
	    var ppe = R.prop('ppe', product);
	    var spec = R.prop('spec', product);
	    var variants = R.propOr([], 'variants', product);
	
	    var self = {
	      title: title,
	      slug: slug,
	      template: [{
	        shortName: shortName,
	        spec: spec
	      }]
	    };
	
	    var options = this.getOptions(variants);
	    var specs = this.getSpecs(spec);
	    var varsWIthSelf = R.prepend(self, variants);
	    var headings = this.getHeadings(varsWIthSelf);
	    var links = this.getLinks(varsWIthSelf);
	    var rows = specs && this.buildRows(varsWIthSelf);
	    var showVariants = R.gt(R.propOr(0, 'length', varsWIthSelf), 1);
	
	    return _react2.default.createElement(
	      _PageWrap2.default,
	      null,
	      title && _react2.default.createElement(_BlockTitle2.default, { title: title, DynamicTag: 'h1' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'src-containers-Product----Product-module---product-code---3vTGd' },
	        'Product Code: ',
	        productCode
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'src-containers-Product----Product-module---cols---3VT7U' },
	        imageSrc && _react2.default.createElement(
	          'div',
	          { className: 'src-containers-Product----Product-module---imageWrapper---3hqDh' },
	          _react2.default.createElement(_ProductImage2.default, { src: imageSrc, alt: title })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'src-containers-Product----Product-module---descriptionWrapper---1lt9B' },
	          showVariants && _react2.default.createElement(
	            'div',
	            { className: 'src-containers-Product----Product-module---variants-dropdown---2OJwR' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'src-containers-Product----Product-module---heading---J8bjH' },
	              'Product Variants'
	            ),
	            _react2.default.createElement(_ComboBox2.default, {
	              options: options,
	              change: this.onChange,
	              selectedValue: slug,
	              defaultValue: 'Select Variant'
	            })
	          ),
	          description && _react2.default.createElement(
	            'div',
	            { className: 'src-containers-Product----Product-module---description---3ltvI' },
	            _react2.default.createElement(
	              'h3',
	              { className: 'src-containers-Product----Product-module---heading---J8bjH' },
	              'Features'
	            ),
	            _react2.default.createElement(_Markdown2.default, { content: description })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(_BookingForm2.default, { product: product })
	      ),
	      R.and(spec, R.gt(rows.length, 0)) && _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(_TechSpecTable2.default, { headings: headings, links: links, rows: rows, slug: slug })
	      ),
	      ppe && _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(_PpeItemList2.default, { items: ppe })
	      )
	    );
	  };
	
	  return Product;
	}(_react.Component);
	
	Product.propTypes = {
	  product: _propTypes2.default.object.isRequired
	};
	
	exports.default = Product;
	module.exports = exports['default'];

/***/ }),

/***/ 1219:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"cols":"src-containers-Product----Product-module---cols---3VT7U","imageWrapper":"src-containers-Product----Product-module---imageWrapper---3hqDh","descriptionWrapper":"src-containers-Product----Product-module---descriptionWrapper---1lt9B","variants-dropdown":"src-containers-Product----Product-module---variants-dropdown---2OJwR","description":"src-containers-Product----Product-module---description---3ltvI","product-code":"src-containers-Product----Product-module---product-code---3vTGd","heading":"src-containers-Product----Product-module---heading---J8bjH"};

/***/ }),

/***/ 859:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var technicalSpecificationFields = exports.technicalSpecificationFields = "** extracted graphql fragment **";

/***/ }),

/***/ 860:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Product = __webpack_require__(858);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Product).default;
	  }
	});
	
	var _Query = __webpack_require__(859);
	
	Object.defineProperty(exports, 'technicalSpecificationFields', {
	  enumerable: true,
	  get: function get() {
	    return _Query.technicalSpecificationFields;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	var _moment = __webpack_require__(8);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _StorageHelper = __webpack_require__(116);
	
	var _StorageHelper2 = _interopRequireDefault(_StorageHelper);
	
	var _constants = __webpack_require__(179);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Basket = function () {
	  function Basket() {
	    _classCallCheck(this, Basket);
	
	    this.key = _constants.STORAGE_KEY;
	    var data = _StorageHelper2.default.get(this.key) || '[]';
	    this.items = JSON.parse(data);
	  }
	
	  // writes whole array to LS
	
	
	  Basket.prototype.addItems = function addItems(items) {
	    // only allow arrays to be added to store
	    if (R.not(R.is(Array, items))) {
	      console.log('Basket addItems requires an array');
	      return;
	    }
	
	    this.items = items;
	    _StorageHelper2.default.set(this.key, JSON.stringify(this.items));
	
	    this._emitUpdate();
	  };
	
	  Basket.prototype.getItems = function getItems() {
	    // convert all dates to moment dates before returning
	    var items = R.map(function (item) {
	      var itemObj = _extends({}, item);
	      itemObj.startDate = (0, _moment2.default)(item.startDate);
	      itemObj.endDate = (0, _moment2.default)(item.endDate);
	      return itemObj;
	    }, this.items);
	
	    return items;
	  };
	
	  Basket.prototype.countItems = function countItems() {
	    // return total of all quantities within each basket listing
	    if (R.isEmpty(this.items)) {
	      return 0;
	    }
	
	    return R.pipe(R.map(function (item) {
	      return Number(item.quantity);
	    }), R.sum)(this.items);
	  };
	
	  Basket.prototype.removeItem = function removeItem(index) {
	    this.items.splice(index, 1);
	    _StorageHelper2.default.set(this.key, JSON.stringify(this.items));
	
	    this._emitUpdate();
	  };
	
	  Basket.prototype._emitUpdate = function _emitUpdate() {
	    var event = new Event('updateBasket');
	    document.dispatchEvent(event);
	  };
	
	  return Basket;
	}();
	
	exports.default = new Basket();
	module.exports = exports['default'];

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	// generate quantity values 1 to 25 for ComboBox
	var generateQuantityValues = exports.generateQuantityValues = function generateQuantityValues() {
	  var options = [];
	  var MIN = 1;
	  var MAX = 25;
	
	  for (var i = MIN; i <= MAX; i++) {
	    var option = {};
	    var iStr = i.toString();
	    option.value = iStr;
	    option.text = iStr;
	    options.push(option);
	  }
	
	  return options;
	};

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jsCookie = __webpack_require__(133);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LocalStorage = function () {
	  function LocalStorage() {
	    _classCallCheck(this, LocalStorage);
	  }
	
	  LocalStorage.prototype.get = function get(key) {
	    try {
	      return localStorage.getItem(key);
	    } catch (e) {
	      return _jsCookie2.default.get(key);
	    }
	  };
	
	  LocalStorage.prototype.set = function set(key, value) {
	    try {
	      localStorage.setItem(key, value);
	    } catch (e) {
	      _jsCookie2.default.set(key, value);
	    }
	  };
	
	  LocalStorage.prototype.remove = function remove(key) {
	    try {
	      localStorage.removeItem(key);
	    } catch (e) {
	      _jsCookie2.default.remove(key);
	    }
	  };
	
	  return LocalStorage;
	}();
	
	exports.default = new LocalStorage();
	module.exports = exports['default'];

/***/ }),

/***/ 886:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Seo = __webpack_require__(35);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	var _Product = __webpack_require__(860);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	var _Ctas = __webpack_require__(114);
	
	var _Ctas2 = _interopRequireDefault(_Ctas);
	
	var _ContactDetails = __webpack_require__(89);
	
	var _ContactDetails2 = _interopRequireDefault(_ContactDetails);
	
	var _ramda = __webpack_require__(6);
	
	var R = _interopRequireWildcard(_ramda);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProductPage = function ProductPage(_ref) {
	  var data = _ref.data;
	
	  var metaTitle = R.pathOr('', ['contentfulPage', 'metaTitle'], data);
	  var metaDescription = R.pathOr('', ['contentfulPage', 'metaDescription'], data);
	  var canonicalUrl = R.pathOr('', ['contentfulPage', 'canonicalUrl'], data);
	  var slug = R.pathOr('', ['contentfulPage', 'slug'], data);
	  var product = R.pathOr('', ['contentfulPage', 'template', '0'], data);
	  var ctaComponents = R.pathOr([], ['ctaBlock', 'ctaComponents'], product);
	  var contactDetailsData = R.pathOr([], ['allContentfulContactComponent', 'edges', '0', 'node'], data);
	
	  product.slug = slug;
	
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_Seo2.default, {
	      title: metaTitle,
	      canonicalUrl: canonicalUrl,
	      description: metaDescription
	    }),
	    product && _react2.default.createElement(_Product2.default, { product: product }),
	    R.not(R.isEmpty(ctaComponents)) && _react2.default.createElement(_Ctas2.default, { data: ctaComponents }),
	    contactDetailsData && _react2.default.createElement(_ContactDetails2.default, { data: contactDetailsData })
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = ProductPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-product-js-0329654f8eb2e1c6c692.js